/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error('jQuery requires a window with a document');
            return t(e);
          })
    : t(e);
})('undefined' != typeof window ? window : this, function (C, e) {
  'use strict';
  var t = [],
    r = Object.getPrototypeOf,
    s = t.slice,
    g = t.flat
      ? function (e) {
          return t.flat.call(e);
        }
      : function (e) {
          return t.concat.apply([], e);
        },
    u = t.push,
    i = t.indexOf,
    n = {},
    o = n.toString,
    v = n.hasOwnProperty,
    a = v.toString,
    l = a.call(Object),
    y = {},
    m = function (e) {
      return 'function' == typeof e && 'number' != typeof e.nodeType;
    },
    x = function (e) {
      return null != e && e === e.window;
    },
    E = C.document,
    c = { type: !0, src: !0, nonce: !0, noModule: !0 };
  function b(e, t, n) {
    var r,
      i,
      o = (n = n || E).createElement('script');
    if (((o.text = e), t))
      for (r in c)
        (i = t[r] || (t.getAttribute && t.getAttribute(r))) &&
          o.setAttribute(r, i);
    n.head.appendChild(o).parentNode.removeChild(o);
  }
  function w(e) {
    return null == e
      ? e + ''
      : 'object' == typeof e || 'function' == typeof e
      ? n[o.call(e)] || 'object'
      : typeof e;
  }
  var f = '3.5.1',
    S = function (e, t) {
      return new S.fn.init(e, t);
    };
  function p(e) {
    var t = !!e && 'length' in e && e.length,
      n = w(e);
    return (
      !m(e) &&
      !x(e) &&
      ('array' === n ||
        0 === t ||
        ('number' == typeof t && 0 < t && t - 1 in e))
    );
  }
  (S.fn = S.prototype =
    {
      jquery: f,
      constructor: S,
      length: 0,
      toArray: function () {
        return s.call(this);
      },
      get: function (e) {
        return null == e
          ? s.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = S.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return S.each(this, e);
      },
      map: function (n) {
        return this.pushStack(
          S.map(this, function (e, t) {
            return n.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(s.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          S.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          S.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= n && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: u,
      sort: t.sort,
      splice: t.splice,
    }),
    (S.extend = S.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          'boolean' == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            'object' == typeof a || m(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (r = e[t]),
                '__proto__' !== t &&
                  a !== r &&
                  (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                    ? ((n = a[t]),
                      (o =
                        i && !Array.isArray(n)
                          ? []
                          : i || S.isPlainObject(n)
                          ? n
                          : {}),
                      (i = !1),
                      (a[t] = S.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    S.extend({
      expando: 'jQuery' + (f + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || '[object Object]' !== o.call(e)) &&
          (!(t = r(e)) ||
            ('function' ==
              typeof (n = v.call(t, 'constructor') && t.constructor) &&
              a.call(n) === l))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, n) {
        b(e, { nonce: t && t.nonce }, n);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (p(e)) {
          for (n = e.length; r < n; r++)
            if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (p(Object(e))
              ? S.merge(n, 'string' == typeof e ? [e] : e)
              : u.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : i.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r = [], i = 0, o = e.length, a = !n; i < o; i++)
          !t(e[i], i) !== a && r.push(e[i]);
        return r;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          a = [];
        if (p(e))
          for (r = e.length; o < r; o++)
            null != (i = t(e[o], o, n)) && a.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
        return g(a);
      },
      guid: 1,
      support: y,
    }),
    'function' == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
    S.each(
      'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
        ' '
      ),
      function (e, t) {
        n['[object ' + t + ']'] = t.toLowerCase();
      }
    );
  var d = (function (n) {
    var e,
      d,
      b,
      o,
      i,
      h,
      f,
      g,
      w,
      u,
      l,
      T,
      C,
      a,
      E,
      v,
      s,
      c,
      y,
      S = 'sizzle' + 1 * new Date(),
      p = n.document,
      k = 0,
      r = 0,
      m = ue(),
      x = ue(),
      A = ue(),
      N = ue(),
      D = function (e, t) {
        return e === t && (l = !0), 0;
      },
      j = {}.hasOwnProperty,
      t = [],
      q = t.pop,
      L = t.push,
      H = t.push,
      O = t.slice,
      P = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      R =
        'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
      M = '[\\x20\\t\\r\\n\\f]',
      I =
        '(?:\\\\[\\da-fA-F]{1,6}' +
        M +
        '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
      W =
        '\\[' +
        M +
        '*(' +
        I +
        ')(?:' +
        M +
        '*([*^$|!~]?=)' +
        M +
        '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
        I +
        '))|)' +
        M +
        '*\\]',
      F =
        ':(' +
        I +
        ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
        W +
        ')*)|.*)\\)|)',
      B = new RegExp(M + '+', 'g'),
      $ = new RegExp('^' + M + '+|((?:^|[^\\\\])(?:\\\\.)*)' + M + '+$', 'g'),
      _ = new RegExp('^' + M + '*,' + M + '*'),
      z = new RegExp('^' + M + '*([>+~]|' + M + ')' + M + '*'),
      U = new RegExp(M + '|>'),
      X = new RegExp(F),
      V = new RegExp('^' + I + '$'),
      G = {
        ID: new RegExp('^#(' + I + ')'),
        CLASS: new RegExp('^\\.(' + I + ')'),
        TAG: new RegExp('^(' + I + '|[*])'),
        ATTR: new RegExp('^' + W),
        PSEUDO: new RegExp('^' + F),
        CHILD: new RegExp(
          '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
            M +
            '*(even|odd|(([+-]|)(\\d*)n|)' +
            M +
            '*(?:([+-]|)' +
            M +
            '*(\\d+)|))' +
            M +
            '*\\)|)',
          'i'
        ),
        bool: new RegExp('^(?:' + R + ')$', 'i'),
        needsContext: new RegExp(
          '^' +
            M +
            '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
            M +
            '*((?:-\\d)?\\d*)' +
            M +
            '*\\)|)(?=[^-]|$)',
          'i'
        ),
      },
      Y = /HTML$/i,
      Q = /^(?:input|select|textarea|button)$/i,
      J = /^h\d$/i,
      K = /^[^{]+\{\s*\[native \w/,
      Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ee = /[+~]/,
      te = new RegExp('\\\\[\\da-fA-F]{1,6}' + M + '?|\\\\([^\\r\\n\\f])', 'g'),
      ne = function (e, t) {
        var n = '0x' + e.slice(1) - 65536;
        return (
          t ||
          (n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
        );
      },
      re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ie = function (e, t) {
        return t
          ? '\0' === e
            ? '\ufffd'
            : e.slice(0, -1) +
              '\\' +
              e.charCodeAt(e.length - 1).toString(16) +
              ' '
          : '\\' + e;
      },
      oe = function () {
        T();
      },
      ae = be(
        function (e) {
          return !0 === e.disabled && 'fieldset' === e.nodeName.toLowerCase();
        },
        { dir: 'parentNode', next: 'legend' }
      );
    try {
      H.apply((t = O.call(p.childNodes)), p.childNodes),
        t[p.childNodes.length].nodeType;
    } catch (e) {
      H = {
        apply: t.length
          ? function (e, t) {
              L.apply(e, O.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            },
      };
    }
    function se(t, e, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = e && e.ownerDocument,
        p = e ? e.nodeType : 9;
      if (
        ((n = n || []),
        'string' != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))
      )
        return n;
      if (!r && (T(e), (e = e || C), E)) {
        if (11 !== p && (u = Z.exec(t)))
          if ((i = u[1])) {
            if (9 === p) {
              if (!(a = e.getElementById(i))) return n;
              if (a.id === i) return n.push(a), n;
            } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i)
              return n.push(a), n;
          } else {
            if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
            if (
              (i = u[3]) &&
              d.getElementsByClassName &&
              e.getElementsByClassName
            )
              return H.apply(n, e.getElementsByClassName(i)), n;
          }
        if (
          d.qsa &&
          !N[t + ' '] &&
          (!v || !v.test(t)) &&
          (1 !== p || 'object' !== e.nodeName.toLowerCase())
        ) {
          if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
            ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) ||
              ((s = e.getAttribute('id'))
                ? (s = s.replace(re, ie))
                : e.setAttribute('id', (s = S))),
              (o = (l = h(t)).length);
            while (o--) l[o] = (s ? '#' + s : ':scope') + ' ' + xe(l[o]);
            c = l.join(',');
          }
          try {
            return H.apply(n, f.querySelectorAll(c)), n;
          } catch (e) {
            N(t, !0);
          } finally {
            s === S && e.removeAttribute('id');
          }
        }
      }
      return g(t.replace($, '$1'), e, n, r);
    }
    function ue() {
      var r = [];
      return function e(t, n) {
        return (
          r.push(t + ' ') > b.cacheLength && delete e[r.shift()],
          (e[t + ' '] = n)
        );
      };
    }
    function le(e) {
      return (e[S] = !0), e;
    }
    function ce(e) {
      var t = C.createElement('fieldset');
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function fe(e, t) {
      var n = e.split('|'),
        r = n.length;
      while (r--) b.attrHandle[n[r]] = t;
    }
    function pe(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function de(t) {
      return function (e) {
        return 'input' === e.nodeName.toLowerCase() && e.type === t;
      };
    }
    function he(n) {
      return function (e) {
        var t = e.nodeName.toLowerCase();
        return ('input' === t || 'button' === t) && e.type === n;
      };
    }
    function ge(t) {
      return function (e) {
        return 'form' in e
          ? e.parentNode && !1 === e.disabled
            ? 'label' in e
              ? 'label' in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
            : e.disabled === t
          : 'label' in e && e.disabled === t;
      };
    }
    function ve(a) {
      return le(function (o) {
        return (
          (o = +o),
          le(function (e, t) {
            var n,
              r = a([], e.length, o),
              i = r.length;
            while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
          })
        );
      });
    }
    function ye(e) {
      return e && 'undefined' != typeof e.getElementsByTagName && e;
    }
    for (e in ((d = se.support = {}),
    (i = se.isXML =
      function (e) {
        var t = e.namespaceURI,
          n = (e.ownerDocument || e).documentElement;
        return !Y.test(t || (n && n.nodeName) || 'HTML');
      }),
    (T = se.setDocument =
      function (e) {
        var t,
          n,
          r = e ? e.ownerDocument || e : p;
        return (
          r != C &&
            9 === r.nodeType &&
            r.documentElement &&
            ((a = (C = r).documentElement),
            (E = !i(C)),
            p != C &&
              (n = C.defaultView) &&
              n.top !== n &&
              (n.addEventListener
                ? n.addEventListener('unload', oe, !1)
                : n.attachEvent && n.attachEvent('onunload', oe)),
            (d.scope = ce(function (e) {
              return (
                a.appendChild(e).appendChild(C.createElement('div')),
                'undefined' != typeof e.querySelectorAll &&
                  !e.querySelectorAll(':scope fieldset div').length
              );
            })),
            (d.attributes = ce(function (e) {
              return (e.className = 'i'), !e.getAttribute('className');
            })),
            (d.getElementsByTagName = ce(function (e) {
              return (
                e.appendChild(C.createComment('')),
                !e.getElementsByTagName('*').length
              );
            })),
            (d.getElementsByClassName = K.test(C.getElementsByClassName)),
            (d.getById = ce(function (e) {
              return (
                (a.appendChild(e).id = S),
                !C.getElementsByName || !C.getElementsByName(S).length
              );
            })),
            d.getById
              ? ((b.filter.ID = function (e) {
                  var t = e.replace(te, ne);
                  return function (e) {
                    return e.getAttribute('id') === t;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if ('undefined' != typeof t.getElementById && E) {
                    var n = t.getElementById(e);
                    return n ? [n] : [];
                  }
                }))
              : ((b.filter.ID = function (e) {
                  var n = e.replace(te, ne);
                  return function (e) {
                    var t =
                      'undefined' != typeof e.getAttributeNode &&
                      e.getAttributeNode('id');
                    return t && t.value === n;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if ('undefined' != typeof t.getElementById && E) {
                    var n,
                      r,
                      i,
                      o = t.getElementById(e);
                    if (o) {
                      if ((n = o.getAttributeNode('id')) && n.value === e)
                        return [o];
                      (i = t.getElementsByName(e)), (r = 0);
                      while ((o = i[r++]))
                        if ((n = o.getAttributeNode('id')) && n.value === e)
                          return [o];
                    }
                    return [];
                  }
                })),
            (b.find.TAG = d.getElementsByTagName
              ? function (e, t) {
                  return 'undefined' != typeof t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : d.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var n,
                    r = [],
                    i = 0,
                    o = t.getElementsByTagName(e);
                  if ('*' === e) {
                    while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                    return r;
                  }
                  return o;
                }),
            (b.find.CLASS =
              d.getElementsByClassName &&
              function (e, t) {
                if ('undefined' != typeof t.getElementsByClassName && E)
                  return t.getElementsByClassName(e);
              }),
            (s = []),
            (v = []),
            (d.qsa = K.test(C.querySelectorAll)) &&
              (ce(function (e) {
                var t;
                (a.appendChild(e).innerHTML =
                  "<a id='" +
                  S +
                  "'></a><select id='" +
                  S +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    v.push('[*^$]=' + M + '*(?:\'\'|"")'),
                  e.querySelectorAll('[selected]').length ||
                    v.push('\\[' + M + '*(?:value|' + R + ')'),
                  e.querySelectorAll('[id~=' + S + '-]').length || v.push('~='),
                  (t = C.createElement('input')).setAttribute('name', ''),
                  e.appendChild(t),
                  e.querySelectorAll("[name='']").length ||
                    v.push('\\[' + M + '*name' + M + '*=' + M + '*(?:\'\'|"")'),
                  e.querySelectorAll(':checked').length || v.push(':checked'),
                  e.querySelectorAll('a#' + S + '+*').length ||
                    v.push('.#.+[+~]'),
                  e.querySelectorAll('\\\f'),
                  v.push('[\\r\\n\\f]');
              }),
              ce(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = C.createElement('input');
                t.setAttribute('type', 'hidden'),
                  e.appendChild(t).setAttribute('name', 'D'),
                  e.querySelectorAll('[name=d]').length &&
                    v.push('name' + M + '*[*^$|!~]?='),
                  2 !== e.querySelectorAll(':enabled').length &&
                    v.push(':enabled', ':disabled'),
                  (a.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(':disabled').length &&
                    v.push(':enabled', ':disabled'),
                  e.querySelectorAll('*,:x'),
                  v.push(',.*:');
              })),
            (d.matchesSelector = K.test(
              (c =
                a.matches ||
                a.webkitMatchesSelector ||
                a.mozMatchesSelector ||
                a.oMatchesSelector ||
                a.msMatchesSelector)
            )) &&
              ce(function (e) {
                (d.disconnectedMatch = c.call(e, '*')),
                  c.call(e, "[s!='']:x"),
                  s.push('!=', F);
              }),
            (v = v.length && new RegExp(v.join('|'))),
            (s = s.length && new RegExp(s.join('|'))),
            (t = K.test(a.compareDocumentPosition)),
            (y =
              t || K.test(a.contains)
                ? function (e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                      r = t && t.parentNode;
                    return (
                      e === r ||
                      !(
                        !r ||
                        1 !== r.nodeType ||
                        !(n.contains
                          ? n.contains(r)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(r))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) while ((t = t.parentNode)) if (t === e) return !0;
                    return !1;
                  }),
            (D = t
              ? function (e, t) {
                  if (e === t) return (l = !0), 0;
                  var n =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    n ||
                    (1 &
                      (n =
                        (e.ownerDocument || e) == (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!d.sortDetached && t.compareDocumentPosition(e) === n)
                      ? e == C || (e.ownerDocument == p && y(p, e))
                        ? -1
                        : t == C || (t.ownerDocument == p && y(p, t))
                        ? 1
                        : u
                        ? P(u, e) - P(u, t)
                        : 0
                      : 4 & n
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (l = !0), 0;
                  var n,
                    r = 0,
                    i = e.parentNode,
                    o = t.parentNode,
                    a = [e],
                    s = [t];
                  if (!i || !o)
                    return e == C
                      ? -1
                      : t == C
                      ? 1
                      : i
                      ? -1
                      : o
                      ? 1
                      : u
                      ? P(u, e) - P(u, t)
                      : 0;
                  if (i === o) return pe(e, t);
                  n = e;
                  while ((n = n.parentNode)) a.unshift(n);
                  n = t;
                  while ((n = n.parentNode)) s.unshift(n);
                  while (a[r] === s[r]) r++;
                  return r
                    ? pe(a[r], s[r])
                    : a[r] == p
                    ? -1
                    : s[r] == p
                    ? 1
                    : 0;
                })),
          C
        );
      }),
    (se.matches = function (e, t) {
      return se(e, null, null, t);
    }),
    (se.matchesSelector = function (e, t) {
      if (
        (T(e),
        d.matchesSelector &&
          E &&
          !N[t + ' '] &&
          (!s || !s.test(t)) &&
          (!v || !v.test(t)))
      )
        try {
          var n = c.call(e, t);
          if (
            n ||
            d.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return n;
        } catch (e) {
          N(t, !0);
        }
      return 0 < se(t, C, null, [e]).length;
    }),
    (se.contains = function (e, t) {
      return (e.ownerDocument || e) != C && T(e), y(e, t);
    }),
    (se.attr = function (e, t) {
      (e.ownerDocument || e) != C && T(e);
      var n = b.attrHandle[t.toLowerCase()],
        r = n && j.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
      return void 0 !== r
        ? r
        : d.attributes || !E
        ? e.getAttribute(t)
        : (r = e.getAttributeNode(t)) && r.specified
        ? r.value
        : null;
    }),
    (se.escape = function (e) {
      return (e + '').replace(re, ie);
    }),
    (se.error = function (e) {
      throw new Error('Syntax error, unrecognized expression: ' + e);
    }),
    (se.uniqueSort = function (e) {
      var t,
        n = [],
        r = 0,
        i = 0;
      if (
        ((l = !d.detectDuplicates),
        (u = !d.sortStable && e.slice(0)),
        e.sort(D),
        l)
      ) {
        while ((t = e[i++])) t === e[i] && (r = n.push(i));
        while (r--) e.splice(n[r], 1);
      }
      return (u = null), e;
    }),
    (o = se.getText =
      function (e) {
        var t,
          n = '',
          r = 0,
          i = e.nodeType;
        if (i) {
          if (1 === i || 9 === i || 11 === i) {
            if ('string' == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
          } else if (3 === i || 4 === i) return e.nodeValue;
        } else while ((t = e[r++])) n += o(t);
        return n;
      }),
    ((b = se.selectors =
      {
        cacheLength: 50,
        createPseudo: le,
        match: G,
        attrHandle: {},
        find: {},
        relative: {
          '>': { dir: 'parentNode', first: !0 },
          ' ': { dir: 'parentNode' },
          '+': { dir: 'previousSibling', first: !0 },
          '~': { dir: 'previousSibling' },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(te, ne)),
              (e[3] = (e[3] || e[4] || e[5] || '').replace(te, ne)),
              '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              'nth' === e[1].slice(0, 3)
                ? (e[3] || se.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ('even' === e[3] || 'odd' === e[3]))),
                  (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                : e[3] && se.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              n = !e[6] && e[2];
            return G.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || '')
                  : n &&
                    X.test(n) &&
                    (t = h(n, !0)) &&
                    (t = n.indexOf(')', n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(te, ne).toLowerCase();
            return '*' === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = m[e + ' '];
            return (
              t ||
              ((t = new RegExp('(^|' + M + ')' + e + '(' + M + '|$)')) &&
                m(e, function (e) {
                  return t.test(
                    ('string' == typeof e.className && e.className) ||
                      ('undefined' != typeof e.getAttribute &&
                        e.getAttribute('class')) ||
                      ''
                  );
                }))
            );
          },
          ATTR: function (n, r, i) {
            return function (e) {
              var t = se.attr(e, n);
              return null == t
                ? '!=' === r
                : !r ||
                    ((t += ''),
                    '=' === r
                      ? t === i
                      : '!=' === r
                      ? t !== i
                      : '^=' === r
                      ? i && 0 === t.indexOf(i)
                      : '*=' === r
                      ? i && -1 < t.indexOf(i)
                      : '$=' === r
                      ? i && t.slice(-i.length) === i
                      : '~=' === r
                      ? -1 < (' ' + t.replace(B, ' ') + ' ').indexOf(i)
                      : '|=' === r &&
                        (t === i || t.slice(0, i.length + 1) === i + '-'));
            };
          },
          CHILD: function (h, e, t, g, v) {
            var y = 'nth' !== h.slice(0, 3),
              m = 'last' !== h.slice(-4),
              x = 'of-type' === e;
            return 1 === g && 0 === v
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (e, t, n) {
                  var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = y !== m ? 'nextSibling' : 'previousSibling',
                    c = e.parentNode,
                    f = x && e.nodeName.toLowerCase(),
                    p = !n && !x,
                    d = !1;
                  if (c) {
                    if (y) {
                      while (l) {
                        a = e;
                        while ((a = a[l]))
                          if (
                            x
                              ? a.nodeName.toLowerCase() === f
                              : 1 === a.nodeType
                          )
                            return !1;
                        u = l = 'only' === h && !u && 'nextSibling';
                      }
                      return !0;
                    }
                    if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                      (d =
                        (s =
                          (r =
                            (i =
                              (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] || [])[0] === k &&
                          r[1]) && r[2]),
                        (a = s && c.childNodes[s]);
                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                        if (1 === a.nodeType && ++d && a === e) {
                          i[h] = [k, s, d];
                          break;
                        }
                    } else if (
                      (p &&
                        (d = s =
                          (r =
                            (i =
                              (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]),
                      !1 === d)
                    )
                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                        if (
                          (x
                            ? a.nodeName.toLowerCase() === f
                            : 1 === a.nodeType) &&
                          ++d &&
                          (p &&
                            ((i =
                              (o = a[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] = [k, d]),
                          a === e)
                        )
                          break;
                    return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                  }
                };
          },
          PSEUDO: function (e, o) {
            var t,
              a =
                b.pseudos[e] ||
                b.setFilters[e.toLowerCase()] ||
                se.error('unsupported pseudo: ' + e);
            return a[S]
              ? a(o)
              : 1 < a.length
              ? ((t = [e, e, '', o]),
                b.setFilters.hasOwnProperty(e.toLowerCase())
                  ? le(function (e, t) {
                      var n,
                        r = a(e, o),
                        i = r.length;
                      while (i--) e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                    })
                  : function (e) {
                      return a(e, 0, t);
                    })
              : a;
          },
        },
        pseudos: {
          not: le(function (e) {
            var r = [],
              i = [],
              s = f(e.replace($, '$1'));
            return s[S]
              ? le(function (e, t, n, r) {
                  var i,
                    o = s(e, null, r, []),
                    a = e.length;
                  while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
                })
              : function (e, t, n) {
                  return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                };
          }),
          has: le(function (t) {
            return function (e) {
              return 0 < se(t, e).length;
            };
          }),
          contains: le(function (t) {
            return (
              (t = t.replace(te, ne)),
              function (e) {
                return -1 < (e.textContent || o(e)).indexOf(t);
              }
            );
          }),
          lang: le(function (n) {
            return (
              V.test(n || '') || se.error('unsupported lang: ' + n),
              (n = n.replace(te, ne).toLowerCase()),
              function (e) {
                var t;
                do {
                  if (
                    (t = E
                      ? e.lang
                      : e.getAttribute('xml:lang') || e.getAttribute('lang'))
                  )
                    return (
                      (t = t.toLowerCase()) === n || 0 === t.indexOf(n + '-')
                    );
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              }
            );
          }),
          target: function (e) {
            var t = n.location && n.location.hash;
            return t && t.slice(1) === e.id;
          },
          root: function (e) {
            return e === a;
          },
          focus: function (e) {
            return (
              e === C.activeElement &&
              (!C.hasFocus || C.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: ge(!1),
          disabled: ge(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ('input' === t && !!e.checked) || ('option' === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !b.pseudos.empty(e);
          },
          header: function (e) {
            return J.test(e.nodeName);
          },
          input: function (e) {
            return Q.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ('input' === t && 'button' === e.type) || 'button' === t;
          },
          text: function (e) {
            var t;
            return (
              'input' === e.nodeName.toLowerCase() &&
              'text' === e.type &&
              (null == (t = e.getAttribute('type')) ||
                'text' === t.toLowerCase())
            );
          },
          first: ve(function () {
            return [0];
          }),
          last: ve(function (e, t) {
            return [t - 1];
          }),
          eq: ve(function (e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: ve(function (e, t) {
            for (var n = 0; n < t; n += 2) e.push(n);
            return e;
          }),
          odd: ve(function (e, t) {
            for (var n = 1; n < t; n += 2) e.push(n);
            return e;
          }),
          lt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
            return e;
          }),
          gt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
            return e;
          }),
        },
      }).pseudos.nth = b.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      b.pseudos[e] = de(e);
    for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e);
    function me() {}
    function xe(e) {
      for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
      return r;
    }
    function be(s, e, t) {
      var u = e.dir,
        l = e.next,
        c = l || u,
        f = t && 'parentNode' === c,
        p = r++;
      return e.first
        ? function (e, t, n) {
            while ((e = e[u])) if (1 === e.nodeType || f) return s(e, t, n);
            return !1;
          }
        : function (e, t, n) {
            var r,
              i,
              o,
              a = [k, p];
            if (n) {
              while ((e = e[u]))
                if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
            } else
              while ((e = e[u]))
                if (1 === e.nodeType || f)
                  if (
                    ((i =
                      (o = e[S] || (e[S] = {}))[e.uniqueID] ||
                      (o[e.uniqueID] = {})),
                    l && l === e.nodeName.toLowerCase())
                  )
                    e = e[u] || e;
                  else {
                    if ((r = i[c]) && r[0] === k && r[1] === p)
                      return (a[2] = r[2]);
                    if (((i[c] = a)[2] = s(e, t, n))) return !0;
                  }
            return !1;
          };
    }
    function we(i) {
      return 1 < i.length
        ? function (e, t, n) {
            var r = i.length;
            while (r--) if (!i[r](e, t, n)) return !1;
            return !0;
          }
        : i[0];
    }
    function Te(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Ce(d, h, g, v, y, e) {
      return (
        v && !v[S] && (v = Ce(v)),
        y && !y[S] && (y = Ce(y, e)),
        le(function (e, t, n, r) {
          var i,
            o,
            a,
            s = [],
            u = [],
            l = t.length,
            c =
              e ||
              (function (e, t, n) {
                for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                return n;
              })(h || '*', n.nodeType ? [n] : n, []),
            f = !d || (!e && h) ? c : Te(c, s, d, n, r),
            p = g ? (y || (e ? d : l || v) ? [] : t) : f;
          if ((g && g(f, p, n, r), v)) {
            (i = Te(p, u)), v(i, [], n, r), (o = i.length);
            while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
          }
          if (e) {
            if (y || d) {
              if (y) {
                (i = []), (o = p.length);
                while (o--) (a = p[o]) && i.push((f[o] = a));
                y(null, (p = []), i, r);
              }
              o = p.length;
              while (o--)
                (a = p[o]) &&
                  -1 < (i = y ? P(e, a) : s[o]) &&
                  (e[i] = !(t[i] = a));
            }
          } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
        })
      );
    }
    function Ee(e) {
      for (
        var i,
          t,
          n,
          r = e.length,
          o = b.relative[e[0].type],
          a = o || b.relative[' '],
          s = o ? 1 : 0,
          u = be(
            function (e) {
              return e === i;
            },
            a,
            !0
          ),
          l = be(
            function (e) {
              return -1 < P(i, e);
            },
            a,
            !0
          ),
          c = [
            function (e, t, n) {
              var r =
                (!o && (n || t !== w)) ||
                ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
              return (i = null), r;
            },
          ];
        s < r;
        s++
      )
        if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
        else {
          if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
            for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
            return Ce(
              1 < s && we(c),
              1 < s &&
                xe(
                  e
                    .slice(0, s - 1)
                    .concat({ value: ' ' === e[s - 2].type ? '*' : '' })
                ).replace($, '$1'),
              t,
              s < n && Ee(e.slice(s, n)),
              n < r && Ee((e = e.slice(n))),
              n < r && xe(e)
            );
          }
          c.push(t);
        }
      return we(c);
    }
    return (
      (me.prototype = b.filters = b.pseudos),
      (b.setFilters = new me()),
      (h = se.tokenize =
        function (e, t) {
          var n,
            r,
            i,
            o,
            a,
            s,
            u,
            l = x[e + ' '];
          if (l) return t ? 0 : l.slice(0);
          (a = e), (s = []), (u = b.preFilter);
          while (a) {
            for (o in ((n && !(r = _.exec(a))) ||
              (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
            (n = !1),
            (r = z.exec(a)) &&
              ((n = r.shift()),
              i.push({ value: n, type: r[0].replace($, ' ') }),
              (a = a.slice(n.length))),
            b.filter))
              !(r = G[o].exec(a)) ||
                (u[o] && !(r = u[o](r))) ||
                ((n = r.shift()),
                i.push({ value: n, type: o, matches: r }),
                (a = a.slice(n.length)));
            if (!n) break;
          }
          return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
        }),
      (f = se.compile =
        function (e, t) {
          var n,
            v,
            y,
            m,
            x,
            r,
            i = [],
            o = [],
            a = A[e + ' '];
          if (!a) {
            t || (t = h(e)), (n = t.length);
            while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
            (a = A(
              e,
              ((v = o),
              (m = 0 < (y = i).length),
              (x = 0 < v.length),
              (r = function (e, t, n, r, i) {
                var o,
                  a,
                  s,
                  u = 0,
                  l = '0',
                  c = e && [],
                  f = [],
                  p = w,
                  d = e || (x && b.find.TAG('*', i)),
                  h = (k += null == p ? 1 : Math.random() || 0.1),
                  g = d.length;
                for (
                  i && (w = t == C || t || i);
                  l !== g && null != (o = d[l]);
                  l++
                ) {
                  if (x && o) {
                    (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                    while ((s = v[a++]))
                      if (s(o, t || C, n)) {
                        r.push(o);
                        break;
                      }
                    i && (k = h);
                  }
                  m && ((o = !s && o) && u--, e && c.push(o));
                }
                if (((u += l), m && l !== u)) {
                  a = 0;
                  while ((s = y[a++])) s(c, f, t, n);
                  if (e) {
                    if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r));
                    f = Te(f);
                  }
                  H.apply(r, f),
                    i &&
                      !e &&
                      0 < f.length &&
                      1 < u + y.length &&
                      se.uniqueSort(r);
                }
                return i && ((k = h), (w = p)), c;
              }),
              m ? le(r) : r)
            )).selector = e;
          }
          return a;
        }),
      (g = se.select =
        function (e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = 'function' == typeof e && e,
            c = !r && h((e = l.selector || e));
          if (((n = n || []), 1 === c.length)) {
            if (
              2 < (o = c[0] = c[0].slice(0)).length &&
              'ID' === (a = o[0]).type &&
              9 === t.nodeType &&
              E &&
              b.relative[o[1].type]
            ) {
              if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0]))
                return n;
              l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
            }
            i = G.needsContext.test(e) ? 0 : o.length;
            while (i--) {
              if (((a = o[i]), b.relative[(s = a.type)])) break;
              if (
                (u = b.find[s]) &&
                (r = u(
                  a.matches[0].replace(te, ne),
                  (ee.test(o[0].type) && ye(t.parentNode)) || t
                ))
              ) {
                if ((o.splice(i, 1), !(e = r.length && xe(o))))
                  return H.apply(n, r), n;
                break;
              }
            }
          }
          return (
            (l || f(e, c))(
              r,
              t,
              !E,
              n,
              !t || (ee.test(e) && ye(t.parentNode)) || t
            ),
            n
          );
        }),
      (d.sortStable = S.split('').sort(D).join('') === S),
      (d.detectDuplicates = !!l),
      T(),
      (d.sortDetached = ce(function (e) {
        return 1 & e.compareDocumentPosition(C.createElement('fieldset'));
      })),
      ce(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          '#' === e.firstChild.getAttribute('href')
        );
      }) ||
        fe('type|href|height|width', function (e, t, n) {
          if (!n) return e.getAttribute(t, 'type' === t.toLowerCase() ? 1 : 2);
        }),
      (d.attributes &&
        ce(function (e) {
          return (
            (e.innerHTML = '<input/>'),
            e.firstChild.setAttribute('value', ''),
            '' === e.firstChild.getAttribute('value')
          );
        })) ||
        fe('value', function (e, t, n) {
          if (!n && 'input' === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ce(function (e) {
        return null == e.getAttribute('disabled');
      }) ||
        fe(R, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      se
    );
  })(C);
  (S.find = d),
    (S.expr = d.selectors),
    (S.expr[':'] = S.expr.pseudos),
    (S.uniqueSort = S.unique = d.uniqueSort),
    (S.text = d.getText),
    (S.isXMLDoc = d.isXML),
    (S.contains = d.contains),
    (S.escapeSelector = d.escape);
  var h = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && S(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    T = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    k = S.expr.match.needsContext;
  function A(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function D(e, n, r) {
    return m(n)
      ? S.grep(e, function (e, t) {
          return !!n.call(e, t, e) !== r;
        })
      : n.nodeType
      ? S.grep(e, function (e) {
          return (e === n) !== r;
        })
      : 'string' != typeof n
      ? S.grep(e, function (e) {
          return -1 < i.call(n, e) !== r;
        })
      : S.filter(n, e, r);
  }
  (S.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ':not(' + e + ')'),
      1 === t.length && 1 === r.nodeType
        ? S.find.matchesSelector(r, e)
          ? [r]
          : []
        : S.find.matches(
            e,
            S.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    S.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ('string' != typeof e)
          return this.pushStack(
            S(e).filter(function () {
              for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
        return 1 < r ? S.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(D(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(D(this, e || [], !0));
      },
      is: function (e) {
        return !!D(this, 'string' == typeof e && k.test(e) ? S(e) : e || [], !1)
          .length;
      },
    });
  var j,
    q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((S.fn.init = function (e, t, n) {
    var r, i;
    if (!e) return this;
    if (((n = n || j), 'string' == typeof e)) {
      if (
        !(r =
          '<' === e[0] && '>' === e[e.length - 1] && 3 <= e.length
            ? [null, e, null]
            : q.exec(e)) ||
        (!r[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (r[1]) {
        if (
          ((t = t instanceof S ? t[0] : t),
          S.merge(
            this,
            S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)
          ),
          N.test(r[1]) && S.isPlainObject(t))
        )
          for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
        return this;
      }
      return (
        (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : m(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(S)
      : S.makeArray(e, this);
  }).prototype = S.fn),
    (j = S(E));
  var L = /^(?:parents|prev(?:Until|All))/,
    H = { children: !0, contents: !0, next: !0, prev: !0 };
  function O(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  S.fn.extend({
    has: function (e) {
      var t = S(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = 'string' != typeof e && S(e);
      if (!k.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a
                ? -1 < a.index(n)
                : 1 === n.nodeType && S.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? 'string' == typeof e
          ? i.call(S(e), this[0])
          : i.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    S.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return h(e, 'parentNode');
        },
        parentsUntil: function (e, t, n) {
          return h(e, 'parentNode', n);
        },
        next: function (e) {
          return O(e, 'nextSibling');
        },
        prev: function (e) {
          return O(e, 'previousSibling');
        },
        nextAll: function (e) {
          return h(e, 'nextSibling');
        },
        prevAll: function (e) {
          return h(e, 'previousSibling');
        },
        nextUntil: function (e, t, n) {
          return h(e, 'nextSibling', n);
        },
        prevUntil: function (e, t, n) {
          return h(e, 'previousSibling', n);
        },
        siblings: function (e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return T(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && r(e.contentDocument)
            ? e.contentDocument
            : (A(e, 'template') && (e = e.content || e),
              S.merge([], e.childNodes));
        },
      },
      function (r, i) {
        S.fn[r] = function (e, t) {
          var n = S.map(this, i, e);
          return (
            'Until' !== r.slice(-5) && (t = e),
            t && 'string' == typeof t && (n = S.filter(t, n)),
            1 < this.length &&
              (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()),
            this.pushStack(n)
          );
        };
      }
    );
  var P = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    return e;
  }
  function M(e) {
    throw e;
  }
  function I(e, t, n, r) {
    var i;
    try {
      e && m((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && m((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  (S.Callbacks = function (r) {
    var e, n;
    r =
      'string' == typeof r
        ? ((e = r),
          (n = {}),
          S.each(e.match(P) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : S.extend({}, r);
    var i,
      t,
      o,
      a,
      s = [],
      u = [],
      l = -1,
      c = function () {
        for (a = a || r.once, o = i = !0; u.length; l = -1) {
          t = u.shift();
          while (++l < s.length)
            !1 === s[l].apply(t[0], t[1]) &&
              r.stopOnFalse &&
              ((l = s.length), (t = !1));
        }
        r.memory || (t = !1), (i = !1), a && (s = t ? [] : '');
      },
      f = {
        add: function () {
          return (
            s &&
              (t && !i && ((l = s.length - 1), u.push(t)),
              (function n(e) {
                S.each(e, function (e, t) {
                  m(t)
                    ? (r.unique && f.has(t)) || s.push(t)
                    : t && t.length && 'string' !== w(t) && n(t);
                });
              })(arguments),
              t && !i && c()),
            this
          );
        },
        remove: function () {
          return (
            S.each(arguments, function (e, t) {
              var n;
              while (-1 < (n = S.inArray(t, s, n)))
                s.splice(n, 1), n <= l && l--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < S.inArray(e, s) : 0 < s.length;
        },
        empty: function () {
          return s && (s = []), this;
        },
        disable: function () {
          return (a = u = []), (s = t = ''), this;
        },
        disabled: function () {
          return !s;
        },
        lock: function () {
          return (a = u = []), t || i || (s = t = ''), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              u.push(t),
              i || c()),
            this
          );
        },
        fire: function () {
          return f.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!o;
        },
      };
    return f;
  }),
    S.extend({
      Deferred: function (e) {
        var o = [
            [
              'notify',
              'progress',
              S.Callbacks('memory'),
              S.Callbacks('memory'),
              2,
            ],
            [
              'resolve',
              'done',
              S.Callbacks('once memory'),
              S.Callbacks('once memory'),
              0,
              'resolved',
            ],
            [
              'reject',
              'fail',
              S.Callbacks('once memory'),
              S.Callbacks('once memory'),
              1,
              'rejected',
            ],
          ],
          i = 'pending',
          a = {
            state: function () {
              return i;
            },
            always: function () {
              return s.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return a.then(null, e);
            },
            pipe: function () {
              var i = arguments;
              return S.Deferred(function (r) {
                S.each(o, function (e, t) {
                  var n = m(i[t[4]]) && i[t[4]];
                  s[t[1]](function () {
                    var e = n && n.apply(this, arguments);
                    e && m(e.promise)
                      ? e
                          .promise()
                          .progress(r.notify)
                          .done(r.resolve)
                          .fail(r.reject)
                      : r[t[0] + 'With'](this, n ? [e] : arguments);
                  });
                }),
                  (i = null);
              }).promise();
            },
            then: function (t, n, r) {
              var u = 0;
              function l(i, o, a, s) {
                return function () {
                  var n = this,
                    r = arguments,
                    e = function () {
                      var e, t;
                      if (!(i < u)) {
                        if ((e = a.apply(n, r)) === o.promise())
                          throw new TypeError('Thenable self-resolution');
                        (t =
                          e &&
                          ('object' == typeof e || 'function' == typeof e) &&
                          e.then),
                          m(t)
                            ? s
                              ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                              : (u++,
                                t.call(
                                  e,
                                  l(u, o, R, s),
                                  l(u, o, M, s),
                                  l(u, o, R, o.notifyWith)
                                ))
                            : (a !== R && ((n = void 0), (r = [e])),
                              (s || o.resolveWith)(n, r));
                      }
                    },
                    t = s
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            S.Deferred.exceptionHook &&
                              S.Deferred.exceptionHook(e, t.stackTrace),
                              u <= i + 1 &&
                                (a !== M && ((n = void 0), (r = [e])),
                                o.rejectWith(n, r));
                          }
                        };
                  i
                    ? t()
                    : (S.Deferred.getStackHook &&
                        (t.stackTrace = S.Deferred.getStackHook()),
                      C.setTimeout(t));
                };
              }
              return S.Deferred(function (e) {
                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)),
                  o[1][3].add(l(0, e, m(t) ? t : R)),
                  o[2][3].add(l(0, e, m(n) ? n : M));
              }).promise();
            },
            promise: function (e) {
              return null != e ? S.extend(e, a) : a;
            },
          },
          s = {};
        return (
          S.each(o, function (e, t) {
            var n = t[2],
              r = t[5];
            (a[t[1]] = n.add),
              r &&
                n.add(
                  function () {
                    i = r;
                  },
                  o[3 - e][2].disable,
                  o[3 - e][3].disable,
                  o[0][2].lock,
                  o[0][3].lock
                ),
              n.add(t[3].fire),
              (s[t[0]] = function () {
                return (
                  s[t[0] + 'With'](this === s ? void 0 : this, arguments), this
                );
              }),
              (s[t[0] + 'With'] = n.fireWith);
          }),
          a.promise(s),
          e && e.call(s, s),
          s
        );
      },
      when: function (e) {
        var n = arguments.length,
          t = n,
          r = Array(t),
          i = s.call(arguments),
          o = S.Deferred(),
          a = function (t) {
            return function (e) {
              (r[t] = this),
                (i[t] = 1 < arguments.length ? s.call(arguments) : e),
                --n || o.resolveWith(r, i);
            };
          };
        if (
          n <= 1 &&
          (I(e, o.done(a(t)).resolve, o.reject, !n),
          'pending' === o.state() || m(i[t] && i[t].then))
        )
          return o.then();
        while (t--) I(i[t], a(t), o.reject);
        return o.promise();
      },
    });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (S.Deferred.exceptionHook = function (e, t) {
    C.console &&
      C.console.warn &&
      e &&
      W.test(e.name) &&
      C.console.warn('jQuery.Deferred exception: ' + e.message, e.stack, t);
  }),
    (S.readyException = function (e) {
      C.setTimeout(function () {
        throw e;
      });
    });
  var F = S.Deferred();
  function B() {
    E.removeEventListener('DOMContentLoaded', B),
      C.removeEventListener('load', B),
      S.ready();
  }
  (S.fn.ready = function (e) {
    return (
      F.then(e)['catch'](function (e) {
        S.readyException(e);
      }),
      this
    );
  }),
    S.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --S.readyWait : S.isReady) ||
          ((S.isReady = !0) !== e && 0 < --S.readyWait) ||
          F.resolveWith(E, [S]);
      },
    }),
    (S.ready.then = F.then),
    'complete' === E.readyState ||
    ('loading' !== E.readyState && !E.documentElement.doScroll)
      ? C.setTimeout(S.ready)
      : (E.addEventListener('DOMContentLoaded', B),
        C.addEventListener('load', B));
  var $ = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ('object' === w(n))
        for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
      else if (
        void 0 !== r &&
        ((i = !0),
        m(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(S(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    _ = /^-ms-/,
    z = /-([a-z])/g;
  function U(e, t) {
    return t.toUpperCase();
  }
  function X(e) {
    return e.replace(_, 'ms-').replace(z, U);
  }
  var V = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function G() {
    this.expando = S.expando + G.uid++;
  }
  (G.uid = 1),
    (G.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            V(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ('string' == typeof t) i[X(t)] = n;
        else for (r in t) i[X(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][X(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && 'string' == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(X)
              : (t = X(t)) in r
              ? [t]
              : t.match(P) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || S.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !S.isEmptyObject(t);
      },
    });
  var Y = new G(),
    Q = new G(),
    J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    K = /[A-Z]/g;
  function Z(e, t, n) {
    var r, i;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = 'data-' + t.replace(K, '-$&').toLowerCase()),
        'string' == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n =
            'true' === (i = n) ||
            ('false' !== i &&
              ('null' === i
                ? null
                : i === +i + ''
                ? +i
                : J.test(i)
                ? JSON.parse(i)
                : i));
        } catch (e) {}
        Q.set(e, t, n);
      } else n = void 0;
    return n;
  }
  S.extend({
    hasData: function (e) {
      return Q.hasData(e) || Y.hasData(e);
    },
    data: function (e, t, n) {
      return Q.access(e, t, n);
    },
    removeData: function (e, t) {
      Q.remove(e, t);
    },
    _data: function (e, t, n) {
      return Y.access(e, t, n);
    },
    _removeData: function (e, t) {
      Y.remove(e, t);
    },
  }),
    S.fn.extend({
      data: function (n, e) {
        var t,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === n) {
          if (
            this.length &&
            ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, 'hasDataAttrs'))
          ) {
            t = a.length;
            while (t--)
              a[t] &&
                0 === (r = a[t].name).indexOf('data-') &&
                ((r = X(r.slice(5))), Z(o, r, i[r]));
            Y.set(o, 'hasDataAttrs', !0);
          }
          return i;
        }
        return 'object' == typeof n
          ? this.each(function () {
              Q.set(this, n);
            })
          : $(
              this,
              function (e) {
                var t;
                if (o && void 0 === e)
                  return void 0 !== (t = Q.get(o, n))
                    ? t
                    : void 0 !== (t = Z(o, n))
                    ? t
                    : void 0;
                this.each(function () {
                  Q.set(this, n, e);
                });
              },
              null,
              e,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          Q.remove(this, e);
        });
      },
    }),
    S.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || 'fx') + 'queue'),
            (r = Y.get(e, t)),
            n &&
              (!r || Array.isArray(n)
                ? (r = Y.access(e, t, S.makeArray(n)))
                : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || 'fx';
        var n = S.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = S._queueHooks(e, t);
        'inprogress' === i && ((i = n.shift()), r--),
          i &&
            ('fx' === t && n.unshift('inprogress'),
            delete o.stop,
            i.call(
              e,
              function () {
                S.dequeue(e, t);
              },
              o
            )),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + 'queueHooks';
        return (
          Y.get(e, n) ||
          Y.access(e, n, {
            empty: S.Callbacks('once memory').add(function () {
              Y.remove(e, [t + 'queue', n]);
            }),
          })
        );
      },
    }),
    S.fn.extend({
      queue: function (t, n) {
        var e = 2;
        return (
          'string' != typeof t && ((n = t), (t = 'fx'), e--),
          arguments.length < e
            ? S.queue(this[0], t)
            : void 0 === n
            ? this
            : this.each(function () {
                var e = S.queue(this, t, n);
                S._queueHooks(this, t),
                  'fx' === t && 'inprogress' !== e[0] && S.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          S.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || 'fx', []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = S.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        'string' != typeof e && ((t = e), (e = void 0)), (e = e || 'fx');
        while (a--)
          (n = Y.get(o[a], e + 'queueHooks')) &&
            n.empty &&
            (r++, n.empty.add(s));
        return s(), i.promise(t);
      },
    });
  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    te = new RegExp('^(?:([+-])=|)(' + ee + ')([a-z%]*)$', 'i'),
    ne = ['Top', 'Right', 'Bottom', 'Left'],
    re = E.documentElement,
    ie = function (e) {
      return S.contains(e.ownerDocument, e);
    },
    oe = { composed: !0 };
  re.getRootNode &&
    (ie = function (e) {
      return (
        S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument
      );
    });
  var ae = function (e, t) {
    return (
      'none' === (e = t || e).style.display ||
      ('' === e.style.display && ie(e) && 'none' === S.css(e, 'display'))
    );
  };
  function se(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return S.css(e, t, '');
          },
      u = s(),
      l = (n && n[3]) || (S.cssNumber[t] ? '' : 'px'),
      c =
        e.nodeType &&
        (S.cssNumber[t] || ('px' !== l && +u)) &&
        te.exec(S.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        S.style(e, t, c + l),
          (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
          (c /= o);
      (c *= 2), S.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var ue = {};
  function le(e, t) {
    for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
      (r = e[c]).style &&
        ((n = r.style.display),
        t
          ? ('none' === n &&
              ((l[c] = Y.get(r, 'display') || null),
              l[c] || (r.style.display = '')),
            '' === r.style.display &&
              ae(r) &&
              (l[c] =
                ((u = a = o = void 0),
                (a = (i = r).ownerDocument),
                (s = i.nodeName),
                (u = ue[s]) ||
                  ((o = a.body.appendChild(a.createElement(s))),
                  (u = S.css(o, 'display')),
                  o.parentNode.removeChild(o),
                  'none' === u && (u = 'block'),
                  (ue[s] = u)))))
          : 'none' !== n && ((l[c] = 'none'), Y.set(r, 'display', n)));
    for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
    return e;
  }
  S.fn.extend({
    show: function () {
      return le(this, !0);
    },
    hide: function () {
      return le(this);
    },
    toggle: function (e) {
      return 'boolean' == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? S(this).show() : S(this).hide();
          });
    },
  });
  var ce,
    fe,
    pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i;
  (ce = E.createDocumentFragment().appendChild(E.createElement('div'))),
    (fe = E.createElement('input')).setAttribute('type', 'radio'),
    fe.setAttribute('checked', 'checked'),
    fe.setAttribute('name', 't'),
    ce.appendChild(fe),
    (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (ce.innerHTML = '<textarea>x</textarea>'),
    (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
    (ce.innerHTML = '<option></option>'),
    (y.option = !!ce.lastChild);
  var ge = {
    thead: [1, '<table>', '</table>'],
    col: [2, '<table><colgroup>', '</colgroup></table>'],
    tr: [2, '<table><tbody>', '</tbody></table>'],
    td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
    _default: [0, '', ''],
  };
  function ve(e, t) {
    var n;
    return (
      (n =
        'undefined' != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || '*')
          : 'undefined' != typeof e.querySelectorAll
          ? e.querySelectorAll(t || '*')
          : []),
      void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n
    );
  }
  function ye(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      Y.set(e[n], 'globalEval', !t || Y.get(t[n], 'globalEval'));
  }
  (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td),
    y.option ||
      (ge.optgroup = ge.option =
        [1, "<select multiple='multiple'>", '</select>']);
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o,
        a,
        s,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        d = 0,
        h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ('object' === w(o)) S.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement('div'))),
            (s = (de.exec(o) || ['', ''])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          S.merge(p, a.childNodes), ((a = f.firstChild).textContent = '');
        } else p.push(t.createTextNode(o));
    (f.textContent = ''), (d = 0);
    while ((o = p[d++]))
      if (r && -1 < S.inArray(o, r)) i && i.push(o);
      else if (
        ((l = ie(o)), (a = ve(f.appendChild(o), 'script')), l && ye(a), n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || '') && n.push(o);
      }
    return f;
  }
  var be = /^key/,
    we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Te = /^([^.]*)(?:\.(.+)|)/;
  function Ce() {
    return !0;
  }
  function Ee() {
    return !1;
  }
  function Se(e, t) {
    return (
      (e ===
        (function () {
          try {
            return E.activeElement;
          } catch (e) {}
        })()) ==
      ('focus' === t)
    );
  }
  function ke(e, t, n, r, i, o) {
    var a, s;
    if ('object' == typeof t) {
      for (s in ('string' != typeof n && ((r = r || n), (n = void 0)), t))
        ke(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ('string' == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = Ee;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return S().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = S.guid++))),
      e.each(function () {
        S.event.add(this, t, i, r, n);
      })
    );
  }
  function Ae(e, i, o) {
    o
      ? (Y.set(e, i, !1),
        S.event.add(e, i, {
          namespace: !1,
          handler: function (e) {
            var t,
              n,
              r = Y.get(this, i);
            if (1 & e.isTrigger && this[i]) {
              if (r.length)
                (S.event.special[i] || {}).delegateType && e.stopPropagation();
              else if (
                ((r = s.call(arguments)),
                Y.set(this, i, r),
                (t = o(this, i)),
                this[i](),
                r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}),
                r !== n)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), n.value
                );
            } else
              r.length &&
                (Y.set(this, i, {
                  value: S.event.trigger(
                    S.extend(r[0], S.Event.prototype),
                    r.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === Y.get(e, i) && S.event.add(e, i, Ce);
  }
  (S.event = {
    global: {},
    add: function (t, e, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.get(t);
      if (V(t)) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && S.find.matchesSelector(re, i),
          n.guid || (n.guid = S.guid++),
          (u = v.events) || (u = v.events = Object.create(null)),
          (a = v.handle) ||
            (a = v.handle =
              function (e) {
                return 'undefined' != typeof S && S.event.triggered !== e.type
                  ? S.event.dispatch.apply(t, arguments)
                  : void 0;
              }),
          (l = (e = (e || '').match(P) || ['']).length);
        while (l--)
          (d = g = (s = Te.exec(e[l]) || [])[1]),
            (h = (s[2] || '').split('.').sort()),
            d &&
              ((f = S.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = S.event.special[d] || {}),
              (c = S.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && S.expr.match.needsContext.test(i),
                  namespace: h.join('.'),
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(t, r, h, a)) ||
                  (t.addEventListener && t.addEventListener(d, a))),
              f.add &&
                (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (S.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.hasData(e) && Y.get(e);
      if (v && (u = v.events)) {
        l = (t = (t || '').match(P) || ['']).length;
        while (l--)
          if (
            ((d = g = (s = Te.exec(t[l]) || [])[1]),
            (h = (s[2] || '').split('.').sort()),
            d)
          ) {
            (f = S.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s =
                s[2] &&
                new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)')),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) ||
                S.removeEvent(e, d, v.handle),
              delete u[d]);
          } else for (d in u) S.event.remove(e, d + t[l], n, r, !0);
        S.isEmptyObject(u) && Y.remove(e, 'handle events');
      }
    },
    dispatch: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s = new Array(arguments.length),
        u = S.event.fix(e),
        l = (Y.get(this, 'events') || Object.create(null))[u.type] || [],
        c = S.event.special[u.type] || {};
      for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
      if (
        ((u.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, u))
      ) {
        (a = S.event.handlers.call(this, u, l)), (t = 0);
        while ((i = a[t++]) && !u.isPropagationStopped()) {
          (u.currentTarget = i.elem), (n = 0);
          while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
            (u.rnamespace &&
              !1 !== o.namespace &&
              !u.rnamespace.test(o.namespace)) ||
              ((u.handleObj = o),
              (u.data = o.data),
              void 0 !==
                (r = (
                  (S.event.special[o.origType] || {}).handle || o.handler
                ).apply(i.elem, s)) &&
                !1 === (u.result = r) &&
                (u.preventDefault(), u.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, u), u.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !('click' === e.type && 1 <= e.button))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ('click' !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + ' ')] &&
                (a[i] = r.needsContext
                  ? -1 < S(i, this).index(l)
                  : S.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({ elem: l, handlers: o });
          }
      return (
        (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(S.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: m(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[S.expando] ? e : new S.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, 'input') && Ae(t, 'click', Ce),
            !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, 'input') && Ae(t, 'click'), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (pe.test(t.type) &&
              t.click &&
              A(t, 'input') &&
              Y.get(t, 'click')) ||
            A(t, 'a')
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (S.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (S.Event = function (e, t) {
      if (!(this instanceof S.Event)) return new S.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ce
              : Ee),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && S.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[S.expando] = !0);
    }),
    (S.Event.prototype = {
      constructor: S.Event,
      isDefaultPrevented: Ee,
      isPropagationStopped: Ee,
      isImmediatePropagationStopped: Ee,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ce),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ce),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ce),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    S.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && be.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && we.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      S.event.addProp
    ),
    S.each({ focus: 'focusin', blur: 'focusout' }, function (e, t) {
      S.event.special[e] = {
        setup: function () {
          return Ae(this, e, Se), !1;
        },
        trigger: function () {
          return Ae(this, e), !0;
        },
        delegateType: t,
      };
    }),
    S.each(
      {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        pointerenter: 'pointerover',
        pointerleave: 'pointerout',
      },
      function (e, i) {
        S.event.special[e] = {
          delegateType: i,
          bindType: i,
          handle: function (e) {
            var t,
              n = e.relatedTarget,
              r = e.handleObj;
            return (
              (n && (n === this || S.contains(this, n))) ||
                ((e.type = r.origType),
                (t = r.handler.apply(this, arguments)),
                (e.type = i)),
              t
            );
          },
        };
      }
    ),
    S.fn.extend({
      on: function (e, t, n, r) {
        return ke(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return ke(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            S(e.delegateTarget).off(
              r.namespace ? r.origType + '.' + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ('object' == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = Ee),
          this.each(function () {
            S.event.remove(this, e, n, t);
          })
        );
      },
    });
  var Ne = /<script|<style|<link/i,
    De = /checked\s*(?:[^=]|=\s*.checked.)/i,
    je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function qe(e, t) {
    return (
      (A(e, 'table') &&
        A(11 !== t.nodeType ? t : t.firstChild, 'tr') &&
        S(e).children('tbody')[0]) ||
      e
    );
  }
  function Le(e) {
    return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
  }
  function He(e) {
    return (
      'true/' === (e.type || '').slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute('type'),
      e
    );
  }
  function Oe(e, t) {
    var n, r, i, o, a, s;
    if (1 === t.nodeType) {
      if (Y.hasData(e) && (s = Y.get(e).events))
        for (i in (Y.remove(t, 'handle events'), s))
          for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
      Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
    }
  }
  function Pe(n, r, i, o) {
    r = g(r);
    var e,
      t,
      a,
      s,
      u,
      l,
      c = 0,
      f = n.length,
      p = f - 1,
      d = r[0],
      h = m(d);
    if (h || (1 < f && 'string' == typeof d && !y.checkClone && De.test(d)))
      return n.each(function (e) {
        var t = n.eq(e);
        h && (r[0] = d.call(this, e, t.html())), Pe(t, r, i, o);
      });
    if (
      f &&
      ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || o)
    ) {
      for (s = (a = S.map(ve(e, 'script'), Le)).length; c < f; c++)
        (u = e),
          c !== p &&
            ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, 'script'))),
          i.call(n[c], u, c);
      if (s)
        for (l = a[a.length - 1].ownerDocument, S.map(a, He), c = 0; c < s; c++)
          (u = a[c]),
            he.test(u.type || '') &&
              !Y.access(u, 'globalEval') &&
              S.contains(l, u) &&
              (u.src && 'module' !== (u.type || '').toLowerCase()
                ? S._evalUrl &&
                  !u.noModule &&
                  S._evalUrl(
                    u.src,
                    { nonce: u.nonce || u.getAttribute('nonce') },
                    l
                  )
                : b(u.textContent.replace(je, ''), u, l));
    }
    return n;
  }
  function Re(e, t, n) {
    for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || S.cleanData(ve(r)),
        r.parentNode &&
          (n && ie(r) && ye(ve(r, 'script')), r.parentNode.removeChild(r));
    return e;
  }
  S.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c = e.cloneNode(!0),
        f = ie(e);
      if (
        !(
          y.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          S.isXMLDoc(e)
        )
      )
        for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)
          (s = o[r]),
            (u = a[r]),
            void 0,
            'input' === (l = u.nodeName.toLowerCase()) && pe.test(s.type)
              ? (u.checked = s.checked)
              : ('input' !== l && 'textarea' !== l) ||
                (u.defaultValue = s.defaultValue);
      if (t)
        if (n)
          for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++)
            Oe(o[r], a[r]);
        else Oe(e, c);
      return (
        0 < (a = ve(c, 'script')).length && ye(a, !f && ve(e, 'script')), c
      );
    },
    cleanData: function (e) {
      for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (V(n)) {
          if ((t = n[Y.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
            n[Y.expando] = void 0;
          }
          n[Q.expando] && (n[Q.expando] = void 0);
        }
    },
  }),
    S.fn.extend({
      detach: function (e) {
        return Re(this, e, !0);
      },
      remove: function (e) {
        return Re(this, e);
      },
      text: function (e) {
        return $(
          this,
          function (e) {
            return void 0 === e
              ? S.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Pe(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            qe(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Pe(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = qe(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Pe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Pe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ''));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return S.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return $(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              'string' == typeof e &&
              !Ne.test(e) &&
              !ge[(de.exec(e) || ['', ''])[1].toLowerCase()]
            ) {
              e = S.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return Pe(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            S.inArray(this, n) < 0 &&
              (S.cleanData(ve(this)), t && t.replaceChild(e, this));
          },
          n
        );
      },
    }),
    S.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith',
      },
      function (e, a) {
        S.fn[e] = function (e) {
          for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++)
            (t = o === i ? this : this.clone(!0)),
              S(r[o])[a](t),
              u.apply(n, t.get());
          return this.pushStack(n);
        };
      }
    );
  var Me = new RegExp('^(' + ee + ')(?!px)[a-z%]+$', 'i'),
    Ie = function (e) {
      var t = e.ownerDocument.defaultView;
      return (t && t.opener) || (t = C), t.getComputedStyle(e);
    },
    We = function (e, t, n) {
      var r,
        i,
        o = {};
      for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
      for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
      return r;
    },
    Fe = new RegExp(ne.join('|'), 'i');
  function Be(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || Ie(e)) &&
        ('' !== (a = n.getPropertyValue(t) || n[t]) ||
          ie(e) ||
          (a = S.style(e, t)),
        !y.pixelBoxStyles() &&
          Me.test(a) &&
          Fe.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + '' : a
    );
  }
  function $e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  !(function () {
    function e() {
      if (l) {
        (u.style.cssText =
          'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
          (l.style.cssText =
            'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
          re.appendChild(u).appendChild(l);
        var e = C.getComputedStyle(l);
        (n = '1%' !== e.top),
          (s = 12 === t(e.marginLeft)),
          (l.style.right = '60%'),
          (o = 36 === t(e.right)),
          (r = 36 === t(e.width)),
          (l.style.position = 'absolute'),
          (i = 12 === t(l.offsetWidth / 3)),
          re.removeChild(u),
          (l = null);
      }
    }
    function t(e) {
      return Math.round(parseFloat(e));
    }
    var n,
      r,
      i,
      o,
      a,
      s,
      u = E.createElement('div'),
      l = E.createElement('div');
    l.style &&
      ((l.style.backgroundClip = 'content-box'),
      (l.cloneNode(!0).style.backgroundClip = ''),
      (y.clearCloneStyle = 'content-box' === l.style.backgroundClip),
      S.extend(y, {
        boxSizingReliable: function () {
          return e(), r;
        },
        pixelBoxStyles: function () {
          return e(), o;
        },
        pixelPosition: function () {
          return e(), n;
        },
        reliableMarginLeft: function () {
          return e(), s;
        },
        scrollboxSize: function () {
          return e(), i;
        },
        reliableTrDimensions: function () {
          var e, t, n, r;
          return (
            null == a &&
              ((e = E.createElement('table')),
              (t = E.createElement('tr')),
              (n = E.createElement('div')),
              (e.style.cssText = 'position:absolute;left:-11111px'),
              (t.style.height = '1px'),
              (n.style.height = '9px'),
              re.appendChild(e).appendChild(t).appendChild(n),
              (r = C.getComputedStyle(t)),
              (a = 3 < parseInt(r.height)),
              re.removeChild(e)),
            a
          );
        },
      }));
  })();
  var _e = ['Webkit', 'Moz', 'ms'],
    ze = E.createElement('div').style,
    Ue = {};
  function Xe(e) {
    var t = S.cssProps[e] || Ue[e];
    return (
      t ||
      (e in ze
        ? e
        : (Ue[e] =
            (function (e) {
              var t = e[0].toUpperCase() + e.slice(1),
                n = _e.length;
              while (n--) if ((e = _e[n] + t) in ze) return e;
            })(e) || e))
    );
  }
  var Ve = /^(none|table(?!-c[ea]).+)/,
    Ge = /^--/,
    Ye = { position: 'absolute', visibility: 'hidden', display: 'block' },
    Qe = { letterSpacing: '0', fontWeight: '400' };
  function Je(e, t, n) {
    var r = te.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
  }
  function Ke(e, t, n, r, i, o) {
    var a = 'width' === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? 'border' : 'content')) return 0;
    for (; a < 4; a += 2)
      'margin' === n && (u += S.css(e, n + ne[a], !0, i)),
        r
          ? ('content' === n && (u -= S.css(e, 'padding' + ne[a], !0, i)),
            'margin' !== n &&
              (u -= S.css(e, 'border' + ne[a] + 'Width', !0, i)))
          : ((u += S.css(e, 'padding' + ne[a], !0, i)),
            'padding' !== n
              ? (u += S.css(e, 'border' + ne[a] + 'Width', !0, i))
              : (s += S.css(e, 'border' + ne[a] + 'Width', !0, i)));
    return (
      !r &&
        0 <= o &&
        (u +=
          Math.max(
            0,
            Math.ceil(
              e['offset' + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5
            )
          ) || 0),
      u
    );
  }
  function Ze(e, t, n) {
    var r = Ie(e),
      i =
        (!y.boxSizingReliable() || n) &&
        'border-box' === S.css(e, 'boxSizing', !1, r),
      o = i,
      a = Be(e, t, r),
      s = 'offset' + t[0].toUpperCase() + t.slice(1);
    if (Me.test(a)) {
      if (!n) return a;
      a = 'auto';
    }
    return (
      ((!y.boxSizingReliable() && i) ||
        (!y.reliableTrDimensions() && A(e, 'tr')) ||
        'auto' === a ||
        (!parseFloat(a) && 'inline' === S.css(e, 'display', !1, r))) &&
        e.getClientRects().length &&
        ((i = 'border-box' === S.css(e, 'boxSizing', !1, r)),
        (o = s in e) && (a = e[s])),
      (a = parseFloat(a) || 0) +
        Ke(e, t, n || (i ? 'border' : 'content'), o, r, a) +
        'px'
    );
  }
  function et(e, t, n, r, i) {
    return new et.prototype.init(e, t, n, r, i);
  }
  S.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Be(e, 'opacity');
            return '' === n ? '1' : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = X(t),
          u = Ge.test(t),
          l = e.style;
        if (
          (u || (t = Xe(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n)
        )
          return a && 'get' in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        'string' === (o = typeof n) &&
          (i = te.exec(n)) &&
          i[1] &&
          ((n = se(e, t, i)), (o = 'number')),
          null != n &&
            n == n &&
            ('number' !== o ||
              u ||
              (n += (i && i[3]) || (S.cssNumber[s] ? '' : 'px')),
            y.clearCloneStyle ||
              '' !== n ||
              0 !== t.indexOf('background') ||
              (l[t] = 'inherit'),
            (a && 'set' in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = X(t);
      return (
        Ge.test(t) || (t = Xe(s)),
        (a = S.cssHooks[t] || S.cssHooks[s]) &&
          'get' in a &&
          (i = a.get(e, !0, n)),
        void 0 === i && (i = Be(e, t, r)),
        'normal' === i && t in Qe && (i = Qe[t]),
        '' === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    },
  }),
    S.each(['height', 'width'], function (e, u) {
      S.cssHooks[u] = {
        get: function (e, t, n) {
          if (t)
            return !Ve.test(S.css(e, 'display')) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? Ze(e, u, n)
              : We(e, Ye, function () {
                  return Ze(e, u, n);
                });
        },
        set: function (e, t, n) {
          var r,
            i = Ie(e),
            o = !y.scrollboxSize() && 'absolute' === i.position,
            a = (o || n) && 'border-box' === S.css(e, 'boxSizing', !1, i),
            s = n ? Ke(e, u, n, a, i) : 0;
          return (
            a &&
              o &&
              (s -= Math.ceil(
                e['offset' + u[0].toUpperCase() + u.slice(1)] -
                  parseFloat(i[u]) -
                  Ke(e, u, 'border', !1, i) -
                  0.5
              )),
            s &&
              (r = te.exec(t)) &&
              'px' !== (r[3] || 'px') &&
              ((e.style[u] = t), (t = S.css(e, u))),
            Je(0, t, s)
          );
        },
      };
    }),
    (S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Be(e, 'marginLeft')) ||
            e.getBoundingClientRect().left -
              We(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + 'px'
        );
    })),
    S.each({ margin: '', padding: '', border: 'Width' }, function (i, o) {
      (S.cssHooks[i + o] = {
        expand: function (e) {
          for (
            var t = 0, n = {}, r = 'string' == typeof e ? e.split(' ') : [e];
            t < 4;
            t++
          )
            n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
          return n;
        },
      }),
        'margin' !== i && (S.cssHooks[i + o].set = Je);
    }),
    S.fn.extend({
      css: function (e, t) {
        return $(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = Ie(e), i = t.length; a < i; a++)
                o[t[a]] = S.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((S.Tween = et).prototype = {
      constructor: et,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || S.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (S.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var e = et.propHooks[this.prop];
        return e && e.get ? e.get(this) : et.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = et.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                S.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : et.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = et.prototype),
    ((et.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = S.css(e.elem, e.prop, '')) && 'auto' !== t
            ? t
            : 0;
        },
        set: function (e) {
          S.fx.step[e.prop]
            ? S.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!S.cssHooks[e.prop] && null == e.elem.style[Xe(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : S.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = et.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (S.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: 'swing',
    }),
    (S.fx = et.prototype.init),
    (S.fx.step = {});
  var tt,
    nt,
    rt,
    it,
    ot = /^(?:toggle|show|hide)$/,
    at = /queueHooks$/;
  function st() {
    nt &&
      (!1 === E.hidden && C.requestAnimationFrame
        ? C.requestAnimationFrame(st)
        : C.setTimeout(st, S.fx.interval),
      S.fx.tick());
  }
  function ut() {
    return (
      C.setTimeout(function () {
        tt = void 0;
      }),
      (tt = Date.now())
    );
  }
  function lt(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; r < 4; r += 2 - t)
      i['margin' + (n = ne[r])] = i['padding' + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function ct(e, t, n) {
    for (
      var r,
        i = (ft.tweeners[t] || []).concat(ft.tweeners['*']),
        o = 0,
        a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ft(o, e, t) {
    var n,
      a,
      r = 0,
      i = ft.prefilters.length,
      s = S.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (a) return !1;
        for (
          var e = tt || ut(),
            t = Math.max(0, l.startTime + l.duration - e),
            n = 1 - (t / l.duration || 0),
            r = 0,
            i = l.tweens.length;
          r < i;
          r++
        )
          l.tweens[r].run(n);
        return (
          s.notifyWith(o, [l, n, t]),
          n < 1 && i
            ? t
            : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1)
        );
      },
      l = s.promise({
        elem: o,
        props: S.extend({}, e),
        opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
        originalProperties: e,
        originalOptions: t,
        startTime: tt || ut(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          var n = S.Tween(
            o,
            l.opts,
            e,
            t,
            l.opts.specialEasing[e] || l.opts.easing
          );
          return l.tweens.push(n), n;
        },
        stop: function (e) {
          var t = 0,
            n = e ? l.tweens.length : 0;
          if (a) return this;
          for (a = !0; t < n; t++) l.tweens[t].run(1);
          return (
            e
              ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e]))
              : s.rejectWith(o, [l, e]),
            this
          );
        },
      }),
      c = l.props;
    for (
      !(function (e, t) {
        var n, r, i, o, a;
        for (n in e)
          if (
            ((i = t[(r = X(n))]),
            (o = e[n]),
            Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
            n !== r && ((e[r] = o), delete e[n]),
            (a = S.cssHooks[r]) && ('expand' in a))
          )
            for (n in ((o = a.expand(o)), delete e[r], o))
              (n in e) || ((e[n] = o[n]), (t[n] = i));
          else t[r] = i;
      })(c, l.opts.specialEasing);
      r < i;
      r++
    )
      if ((n = ft.prefilters[r].call(l, o, c, l.opts)))
        return (
          m(n.stop) &&
            (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)),
          n
        );
    return (
      S.map(c, ct, l),
      m(l.opts.start) && l.opts.start.call(o, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
      l
    );
  }
  (S.Animation = S.extend(ft, {
    tweeners: {
      '*': [
        function (e, t) {
          var n = this.createTween(e, t);
          return se(n.elem, e, te.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      m(e) ? ((t = e), (e = ['*'])) : (e = e.match(P));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]),
          (ft.tweeners[n] = ft.tweeners[n] || []),
          ft.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = 'width' in t || 'height' in t,
          p = this,
          d = {},
          h = e.style,
          g = e.nodeType && ae(e),
          v = Y.get(e, 'fxshow');
        for (r in (n.queue ||
          (null == (a = S._queueHooks(e, 'fx')).unqueued &&
            ((a.unqueued = 0),
            (s = a.empty.fire),
            (a.empty.fire = function () {
              a.unqueued || s();
            })),
          a.unqueued++,
          p.always(function () {
            p.always(function () {
              a.unqueued--, S.queue(e, 'fx').length || a.empty.fire();
            });
          })),
        t))
          if (((i = t[r]), ot.test(i))) {
            if (
              (delete t[r],
              (o = o || 'toggle' === i),
              i === (g ? 'hide' : 'show'))
            ) {
              if ('show' !== i || !v || void 0 === v[r]) continue;
              g = !0;
            }
            d[r] = (v && v[r]) || S.style(e, r);
          }
        if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
          for (r in (f &&
            1 === e.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (l = v && v.display) && (l = Y.get(e, 'display')),
            'none' === (c = S.css(e, 'display')) &&
              (l
                ? (c = l)
                : (le([e], !0),
                  (l = e.style.display || l),
                  (c = S.css(e, 'display')),
                  le([e]))),
            ('inline' === c || ('inline-block' === c && null != l)) &&
              'none' === S.css(e, 'float') &&
              (u ||
                (p.done(function () {
                  h.display = l;
                }),
                null == l && ((c = h.display), (l = 'none' === c ? '' : c))),
              (h.display = 'inline-block'))),
          n.overflow &&
            ((h.overflow = 'hidden'),
            p.always(function () {
              (h.overflow = n.overflow[0]),
                (h.overflowX = n.overflow[1]),
                (h.overflowY = n.overflow[2]);
            })),
          (u = !1),
          d))
            u ||
              (v
                ? 'hidden' in v && (g = v.hidden)
                : (v = Y.access(e, 'fxshow', { display: l })),
              o && (v.hidden = !g),
              g && le([e], !0),
              p.done(function () {
                for (r in (g || le([e]), Y.remove(e, 'fxshow'), d))
                  S.style(e, r, d[r]);
              })),
              (u = ct(g ? v[r] : 0, r, p)),
              r in v ||
                ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
    },
  })),
    (S.speed = function (e, t, n) {
      var r =
        e && 'object' == typeof e
          ? S.extend({}, e)
          : {
              complete: n || (!n && t) || (m(e) && e),
              duration: e,
              easing: (n && t) || (t && !m(t) && t),
            };
      return (
        S.fx.off
          ? (r.duration = 0)
          : 'number' != typeof r.duration &&
            (r.duration in S.fx.speeds
              ? (r.duration = S.fx.speeds[r.duration])
              : (r.duration = S.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
        (r.old = r.complete),
        (r.complete = function () {
          m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
        }),
        r
      );
    }),
    S.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae)
          .css('opacity', 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function (t, e, n, r) {
        var i = S.isEmptyObject(t),
          o = S.speed(e, n, r),
          a = function () {
            var e = ft(this, S.extend({}, t), o);
            (i || Y.get(this, 'finish')) && e.stop(!0);
          };
        return (
          (a.finish = a),
          i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        );
      },
      stop: function (i, e, o) {
        var a = function (e) {
          var t = e.stop;
          delete e.stop, t(o);
        };
        return (
          'string' != typeof i && ((o = e), (e = i), (i = void 0)),
          e && this.queue(i || 'fx', []),
          this.each(function () {
            var e = !0,
              t = null != i && i + 'queueHooks',
              n = S.timers,
              r = Y.get(this);
            if (t) r[t] && r[t].stop && a(r[t]);
            else for (t in r) r[t] && r[t].stop && at.test(t) && a(r[t]);
            for (t = n.length; t--; )
              n[t].elem !== this ||
                (null != i && n[t].queue !== i) ||
                (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
            (!e && o) || S.dequeue(this, i);
          })
        );
      },
      finish: function (a) {
        return (
          !1 !== a && (a = a || 'fx'),
          this.each(function () {
            var e,
              t = Y.get(this),
              n = t[a + 'queue'],
              r = t[a + 'queueHooks'],
              i = S.timers,
              o = n ? n.length : 0;
            for (
              t.finish = !0,
                S.queue(this, a, []),
                r && r.stop && r.stop.call(this, !0),
                e = i.length;
              e--;

            )
              i[e].elem === this &&
                i[e].queue === a &&
                (i[e].anim.stop(!0), i.splice(e, 1));
            for (e = 0; e < o; e++)
              n[e] && n[e].finish && n[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    S.each(['toggle', 'show', 'hide'], function (e, r) {
      var i = S.fn[r];
      S.fn[r] = function (e, t, n) {
        return null == e || 'boolean' == typeof e
          ? i.apply(this, arguments)
          : this.animate(lt(r, !0), e, t, n);
      };
    }),
    S.each(
      {
        slideDown: lt('show'),
        slideUp: lt('hide'),
        slideToggle: lt('toggle'),
        fadeIn: { opacity: 'show' },
        fadeOut: { opacity: 'hide' },
        fadeToggle: { opacity: 'toggle' },
      },
      function (e, r) {
        S.fn[e] = function (e, t, n) {
          return this.animate(r, e, t, n);
        };
      }
    ),
    (S.timers = []),
    (S.fx.tick = function () {
      var e,
        t = 0,
        n = S.timers;
      for (tt = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || S.fx.stop(), (tt = void 0);
    }),
    (S.fx.timer = function (e) {
      S.timers.push(e), S.fx.start();
    }),
    (S.fx.interval = 13),
    (S.fx.start = function () {
      nt || ((nt = !0), st());
    }),
    (S.fx.stop = function () {
      nt = null;
    }),
    (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (S.fn.delay = function (r, e) {
      return (
        (r = (S.fx && S.fx.speeds[r]) || r),
        (e = e || 'fx'),
        this.queue(e, function (e, t) {
          var n = C.setTimeout(e, r);
          t.stop = function () {
            C.clearTimeout(n);
          };
        })
      );
    }),
    (rt = E.createElement('input')),
    (it = E.createElement('select').appendChild(E.createElement('option'))),
    (rt.type = 'checkbox'),
    (y.checkOn = '' !== rt.value),
    (y.optSelected = it.selected),
    ((rt = E.createElement('input')).value = 't'),
    (rt.type = 'radio'),
    (y.radioValue = 't' === rt.value);
  var pt,
    dt = S.expr.attrHandle;
  S.fn.extend({
    attr: function (e, t) {
      return $(this, S.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        S.removeAttr(this, e);
      });
    },
  }),
    S.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return 'undefined' == typeof e.getAttribute
            ? S.prop(e, t, n)
            : ((1 === o && S.isXMLDoc(e)) ||
                (i =
                  S.attrHooks[t.toLowerCase()] ||
                  (S.expr.match.bool.test(t) ? pt : void 0)),
              void 0 !== n
                ? null === n
                  ? void S.removeAttr(e, t)
                  : i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ''), n)
                : i && 'get' in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = S.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!y.radioValue && 'radio' === t && A(e, 'input')) {
              var n = e.value;
              return e.setAttribute('type', t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(P);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      },
    }),
    (pt = {
      set: function (e, t, n) {
        return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var a = dt[t] || S.find.attr;
      dt[t] = function (e, t, n) {
        var r,
          i,
          o = t.toLowerCase();
        return (
          n ||
            ((i = dt[o]),
            (dt[o] = r),
            (r = null != a(e, t, n) ? o : null),
            (dt[o] = i)),
          r
        );
      };
    });
  var ht = /^(?:input|select|textarea|button)$/i,
    gt = /^(?:a|area)$/i;
  function vt(e) {
    return (e.match(P) || []).join(' ');
  }
  function yt(e) {
    return (e.getAttribute && e.getAttribute('class')) || '';
  }
  function mt(e) {
    return Array.isArray(e) ? e : ('string' == typeof e && e.match(P)) || [];
  }
  S.fn.extend({
    prop: function (e, t) {
      return $(this, S.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[S.propFix[e] || e];
      });
    },
  }),
    S.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && S.isXMLDoc(e)) ||
              ((t = S.propFix[t] || t), (i = S.propHooks[t])),
            void 0 !== n
              ? i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && 'get' in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = S.find.attr(e, 'tabindex');
            return t
              ? parseInt(t, 10)
              : ht.test(e.nodeName) || (gt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: 'htmlFor', class: 'className' },
    }),
    y.optSelected ||
      (S.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    S.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable',
      ],
      function () {
        S.propFix[this.toLowerCase()] = this;
      }
    ),
    S.fn.extend({
      addClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).addClass(t.call(this, e, yt(this)));
          });
        if ((e = mt(t)).length)
          while ((n = this[u++]))
            if (((i = yt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
              a = 0;
              while ((o = e[a++]))
                r.indexOf(' ' + o + ' ') < 0 && (r += o + ' ');
              i !== (s = vt(r)) && n.setAttribute('class', s);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).removeClass(t.call(this, e, yt(this)));
          });
        if (!arguments.length) return this.attr('class', '');
        if ((e = mt(t)).length)
          while ((n = this[u++]))
            if (((i = yt(n)), (r = 1 === n.nodeType && ' ' + vt(i) + ' '))) {
              a = 0;
              while ((o = e[a++]))
                while (-1 < r.indexOf(' ' + o + ' '))
                  r = r.replace(' ' + o + ' ', ' ');
              i !== (s = vt(r)) && n.setAttribute('class', s);
            }
        return this;
      },
      toggleClass: function (i, t) {
        var o = typeof i,
          a = 'string' === o || Array.isArray(i);
        return 'boolean' == typeof t && a
          ? t
            ? this.addClass(i)
            : this.removeClass(i)
          : m(i)
          ? this.each(function (e) {
              S(this).toggleClass(i.call(this, e, yt(this), t), t);
            })
          : this.each(function () {
              var e, t, n, r;
              if (a) {
                (t = 0), (n = S(this)), (r = mt(i));
                while ((e = r[t++]))
                  n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
              } else (void 0 !== i && 'boolean' !== o) || ((e = yt(this)) && Y.set(this, '__className__', e), this.setAttribute && this.setAttribute('class', e || !1 === i ? '' : Y.get(this, '__className__') || ''));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          r = 0;
        t = ' ' + e + ' ';
        while ((n = this[r++]))
          if (1 === n.nodeType && -1 < (' ' + vt(yt(n)) + ' ').indexOf(t))
            return !0;
        return !1;
      },
    });
  var xt = /\r/g;
  S.fn.extend({
    val: function (n) {
      var r,
        e,
        i,
        t = this[0];
      return arguments.length
        ? ((i = m(n)),
          this.each(function (e) {
            var t;
            1 === this.nodeType &&
              (null == (t = i ? n.call(this, e, S(this).val()) : n)
                ? (t = '')
                : 'number' == typeof t
                ? (t += '')
                : Array.isArray(t) &&
                  (t = S.map(t, function (e) {
                    return null == e ? '' : e + '';
                  })),
              ((r =
                S.valHooks[this.type] ||
                S.valHooks[this.nodeName.toLowerCase()]) &&
                'set' in r &&
                void 0 !== r.set(this, t, 'value')) ||
                (this.value = t));
          }))
        : t
        ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) &&
          'get' in r &&
          void 0 !== (e = r.get(t, 'value'))
          ? e
          : 'string' == typeof (e = t.value)
          ? e.replace(xt, '')
          : null == e
          ? ''
          : e
        : void 0;
    },
  }),
    S.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = S.find.attr(e, 'value');
            return null != t ? t : vt(S.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = 'select-one' === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !A(n.parentNode, 'optgroup'))
              ) {
                if (((t = S(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = S.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected =
                -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    S.each(['radio', 'checkbox'], function () {
      (S.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < S.inArray(S(e).val(), t));
        },
      }),
        y.checkOn ||
          (S.valHooks[this].get = function (e) {
            return null === e.getAttribute('value') ? 'on' : e.value;
          });
    }),
    (y.focusin = 'onfocusin' in C);
  var bt = /^(?:focusinfocus|focusoutblur)$/,
    wt = function (e) {
      e.stopPropagation();
    };
  S.extend(S.event, {
    trigger: function (e, t, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = [n || E],
        d = v.call(e, 'type') ? e.type : e,
        h = v.call(e, 'namespace') ? e.namespace.split('.') : [];
      if (
        ((o = f = a = n = n || E),
        3 !== n.nodeType &&
          8 !== n.nodeType &&
          !bt.test(d + S.event.triggered) &&
          (-1 < d.indexOf('.') && ((d = (h = d.split('.')).shift()), h.sort()),
          (u = d.indexOf(':') < 0 && 'on' + d),
          ((e = e[S.expando]
            ? e
            : new S.Event(d, 'object' == typeof e && e)).isTrigger = r ? 2 : 3),
          (e.namespace = h.join('.')),
          (e.rnamespace = e.namespace
            ? new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)')
            : null),
          (e.result = void 0),
          e.target || (e.target = n),
          (t = null == t ? [e] : S.makeArray(t, [e])),
          (c = S.event.special[d] || {}),
          r || !c.trigger || !1 !== c.trigger.apply(n, t)))
      ) {
        if (!r && !c.noBubble && !x(n)) {
          for (
            s = c.delegateType || d, bt.test(s + d) || (o = o.parentNode);
            o;
            o = o.parentNode
          )
            p.push(o), (a = o);
          a === (n.ownerDocument || E) &&
            p.push(a.defaultView || a.parentWindow || C);
        }
        i = 0;
        while ((o = p[i++]) && !e.isPropagationStopped())
          (f = o),
            (e.type = 1 < i ? s : c.bindType || d),
            (l =
              (Y.get(o, 'events') || Object.create(null))[e.type] &&
              Y.get(o, 'handle')) && l.apply(o, t),
            (l = u && o[u]) &&
              l.apply &&
              V(o) &&
              ((e.result = l.apply(o, t)),
              !1 === e.result && e.preventDefault());
        return (
          (e.type = d),
          r ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(p.pop(), t)) ||
            !V(n) ||
            (u &&
              m(n[d]) &&
              !x(n) &&
              ((a = n[u]) && (n[u] = null),
              (S.event.triggered = d),
              e.isPropagationStopped() && f.addEventListener(d, wt),
              n[d](),
              e.isPropagationStopped() && f.removeEventListener(d, wt),
              (S.event.triggered = void 0),
              a && (n[u] = a))),
          e.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
      S.event.trigger(r, null, t);
    },
  }),
    S.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          S.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return S.event.trigger(e, t, n, !0);
      },
    }),
    y.focusin ||
      S.each({ focus: 'focusin', blur: 'focusout' }, function (n, r) {
        var i = function (e) {
          S.event.simulate(r, e.target, S.event.fix(e));
        };
        S.event.special[r] = {
          setup: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r);
            t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r) - 1;
            t
              ? Y.access(e, r, t)
              : (e.removeEventListener(n, i, !0), Y.remove(e, r));
          },
        };
      });
  var Tt = C.location,
    Ct = { guid: Date.now() },
    Et = /\?/;
  S.parseXML = function (e) {
    var t;
    if (!e || 'string' != typeof e) return null;
    try {
      t = new C.DOMParser().parseFromString(e, 'text/xml');
    } catch (e) {
      t = void 0;
    }
    return (
      (t && !t.getElementsByTagName('parsererror').length) ||
        S.error('Invalid XML: ' + e),
      t
    );
  };
  var St = /\[\]$/,
    kt = /\r?\n/g,
    At = /^(?:submit|button|image|reset|file)$/i,
    Nt = /^(?:input|select|textarea|keygen)/i;
  function Dt(n, e, r, i) {
    var t;
    if (Array.isArray(e))
      S.each(e, function (e, t) {
        r || St.test(n)
          ? i(n, t)
          : Dt(
              n + '[' + ('object' == typeof t && null != t ? e : '') + ']',
              t,
              r,
              i
            );
      });
    else if (r || 'object' !== w(e)) i(n, e);
    else for (t in e) Dt(n + '[' + t + ']', e[t], r, i);
  }
  (S.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = m(t) ? t() : t;
        r[r.length] =
          encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
      };
    if (null == e) return '';
    if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
      S.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) Dt(n, e[n], t, i);
    return r.join('&');
  }),
    S.fn.extend({
      serialize: function () {
        return S.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = S.prop(this, 'elements');
          return e ? S.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !S(this).is(':disabled') &&
              Nt.test(this.nodeName) &&
              !At.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = S(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? S.map(n, function (e) {
                  return { name: t.name, value: e.replace(kt, '\r\n') };
                })
              : { name: t.name, value: n.replace(kt, '\r\n') };
          })
          .get();
      },
    });
  var jt = /%20/g,
    qt = /#.*$/,
    Lt = /([?&])_=[^&]*/,
    Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Ot = /^(?:GET|HEAD)$/,
    Pt = /^\/\//,
    Rt = {},
    Mt = {},
    It = '*/'.concat('*'),
    Wt = E.createElement('a');
  function Ft(o) {
    return function (e, t) {
      'string' != typeof e && ((t = e), (e = '*'));
      var n,
        r = 0,
        i = e.toLowerCase().match(P) || [];
      if (m(t))
        while ((n = i[r++]))
          '+' === n[0]
            ? ((n = n.slice(1) || '*'), (o[n] = o[n] || []).unshift(t))
            : (o[n] = o[n] || []).push(t);
    };
  }
  function Bt(t, i, o, a) {
    var s = {},
      u = t === Mt;
    function l(e) {
      var r;
      return (
        (s[e] = !0),
        S.each(t[e] || [], function (e, t) {
          var n = t(i, o, a);
          return 'string' != typeof n || u || s[n]
            ? u
              ? !(r = n)
              : void 0
            : (i.dataTypes.unshift(n), l(n), !1);
        }),
        r
      );
    }
    return l(i.dataTypes[0]) || (!s['*'] && l('*'));
  }
  function $t(e, t) {
    var n,
      r,
      i = S.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && S.extend(!0, e, r), e;
  }
  (Wt.href = Tt.href),
    S.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Tt.href,
        type: 'GET',
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            Tt.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        accepts: {
          '*': It,
          text: 'text/plain',
          html: 'text/html',
          xml: 'application/xml, text/xml',
          json: 'application/json, text/javascript',
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: 'responseXML',
          text: 'responseText',
          json: 'responseJSON',
        },
        converters: {
          '* text': String,
          'text html': !0,
          'text json': JSON.parse,
          'text xml': S.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? $t($t(e, S.ajaxSettings), t) : $t(S.ajaxSettings, e);
      },
      ajaxPrefilter: Ft(Rt),
      ajaxTransport: Ft(Mt),
      ajax: function (e, t) {
        'object' == typeof e && ((t = e), (e = void 0)), (t = t || {});
        var c,
          f,
          p,
          n,
          d,
          r,
          h,
          g,
          i,
          o,
          v = S.ajaxSetup({}, t),
          y = v.context || v,
          m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
          x = S.Deferred(),
          b = S.Callbacks('once memory'),
          w = v.statusCode || {},
          a = {},
          s = {},
          u = 'canceled',
          T = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (h) {
                if (!n) {
                  n = {};
                  while ((t = Ht.exec(p)))
                    n[t[1].toLowerCase() + ' '] = (
                      n[t[1].toLowerCase() + ' '] || []
                    ).concat(t[2]);
                }
                t = n[e.toLowerCase() + ' '];
              }
              return null == t ? null : t.join(', ');
            },
            getAllResponseHeaders: function () {
              return h ? p : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == h &&
                  ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e),
                  (a[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == h && (v.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (h) T.always(e[T.status]);
                else for (t in e) w[t] = [w[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || u;
              return c && c.abort(t), l(0, t), this;
            },
          };
        if (
          (x.promise(T),
          (v.url = ((e || v.url || Tt.href) + '').replace(
            Pt,
            Tt.protocol + '//'
          )),
          (v.type = t.method || t.type || v.method || v.type),
          (v.dataTypes = (v.dataType || '*').toLowerCase().match(P) || ['']),
          null == v.crossDomain)
        ) {
          r = E.createElement('a');
          try {
            (r.href = v.url),
              (r.href = r.href),
              (v.crossDomain =
                Wt.protocol + '//' + Wt.host != r.protocol + '//' + r.host);
          } catch (e) {
            v.crossDomain = !0;
          }
        }
        if (
          (v.data &&
            v.processData &&
            'string' != typeof v.data &&
            (v.data = S.param(v.data, v.traditional)),
          Bt(Rt, v, t, T),
          h)
        )
          return T;
        for (i in ((g = S.event && v.global) &&
          0 == S.active++ &&
          S.event.trigger('ajaxStart'),
        (v.type = v.type.toUpperCase()),
        (v.hasContent = !Ot.test(v.type)),
        (f = v.url.replace(qt, '')),
        v.hasContent
          ? v.data &&
            v.processData &&
            0 ===
              (v.contentType || '').indexOf(
                'application/x-www-form-urlencoded'
              ) &&
            (v.data = v.data.replace(jt, '+'))
          : ((o = v.url.slice(f.length)),
            v.data &&
              (v.processData || 'string' == typeof v.data) &&
              ((f += (Et.test(f) ? '&' : '?') + v.data), delete v.data),
            !1 === v.cache &&
              ((f = f.replace(Lt, '$1')),
              (o = (Et.test(f) ? '&' : '?') + '_=' + Ct.guid++ + o)),
            (v.url = f + o)),
        v.ifModified &&
          (S.lastModified[f] &&
            T.setRequestHeader('If-Modified-Since', S.lastModified[f]),
          S.etag[f] && T.setRequestHeader('If-None-Match', S.etag[f])),
        ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
          T.setRequestHeader('Content-Type', v.contentType),
        T.setRequestHeader(
          'Accept',
          v.dataTypes[0] && v.accepts[v.dataTypes[0]]
            ? v.accepts[v.dataTypes[0]] +
                ('*' !== v.dataTypes[0] ? ', ' + It + '; q=0.01' : '')
            : v.accepts['*']
        ),
        v.headers))
          T.setRequestHeader(i, v.headers[i]);
        if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h))
          return T.abort();
        if (
          ((u = 'abort'),
          b.add(v.complete),
          T.done(v.success),
          T.fail(v.error),
          (c = Bt(Mt, v, t, T)))
        ) {
          if (((T.readyState = 1), g && m.trigger('ajaxSend', [T, v]), h))
            return T;
          v.async &&
            0 < v.timeout &&
            (d = C.setTimeout(function () {
              T.abort('timeout');
            }, v.timeout));
          try {
            (h = !1), c.send(a, l);
          } catch (e) {
            if (h) throw e;
            l(-1, e);
          }
        } else l(-1, 'No Transport');
        function l(e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = t;
          h ||
            ((h = !0),
            d && C.clearTimeout(d),
            (c = void 0),
            (p = r || ''),
            (T.readyState = 0 < e ? 4 : 0),
            (i = (200 <= e && e < 300) || 304 === e),
            n &&
              (s = (function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s = e.contents,
                  u = e.dataTypes;
                while ('*' === u[0])
                  u.shift(),
                    void 0 === r &&
                      (r = e.mimeType || t.getResponseHeader('Content-Type'));
                if (r)
                  for (i in s)
                    if (s[i] && s[i].test(r)) {
                      u.unshift(i);
                      break;
                    }
                if (u[0] in n) o = u[0];
                else {
                  for (i in n) {
                    if (!u[0] || e.converters[i + ' ' + u[0]]) {
                      o = i;
                      break;
                    }
                    a || (a = i);
                  }
                  o = o || a;
                }
                if (o) return o !== u[0] && u.unshift(o), n[o];
              })(v, T, n)),
            !i &&
              -1 < S.inArray('script', v.dataTypes) &&
              (v.converters['text script'] = function () {}),
            (s = (function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                u,
                l = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
              o = c.shift();
              while (o)
                if (
                  (e.responseFields[o] && (n[e.responseFields[o]] = t),
                  !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (u = o),
                  (o = c.shift()))
                )
                  if ('*' === o) o = u;
                  else if ('*' !== u && u !== o) {
                    if (!(a = l[u + ' ' + o] || l['* ' + o]))
                      for (i in l)
                        if (
                          (s = i.split(' '))[1] === o &&
                          (a = l[u + ' ' + s[0]] || l['* ' + s[0]])
                        ) {
                          !0 === a
                            ? (a = l[i])
                            : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                          break;
                        }
                    if (!0 !== a)
                      if (a && e['throws']) t = a(t);
                      else
                        try {
                          t = a(t);
                        } catch (e) {
                          return {
                            state: 'parsererror',
                            error: a
                              ? e
                              : 'No conversion from ' + u + ' to ' + o,
                          };
                        }
                  }
              return { state: 'success', data: t };
            })(v, s, T, i)),
            i
              ? (v.ifModified &&
                  ((u = T.getResponseHeader('Last-Modified')) &&
                    (S.lastModified[f] = u),
                  (u = T.getResponseHeader('etag')) && (S.etag[f] = u)),
                204 === e || 'HEAD' === v.type
                  ? (l = 'nocontent')
                  : 304 === e
                  ? (l = 'notmodified')
                  : ((l = s.state), (o = s.data), (i = !(a = s.error))))
              : ((a = l), (!e && l) || ((l = 'error'), e < 0 && (e = 0))),
            (T.status = e),
            (T.statusText = (t || l) + ''),
            i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
            T.statusCode(w),
            (w = void 0),
            g && m.trigger(i ? 'ajaxSuccess' : 'ajaxError', [T, v, i ? o : a]),
            b.fireWith(y, [T, l]),
            g &&
              (m.trigger('ajaxComplete', [T, v]),
              --S.active || S.event.trigger('ajaxStop')));
        }
        return T;
      },
      getJSON: function (e, t, n) {
        return S.get(e, t, n, 'json');
      },
      getScript: function (e, t) {
        return S.get(e, void 0, t, 'script');
      },
    }),
    S.each(['get', 'post'], function (e, i) {
      S[i] = function (e, t, n, r) {
        return (
          m(t) && ((r = r || n), (n = t), (t = void 0)),
          S.ajax(
            S.extend(
              { url: e, type: i, dataType: r, data: t, success: n },
              S.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    S.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        'content-type' === t.toLowerCase() &&
          (e.contentType = e.headers[t] || '');
    }),
    (S._evalUrl = function (e, t, n) {
      return S.ajax({
        url: e,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        converters: { 'text script': function () {} },
        dataFilter: function (e) {
          S.globalEval(e, t, n);
        },
      });
    }),
    S.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (m(e) && (e = e.call(this[0])),
            (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return m(n)
          ? this.each(function (e) {
              S(this).wrapInner(n.call(this, e));
            })
          : this.each(function () {
              var e = S(this),
                t = e.contents();
              t.length ? t.wrapAll(n) : e.append(n);
            });
      },
      wrap: function (t) {
        var n = m(t);
        return this.each(function (e) {
          S(this).wrapAll(n ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not('body')
            .each(function () {
              S(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (S.expr.pseudos.hidden = function (e) {
      return !S.expr.pseudos.visible(e);
    }),
    (S.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (S.ajaxSettings.xhr = function () {
      try {
        return new C.XMLHttpRequest();
      } catch (e) {}
    });
  var _t = { 0: 200, 1223: 204 },
    zt = S.ajaxSettings.xhr();
  (y.cors = !!zt && 'withCredentials' in zt),
    (y.ajax = zt = !!zt),
    S.ajaxTransport(function (i) {
      var o, a;
      if (y.cors || (zt && !i.crossDomain))
        return {
          send: function (e, t) {
            var n,
              r = i.xhr();
            if (
              (r.open(i.type, i.url, i.async, i.username, i.password),
              i.xhrFields)
            )
              for (n in i.xhrFields) r[n] = i.xhrFields[n];
            for (n in (i.mimeType &&
              r.overrideMimeType &&
              r.overrideMimeType(i.mimeType),
            i.crossDomain ||
              e['X-Requested-With'] ||
              (e['X-Requested-With'] = 'XMLHttpRequest'),
            e))
              r.setRequestHeader(n, e[n]);
            (o = function (e) {
              return function () {
                o &&
                  ((o =
                    a =
                    r.onload =
                    r.onerror =
                    r.onabort =
                    r.ontimeout =
                    r.onreadystatechange =
                      null),
                  'abort' === e
                    ? r.abort()
                    : 'error' === e
                    ? 'number' != typeof r.status
                      ? t(0, 'error')
                      : t(r.status, r.statusText)
                    : t(
                        _t[r.status] || r.status,
                        r.statusText,
                        'text' !== (r.responseType || 'text') ||
                          'string' != typeof r.responseText
                          ? { binary: r.response }
                          : { text: r.responseText },
                        r.getAllResponseHeaders()
                      ));
              };
            }),
              (r.onload = o()),
              (a = r.onerror = r.ontimeout = o('error')),
              void 0 !== r.onabort
                ? (r.onabort = a)
                : (r.onreadystatechange = function () {
                    4 === r.readyState &&
                      C.setTimeout(function () {
                        o && a();
                      });
                  }),
              (o = o('abort'));
            try {
              r.send((i.hasContent && i.data) || null);
            } catch (e) {
              if (o) throw e;
            }
          },
          abort: function () {
            o && o();
          },
        };
    }),
    S.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    S.ajaxSetup({
      accepts: {
        script:
          'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        'text script': function (e) {
          return S.globalEval(e), e;
        },
      },
    }),
    S.ajaxPrefilter('script', function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
    }),
    S.ajaxTransport('script', function (n) {
      var r, i;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (e, t) {
            (r = S('<script>')
              .attr(n.scriptAttrs || {})
              .prop({ charset: n.scriptCharset, src: n.url })
              .on(
                'load error',
                (i = function (e) {
                  r.remove(),
                    (i = null),
                    e && t('error' === e.type ? 404 : 200, e.type);
                })
              )),
              E.head.appendChild(r[0]);
          },
          abort: function () {
            i && i();
          },
        };
    });
  var Ut,
    Xt = [],
    Vt = /(=)\?(?=&|$)|\?\?/;
  S.ajaxSetup({
    jsonp: 'callback',
    jsonpCallback: function () {
      var e = Xt.pop() || S.expando + '_' + Ct.guid++;
      return (this[e] = !0), e;
    },
  }),
    S.ajaxPrefilter('json jsonp', function (e, t, n) {
      var r,
        i,
        o,
        a =
          !1 !== e.jsonp &&
          (Vt.test(e.url)
            ? 'url'
            : 'string' == typeof e.data &&
              0 ===
                (e.contentType || '').indexOf(
                  'application/x-www-form-urlencoded'
                ) &&
              Vt.test(e.data) &&
              'data');
      if (a || 'jsonp' === e.dataTypes[0])
        return (
          (r = e.jsonpCallback =
            m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
          a
            ? (e[a] = e[a].replace(Vt, '$1' + r))
            : !1 !== e.jsonp &&
              (e.url += (Et.test(e.url) ? '&' : '?') + e.jsonp + '=' + r),
          (e.converters['script json'] = function () {
            return o || S.error(r + ' was not called'), o[0];
          }),
          (e.dataTypes[0] = 'json'),
          (i = C[r]),
          (C[r] = function () {
            o = arguments;
          }),
          n.always(function () {
            void 0 === i ? S(C).removeProp(r) : (C[r] = i),
              e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
              o && m(i) && i(o[0]),
              (o = i = void 0);
          }),
          'script'
        );
    }),
    (y.createHTMLDocument =
      (((Ut = E.implementation.createHTMLDocument('').body).innerHTML =
        '<form></form><form></form>'),
      2 === Ut.childNodes.length)),
    (S.parseHTML = function (e, t, n) {
      return 'string' != typeof e
        ? []
        : ('boolean' == typeof t && ((n = t), (t = !1)),
          t ||
            (y.createHTMLDocument
              ? (((r = (t =
                  E.implementation.createHTMLDocument('')).createElement(
                  'base'
                )).href = E.location.href),
                t.head.appendChild(r))
              : (t = E)),
          (o = !n && []),
          (i = N.exec(e))
            ? [t.createElement(i[1])]
            : ((i = xe([e], t, o)),
              o && o.length && S(o).remove(),
              S.merge([], i.childNodes)));
      var r, i, o;
    }),
    (S.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(' ');
      return (
        -1 < s && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        m(t)
          ? ((n = t), (t = void 0))
          : t && 'object' == typeof t && (i = 'POST'),
        0 < a.length &&
          S.ajax({ url: e, type: i || 'GET', dataType: 'html', data: t })
            .done(function (e) {
              (o = arguments),
                a.html(r ? S('<div>').append(S.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (S.expr.pseudos.animated = function (t) {
      return S.grep(S.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (S.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l = S.css(e, 'position'),
          c = S(e),
          f = {};
        'static' === l && (e.style.position = 'relative'),
          (s = c.offset()),
          (o = S.css(e, 'top')),
          (u = S.css(e, 'left')),
          ('absolute' === l || 'fixed' === l) && -1 < (o + u).indexOf('auto')
            ? ((a = (r = c.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          m(t) && (t = t.call(e, n, S.extend({}, s))),
          null != t.top && (f.top = t.top - s.top + a),
          null != t.left && (f.left = t.left - s.left + i),
          'using' in t
            ? t.using.call(e, f)
            : ('number' == typeof f.top && (f.top += 'px'),
              'number' == typeof f.left && (f.left += 'px'),
              c.css(f));
      },
    }),
    S.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                S.offset.setOffset(this, t, e);
              });
        var e,
          n,
          r = this[0];
        return r
          ? r.getClientRects().length
            ? ((e = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };
          if ('fixed' === S.css(r, 'position')) t = r.getBoundingClientRect();
          else {
            (t = this.offset()),
              (n = r.ownerDocument),
              (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              'static' === S.css(e, 'position')
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = S(e).offset()).top += S.css(e, 'borderTopWidth', !0)),
              (i.left += S.css(e, 'borderLeftWidth', !0)));
          }
          return {
            top: t.top - i.top - S.css(r, 'marginTop', !0),
            left: t.left - i.left - S.css(r, 'marginLeft', !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && 'static' === S.css(e, 'position')) e = e.offsetParent;
          return e || re;
        });
      },
    }),
    S.each(
      { scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' },
      function (t, i) {
        var o = 'pageYOffset' === i;
        S.fn[t] = function (e) {
          return $(
            this,
            function (e, t, n) {
              var r;
              if (
                (x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView),
                void 0 === n)
              )
                return r ? r[i] : e[t];
              r
                ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset)
                : (e[t] = n);
            },
            t,
            e,
            arguments.length
          );
        };
      }
    ),
    S.each(['top', 'left'], function (e, n) {
      S.cssHooks[n] = $e(y.pixelPosition, function (e, t) {
        if (t)
          return (t = Be(e, n)), Me.test(t) ? S(e).position()[n] + 'px' : t;
      });
    }),
    S.each({ Height: 'height', Width: 'width' }, function (a, s) {
      S.each(
        { padding: 'inner' + a, content: s, '': 'outer' + a },
        function (r, o) {
          S.fn[o] = function (e, t) {
            var n = arguments.length && (r || 'boolean' != typeof e),
              i = r || (!0 === e || !0 === t ? 'margin' : 'border');
            return $(
              this,
              function (e, t, n) {
                var r;
                return x(e)
                  ? 0 === o.indexOf('outer')
                    ? e['inner' + a]
                    : e.document.documentElement['client' + a]
                  : 9 === e.nodeType
                  ? ((r = e.documentElement),
                    Math.max(
                      e.body['scroll' + a],
                      r['scroll' + a],
                      e.body['offset' + a],
                      r['offset' + a],
                      r['client' + a]
                    ))
                  : void 0 === n
                  ? S.css(e, t, i)
                  : S.style(e, t, n, i);
              },
              s,
              n ? e : void 0,
              n
            );
          };
        }
      );
    }),
    S.each(
      [
        'ajaxStart',
        'ajaxStop',
        'ajaxComplete',
        'ajaxError',
        'ajaxSuccess',
        'ajaxSend',
      ],
      function (e, t) {
        S.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    S.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, '**')
          : this.off(t, e || '**', n);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    S.each(
      'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
        ' '
      ),
      function (e, n) {
        S.fn[n] = function (e, t) {
          return 0 < arguments.length
            ? this.on(n, null, e, t)
            : this.trigger(n);
        };
      }
    );
  var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (S.proxy = function (e, t) {
    var n, r, i;
    if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
      return (
        (r = s.call(arguments, 2)),
        ((i = function () {
          return e.apply(t || this, r.concat(s.call(arguments)));
        }).guid = e.guid =
          e.guid || S.guid++),
        i
      );
  }),
    (S.holdReady = function (e) {
      e ? S.readyWait++ : S.ready(!0);
    }),
    (S.isArray = Array.isArray),
    (S.parseJSON = JSON.parse),
    (S.nodeName = A),
    (S.isFunction = m),
    (S.isWindow = x),
    (S.camelCase = X),
    (S.type = w),
    (S.now = Date.now),
    (S.isNumeric = function (e) {
      var t = S.type(e);
      return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
    }),
    (S.trim = function (e) {
      return null == e ? '' : (e + '').replace(Gt, '');
    }),
    'function' == typeof define &&
      define.amd &&
      define('jquery', [], function () {
        return S;
      });
  var Yt = C.jQuery,
    Qt = C.$;
  return (
    (S.noConflict = function (e) {
      return C.$ === S && (C.$ = Qt), e && C.jQuery === S && (C.jQuery = Yt), S;
    }),
    'undefined' == typeof e && (C.jQuery = C.$ = S),
    S
  );
});

/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */
!(function (a) {
  'function' == typeof define && define.amd
    ? define(['jquery'], a)
    : a(
        'object' == typeof exports
          ? require('jquery')
          : window.jQuery || window.Zepto
      );
})(function (a) {
  var b,
    c,
    d,
    e,
    f,
    g,
    h = 'Close',
    i = 'BeforeClose',
    j = 'AfterClose',
    k = 'BeforeAppend',
    l = 'MarkupParse',
    m = 'Open',
    n = 'Change',
    o = 'mfp',
    p = '.' + o,
    q = 'mfp-ready',
    r = 'mfp-removing',
    s = 'mfp-prevent-close',
    t = function () {},
    u = !!window.jQuery,
    v = a(window),
    w = function (a, c) {
      b.ev.on(o + a + p, c);
    },
    x = function (b, c, d, e) {
      var f = document.createElement('div');
      return (
        (f.className = 'mfp-' + b),
        d && (f.innerHTML = d),
        e ? c && c.appendChild(f) : ((f = a(f)), c && f.appendTo(c)),
        f
      );
    },
    y = function (c, d) {
      b.ev.triggerHandler(o + c, d),
        b.st.callbacks &&
          ((c = c.charAt(0).toLowerCase() + c.slice(1)),
          b.st.callbacks[c] &&
            b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
    },
    z = function (c) {
      return (
        (c === g && b.currTemplate.closeBtn) ||
          ((b.currTemplate.closeBtn = a(
            b.st.closeMarkup.replace('%title%', b.st.tClose)
          )),
          (g = c)),
        b.currTemplate.closeBtn
      );
    },
    A = function () {
      a.magnificPopup.instance ||
        ((b = new t()), b.init(), (a.magnificPopup.instance = b));
    },
    B = function () {
      var a = document.createElement('p').style,
        b = ['ms', 'O', 'Moz', 'Webkit'];
      if (void 0 !== a.transition) return !0;
      for (; b.length; ) if (b.pop() + 'Transition' in a) return !0;
      return !1;
    };
  (t.prototype = {
    constructor: t,
    init: function () {
      var c = navigator.appVersion;
      (b.isLowIE = b.isIE8 = document.all && !document.addEventListener),
        (b.isAndroid = /android/gi.test(c)),
        (b.isIOS = /iphone|ipad|ipod/gi.test(c)),
        (b.supportsTransition = B()),
        (b.probablyMobile =
          b.isAndroid ||
          b.isIOS ||
          /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
            navigator.userAgent
          )),
        (d = a(document)),
        (b.popupsCache = {});
    },
    open: function (c) {
      var e;
      if (c.isObj === !1) {
        (b.items = c.items.toArray()), (b.index = 0);
        var g,
          h = c.items;
        for (e = 0; e < h.length; e++)
          if (((g = h[e]), g.parsed && (g = g.el[0]), g === c.el[0])) {
            b.index = e;
            break;
          }
      } else
        (b.items = a.isArray(c.items) ? c.items : [c.items]),
          (b.index = c.index || 0);
      if (b.isOpen) return void b.updateItemHTML();
      (b.types = []),
        (f = ''),
        c.mainEl && c.mainEl.length ? (b.ev = c.mainEl.eq(0)) : (b.ev = d),
        c.key
          ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}),
            (b.currTemplate = b.popupsCache[c.key]))
          : (b.currTemplate = {}),
        (b.st = a.extend(!0, {}, a.magnificPopup.defaults, c)),
        (b.fixedContentPos =
          'auto' === b.st.fixedContentPos
            ? !b.probablyMobile
            : b.st.fixedContentPos),
        b.st.modal &&
          ((b.st.closeOnContentClick = !1),
          (b.st.closeOnBgClick = !1),
          (b.st.showCloseBtn = !1),
          (b.st.enableEscapeKey = !1)),
        b.bgOverlay ||
          ((b.bgOverlay = x('bg').on('click' + p, function () {
            b.close();
          })),
          (b.wrap = x('wrap')
            .attr('tabindex', -1)
            .on('click' + p, function (a) {
              b._checkIfClose(a.target) && b.close();
            })),
          (b.container = x('container', b.wrap))),
        (b.contentContainer = x('content')),
        b.st.preloader &&
          (b.preloader = x('preloader', b.container, b.st.tLoading));
      var i = a.magnificPopup.modules;
      for (e = 0; e < i.length; e++) {
        var j = i[e];
        (j = j.charAt(0).toUpperCase() + j.slice(1)), b['init' + j].call(b);
      }
      y('BeforeOpen'),
        b.st.showCloseBtn &&
          (b.st.closeBtnInside
            ? (w(l, function (a, b, c, d) {
                c.close_replaceWith = z(d.type);
              }),
              (f += ' mfp-close-btn-in'))
            : b.wrap.append(z())),
        b.st.alignTop && (f += ' mfp-align-top'),
        b.fixedContentPos
          ? b.wrap.css({
              overflow: b.st.overflowY,
              overflowX: 'hidden',
              overflowY: b.st.overflowY,
            })
          : b.wrap.css({ top: v.scrollTop(), position: 'absolute' }),
        (b.st.fixedBgPos === !1 ||
          ('auto' === b.st.fixedBgPos && !b.fixedContentPos)) &&
          b.bgOverlay.css({ height: d.height(), position: 'absolute' }),
        b.st.enableEscapeKey &&
          d.on('keyup' + p, function (a) {
            27 === a.keyCode && b.close();
          }),
        v.on('resize' + p, function () {
          b.updateSize();
        }),
        b.st.closeOnContentClick || (f += ' mfp-auto-cursor'),
        f && b.wrap.addClass(f);
      var k = (b.wH = v.height()),
        n = {};
      if (b.fixedContentPos && b._hasScrollBar(k)) {
        var o = b._getScrollbarSize();
        o && (n.marginRight = o);
      }
      b.fixedContentPos &&
        (b.isIE7
          ? a('body, html').css('overflow', 'hidden')
          : (n.overflow = 'hidden'));
      var r = b.st.mainClass;
      return (
        b.isIE7 && (r += ' mfp-ie7'),
        r && b._addClassToMFP(r),
        b.updateItemHTML(),
        y('BuildControls'),
        a('html').css(n),
        b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
        (b._lastFocusedEl = document.activeElement),
        setTimeout(function () {
          b.content
            ? (b._addClassToMFP(q), b._setFocus())
            : b.bgOverlay.addClass(q),
            d.on('focusin' + p, b._onFocusIn);
        }, 16),
        (b.isOpen = !0),
        b.updateSize(k),
        y(m),
        c
      );
    },
    close: function () {
      b.isOpen &&
        (y(i),
        (b.isOpen = !1),
        b.st.removalDelay && !b.isLowIE && b.supportsTransition
          ? (b._addClassToMFP(r),
            setTimeout(function () {
              b._close();
            }, b.st.removalDelay))
          : b._close());
    },
    _close: function () {
      y(h);
      var c = r + ' ' + q + ' ';
      if (
        (b.bgOverlay.detach(),
        b.wrap.detach(),
        b.container.empty(),
        b.st.mainClass && (c += b.st.mainClass + ' '),
        b._removeClassFromMFP(c),
        b.fixedContentPos)
      ) {
        var e = { marginRight: '' };
        b.isIE7 ? a('body, html').css('overflow', '') : (e.overflow = ''),
          a('html').css(e);
      }
      d.off('keyup' + p + ' focusin' + p),
        b.ev.off(p),
        b.wrap.attr('class', 'mfp-wrap').removeAttr('style'),
        b.bgOverlay.attr('class', 'mfp-bg'),
        b.container.attr('class', 'mfp-container'),
        !b.st.showCloseBtn ||
          (b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0) ||
          (b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach()),
        b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(),
        (b.currItem = null),
        (b.content = null),
        (b.currTemplate = null),
        (b.prevHeight = 0),
        y(j);
    },
    updateSize: function (a) {
      if (b.isIOS) {
        var c = document.documentElement.clientWidth / window.innerWidth,
          d = window.innerHeight * c;
        b.wrap.css('height', d), (b.wH = d);
      } else b.wH = a || v.height();
      b.fixedContentPos || b.wrap.css('height', b.wH), y('Resize');
    },
    updateItemHTML: function () {
      var c = b.items[b.index];
      b.contentContainer.detach(),
        b.content && b.content.detach(),
        c.parsed || (c = b.parseEl(b.index));
      var d = c.type;
      if (
        (y('BeforeChange', [b.currItem ? b.currItem.type : '', d]),
        (b.currItem = c),
        !b.currTemplate[d])
      ) {
        var f = b.st[d] ? b.st[d].markup : !1;
        y('FirstMarkupParse', f),
          f ? (b.currTemplate[d] = a(f)) : (b.currTemplate[d] = !0);
      }
      e && e !== c.type && b.container.removeClass('mfp-' + e + '-holder');
      var g = b['get' + d.charAt(0).toUpperCase() + d.slice(1)](
        c,
        b.currTemplate[d]
      );
      b.appendContent(g, d),
        (c.preloaded = !0),
        y(n, c),
        (e = c.type),
        b.container.prepend(b.contentContainer),
        y('AfterChange');
    },
    appendContent: function (a, c) {
      (b.content = a),
        a
          ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0
            ? b.content.find('.mfp-close').length || b.content.append(z())
            : (b.content = a)
          : (b.content = ''),
        y(k),
        b.container.addClass('mfp-' + c + '-holder'),
        b.contentContainer.append(b.content);
    },
    parseEl: function (c) {
      var d,
        e = b.items[c];
      if (
        (e.tagName
          ? (e = { el: a(e) })
          : ((d = e.type), (e = { data: e, src: e.src })),
        e.el)
      ) {
        for (var f = b.types, g = 0; g < f.length; g++)
          if (e.el.hasClass('mfp-' + f[g])) {
            d = f[g];
            break;
          }
        (e.src = e.el.attr('data-mfp-src')),
          e.src || (e.src = e.el.attr('href'));
      }
      return (
        (e.type = d || b.st.type || 'inline'),
        (e.index = c),
        (e.parsed = !0),
        (b.items[c] = e),
        y('ElementParse', e),
        b.items[c]
      );
    },
    addGroup: function (a, c) {
      var d = function (d) {
        (d.mfpEl = this), b._openClick(d, a, c);
      };
      c || (c = {});
      var e = 'click.magnificPopup';
      (c.mainEl = a),
        c.items
          ? ((c.isObj = !0), a.off(e).on(e, d))
          : ((c.isObj = !1),
            c.delegate
              ? a.off(e).on(e, c.delegate, d)
              : ((c.items = a), a.off(e).on(e, d)));
    },
    _openClick: function (c, d, e) {
      var f =
        void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
      if (
        f ||
        !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)
      ) {
        var g =
          void 0 !== e.disableOn
            ? e.disableOn
            : a.magnificPopup.defaults.disableOn;
        if (g)
          if (a.isFunction(g)) {
            if (!g.call(b)) return !0;
          } else if (v.width() < g) return !0;
        c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()),
          (e.el = a(c.mfpEl)),
          e.delegate && (e.items = d.find(e.delegate)),
          b.open(e);
      }
    },
    updateStatus: function (a, d) {
      if (b.preloader) {
        c !== a && b.container.removeClass('mfp-s-' + c),
          d || 'loading' !== a || (d = b.st.tLoading);
        var e = { status: a, text: d };
        y('UpdateStatus', e),
          (a = e.status),
          (d = e.text),
          b.preloader.html(d),
          b.preloader.find('a').on('click', function (a) {
            a.stopImmediatePropagation();
          }),
          b.container.addClass('mfp-s-' + a),
          (c = a);
      }
    },
    _checkIfClose: function (c) {
      if (!a(c).hasClass(s)) {
        var d = b.st.closeOnContentClick,
          e = b.st.closeOnBgClick;
        if (d && e) return !0;
        if (
          !b.content ||
          a(c).hasClass('mfp-close') ||
          (b.preloader && c === b.preloader[0])
        )
          return !0;
        if (c === b.content[0] || a.contains(b.content[0], c)) {
          if (d) return !0;
        } else if (e && a.contains(document, c)) return !0;
        return !1;
      }
    },
    _addClassToMFP: function (a) {
      b.bgOverlay.addClass(a), b.wrap.addClass(a);
    },
    _removeClassFromMFP: function (a) {
      this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
    },
    _hasScrollBar: function (a) {
      return (
        (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
      );
    },
    _setFocus: function () {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
    },
    _onFocusIn: function (c) {
      return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target)
        ? void 0
        : (b._setFocus(), !1);
    },
    _parseMarkup: function (b, c, d) {
      var e;
      d.data && (c = a.extend(d.data, c)),
        y(l, [b, c, d]),
        a.each(c, function (c, d) {
          if (void 0 === d || d === !1) return !0;
          if (((e = c.split('_')), e.length > 1)) {
            var f = b.find(p + '-' + e[0]);
            if (f.length > 0) {
              var g = e[1];
              'replaceWith' === g
                ? f[0] !== d[0] && f.replaceWith(d)
                : 'img' === g
                ? f.is('img')
                  ? f.attr('src', d)
                  : f.replaceWith(
                      a('<img>').attr('src', d).attr('class', f.attr('class'))
                    )
                : f.attr(e[1], d);
            }
          } else b.find(p + '-' + c).html(d);
        });
    },
    _getScrollbarSize: function () {
      if (void 0 === b.scrollbarSize) {
        var a = document.createElement('div');
        (a.style.cssText =
          'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;'),
          document.body.appendChild(a),
          (b.scrollbarSize = a.offsetWidth - a.clientWidth),
          document.body.removeChild(a);
      }
      return b.scrollbarSize;
    },
  }),
    (a.magnificPopup = {
      instance: null,
      proto: t.prototype,
      modules: [],
      open: function (b, c) {
        return (
          A(),
          (b = b ? a.extend(!0, {}, b) : {}),
          (b.isObj = !0),
          (b.index = c || 0),
          this.instance.open(b)
        );
      },
      close: function () {
        return a.magnificPopup.instance && a.magnificPopup.instance.close();
      },
      registerModule: function (b, c) {
        c.options && (a.magnificPopup.defaults[b] = c.options),
          a.extend(this.proto, c.proto),
          this.modules.push(b);
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: '',
        preloader: !0,
        focus: '',
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: 'auto',
        fixedBgPos: 'auto',
        overflowY: 'auto',
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
        tClose: 'Close (Esc)',
        tLoading: 'Loading...',
        autoFocusLast: !0,
      },
    }),
    (a.fn.magnificPopup = function (c) {
      A();
      var d = a(this);
      if ('string' == typeof c)
        if ('open' === c) {
          var e,
            f = u ? d.data('magnificPopup') : d[0].magnificPopup,
            g = parseInt(arguments[1], 10) || 0;
          f.items
            ? (e = f.items[g])
            : ((e = d), f.delegate && (e = e.find(f.delegate)), (e = e.eq(g))),
            b._openClick({ mfpEl: e }, d, f);
        } else
          b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
      else
        (c = a.extend(!0, {}, c)),
          u ? d.data('magnificPopup', c) : (d[0].magnificPopup = c),
          b.addGroup(d, c);
      return d;
    });
  var C,
    D,
    E,
    F = 'inline',
    G = function () {
      E && (D.after(E.addClass(C)).detach(), (E = null));
    };
  a.magnificPopup.registerModule(F, {
    options: {
      hiddenClass: 'hide',
      markup: '',
      tNotFound: 'Content not found',
    },
    proto: {
      initInline: function () {
        b.types.push(F),
          w(h + '.' + F, function () {
            G();
          });
      },
      getInline: function (c, d) {
        if ((G(), c.src)) {
          var e = b.st.inline,
            f = a(c.src);
          if (f.length) {
            var g = f[0].parentNode;
            g &&
              g.tagName &&
              (D || ((C = e.hiddenClass), (D = x(C)), (C = 'mfp-' + C)),
              (E = f.after(D).detach().removeClass(C))),
              b.updateStatus('ready');
          } else b.updateStatus('error', e.tNotFound), (f = a('<div>'));
          return (c.inlineElement = f), f;
        }
        return b.updateStatus('ready'), b._parseMarkup(d, {}, c), d;
      },
    },
  });
  var H,
    I = 'ajax',
    J = function () {
      H && a(document.body).removeClass(H);
    },
    K = function () {
      J(), b.req && b.req.abort();
    };
  a.magnificPopup.registerModule(I, {
    options: {
      settings: null,
      cursor: 'mfp-ajax-cur',
      tError: '<a href="%url%">The content</a> could not be loaded.',
    },
    proto: {
      initAjax: function () {
        b.types.push(I),
          (H = b.st.ajax.cursor),
          w(h + '.' + I, K),
          w('BeforeChange.' + I, K);
      },
      getAjax: function (c) {
        H && a(document.body).addClass(H), b.updateStatus('loading');
        var d = a.extend(
          {
            url: c.src,
            success: function (d, e, f) {
              var g = { data: d, xhr: f };
              y('ParseAjax', g),
                b.appendContent(a(g.data), I),
                (c.finished = !0),
                J(),
                b._setFocus(),
                setTimeout(function () {
                  b.wrap.addClass(q);
                }, 16),
                b.updateStatus('ready'),
                y('AjaxContentAdded');
            },
            error: function () {
              J(),
                (c.finished = c.loadError = !0),
                b.updateStatus(
                  'error',
                  b.st.ajax.tError.replace('%url%', c.src)
                );
            },
          },
          b.st.ajax.settings
        );
        return (b.req = a.ajax(d)), '';
      },
    },
  });
  var L,
    M = function (c) {
      if (c.data && void 0 !== c.data.title) return c.data.title;
      var d = b.st.image.titleSrc;
      if (d) {
        if (a.isFunction(d)) return d.call(b, c);
        if (c.el) return c.el.attr(d) || '';
      }
      return '';
    };
  a.magnificPopup.registerModule('image', {
    options: {
      markup:
        '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: 'mfp-zoom-out-cur',
      titleSrc: 'title',
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },
    proto: {
      initImage: function () {
        var c = b.st.image,
          d = '.image';
        b.types.push('image'),
          w(m + d, function () {
            'image' === b.currItem.type &&
              c.cursor &&
              a(document.body).addClass(c.cursor);
          }),
          w(h + d, function () {
            c.cursor && a(document.body).removeClass(c.cursor),
              v.off('resize' + p);
          }),
          w('Resize' + d, b.resizeImage),
          b.isLowIE && w('AfterChange', b.resizeImage);
      },
      resizeImage: function () {
        var a = b.currItem;
        if (a && a.img && b.st.image.verticalFit) {
          var c = 0;
          b.isLowIE &&
            (c =
              parseInt(a.img.css('padding-top'), 10) +
              parseInt(a.img.css('padding-bottom'), 10)),
            a.img.css('max-height', b.wH - c);
        }
      },
      _onImageHasSize: function (a) {
        a.img &&
          ((a.hasSize = !0),
          L && clearInterval(L),
          (a.isCheckingImgSize = !1),
          y('ImageHasSize', a),
          a.imgHidden &&
            (b.content && b.content.removeClass('mfp-loading'),
            (a.imgHidden = !1)));
      },
      findImageSize: function (a) {
        var c = 0,
          d = a.img[0],
          e = function (f) {
            L && clearInterval(L),
              (L = setInterval(function () {
                return d.naturalWidth > 0
                  ? void b._onImageHasSize(a)
                  : (c > 200 && clearInterval(L),
                    c++,
                    void (3 === c
                      ? e(10)
                      : 40 === c
                      ? e(50)
                      : 100 === c && e(500)));
              }, f));
          };
        e(1);
      },
      getImage: function (c, d) {
        var e = 0,
          f = function () {
            c &&
              (c.img[0].complete
                ? (c.img.off('.mfploader'),
                  c === b.currItem &&
                    (b._onImageHasSize(c), b.updateStatus('ready')),
                  (c.hasSize = !0),
                  (c.loaded = !0),
                  y('ImageLoadComplete'))
                : (e++, 200 > e ? setTimeout(f, 100) : g()));
          },
          g = function () {
            c &&
              (c.img.off('.mfploader'),
              c === b.currItem &&
                (b._onImageHasSize(c),
                b.updateStatus('error', h.tError.replace('%url%', c.src))),
              (c.hasSize = !0),
              (c.loaded = !0),
              (c.loadError = !0));
          },
          h = b.st.image,
          i = d.find('.mfp-img');
        if (i.length) {
          var j = document.createElement('img');
          (j.className = 'mfp-img'),
            c.el &&
              c.el.find('img').length &&
              (j.alt = c.el.find('img').attr('alt')),
            (c.img = a(j).on('load.mfploader', f).on('error.mfploader', g)),
            (j.src = c.src),
            i.is('img') && (c.img = c.img.clone()),
            (j = c.img[0]),
            j.naturalWidth > 0 ? (c.hasSize = !0) : j.width || (c.hasSize = !1);
        }
        return (
          b._parseMarkup(d, { title: M(c), img_replaceWith: c.img }, c),
          b.resizeImage(),
          c.hasSize
            ? (L && clearInterval(L),
              c.loadError
                ? (d.addClass('mfp-loading'),
                  b.updateStatus('error', h.tError.replace('%url%', c.src)))
                : (d.removeClass('mfp-loading'), b.updateStatus('ready')),
              d)
            : (b.updateStatus('loading'),
              (c.loading = !0),
              c.hasSize ||
                ((c.imgHidden = !0),
                d.addClass('mfp-loading'),
                b.findImageSize(c)),
              d)
        );
      },
    },
  });
  var N,
    O = function () {
      return (
        void 0 === N &&
          (N = void 0 !== document.createElement('p').style.MozTransform),
        N
      );
    };
  a.magnificPopup.registerModule('zoom', {
    options: {
      enabled: !1,
      easing: 'ease-in-out',
      duration: 300,
      opener: function (a) {
        return a.is('img') ? a : a.find('img');
      },
    },
    proto: {
      initZoom: function () {
        var a,
          c = b.st.zoom,
          d = '.zoom';
        if (c.enabled && b.supportsTransition) {
          var e,
            f,
            g = c.duration,
            j = function (a) {
              var b = a
                  .clone()
                  .removeAttr('style')
                  .removeAttr('class')
                  .addClass('mfp-animated-image'),
                d = 'all ' + c.duration / 1e3 + 's ' + c.easing,
                e = {
                  position: 'fixed',
                  zIndex: 9999,
                  left: 0,
                  top: 0,
                  '-webkit-backface-visibility': 'hidden',
                },
                f = 'transition';
              return (
                (e['-webkit-' + f] = e['-moz-' + f] = e['-o-' + f] = e[f] = d),
                b.css(e),
                b
              );
            },
            k = function () {
              b.content.css('visibility', 'visible');
            };
          w('BuildControls' + d, function () {
            if (b._allowZoom()) {
              if (
                (clearTimeout(e),
                b.content.css('visibility', 'hidden'),
                (a = b._getItemToZoom()),
                !a)
              )
                return void k();
              (f = j(a)),
                f.css(b._getOffset()),
                b.wrap.append(f),
                (e = setTimeout(function () {
                  f.css(b._getOffset(!0)),
                    (e = setTimeout(function () {
                      k(),
                        setTimeout(function () {
                          f.remove(), (a = f = null), y('ZoomAnimationEnded');
                        }, 16);
                    }, g));
                }, 16));
            }
          }),
            w(i + d, function () {
              if (b._allowZoom()) {
                if ((clearTimeout(e), (b.st.removalDelay = g), !a)) {
                  if (((a = b._getItemToZoom()), !a)) return;
                  f = j(a);
                }
                f.css(b._getOffset(!0)),
                  b.wrap.append(f),
                  b.content.css('visibility', 'hidden'),
                  setTimeout(function () {
                    f.css(b._getOffset());
                  }, 16);
              }
            }),
            w(h + d, function () {
              b._allowZoom() && (k(), f && f.remove(), (a = null));
            });
        }
      },
      _allowZoom: function () {
        return 'image' === b.currItem.type;
      },
      _getItemToZoom: function () {
        return b.currItem.hasSize ? b.currItem.img : !1;
      },
      _getOffset: function (c) {
        var d;
        d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e = d.offset(),
          f = parseInt(d.css('padding-top'), 10),
          g = parseInt(d.css('padding-bottom'), 10);
        e.top -= a(window).scrollTop() - f;
        var h = {
          width: d.width(),
          height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f,
        };
        return (
          O()
            ? (h['-moz-transform'] = h.transform =
                'translate(' + e.left + 'px,' + e.top + 'px)')
            : ((h.left = e.left), (h.top = e.top)),
          h
        );
      },
    },
  });
  var P = 'iframe',
    Q = '//about:blank',
    R = function (a) {
      if (b.currTemplate[P]) {
        var c = b.currTemplate[P].find('iframe');
        c.length &&
          (a || (c[0].src = Q),
          b.isIE8 && c.css('display', a ? 'block' : 'none'));
      }
    };
  a.magnificPopup.registerModule(P, {
    options: {
      markup:
        '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: 'iframe_src',
      patterns: {
        youtube: {
          index: 'youtube.com',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?autoplay=1',
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1',
        },
        gmaps: { index: '//maps.google.', src: '%id%&output=embed' },
      },
    },
    proto: {
      initIframe: function () {
        b.types.push(P),
          w('BeforeChange', function (a, b, c) {
            b !== c && (b === P ? R() : c === P && R(!0));
          }),
          w(h + '.' + P, function () {
            R();
          });
      },
      getIframe: function (c, d) {
        var e = c.src,
          f = b.st.iframe;
        a.each(f.patterns, function () {
          return e.indexOf(this.index) > -1
            ? (this.id &&
                (e =
                  'string' == typeof this.id
                    ? e.substr(
                        e.lastIndexOf(this.id) + this.id.length,
                        e.length
                      )
                    : this.id.call(this, e)),
              (e = this.src.replace('%id%', e)),
              !1)
            : void 0;
        });
        var g = {};
        return (
          f.srcAction && (g[f.srcAction] = e),
          b._parseMarkup(d, g, c),
          b.updateStatus('ready'),
          d
        );
      },
    },
  });
  var S = function (a) {
      var c = b.items.length;
      return a > c - 1 ? a - c : 0 > a ? c + a : a;
    },
    T = function (a, b, c) {
      return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
    };
  a.magnificPopup.registerModule('gallery', {
    options: {
      enabled: !1,
      arrowMarkup:
        '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      tCounter: '%curr% of %total%',
    },
    proto: {
      initGallery: function () {
        var c = b.st.gallery,
          e = '.mfp-gallery';
        return (
          (b.direction = !0),
          c && c.enabled
            ? ((f += ' mfp-gallery'),
              w(m + e, function () {
                c.navigateByImgClick &&
                  b.wrap.on('click' + e, '.mfp-img', function () {
                    return b.items.length > 1 ? (b.next(), !1) : void 0;
                  }),
                  d.on('keydown' + e, function (a) {
                    37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
                  });
              }),
              w('UpdateStatus' + e, function (a, c) {
                c.text &&
                  (c.text = T(c.text, b.currItem.index, b.items.length));
              }),
              w(l + e, function (a, d, e, f) {
                var g = b.items.length;
                e.counter = g > 1 ? T(c.tCounter, f.index, g) : '';
              }),
              w('BuildControls' + e, function () {
                if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                  var d = c.arrowMarkup,
                    e = (b.arrowLeft = a(
                      d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, 'left')
                    ).addClass(s)),
                    f = (b.arrowRight = a(
                      d
                        .replace(/%title%/gi, c.tNext)
                        .replace(/%dir%/gi, 'right')
                    ).addClass(s));
                  e.click(function () {
                    b.prev();
                  }),
                    f.click(function () {
                      b.next();
                    }),
                    b.container.append(e.add(f));
                }
              }),
              w(n + e, function () {
                b._preloadTimeout && clearTimeout(b._preloadTimeout),
                  (b._preloadTimeout = setTimeout(function () {
                    b.preloadNearbyImages(), (b._preloadTimeout = null);
                  }, 16));
              }),
              void w(h + e, function () {
                d.off(e),
                  b.wrap.off('click' + e),
                  (b.arrowRight = b.arrowLeft = null);
              }))
            : !1
        );
      },
      next: function () {
        (b.direction = !0), (b.index = S(b.index + 1)), b.updateItemHTML();
      },
      prev: function () {
        (b.direction = !1), (b.index = S(b.index - 1)), b.updateItemHTML();
      },
      goTo: function (a) {
        (b.direction = a >= b.index), (b.index = a), b.updateItemHTML();
      },
      preloadNearbyImages: function () {
        var a,
          c = b.st.gallery.preload,
          d = Math.min(c[0], b.items.length),
          e = Math.min(c[1], b.items.length);
        for (a = 1; a <= (b.direction ? e : d); a++)
          b._preloadItem(b.index + a);
        for (a = 1; a <= (b.direction ? d : e); a++)
          b._preloadItem(b.index - a);
      },
      _preloadItem: function (c) {
        if (((c = S(c)), !b.items[c].preloaded)) {
          var d = b.items[c];
          d.parsed || (d = b.parseEl(c)),
            y('LazyLoad', d),
            'image' === d.type &&
              (d.img = a('<img class="mfp-img" />')
                .on('load.mfploader', function () {
                  d.hasSize = !0;
                })
                .on('error.mfploader', function () {
                  (d.hasSize = !0), (d.loadError = !0), y('LazyLoadError', d);
                })
                .attr('src', d.src)),
            (d.preloaded = !0);
        }
      },
    },
  });
  var U = 'retina';
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function (a) {
        return a.src.replace(/\.\w+$/, function (a) {
          return '@2x' + a;
        });
      },
      ratio: 1,
    },
    proto: {
      initRetina: function () {
        if (window.devicePixelRatio > 1) {
          var a = b.st.retina,
            c = a.ratio;
          (c = isNaN(c) ? c() : c),
            c > 1 &&
              (w('ImageHasSize.' + U, function (a, b) {
                b.img.css({
                  'max-width': b.img[0].naturalWidth / c,
                  width: '100%',
                });
              }),
              w('ElementParse.' + U, function (b, d) {
                d.src = a.replaceSrc(d, c);
              }));
        }
      },
    },
  }),
    A();
});

/**
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.2
 */
(function (f) {
  'use strict';
  'function' === typeof define && define.amd
    ? define(['jquery'], f)
    : 'undefined' !== typeof module && module.exports
    ? (module.exports = f(require('jquery')))
    : f(jQuery);
})(function ($) {
  'use strict';
  function n(a) {
    return (
      !a.nodeName ||
      -1 !==
        $.inArray(a.nodeName.toLowerCase(), [
          'iframe',
          '#document',
          'html',
          'body',
        ])
    );
  }
  function h(a) {
    return $.isFunction(a) || $.isPlainObject(a) ? a : { top: a, left: a };
  }
  var p = ($.scrollTo = function (a, d, b) {
    return $(window).scrollTo(a, d, b);
  });
  p.defaults = { axis: 'xy', duration: 0, limit: !0 };
  $.fn.scrollTo = function (a, d, b) {
    'object' === typeof d && ((b = d), (d = 0));
    'function' === typeof b && (b = { onAfter: b });
    'max' === a && (a = 9e9);
    b = $.extend({}, p.defaults, b);
    d = d || b.duration;
    var u = b.queue && 1 < b.axis.length;
    u && (d /= 2);
    b.offset = h(b.offset);
    b.over = h(b.over);
    return this.each(function () {
      function k(a) {
        var k = $.extend({}, b, {
          queue: !0,
          duration: d,
          complete:
            a &&
            function () {
              a.call(q, e, b);
            },
        });
        r.animate(f, k);
      }
      if (null !== a) {
        var l = n(this),
          q = l ? this.contentWindow || window : this,
          r = $(q),
          e = a,
          f = {},
          t;
        switch (typeof e) {
          case 'number':
          case 'string':
            if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)) {
              e = h(e);
              break;
            }
            e = l ? $(e) : $(e, q);
          case 'object':
            if (e.length === 0) return;
            if (e.is || e.style) t = (e = $(e)).offset();
        }
        var v = ($.isFunction(b.offset) && b.offset(q, e)) || b.offset;
        $.each(b.axis.split(''), function (a, c) {
          var d = 'x' === c ? 'Left' : 'Top',
            m = d.toLowerCase(),
            g = 'scroll' + d,
            h = r[g](),
            n = p.max(q, c);
          t
            ? ((f[g] = t[m] + (l ? 0 : h - r.offset()[m])),
              b.margin &&
                ((f[g] -= parseInt(e.css('margin' + d), 10) || 0),
                (f[g] -= parseInt(e.css('border' + d + 'Width'), 10) || 0)),
              (f[g] += v[m] || 0),
              b.over[m] &&
                (f[g] += e['x' === c ? 'width' : 'height']() * b.over[m]))
            : ((d = e[m]),
              (f[g] =
                d.slice && '%' === d.slice(-1)
                  ? (parseFloat(d) / 100) * n
                  : d));
          b.limit &&
            /^\d+$/.test(f[g]) &&
            (f[g] = 0 >= f[g] ? 0 : Math.min(f[g], n));
          !a &&
            1 < b.axis.length &&
            (h === f[g] ? (f = {}) : u && (k(b.onAfterFirst), (f = {})));
        });
        k(b.onAfter);
      }
    });
  };
  p.max = function (a, d) {
    var b = 'x' === d ? 'Width' : 'Height',
      h = 'scroll' + b;
    if (!n(a)) return a[h] - $(a)[b.toLowerCase()]();
    var b = 'client' + b,
      k = a.ownerDocument || a.document,
      l = k.documentElement,
      k = k.body;
    return Math.max(l[h], k[h]) - Math.min(l[b], k[b]);
  };
  $.Tween.propHooks.scrollLeft = $.Tween.propHooks.scrollTop = {
    get: function (a) {
      return $(a.elem)[a.prop]();
    },
    set: function (a) {
      var d = this.get(a);
      if (a.options.interrupt && a._last && a._last !== d)
        return $(a.elem).stop();
      var b = Math.round(a.now);
      d !== b && ($(a.elem)[a.prop](b), (a._last = this.get(a)));
    },
  };
  return p;
});

/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
!(function (t, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
    ? define(e)
    : (t.Glide = e());
})(this, function () {
  'use strict';
  var n = {
    type: 'slider',
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    perTouch: !1,
    touchRatio: 0.5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: !0,
    rewindDuration: 800,
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',
    throttle: 10,
    direction: 'ltr',
    peek: 0,
    breakpoints: {},
    classes: {
      direction: { ltr: 'glide--ltr', rtl: 'glide--rtl' },
      slider: 'glide--slider',
      carousel: 'glide--carousel',
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      cloneSlide: 'glide__slide--clone',
      activeNav: 'glide__bullet--active',
      activeSlide: 'glide__slide--active',
      disabledArrow: 'glide__arrow--disabled',
    },
  };
  function i(t, e) {
    if (!(t instanceof e))
      throw new TypeError('Cannot call a class as a function');
  }
  var r =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (t) {
            return typeof t;
          }
        : function (t) {
            return t &&
              'function' == typeof Symbol &&
              t.constructor === Symbol &&
              t !== Symbol.prototype
              ? 'symbol'
              : typeof t;
          },
    t = function (t, e, n) {
      return e && o(t.prototype, e), n && o(t, n), t;
    };
  function o(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        'value' in i && (i.writable = !0),
        Object.defineProperty(t, i.key, i);
    }
  }
  var a =
    Object.assign ||
    function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];
        for (var i in n)
          Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
      return t;
    };
  function y(t) {
    return parseInt(t);
  }
  function s(t) {
    return 'string' == typeof t;
  }
  function u(t) {
    var e = void 0 === t ? 'undefined' : r(t);
    return 'function' === e || ('object' === e && !!t);
  }
  function c(t) {
    return 'function' == typeof t;
  }
  function l(t) {
    return void 0 === t;
  }
  function f(t) {
    return t.constructor === Array;
  }
  function d(t, e, n) {
    Object.defineProperty(t, e, n);
  }
  function h(t, e) {
    var n = a({}, t, e);
    return (
      e.hasOwnProperty('classes') &&
        ((n.classes = a({}, t.classes, e.classes)),
        e.classes.hasOwnProperty('direction') &&
          (n.classes.direction = a(
            {},
            t.classes.direction,
            e.classes.direction
          ))),
      e.hasOwnProperty('breakpoints') &&
        (n.breakpoints = a({}, t.breakpoints, e.breakpoints)),
      n
    );
  }
  var v =
    (t(e, [
      {
        key: 'on',
        value: function (t, e) {
          if (f(t)) for (var n = 0; n < t.length; n++) this.on(t[n], e);
          this.hop.call(this.events, t) || (this.events[t] = []);
          var i = this.events[t].push(e) - 1;
          return {
            remove: function () {
              delete this.events[t][i];
            },
          };
        },
      },
      {
        key: 'emit',
        value: function (t, e) {
          if (f(t)) for (var n = 0; n < t.length; n++) this.emit(t[n], e);
          this.hop.call(this.events, t) &&
            this.events[t].forEach(function (t) {
              t(e || {});
            });
        },
      },
    ]),
    e);
  function e() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, e), (this.events = t), (this.hop = t.hasOwnProperty);
  }
  var p =
    (t(m, [
      {
        key: 'mount',
        value: function (t) {
          var e = 0 < arguments.length && void 0 !== t ? t : {};
          return (
            this._e.emit('mount.before'),
            u(e) &&
              (this._c = (function (t, e, n) {
                var i = {};
                for (var r in e) c(e[r]) && (i[r] = e[r](t, i, n));
                for (var o in i) c(i[o].mount) && i[o].mount();
                return i;
              })(this, e, this._e)),
            this._e.emit('mount.after'),
            this
          );
        },
      },
      {
        key: 'mutate',
        value: function (t) {
          var e = 0 < arguments.length && void 0 !== t ? t : [];
          return f(e) && (this._t = e), this;
        },
      },
      {
        key: 'update',
        value: function (t) {
          var e = 0 < arguments.length && void 0 !== t ? t : {};
          return (
            (this.settings = h(this.settings, e)),
            e.hasOwnProperty('startAt') && (this.index = e.startAt),
            this._e.emit('update'),
            this
          );
        },
      },
      {
        key: 'go',
        value: function (t) {
          return this._c.Run.make(t), this;
        },
      },
      {
        key: 'move',
        value: function (t) {
          return this._c.Transition.disable(), this._c.Move.make(t), this;
        },
      },
      {
        key: 'destroy',
        value: function () {
          return this._e.emit('destroy'), this;
        },
      },
      {
        key: 'play',
        value: function (t) {
          var e = 0 < arguments.length && void 0 !== t && t;
          return e && (this.settings.autoplay = e), this._e.emit('play'), this;
        },
      },
      {
        key: 'pause',
        value: function () {
          return this._e.emit('pause'), this;
        },
      },
      {
        key: 'disable',
        value: function () {
          return (this.disabled = !0), this;
        },
      },
      {
        key: 'enable',
        value: function () {
          return (this.disabled = !1), this;
        },
      },
      {
        key: 'on',
        value: function (t, e) {
          return this._e.on(t, e), this;
        },
      },
      {
        key: 'isType',
        value: function (t) {
          return this.settings.type === t;
        },
      },
      {
        key: 'settings',
        get: function () {
          return this._o;
        },
        set: function (t) {
          u(t) && (this._o = t);
        },
      },
      {
        key: 'index',
        get: function () {
          return this._i;
        },
        set: function (t) {
          this._i = y(t);
        },
      },
      {
        key: 'type',
        get: function () {
          return this.settings.type;
        },
      },
      {
        key: 'disabled',
        get: function () {
          return this._d;
        },
        set: function (t) {
          this._d = !!t;
        },
      },
    ]),
    m);
  function m(t) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
    i(this, m),
      (this._c = {}),
      (this._t = []),
      (this._e = new v()),
      (this.disabled = !1),
      (this.selector = t),
      (this.settings = h(n, e)),
      (this.index = this.settings.startAt);
  }
  function g() {
    return new Date().getTime();
  }
  function b(n, i, r) {
    var o = void 0,
      s = void 0,
      u = void 0,
      a = void 0,
      c = 0;
    r = r || {};
    function l() {
      (c = !1 === r.leading ? 0 : g()),
        (o = null),
        (a = n.apply(s, u)),
        o || (s = u = null);
    }
    function t() {
      var t = g();
      c || !1 !== r.leading || (c = t);
      var e = i - (t - c);
      return (
        (s = this),
        (u = arguments),
        e <= 0 || i < e
          ? (o && (clearTimeout(o), (o = null)),
            (c = t),
            (a = n.apply(s, u)),
            o || (s = u = null))
          : o || !1 === r.trailing || (o = setTimeout(l, e)),
        a
      );
    }
    return (
      (t.cancel = function () {
        clearTimeout(o), (c = 0), (o = s = u = null);
      }),
      t
    );
  }
  var w = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft'],
  };
  function _(t) {
    if (t && t.parentNode) {
      for (var e = t.parentNode.firstChild, n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    }
    return [];
  }
  function k(t) {
    return !!(t && t instanceof window.HTMLElement);
  }
  var S = '[data-glide-el="track"]';
  var H =
    (t(T, [
      {
        key: 'on',
        value: function (t, e, n, i) {
          var r = 3 < arguments.length && void 0 !== i && i;
          s(t) && (t = [t]);
          for (var o = 0; o < t.length; o++)
            (this.listeners[t[o]] = n),
              e.addEventListener(t[o], this.listeners[t[o]], r);
        },
      },
      {
        key: 'off',
        value: function (t, e, n) {
          var i = 2 < arguments.length && void 0 !== n && n;
          s(t) && (t = [t]);
          for (var r = 0; r < t.length; r++)
            e.removeEventListener(t[r], this.listeners[t[r]], i);
        },
      },
      {
        key: 'destroy',
        value: function () {
          delete this.listeners;
        },
      },
    ]),
    T);
  function T() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, T), (this.listeners = t);
  }
  var x = ['ltr', 'rtl'],
    O = { '>': '<', '<': '>', '=': '=' };
  function A(t, e) {
    return {
      modify: function (t) {
        return e.Direction.is('rtl') ? -t : t;
      },
    };
  }
  function M(i, r, o) {
    var s = [
      function (e, n) {
        return {
          modify: function (t) {
            return t + n.Gaps.value * e.index;
          },
        };
      },
      function (t, e) {
        return {
          modify: function (t) {
            return t + e.Clones.grow / 2;
          },
        };
      },
      function (n, i) {
        return {
          modify: function (t) {
            if (0 <= n.settings.focusAt) {
              var e = i.Peek.value;
              return u(e) ? t - e.before : t - e;
            }
            return t;
          },
        };
      },
      function (o, s) {
        return {
          modify: function (t) {
            var e = s.Gaps.value,
              n = s.Sizes.width,
              i = o.settings.focusAt,
              r = s.Sizes.slideWidth;
            return 'center' === i ? t - (n / 2 - r / 2) : t - r * i - e * i;
          },
        };
      },
    ].concat(i._t, [A]);
    return {
      mutate: function (t) {
        for (var e = 0; e < s.length; e++) {
          var n = s[e];
          c(n) && c(n().modify) && (t = n(i, r, o).modify(t));
        }
        return t;
      },
    };
  }
  var C = !1;
  try {
    var P = Object.defineProperty({}, 'passive', {
      get: function () {
        C = !0;
      },
    });
    window.addEventListener('testPassive', null, P),
      window.removeEventListener('testPassive', null, P);
  } catch (t) {}
  var L = C,
    z = ['touchstart', 'mousedown'],
    j = ['touchmove', 'mousemove'],
    D = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'],
    E = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
  function R(t) {
    return u(t)
      ? (function (n) {
          return Object.keys(n)
            .sort()
            .reduce(function (t, e) {
              return (t[e] = n[e]), t[e], t;
            }, {});
        })(t)
      : {};
  }
  var W = {
    Html: function (e, t) {
      var n = {
        mount: function () {
          (this.root = e.selector),
            (this.track = this.root.querySelector(S)),
            (this.slides = Array.prototype.slice
              .call(this.wrapper.children)
              .filter(function (t) {
                return !t.classList.contains(e.settings.classes.cloneSlide);
              }));
        },
      };
      return (
        d(n, 'root', {
          get: function () {
            return n._r;
          },
          set: function (t) {
            s(t) && (t = document.querySelector(t)), k(t) && (n._r = t);
          },
        }),
        d(n, 'track', {
          get: function () {
            return n._t;
          },
          set: function (t) {
            k(t) && (n._t = t);
          },
        }),
        d(n, 'wrapper', {
          get: function () {
            return n.track.children[0];
          },
        }),
        n
      );
    },
    Translate: function (r, o, s) {
      var u = {
        set: function (t) {
          var e = M(r, o).mutate(t);
          o.Html.wrapper.style.transform =
            'translate3d(' + -1 * e + 'px, 0px, 0px)';
        },
        remove: function () {
          o.Html.wrapper.style.transform = '';
        },
      };
      return (
        s.on('move', function (t) {
          var e = o.Gaps.value,
            n = o.Sizes.length,
            i = o.Sizes.slideWidth;
          return r.isType('carousel') && o.Run.isOffset('<')
            ? (o.Transition.after(function () {
                s.emit('translate.jump'), u.set(i * (n - 1));
              }),
              u.set(-i - e * n))
            : r.isType('carousel') && o.Run.isOffset('>')
            ? (o.Transition.after(function () {
                s.emit('translate.jump'), u.set(0);
              }),
              u.set(i * n + e * n))
            : u.set(t.movement);
        }),
        s.on('destroy', function () {
          u.remove();
        }),
        u
      );
    },
    Transition: function (n, i, t) {
      var r = !1,
        e = {
          compose: function (t) {
            var e = n.settings;
            return r
              ? t + ' 0ms ' + e.animationTimingFunc
              : t + ' ' + this.duration + 'ms ' + e.animationTimingFunc;
          },
          set: function (t) {
            var e = 0 < arguments.length && void 0 !== t ? t : 'transform';
            i.Html.wrapper.style.transition = this.compose(e);
          },
          remove: function () {
            i.Html.wrapper.style.transition = '';
          },
          after: function (t) {
            setTimeout(function () {
              t();
            }, this.duration);
          },
          enable: function () {
            (r = !1), this.set();
          },
          disable: function () {
            (r = !0), this.set();
          },
        };
      return (
        d(e, 'duration', {
          get: function () {
            var t = n.settings;
            return n.isType('slider') && i.Run.offset
              ? t.rewindDuration
              : t.animationDuration;
          },
        }),
        t.on('move', function () {
          e.set();
        }),
        t.on(['build.before', 'resize', 'translate.jump'], function () {
          e.disable();
        }),
        t.on('run', function () {
          e.enable();
        }),
        t.on('destroy', function () {
          e.remove();
        }),
        e
      );
    },
    Direction: function (t, e, n) {
      var i = {
        mount: function () {
          this.value = t.settings.direction;
        },
        resolve: function (t) {
          var e = t.slice(0, 1);
          return this.is('rtl') ? t.split(e).join(O[e]) : t;
        },
        is: function (t) {
          return this.value === t;
        },
        addClass: function () {
          e.Html.root.classList.add(t.settings.classes.direction[this.value]);
        },
        removeClass: function () {
          e.Html.root.classList.remove(
            t.settings.classes.direction[this.value]
          );
        },
      };
      return (
        d(i, 'value', {
          get: function () {
            return i._v;
          },
          set: function (t) {
            -1 < x.indexOf(t) && (i._v = t);
          },
        }),
        n.on(['destroy', 'update'], function () {
          i.removeClass();
        }),
        n.on('update', function () {
          i.mount();
        }),
        n.on(['build.before', 'update'], function () {
          i.addClass();
        }),
        i
      );
    },
    Peek: function (n, t, e) {
      var i = {
        mount: function () {
          this.value = n.settings.peek;
        },
      };
      return (
        d(i, 'value', {
          get: function () {
            return i._v;
          },
          set: function (t) {
            u(t)
              ? ((t.before = y(t.before)), (t.after = y(t.after)))
              : (t = y(t)),
              (i._v = t);
          },
        }),
        d(i, 'reductor', {
          get: function () {
            var t = i.value,
              e = n.settings.perView;
            return u(t) ? t.before / e + t.after / e : (2 * t) / e;
          },
        }),
        e.on(['resize', 'update'], function () {
          i.mount();
        }),
        i
      );
    },
    Sizes: function (t, i, e) {
      var n = {
        setupSlides: function () {
          for (
            var t = this.slideWidth + 'px', e = i.Html.slides, n = 0;
            n < e.length;
            n++
          )
            e[n].style.width = t;
        },
        setupWrapper: function (t) {
          i.Html.wrapper.style.width = this.wrapperSize + 'px';
        },
        remove: function () {
          for (var t = i.Html.slides, e = 0; e < t.length; e++)
            t[e].style.width = '';
          i.Html.wrapper.style.width = '';
        },
      };
      return (
        d(n, 'length', {
          get: function () {
            return i.Html.slides.length;
          },
        }),
        d(n, 'width', {
          get: function () {
            return i.Html.root.offsetWidth;
          },
        }),
        d(n, 'wrapperSize', {
          get: function () {
            return n.slideWidth * n.length + i.Gaps.grow + i.Clones.grow;
          },
        }),
        d(n, 'slideWidth', {
          get: function () {
            return (
              n.width / t.settings.perView - i.Peek.reductor - i.Gaps.reductor
            );
          },
        }),
        e.on(['build.before', 'resize', 'update'], function () {
          n.setupSlides(), n.setupWrapper();
        }),
        e.on('destroy', function () {
          n.remove();
        }),
        n
      );
    },
    Gaps: function (e, o, t) {
      var n = {
        apply: function (t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style,
              r = o.Direction.value;
            (i[w[r][0]] = 0 !== e ? this.value / 2 + 'px' : ''),
              e !== t.length - 1
                ? (i[w[r][1]] = this.value / 2 + 'px')
                : (i[w[r][1]] = '');
          }
        },
        remove: function (t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style;
            (i.marginLeft = ''), (i.marginRight = '');
          }
        },
      };
      return (
        d(n, 'value', {
          get: function () {
            return y(e.settings.gap);
          },
        }),
        d(n, 'grow', {
          get: function () {
            return n.value * (o.Sizes.length - 1);
          },
        }),
        d(n, 'reductor', {
          get: function () {
            var t = e.settings.perView;
            return (n.value * (t - 1)) / t;
          },
        }),
        t.on(
          ['build.after', 'update'],
          b(function () {
            n.apply(o.Html.wrapper.children);
          }, 30)
        ),
        t.on('destroy', function () {
          n.remove(o.Html.wrapper.children);
        }),
        n
      );
    },
    Move: function (t, i, r) {
      var e = {
        mount: function () {
          this._o = 0;
        },
        make: function (t) {
          var e = this,
            n = 0 < arguments.length && void 0 !== t ? t : 0;
          (this.offset = n),
            r.emit('move', { movement: this.value }),
            i.Transition.after(function () {
              r.emit('move.after', { movement: e.value });
            });
        },
      };
      return (
        d(e, 'offset', {
          get: function () {
            return e._o;
          },
          set: function (t) {
            e._o = l(t) ? 0 : y(t);
          },
        }),
        d(e, 'translate', {
          get: function () {
            return i.Sizes.slideWidth * t.index;
          },
        }),
        d(e, 'value', {
          get: function () {
            var t = this.offset,
              e = this.translate;
            return i.Direction.is('rtl') ? e + t : e - t;
          },
        }),
        r.on(['build.before', 'run'], function () {
          e.make();
        }),
        e
      );
    },
    Clones: function (v, p, t) {
      var e = {
        mount: function () {
          (this.items = []),
            v.isType('carousel') && (this.items = this.collect());
        },
        collect: function (t) {
          for (
            var e = 0 < arguments.length && void 0 !== t ? t : [],
              n = p.Html.slides,
              i = v.settings,
              r = i.perView,
              o = i.classes,
              s = r + +!!v.settings.peek,
              u = n.slice(0, s),
              a = n.slice(-s),
              c = 0;
            c < Math.max(1, Math.floor(r / n.length));
            c++
          ) {
            for (var l = 0; l < u.length; l++) {
              var f = u[l].cloneNode(!0);
              f.classList.add(o.cloneSlide), e.push(f);
            }
            for (var d = 0; d < a.length; d++) {
              var h = a[d].cloneNode(!0);
              h.classList.add(o.cloneSlide), e.unshift(h);
            }
          }
          return e;
        },
        append: function () {
          for (
            var t = this.items,
              e = p.Html,
              n = e.wrapper,
              i = e.slides,
              r = Math.floor(t.length / 2),
              o = t.slice(0, r).reverse(),
              s = t.slice(r, t.length),
              u = p.Sizes.slideWidth + 'px',
              a = 0;
            a < s.length;
            a++
          )
            n.appendChild(s[a]);
          for (var c = 0; c < o.length; c++) n.insertBefore(o[c], i[0]);
          for (var l = 0; l < t.length; l++) t[l].style.width = u;
        },
        remove: function () {
          for (var t = this.items, e = 0; e < t.length; e++)
            p.Html.wrapper.removeChild(t[e]);
        },
      };
      return (
        d(e, 'grow', {
          get: function () {
            return (p.Sizes.slideWidth + p.Gaps.value) * e.items.length;
          },
        }),
        t.on('update', function () {
          e.remove(), e.mount(), e.append();
        }),
        t.on('build.before', function () {
          v.isType('carousel') && e.append();
        }),
        t.on('destroy', function () {
          e.remove();
        }),
        e
      );
    },
    Resize: function (t, e, n) {
      var i = new H(),
        r = {
          mount: function () {
            this.bind();
          },
          bind: function () {
            i.on(
              'resize',
              window,
              b(function () {
                n.emit('resize');
              }, t.settings.throttle)
            );
          },
          unbind: function () {
            i.off('resize', window);
          },
        };
      return (
        n.on('destroy', function () {
          r.unbind(), i.destroy();
        }),
        r
      );
    },
    Build: function (n, i, t) {
      var e = {
        mount: function () {
          t.emit('build.before'),
            this.typeClass(),
            this.activeClass(),
            t.emit('build.after');
        },
        typeClass: function () {
          i.Html.root.classList.add(n.settings.classes[n.settings.type]);
        },
        activeClass: function () {
          var e = n.settings.classes,
            t = i.Html.slides[n.index];
          t &&
            (t.classList.add(e.activeSlide),
            _(t).forEach(function (t) {
              t.classList.remove(e.activeSlide);
            }));
        },
        removeClasses: function () {
          var e = n.settings.classes;
          i.Html.root.classList.remove(e[n.settings.type]),
            i.Html.slides.forEach(function (t) {
              t.classList.remove(e.activeSlide);
            });
        },
      };
      return (
        t.on(['destroy', 'update'], function () {
          e.removeClasses();
        }),
        t.on(['resize', 'update'], function () {
          e.mount();
        }),
        t.on('move.after', function () {
          e.activeClass();
        }),
        e
      );
    },
    Run: function (o, n, i) {
      var t = {
        mount: function () {
          this._o = !1;
        },
        make: function (t) {
          var e = this;
          o.disabled ||
            (o.disable(),
            (this.move = t),
            i.emit('run.before', this.move),
            this.calculate(),
            i.emit('run', this.move),
            n.Transition.after(function () {
              e.isStart() && i.emit('run.start', e.move),
                e.isEnd() && i.emit('run.end', e.move),
                (e.isOffset('<') || e.isOffset('>')) &&
                  ((e._o = !1), i.emit('run.offset', e.move)),
                i.emit('run.after', e.move),
                o.enable();
            }));
        },
        calculate: function () {
          var t = this.move,
            e = this.length,
            n = t.steps,
            i = t.direction,
            r =
              (function (t) {
                return 'number' == typeof t;
              })(y(n)) && 0 !== y(n);
          switch (i) {
            case '>':
              '>' === n
                ? (o.index = e)
                : this.isEnd()
                ? (o.isType('slider') && !o.settings.rewind) ||
                  ((this._o = !0), (o.index = 0))
                : r
                ? (o.index += Math.min(e - o.index, -y(n)))
                : o.index++;
              break;
            case '<':
              '<' === n
                ? (o.index = 0)
                : this.isStart()
                ? (o.isType('slider') && !o.settings.rewind) ||
                  ((this._o = !0), (o.index = e))
                : r
                ? (o.index -= Math.min(o.index, y(n)))
                : o.index--;
              break;
            case '=':
              o.index = n;
          }
        },
        isStart: function () {
          return 0 === o.index;
        },
        isEnd: function () {
          return o.index === this.length;
        },
        isOffset: function (t) {
          return this._o && this.move.direction === t;
        },
      };
      return (
        d(t, 'move', {
          get: function () {
            return this._m;
          },
          set: function (t) {
            var e = t.substr(1);
            this._m = {
              direction: t.substr(0, 1),
              steps: e ? (y(e) ? y(e) : e) : 0,
            };
          },
        }),
        d(t, 'length', {
          get: function () {
            var t = o.settings,
              e = n.Html.slides.length;
            return o.isType('slider') && 'center' !== t.focusAt && t.bound
              ? e - 1 - (y(t.perView) - 1) + y(t.focusAt)
              : e - 1;
          },
        }),
        d(t, 'offset', {
          get: function () {
            return this._o;
          },
        }),
        t
      );
    },
    Swipe: function (d, h, v) {
      var n = new H(),
        p = 0,
        m = 0,
        g = 0,
        i = !1,
        r = !!L && { passive: !0 },
        t = {
          mount: function () {
            this.bindSwipeStart();
          },
          start: function (t) {
            if (!i && !d.disabled) {
              this.disable();
              var e = this.touches(t);
              (p = null),
                (m = y(e.pageX)),
                (g = y(e.pageY)),
                this.bindSwipeMove(),
                this.bindSwipeEnd(),
                v.emit('swipe.start');
            }
          },
          move: function (t) {
            if (!d.disabled) {
              var e = d.settings,
                n = e.touchAngle,
                i = e.touchRatio,
                r = e.classes,
                o = this.touches(t),
                s = y(o.pageX) - m,
                u = y(o.pageY) - g,
                a = Math.abs(s << 2),
                c = Math.abs(u << 2),
                l = Math.sqrt(a + c),
                f = Math.sqrt(c);
              if (!((180 * (p = Math.asin(f / l))) / Math.PI < n)) return !1;
              t.stopPropagation(),
                h.Move.make(
                  s *
                    (function (t) {
                      return parseFloat(t);
                    })(i)
                ),
                h.Html.root.classList.add(r.dragging),
                v.emit('swipe.move');
            }
          },
          end: function (t) {
            if (!d.disabled) {
              var e = d.settings,
                n = this.touches(t),
                i = this.threshold(t),
                r = n.pageX - m,
                o = (180 * p) / Math.PI,
                s = Math.round(r / h.Sizes.slideWidth);
              this.enable(),
                i < r && o < e.touchAngle
                  ? (e.perTouch && (s = Math.min(s, y(e.perTouch))),
                    h.Direction.is('rtl') && (s = -s),
                    h.Run.make(h.Direction.resolve('<' + s)))
                  : r < -i && o < e.touchAngle
                  ? (e.perTouch && (s = Math.max(s, -y(e.perTouch))),
                    h.Direction.is('rtl') && (s = -s),
                    h.Run.make(h.Direction.resolve('>' + s)))
                  : h.Move.make(),
                h.Html.root.classList.remove(e.classes.dragging),
                this.unbindSwipeMove(),
                this.unbindSwipeEnd(),
                v.emit('swipe.end');
            }
          },
          bindSwipeStart: function () {
            var e = this,
              t = d.settings;
            t.swipeThreshold &&
              n.on(
                z[0],
                h.Html.wrapper,
                function (t) {
                  e.start(t);
                },
                r
              ),
              t.dragThreshold &&
                n.on(
                  z[1],
                  h.Html.wrapper,
                  function (t) {
                    e.start(t);
                  },
                  r
                );
          },
          unbindSwipeStart: function () {
            n.off(z[0], h.Html.wrapper, r), n.off(z[1], h.Html.wrapper, r);
          },
          bindSwipeMove: function () {
            var e = this;
            n.on(
              j,
              h.Html.wrapper,
              b(function (t) {
                e.move(t);
              }, d.settings.throttle),
              r
            );
          },
          unbindSwipeMove: function () {
            n.off(j, h.Html.wrapper, r);
          },
          bindSwipeEnd: function () {
            var e = this;
            n.on(D, h.Html.wrapper, function (t) {
              e.end(t);
            });
          },
          unbindSwipeEnd: function () {
            n.off(D, h.Html.wrapper);
          },
          touches: function (t) {
            return -1 < E.indexOf(t.type)
              ? t
              : t.touches[0] || t.changedTouches[0];
          },
          threshold: function (t) {
            var e = d.settings;
            return -1 < E.indexOf(t.type) ? e.dragThreshold : e.swipeThreshold;
          },
          enable: function () {
            return (i = !1), h.Transition.enable(), this;
          },
          disable: function () {
            return (i = !0), h.Transition.disable(), this;
          },
        };
      return (
        v.on('build.after', function () {
          h.Html.root.classList.add(d.settings.classes.swipeable);
        }),
        v.on('destroy', function () {
          t.unbindSwipeStart(),
            t.unbindSwipeMove(),
            t.unbindSwipeEnd(),
            n.destroy();
        }),
        t
      );
    },
    Images: function (t, e, n) {
      var i = new H(),
        r = {
          mount: function () {
            this.bind();
          },
          bind: function () {
            i.on('dragstart', e.Html.wrapper, this.dragstart);
          },
          unbind: function () {
            i.off('dragstart', e.Html.wrapper);
          },
          dragstart: function (t) {
            t.preventDefault();
          },
        };
      return (
        n.on('destroy', function () {
          r.unbind(), i.destroy();
        }),
        r
      );
    },
    Anchors: function (t, e, n) {
      var i = new H(),
        r = !1,
        o = !1,
        s = {
          mount: function () {
            (this._a = e.Html.wrapper.querySelectorAll('a')), this.bind();
          },
          bind: function () {
            i.on('click', e.Html.wrapper, this.click);
          },
          unbind: function () {
            i.off('click', e.Html.wrapper);
          },
          click: function (t) {
            o && (t.stopPropagation(), t.preventDefault());
          },
          detach: function () {
            if (((o = !0), !r)) {
              for (var t = 0; t < this.items.length; t++)
                (this.items[t].draggable = !1),
                  this.items[t].setAttribute(
                    'data-href',
                    this.items[t].getAttribute('href')
                  ),
                  this.items[t].removeAttribute('href');
              r = !0;
            }
            return this;
          },
          attach: function () {
            if (((o = !1), r)) {
              for (var t = 0; t < this.items.length; t++)
                (this.items[t].draggable = !0),
                  this.items[t].setAttribute(
                    'href',
                    this.items[t].getAttribute('data-href')
                  );
              r = !1;
            }
            return this;
          },
        };
      return (
        d(s, 'items', {
          get: function () {
            return s._a;
          },
        }),
        n.on('swipe.move', function () {
          s.detach();
        }),
        n.on('swipe.end', function () {
          e.Transition.after(function () {
            s.attach();
          });
        }),
        n.on('destroy', function () {
          s.attach(), s.unbind(), i.destroy();
        }),
        s
      );
    },
    Controls: function (i, e, t) {
      var n = new H(),
        r = !!L && { passive: !0 },
        o = {
          mount: function () {
            (this._n = e.Html.root.querySelectorAll(
              '[data-glide-el="controls[nav]"]'
            )),
              (this._c = e.Html.root.querySelectorAll(
                '[data-glide-el^="controls"]'
              )),
              this.addBindings();
          },
          setActive: function () {
            for (var t = 0; t < this._n.length; t++)
              this.addClass(this._n[t].children);
          },
          removeActive: function () {
            for (var t = 0; t < this._n.length; t++)
              this.removeClass(this._n[t].children);
          },
          addClass: function (t) {
            var e = i.settings,
              n = t[i.index];
            n &&
              (n.classList.add(e.classes.activeNav),
              _(n).forEach(function (t) {
                t.classList.remove(e.classes.activeNav);
              }));
          },
          removeClass: function (t) {
            var e = t[i.index];
            e && e.classList.remove(i.settings.classes.activeNav);
          },
          addBindings: function () {
            for (var t = 0; t < this._c.length; t++)
              this.bind(this._c[t].children);
          },
          removeBindings: function () {
            for (var t = 0; t < this._c.length; t++)
              this.unbind(this._c[t].children);
          },
          bind: function (t) {
            for (var e = 0; e < t.length; e++)
              n.on('click', t[e], this.click),
                n.on('touchstart', t[e], this.click, r);
          },
          unbind: function (t) {
            for (var e = 0; e < t.length; e++)
              n.off(['click', 'touchstart'], t[e]);
          },
          click: function (t) {
            t.preventDefault(),
              e.Run.make(
                e.Direction.resolve(
                  t.currentTarget.getAttribute('data-glide-dir')
                )
              );
          },
        };
      return (
        d(o, 'items', {
          get: function () {
            return o._c;
          },
        }),
        t.on(['mount.after', 'move.after'], function () {
          o.setActive();
        }),
        t.on('destroy', function () {
          o.removeBindings(), o.removeActive(), n.destroy();
        }),
        o
      );
    },
    Keyboard: function (t, e, n) {
      var i = new H(),
        r = {
          mount: function () {
            t.settings.keyboard && this.bind();
          },
          bind: function () {
            i.on('keyup', document, this.press);
          },
          unbind: function () {
            i.off('keyup', document);
          },
          press: function (t) {
            39 === t.keyCode && e.Run.make(e.Direction.resolve('>')),
              37 === t.keyCode && e.Run.make(e.Direction.resolve('<'));
          },
        };
      return (
        n.on(['destroy', 'update'], function () {
          r.unbind();
        }),
        n.on('update', function () {
          r.mount();
        }),
        n.on('destroy', function () {
          i.destroy();
        }),
        r
      );
    },
    Autoplay: function (e, n, t) {
      var i = new H(),
        r = {
          mount: function () {
            this.start(), e.settings.hoverpause && this.bind();
          },
          start: function () {
            var t = this;
            e.settings.autoplay &&
              l(this._i) &&
              (this._i = setInterval(function () {
                t.stop(), n.Run.make('>'), t.start();
              }, this.time));
          },
          stop: function () {
            this._i = clearInterval(this._i);
          },
          bind: function () {
            var t = this;
            i.on('mouseover', n.Html.root, function () {
              t.stop();
            }),
              i.on('mouseout', n.Html.root, function () {
                t.start();
              });
          },
          unbind: function () {
            i.off(['mouseover', 'mouseout'], n.Html.root);
          },
        };
      return (
        d(r, 'time', {
          get: function () {
            var t = n.Html.slides[e.index].getAttribute('data-glide-autoplay');
            return y(t || e.settings.autoplay);
          },
        }),
        t.on(['destroy', 'update'], function () {
          r.unbind();
        }),
        t.on(
          ['run.before', 'pause', 'destroy', 'swipe.start', 'update'],
          function () {
            r.stop();
          }
        ),
        t.on(['run.after', 'play', 'swipe.end'], function () {
          r.start();
        }),
        t.on('update', function () {
          r.mount();
        }),
        t.on('destroy', function () {
          i.destroy();
        }),
        r
      );
    },
    Breakpoints: function (t, e, n) {
      var i = new H(),
        r = t.settings,
        o = R(r.breakpoints),
        s = a({}, r),
        u = {
          match: function (t) {
            if (void 0 !== window.matchMedia)
              for (var e in t)
                if (
                  t.hasOwnProperty(e) &&
                  window.matchMedia('(max-width: ' + e + 'px)').matches
                )
                  return t[e];
            return s;
          },
        };
      return (
        a(r, u.match(o)),
        i.on(
          'resize',
          window,
          b(function () {
            t.settings = h(r, u.match(o));
          }, t.settings.throttle)
        ),
        n.on('update', function () {
          (o = R(o)), (s = a({}, r));
        }),
        n.on('destroy', function () {
          i.off('resize', window);
        }),
        u
      );
    },
  };
  function G() {
    return (
      i(this, G),
      (function (t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ('object' != typeof e && 'function' != typeof e) ? t : e;
      })(this, (G.__proto__ || Object.getPrototypeOf(G)).apply(this, arguments))
    );
  }
  return (
    (function (t, e) {
      if ('function' != typeof e && null !== e)
        throw new TypeError(
          'Super expression must either be null or a function, not ' + typeof e
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
        e &&
          (Object.setPrototypeOf
            ? Object.setPrototypeOf(t, e)
            : (t.__proto__ = e));
    })(G, p),
    t(G, [
      {
        key: 'mount',
        value: function (t) {
          var e = 0 < arguments.length && void 0 !== t ? t : {};
          return (function t(e, n, i) {
            null === e && (e = Function.prototype);
            var r = Object.getOwnPropertyDescriptor(e, n);
            if (void 0 === r) {
              var o = Object.getPrototypeOf(e);
              return null === o ? void 0 : t(o, n, i);
            }
            if ('value' in r) return r.value;
            var s = r.get;
            return void 0 !== s ? s.call(i) : void 0;
          })(
            G.prototype.__proto__ || Object.getPrototypeOf(G.prototype),
            'mount',
            this
          ).call(this, a({}, W, e));
        },
      },
    ]),
    G
  );
});

/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!(function (t, e) {
  'function' == typeof define && define.amd
    ? define('jquery-bridget/jquery-bridget', ['jquery'], function (i) {
        return e(t, i);
      })
    : 'object' == typeof module && module.exports
    ? (module.exports = e(t, require('jquery')))
    : (t.jQueryBridget = e(t, t.jQuery));
})(window, function (t, e) {
  'use strict';
  function i(i, r, a) {
    function h(t, e, n) {
      var o,
        r = '$().' + i + '("' + e + '")';
      return (
        t.each(function (t, h) {
          var u = a.data(h, i);
          if (!u)
            return void s(
              i + ' not initialized. Cannot call methods, i.e. ' + r
            );
          var d = u[e];
          if (!d || '_' == e.charAt(0))
            return void s(r + ' is not a valid method');
          var l = d.apply(u, n);
          o = void 0 === o ? l : o;
        }),
        void 0 !== o ? o : t
      );
    }
    function u(t, e) {
      t.each(function (t, n) {
        var o = a.data(n, i);
        o ? (o.option(e), o._init()) : ((o = new r(n, e)), a.data(n, i, o));
      });
    }
    (a = a || e || t.jQuery),
      a &&
        (r.prototype.option ||
          (r.prototype.option = function (t) {
            a.isPlainObject(t) &&
              (this.options = a.extend(!0, this.options, t));
          }),
        (a.fn[i] = function (t) {
          if ('string' == typeof t) {
            var e = o.call(arguments, 1);
            return h(this, t, e);
          }
          return u(this, t), this;
        }),
        n(a));
  }
  function n(t) {
    !t || (t && t.bridget) || (t.bridget = i);
  }
  var o = Array.prototype.slice,
    r = t.console,
    s =
      'undefined' == typeof r
        ? function () {}
        : function (t) {
            r.error(t);
          };
  return n(e || t.jQuery), i;
}),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define('ev-emitter/ev-emitter', e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })('undefined' != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[t] = i[t] || {});
          return (n[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          (i = i.slice(0)), (e = e || []);
          for (
            var n = this._onceEvents && this._onceEvents[t], o = 0;
            o < i.length;
            o++
          ) {
            var r = i[o],
              s = n && n[r];
            s && (this.off(t, r), delete n[r]), r.apply(this, e);
          }
          return this;
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      t
    );
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define('get-size/get-size', e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    'use strict';
    function t(t) {
      var e = parseFloat(t),
        i = -1 == t.indexOf('%') && !isNaN(e);
      return i && e;
    }
    function e() {}
    function i() {
      for (
        var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
          },
          e = 0;
        u > e;
        e++
      ) {
        var i = h[e];
        t[i] = 0;
      }
      return t;
    }
    function n(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          a(
            'Style returned ' +
              e +
              '. Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1'
          ),
        e
      );
    }
    function o() {
      if (!d) {
        d = !0;
        var e = document.createElement('div');
        (e.style.width = '200px'),
          (e.style.padding = '1px 2px 3px 4px'),
          (e.style.borderStyle = 'solid'),
          (e.style.borderWidth = '1px 2px 3px 4px'),
          (e.style.boxSizing = 'border-box');
        var i = document.body || document.documentElement;
        i.appendChild(e);
        var o = n(e);
        (s = 200 == Math.round(t(o.width))),
          (r.isBoxSizeOuter = s),
          i.removeChild(e);
      }
    }
    function r(e) {
      if (
        (o(),
        'string' == typeof e && (e = document.querySelector(e)),
        e && 'object' == typeof e && e.nodeType)
      ) {
        var r = n(e);
        if ('none' == r.display) return i();
        var a = {};
        (a.width = e.offsetWidth), (a.height = e.offsetHeight);
        for (
          var d = (a.isBorderBox = 'border-box' == r.boxSizing), l = 0;
          u > l;
          l++
        ) {
          var c = h[l],
            f = r[c],
            m = parseFloat(f);
          a[c] = isNaN(m) ? 0 : m;
        }
        var p = a.paddingLeft + a.paddingRight,
          g = a.paddingTop + a.paddingBottom,
          y = a.marginLeft + a.marginRight,
          v = a.marginTop + a.marginBottom,
          _ = a.borderLeftWidth + a.borderRightWidth,
          z = a.borderTopWidth + a.borderBottomWidth,
          E = d && s,
          b = t(r.width);
        b !== !1 && (a.width = b + (E ? 0 : p + _));
        var x = t(r.height);
        return (
          x !== !1 && (a.height = x + (E ? 0 : g + z)),
          (a.innerWidth = a.width - (p + _)),
          (a.innerHeight = a.height - (g + z)),
          (a.outerWidth = a.width + y),
          (a.outerHeight = a.height + v),
          a
        );
      }
    }
    var s,
      a =
        'undefined' == typeof console
          ? e
          : function (t) {
              console.error(t);
            },
      h = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth',
      ],
      u = h.length,
      d = !1;
    return r;
  }),
  (function (t, e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define('desandro-matches-selector/matches-selector', e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    'use strict';
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return 'matches';
      if (t.matchesSelector) return 'matchesSelector';
      for (var e = ['webkit', 'moz', 'ms', 'o'], i = 0; i < e.length; i++) {
        var n = e[i],
          o = n + 'MatchesSelector';
        if (t[o]) return o;
      }
    })();
    return function (e, i) {
      return e[t](i);
    };
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define(
          'fizzy-ui-utils/utils',
          ['desandro-matches-selector/matches-selector'],
          function (i) {
            return e(t, i);
          }
        )
      : 'object' == typeof module && module.exports
      ? (module.exports = e(t, require('desandro-matches-selector')))
      : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var i = {};
    (i.extend = function (t, e) {
      for (var i in e) t[i] = e[i];
      return t;
    }),
      (i.modulo = function (t, e) {
        return ((t % e) + e) % e;
      });
    var n = Array.prototype.slice;
    (i.makeArray = function (t) {
      if (Array.isArray(t)) return t;
      if (null === t || void 0 === t) return [];
      var e = 'object' == typeof t && 'number' == typeof t.length;
      return e ? n.call(t) : [t];
    }),
      (i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (i.getParent = function (t, i) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, i))) return t;
      }),
      (i.getQueryElement = function (t) {
        return 'string' == typeof t ? document.querySelector(t) : t;
      }),
      (i.handleEvent = function (t) {
        var e = 'on' + t.type;
        this[e] && this[e](t);
      }),
      (i.filterFindElements = function (t, n) {
        t = i.makeArray(t);
        var o = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement) {
              if (!n) return void o.push(t);
              e(t, n) && o.push(t);
              for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++)
                o.push(i[r]);
            }
          }),
          o
        );
      }),
      (i.debounceMethod = function (t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
          o = e + 'Timeout';
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            r = this;
          this[o] = setTimeout(function () {
            n.apply(r, e), delete r[o];
          }, i);
        };
      }),
      (i.docReady = function (t) {
        var e = document.readyState;
        'complete' == e || 'interactive' == e
          ? setTimeout(t)
          : document.addEventListener('DOMContentLoaded', t);
      }),
      (i.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + '-' + i;
          })
          .toLowerCase();
      });
    var o = t.console;
    return (
      (i.htmlInit = function (e, n) {
        i.docReady(function () {
          var r = i.toDashed(n),
            s = 'data-' + r,
            a = document.querySelectorAll('[' + s + ']'),
            h = document.querySelectorAll('.js-' + r),
            u = i.makeArray(a).concat(i.makeArray(h)),
            d = s + '-options',
            l = t.jQuery;
          u.forEach(function (t) {
            var i,
              r = t.getAttribute(s) || t.getAttribute(d);
            try {
              i = r && JSON.parse(r);
            } catch (a) {
              return void (
                o &&
                o.error('Error parsing ' + s + ' on ' + t.className + ': ' + a)
              );
            }
            var h = new e(t, i);
            l && l.data(t, n, h);
          });
        });
      }),
      i
    );
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define(
          'outlayer/item',
          ['ev-emitter/ev-emitter', 'get-size/get-size'],
          e
        )
      : 'object' == typeof module && module.exports
      ? (module.exports = e(require('ev-emitter'), require('get-size')))
      : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
  })(window, function (t, e) {
    'use strict';
    function i(t) {
      for (var e in t) return !1;
      return (e = null), !0;
    }
    function n(t, e) {
      t &&
        ((this.element = t),
        (this.layout = e),
        (this.position = { x: 0, y: 0 }),
        this._create());
    }
    function o(t) {
      return t.replace(/([A-Z])/g, function (t) {
        return '-' + t.toLowerCase();
      });
    }
    var r = document.documentElement.style,
      s = 'string' == typeof r.transition ? 'transition' : 'WebkitTransition',
      a = 'string' == typeof r.transform ? 'transform' : 'WebkitTransform',
      h = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend',
      }[s],
      u = {
        transform: a,
        transition: s,
        transitionDuration: s + 'Duration',
        transitionProperty: s + 'Property',
        transitionDelay: s + 'Delay',
      },
      d = (n.prototype = Object.create(t.prototype));
    (d.constructor = n),
      (d._create = function () {
        (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
          this.css({ position: 'absolute' });
      }),
      (d.handleEvent = function (t) {
        var e = 'on' + t.type;
        this[e] && this[e](t);
      }),
      (d.getSize = function () {
        this.size = e(this.element);
      }),
      (d.css = function (t) {
        var e = this.element.style;
        for (var i in t) {
          var n = u[i] || i;
          e[n] = t[i];
        }
      }),
      (d.getPosition = function () {
        var t = getComputedStyle(this.element),
          e = this.layout._getOption('originLeft'),
          i = this.layout._getOption('originTop'),
          n = t[e ? 'left' : 'right'],
          o = t[i ? 'top' : 'bottom'],
          r = parseFloat(n),
          s = parseFloat(o),
          a = this.layout.size;
        -1 != n.indexOf('%') && (r = (r / 100) * a.width),
          -1 != o.indexOf('%') && (s = (s / 100) * a.height),
          (r = isNaN(r) ? 0 : r),
          (s = isNaN(s) ? 0 : s),
          (r -= e ? a.paddingLeft : a.paddingRight),
          (s -= i ? a.paddingTop : a.paddingBottom),
          (this.position.x = r),
          (this.position.y = s);
      }),
      (d.layoutPosition = function () {
        var t = this.layout.size,
          e = {},
          i = this.layout._getOption('originLeft'),
          n = this.layout._getOption('originTop'),
          o = i ? 'paddingLeft' : 'paddingRight',
          r = i ? 'left' : 'right',
          s = i ? 'right' : 'left',
          a = this.position.x + t[o];
        (e[r] = this.getXValue(a)), (e[s] = '');
        var h = n ? 'paddingTop' : 'paddingBottom',
          u = n ? 'top' : 'bottom',
          d = n ? 'bottom' : 'top',
          l = this.position.y + t[h];
        (e[u] = this.getYValue(l)),
          (e[d] = ''),
          this.css(e),
          this.emitEvent('layout', [this]);
      }),
      (d.getXValue = function (t) {
        var e = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && !e
          ? (t / this.layout.size.width) * 100 + '%'
          : t + 'px';
      }),
      (d.getYValue = function (t) {
        var e = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && e
          ? (t / this.layout.size.height) * 100 + '%'
          : t + 'px';
      }),
      (d._transitionTo = function (t, e) {
        this.getPosition();
        var i = this.position.x,
          n = this.position.y,
          o = t == this.position.x && e == this.position.y;
        if ((this.setPosition(t, e), o && !this.isTransitioning))
          return void this.layoutPosition();
        var r = t - i,
          s = e - n,
          a = {};
        (a.transform = this.getTranslate(r, s)),
          this.transition({
            to: a,
            onTransitionEnd: { transform: this.layoutPosition },
            isCleaning: !0,
          });
      }),
      (d.getTranslate = function (t, e) {
        var i = this.layout._getOption('originLeft'),
          n = this.layout._getOption('originTop');
        return (
          (t = i ? t : -t),
          (e = n ? e : -e),
          'translate3d(' + t + 'px, ' + e + 'px, 0)'
        );
      }),
      (d.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition();
      }),
      (d.moveTo = d._transitionTo),
      (d.setPosition = function (t, e) {
        (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
      }),
      (d._nonTransition = function (t) {
        this.css(t.to), t.isCleaning && this._removeStyles(t.to);
        for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this);
      }),
      (d.transition = function (t) {
        if (!parseFloat(this.layout.options.transitionDuration))
          return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to)
          (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
          this.css(t.from);
          var n = this.element.offsetHeight;
          n = null;
        }
        this.enableTransition(t.to),
          this.css(t.to),
          (this.isTransitioning = !0);
      });
    var l = 'opacity,' + o(a);
    (d.enableTransition = function () {
      if (!this.isTransitioning) {
        var t = this.layout.options.transitionDuration;
        (t = 'number' == typeof t ? t + 'ms' : t),
          this.css({
            transitionProperty: l,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0,
          }),
          this.element.addEventListener(h, this, !1);
      }
    }),
      (d.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }),
      (d.onotransitionend = function (t) {
        this.ontransitionend(t);
      });
    var c = { '-webkit-transform': 'transform' };
    (d.ontransitionend = function (t) {
      if (t.target === this.element) {
        var e = this._transn,
          n = c[t.propertyName] || t.propertyName;
        if (
          (delete e.ingProperties[n],
          i(e.ingProperties) && this.disableTransition(),
          n in e.clean &&
            ((this.element.style[t.propertyName] = ''), delete e.clean[n]),
          n in e.onEnd)
        ) {
          var o = e.onEnd[n];
          o.call(this), delete e.onEnd[n];
        }
        this.emitEvent('transitionEnd', [this]);
      }
    }),
      (d.disableTransition = function () {
        this.removeTransitionStyles(),
          this.element.removeEventListener(h, this, !1),
          (this.isTransitioning = !1);
      }),
      (d._removeStyles = function (t) {
        var e = {};
        for (var i in t) e[i] = '';
        this.css(e);
      });
    var f = {
      transitionProperty: '',
      transitionDuration: '',
      transitionDelay: '',
    };
    return (
      (d.removeTransitionStyles = function () {
        this.css(f);
      }),
      (d.stagger = function (t) {
        (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + 'ms');
      }),
      (d.removeElem = function () {
        this.element.parentNode.removeChild(this.element),
          this.css({ display: '' }),
          this.emitEvent('remove', [this]);
      }),
      (d.remove = function () {
        return s && parseFloat(this.layout.options.transitionDuration)
          ? (this.once('transitionEnd', function () {
              this.removeElem();
            }),
            void this.hide())
          : void this.removeElem();
      }),
      (d.reveal = function () {
        delete this.isHidden, this.css({ display: '' });
        var t = this.layout.options,
          e = {},
          i = this.getHideRevealTransitionEndProperty('visibleStyle');
        (e[i] = this.onRevealTransitionEnd),
          this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (d.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent('reveal');
      }),
      (d.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return 'opacity';
        for (var i in e) return i;
      }),
      (d.hide = function () {
        (this.isHidden = !0), this.css({ display: '' });
        var t = this.layout.options,
          e = {},
          i = this.getHideRevealTransitionEndProperty('hiddenStyle');
        (e[i] = this.onHideTransitionEnd),
          this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (d.onHideTransitionEnd = function () {
        this.isHidden &&
          (this.css({ display: 'none' }), this.emitEvent('hide'));
      }),
      (d.destroy = function () {
        this.css({
          position: '',
          left: '',
          right: '',
          top: '',
          bottom: '',
          transition: '',
          transform: '',
        });
      }),
      n
    );
  }),
  (function (t, e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(
          'outlayer/outlayer',
          [
            'ev-emitter/ev-emitter',
            'get-size/get-size',
            'fizzy-ui-utils/utils',
            './item',
          ],
          function (i, n, o, r) {
            return e(t, i, n, o, r);
          }
        )
      : 'object' == typeof module && module.exports
      ? (module.exports = e(
          t,
          require('ev-emitter'),
          require('get-size'),
          require('fizzy-ui-utils'),
          require('./item')
        ))
      : (t.Outlayer = e(
          t,
          t.EvEmitter,
          t.getSize,
          t.fizzyUIUtils,
          t.Outlayer.Item
        ));
  })(window, function (t, e, i, n, o) {
    'use strict';
    function r(t, e) {
      var i = n.getQueryElement(t);
      if (!i)
        return void (
          h &&
          h.error(
            'Bad element for ' + this.constructor.namespace + ': ' + (i || t)
          )
        );
      (this.element = i),
        u && (this.$element = u(this.element)),
        (this.options = n.extend({}, this.constructor.defaults)),
        this.option(e);
      var o = ++l;
      (this.element.outlayerGUID = o), (c[o] = this), this._create();
      var r = this._getOption('initLayout');
      r && this.layout();
    }
    function s(t) {
      function e() {
        t.apply(this, arguments);
      }
      return (
        (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        e
      );
    }
    function a(t) {
      if ('number' == typeof t) return t;
      var e = t.match(/(^\d*\.?\d*)(\w*)/),
        i = e && e[1],
        n = e && e[2];
      if (!i.length) return 0;
      i = parseFloat(i);
      var o = m[n] || 1;
      return i * o;
    }
    var h = t.console,
      u = t.jQuery,
      d = function () {},
      l = 0,
      c = {};
    (r.namespace = 'outlayer'),
      (r.Item = o),
      (r.defaults = {
        containerStyle: { position: 'relative' },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: '0.4s',
        hiddenStyle: { opacity: 0, transform: 'scale(0.001)' },
        visibleStyle: { opacity: 1, transform: 'scale(1)' },
      });
    var f = r.prototype;
    n.extend(f, e.prototype),
      (f.option = function (t) {
        n.extend(this.options, t);
      }),
      (f._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e]
          ? this.options[e]
          : this.options[t];
      }),
      (r.compatOptions = {
        initLayout: 'isInitLayout',
        horizontal: 'isHorizontal',
        layoutInstant: 'isLayoutInstant',
        originLeft: 'isOriginLeft',
        originTop: 'isOriginTop',
        resize: 'isResizeBound',
        resizeContainer: 'isResizingContainer',
      }),
      (f._create = function () {
        this.reloadItems(),
          (this.stamps = []),
          this.stamp(this.options.stamp),
          n.extend(this.element.style, this.options.containerStyle);
        var t = this._getOption('resize');
        t && this.bindResize();
      }),
      (f.reloadItems = function () {
        this.items = this._itemize(this.element.children);
      }),
      (f._itemize = function (t) {
        for (
          var e = this._filterFindItemElements(t),
            i = this.constructor.Item,
            n = [],
            o = 0;
          o < e.length;
          o++
        ) {
          var r = e[o],
            s = new i(r, this);
          n.push(s);
        }
        return n;
      }),
      (f._filterFindItemElements = function (t) {
        return n.filterFindElements(t, this.options.itemSelector);
      }),
      (f.getItemElements = function () {
        return this.items.map(function (t) {
          return t.element;
        });
      }),
      (f.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption('layoutInstant'),
          e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), (this._isLayoutInited = !0);
      }),
      (f._init = f.layout),
      (f._resetLayout = function () {
        this.getSize();
      }),
      (f.getSize = function () {
        this.size = i(this.element);
      }),
      (f._getMeasurement = function (t, e) {
        var n,
          o = this.options[t];
        o
          ? ('string' == typeof o
              ? (n = this.element.querySelector(o))
              : o instanceof HTMLElement && (n = o),
            (this[t] = n ? i(n)[e] : o))
          : (this[t] = 0);
      }),
      (f.layoutItems = function (t, e) {
        (t = this._getItemsForLayout(t)),
          this._layoutItems(t, e),
          this._postLayout();
      }),
      (f._getItemsForLayout = function (t) {
        return t.filter(function (t) {
          return !t.isIgnored;
        });
      }),
      (f._layoutItems = function (t, e) {
        if ((this._emitCompleteOnItems('layout', t), t && t.length)) {
          var i = [];
          t.forEach(function (t) {
            var n = this._getItemLayoutPosition(t);
            (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
          }, this),
            this._processLayoutQueue(i);
        }
      }),
      (f._getItemLayoutPosition = function () {
        return { x: 0, y: 0 };
      }),
      (f._processLayoutQueue = function (t) {
        this.updateStagger(),
          t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
          }, this);
      }),
      (f.updateStagger = function () {
        var t = this.options.stagger;
        return null === t || void 0 === t
          ? void (this.stagger = 0)
          : ((this.stagger = a(t)), this.stagger);
      }),
      (f._positionItem = function (t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
      }),
      (f._postLayout = function () {
        this.resizeContainer();
      }),
      (f.resizeContainer = function () {
        var t = this._getOption('resizeContainer');
        if (t) {
          var e = this._getContainerSize();
          e &&
            (this._setContainerMeasure(e.width, !0),
            this._setContainerMeasure(e.height, !1));
        }
      }),
      (f._getContainerSize = d),
      (f._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
          var i = this.size;
          i.isBorderBox &&
            (t += e
              ? i.paddingLeft +
                i.paddingRight +
                i.borderLeftWidth +
                i.borderRightWidth
              : i.paddingBottom +
                i.paddingTop +
                i.borderTopWidth +
                i.borderBottomWidth),
            (t = Math.max(t, 0)),
            (this.element.style[e ? 'width' : 'height'] = t + 'px');
        }
      }),
      (f._emitCompleteOnItems = function (t, e) {
        function i() {
          o.dispatchEvent(t + 'Complete', null, [e]);
        }
        function n() {
          s++, s == r && i();
        }
        var o = this,
          r = e.length;
        if (!e || !r) return void i();
        var s = 0;
        e.forEach(function (e) {
          e.once(t, n);
        });
      }),
      (f.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), u))
          if (((this.$element = this.$element || u(this.element)), e)) {
            var o = u.Event(e);
            (o.type = t), this.$element.trigger(o, i);
          } else this.$element.trigger(t, i);
      }),
      (f.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
      }),
      (f.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
      }),
      (f.stamp = function (t) {
        (t = this._find(t)),
          t &&
            ((this.stamps = this.stamps.concat(t)),
            t.forEach(this.ignore, this));
      }),
      (f.unstamp = function (t) {
        (t = this._find(t)),
          t &&
            t.forEach(function (t) {
              n.removeFrom(this.stamps, t), this.unignore(t);
            }, this);
      }),
      (f._find = function (t) {
        return t
          ? ('string' == typeof t && (t = this.element.querySelectorAll(t)),
            (t = n.makeArray(t)))
          : void 0;
      }),
      (f._manageStamps = function () {
        this.stamps &&
          this.stamps.length &&
          (this._getBoundingRect(),
          this.stamps.forEach(this._manageStamp, this));
      }),
      (f._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(),
          e = this.size;
        this._boundingRect = {
          left: t.left + e.paddingLeft + e.borderLeftWidth,
          top: t.top + e.paddingTop + e.borderTopWidth,
          right: t.right - (e.paddingRight + e.borderRightWidth),
          bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
        };
      }),
      (f._manageStamp = d),
      (f._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(),
          n = this._boundingRect,
          o = i(t),
          r = {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom,
          };
        return r;
      }),
      (f.handleEvent = n.handleEvent),
      (f.bindResize = function () {
        t.addEventListener('resize', this), (this.isResizeBound = !0);
      }),
      (f.unbindResize = function () {
        t.removeEventListener('resize', this), (this.isResizeBound = !1);
      }),
      (f.onresize = function () {
        this.resize();
      }),
      n.debounceMethod(r, 'onresize', 100),
      (f.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
      }),
      (f.needsResizeLayout = function () {
        var t = i(this.element),
          e = this.size && t;
        return e && t.innerWidth !== this.size.innerWidth;
      }),
      (f.addItems = function (t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e;
      }),
      (f.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
      }),
      (f.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          var i = this.items.slice(0);
          (this.items = e.concat(i)),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i);
        }
      }),
      (f.reveal = function (t) {
        if ((this._emitCompleteOnItems('reveal', t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.reveal();
          });
        }
      }),
      (f.hide = function (t) {
        if ((this._emitCompleteOnItems('hide', t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.hide();
          });
        }
      }),
      (f.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e);
      }),
      (f.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e);
      }),
      (f.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var i = this.items[e];
          if (i.element == t) return i;
        }
      }),
      (f.getItems = function (t) {
        t = n.makeArray(t);
        var e = [];
        return (
          t.forEach(function (t) {
            var i = this.getItem(t);
            i && e.push(i);
          }, this),
          e
        );
      }),
      (f.remove = function (t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems('remove', e),
          e &&
            e.length &&
            e.forEach(function (t) {
              t.remove(), n.removeFrom(this.items, t);
            }, this);
      }),
      (f.destroy = function () {
        var t = this.element.style;
        (t.height = ''),
          (t.position = ''),
          (t.width = ''),
          this.items.forEach(function (t) {
            t.destroy();
          }),
          this.unbindResize();
        var e = this.element.outlayerGUID;
        delete c[e],
          delete this.element.outlayerGUID,
          u && u.removeData(this.element, this.constructor.namespace);
      }),
      (r.data = function (t) {
        t = n.getQueryElement(t);
        var e = t && t.outlayerGUID;
        return e && c[e];
      }),
      (r.create = function (t, e) {
        var i = s(r);
        return (
          (i.defaults = n.extend({}, r.defaults)),
          n.extend(i.defaults, e),
          (i.compatOptions = n.extend({}, r.compatOptions)),
          (i.namespace = t),
          (i.data = r.data),
          (i.Item = s(o)),
          n.htmlInit(i, t),
          u && u.bridget && u.bridget(t, i),
          i
        );
      });
    var m = { ms: 1, s: 1e3 };
    return (r.Item = o), r;
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define(['outlayer/outlayer', 'get-size/get-size'], e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e(require('outlayer'), require('get-size')))
      : (t.Masonry = e(t.Outlayer, t.getSize));
  })(window, function (t, e) {
    var i = t.create('masonry');
    i.compatOptions.fitWidth = 'isFitWidth';
    var n = i.prototype;
    return (
      (n._resetLayout = function () {
        this.getSize(),
          this._getMeasurement('columnWidth', 'outerWidth'),
          this._getMeasurement('gutter', 'outerWidth'),
          this.measureColumns(),
          (this.colYs = []);
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        (this.maxY = 0), (this.horizontalColIndex = 0);
      }),
      (n.measureColumns = function () {
        if ((this.getContainerWidth(), !this.columnWidth)) {
          var t = this.items[0],
            i = t && t.element;
          this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
        }
        var n = (this.columnWidth += this.gutter),
          o = this.containerWidth + this.gutter,
          r = o / n,
          s = n - (o % n),
          a = s && 1 > s ? 'round' : 'floor';
        (r = Math[a](r)), (this.cols = Math.max(r, 1));
      }),
      (n.getContainerWidth = function () {
        var t = this._getOption('fitWidth'),
          i = t ? this.element.parentNode : this.element,
          n = e(i);
        this.containerWidth = n && n.innerWidth;
      }),
      (n._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
          i = e && 1 > e ? 'round' : 'ceil',
          n = Math[i](t.size.outerWidth / this.columnWidth);
        n = Math.min(n, this.cols);
        for (
          var o = this.options.horizontalOrder
              ? '_getHorizontalColPosition'
              : '_getTopColPosition',
            r = this[o](n, t),
            s = { x: this.columnWidth * r.col, y: r.y },
            a = r.y + t.size.outerHeight,
            h = n + r.col,
            u = r.col;
          h > u;
          u++
        )
          this.colYs[u] = a;
        return s;
      }),
      (n._getTopColPosition = function (t) {
        var e = this._getTopColGroup(t),
          i = Math.min.apply(Math, e);
        return { col: e.indexOf(i), y: i };
      }),
      (n._getTopColGroup = function (t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++)
          e[n] = this._getColGroupY(n, t);
        return e;
      }),
      (n._getColGroupY = function (t, e) {
        if (2 > e) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i);
      }),
      (n._getHorizontalColPosition = function (t, e) {
        var i = this.horizontalColIndex % this.cols,
          n = t > 1 && i + t > this.cols;
        i = n ? 0 : i;
        var o = e.size.outerWidth && e.size.outerHeight;
        return (
          (this.horizontalColIndex = o ? i + t : this.horizontalColIndex),
          { col: i, y: this._getColGroupY(i, t) }
        );
      }),
      (n._manageStamp = function (t) {
        var i = e(t),
          n = this._getElementOffset(t),
          o = this._getOption('originLeft'),
          r = o ? n.left : n.right,
          s = r + i.outerWidth,
          a = Math.floor(r / this.columnWidth);
        a = Math.max(0, a);
        var h = Math.floor(s / this.columnWidth);
        (h -= s % this.columnWidth ? 0 : 1), (h = Math.min(this.cols - 1, h));
        for (
          var u = this._getOption('originTop'),
            d = (u ? n.top : n.bottom) + i.outerHeight,
            l = a;
          h >= l;
          l++
        )
          this.colYs[l] = Math.max(d, this.colYs[l]);
      }),
      (n._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = { height: this.maxY };
        return (
          this._getOption('fitWidth') &&
            (t.width = this._getContainerFitWidth()),
          t
        );
      }),
      (n._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
      }),
      (n.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth;
      }),
      i
    );
  });

/*!
 * headroom.js v0.12.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!(function (t, n) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = n())
    : 'function' == typeof define && define.amd
    ? define(n)
    : ((t = t || self).Headroom = n());
})(this, function () {
  'use strict';
  function t() {
    return 'undefined' != typeof window;
  }
  function d(t) {
    return (function (t) {
      return (
        t &&
        t.document &&
        (function (t) {
          return 9 === t.nodeType;
        })(t.document)
      );
    })(t)
      ? (function (t) {
          var n = t.document,
            o = n.body,
            s = n.documentElement;
          return {
            scrollHeight: function () {
              return Math.max(
                o.scrollHeight,
                s.scrollHeight,
                o.offsetHeight,
                s.offsetHeight,
                o.clientHeight,
                s.clientHeight
              );
            },
            height: function () {
              return t.innerHeight || s.clientHeight || o.clientHeight;
            },
            scrollY: function () {
              return void 0 !== t.pageYOffset
                ? t.pageYOffset
                : (s || o.parentNode || o).scrollTop;
            },
          };
        })(t)
      : (function (t) {
          return {
            scrollHeight: function () {
              return Math.max(t.scrollHeight, t.offsetHeight, t.clientHeight);
            },
            height: function () {
              return Math.max(t.offsetHeight, t.clientHeight);
            },
            scrollY: function () {
              return t.scrollTop;
            },
          };
        })(t);
  }
  function n(t, s, e) {
    var n,
      o = (function () {
        var n = !1;
        try {
          var t = {
            get passive() {
              n = !0;
            },
          };
          window.addEventListener('test', t, t),
            window.removeEventListener('test', t, t);
        } catch (t) {
          n = !1;
        }
        return n;
      })(),
      i = !1,
      r = d(t),
      l = r.scrollY(),
      a = {};
    function c() {
      var t = Math.round(r.scrollY()),
        n = r.height(),
        o = r.scrollHeight();
      (a.scrollY = t),
        (a.lastScrollY = l),
        (a.direction = l < t ? 'down' : 'up'),
        (a.distance = Math.abs(t - l)),
        (a.isOutOfBounds = t < 0 || o < t + n),
        (a.top = t <= s.offset[a.direction]),
        (a.bottom = o <= t + n),
        (a.toleranceExceeded = a.distance > s.tolerance[a.direction]),
        e(a),
        (l = t),
        (i = !1);
    }
    function h() {
      i || ((i = !0), (n = requestAnimationFrame(c)));
    }
    var u = !!o && { passive: !0, capture: !1 };
    return (
      t.addEventListener('scroll', h, u),
      c(),
      {
        destroy: function () {
          cancelAnimationFrame(n), t.removeEventListener('scroll', h, u);
        },
      }
    );
  }
  function o(t) {
    return t === Object(t) ? t : { down: t, up: t };
  }
  function s(t, n) {
    (n = n || {}),
      Object.assign(this, s.options, n),
      (this.classes = Object.assign({}, s.options.classes, n.classes)),
      (this.elem = t),
      (this.tolerance = o(this.tolerance)),
      (this.offset = o(this.offset)),
      (this.initialised = !1),
      (this.frozen = !1);
  }
  return (
    (s.prototype = {
      constructor: s,
      init: function () {
        return (
          s.cutsTheMustard &&
            !this.initialised &&
            (this.addClass('initial'),
            (this.initialised = !0),
            setTimeout(
              function (t) {
                t.scrollTracker = n(
                  t.scroller,
                  { offset: t.offset, tolerance: t.tolerance },
                  t.update.bind(t)
                );
              },
              100,
              this
            )),
          this
        );
      },
      destroy: function () {
        (this.initialised = !1),
          Object.keys(this.classes).forEach(this.removeClass, this),
          this.scrollTracker.destroy();
      },
      unpin: function () {
        (!this.hasClass('pinned') && this.hasClass('unpinned')) ||
          (this.addClass('unpinned'),
          this.removeClass('pinned'),
          this.onUnpin && this.onUnpin.call(this));
      },
      pin: function () {
        this.hasClass('unpinned') &&
          (this.addClass('pinned'),
          this.removeClass('unpinned'),
          this.onPin && this.onPin.call(this));
      },
      freeze: function () {
        (this.frozen = !0), this.addClass('frozen');
      },
      unfreeze: function () {
        (this.frozen = !1), this.removeClass('frozen');
      },
      top: function () {
        this.hasClass('top') ||
          (this.addClass('top'),
          this.removeClass('notTop'),
          this.onTop && this.onTop.call(this));
      },
      notTop: function () {
        this.hasClass('notTop') ||
          (this.addClass('notTop'),
          this.removeClass('top'),
          this.onNotTop && this.onNotTop.call(this));
      },
      bottom: function () {
        this.hasClass('bottom') ||
          (this.addClass('bottom'),
          this.removeClass('notBottom'),
          this.onBottom && this.onBottom.call(this));
      },
      notBottom: function () {
        this.hasClass('notBottom') ||
          (this.addClass('notBottom'),
          this.removeClass('bottom'),
          this.onNotBottom && this.onNotBottom.call(this));
      },
      shouldUnpin: function (t) {
        return 'down' === t.direction && !t.top && t.toleranceExceeded;
      },
      shouldPin: function (t) {
        return ('up' === t.direction && t.toleranceExceeded) || t.top;
      },
      addClass: function (t) {
        this.elem.classList.add.apply(
          this.elem.classList,
          this.classes[t].split(' ')
        );
      },
      removeClass: function (t) {
        this.elem.classList.remove.apply(
          this.elem.classList,
          this.classes[t].split(' ')
        );
      },
      hasClass: function (t) {
        return this.classes[t].split(' ').every(function (t) {
          return this.classList.contains(t);
        }, this.elem);
      },
      update: function (t) {
        t.isOutOfBounds ||
          (!0 !== this.frozen &&
            (t.top ? this.top() : this.notTop(),
            t.bottom ? this.bottom() : this.notBottom(),
            this.shouldUnpin(t)
              ? this.unpin()
              : this.shouldPin(t) && this.pin()));
      },
    }),
    (s.options = {
      tolerance: { up: 0, down: 0 },
      offset: 0,
      scroller: t() ? window : null,
      classes: {
        frozen: 'headroom--frozen',
        pinned: 'headroom--pinned',
        unpinned: 'headroom--unpinned',
        top: 'headroom--top',
        notTop: 'headroom--not-top',
        bottom: 'headroom--bottom',
        notBottom: 'headroom--not-bottom',
        initial: 'headroom',
      },
    }),
    (s.cutsTheMustard = !!(
      t() &&
      function () {}.bind &&
      'classList' in document.documentElement &&
      Object.assign &&
      Object.keys &&
      requestAnimationFrame
    )),
    s
  );
});

'use strict';
function _typeof(e) {
  return (_typeof =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (e) {
          return typeof e;
        }
      : function (e) {
          return e &&
            'function' == typeof Symbol &&
            e.constructor === Symbol &&
            e !== Symbol.prototype
            ? 'symbol'
            : typeof e;
        })(e);
}
function _possibleConstructorReturn(e, t) {
  return !t || ('object' !== _typeof(t) && 'function' != typeof t)
    ? _assertThisInitialized(e)
    : t;
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
}
function _assertThisInitialized(e) {
  if (void 0 === e)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return e;
}
function _inherits(e, t) {
  if ('function' != typeof t && null !== t)
    throw new TypeError('Super expression must either be null or a function');
  (e.prototype = Object.create(t && t.prototype, {
    constructor: { value: e, writable: !0, configurable: !0 },
  })),
    t && _setPrototypeOf(e, t);
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf =
    Object.setPrototypeOf ||
    function (e, t) {
      return (e.__proto__ = t), e;
    })(e, t);
}
function _classCallCheck(e, t) {
  if (!(e instanceof t))
    throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    (i.enumerable = i.enumerable || !1),
      (i.configurable = !0),
      'value' in i && (i.writable = !0),
      Object.defineProperty(e, i.key, i);
  }
}
function _createClass(e, t, n) {
  return (
    t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
  );
}
var Emitter = (function () {
    function e() {
      _classCallCheck(this, e);
    }
    return (
      _createClass(e, [
        {
          key: 'on',
          value: function (e, t) {
            return (
              (this._callbacks = this._callbacks || {}),
              this._callbacks[e] || (this._callbacks[e] = []),
              this._callbacks[e].push(t),
              this
            );
          },
        },
        {
          key: 'emit',
          value: function (e) {
            this._callbacks = this._callbacks || {};
            var t = this._callbacks[e];
            if (t) {
              for (
                var n = arguments.length,
                  i = new Array(1 < n ? n - 1 : 0),
                  r = 1;
                r < n;
                r++
              )
                i[r - 1] = arguments[r];
              var o = !0,
                a = !1,
                l = void 0;
              try {
                for (
                  var s, u = t[Symbol.iterator]();
                  !(o = (s = u.next()).done);
                  o = !0
                ) {
                  s.value.apply(this, i);
                }
              } catch (e) {
                (a = !0), (l = e);
              } finally {
                try {
                  o || null == u.return || u.return();
                } finally {
                  if (a) throw l;
                }
              }
            }
            return this;
          },
        },
        {
          key: 'off',
          value: function (e, t) {
            if (!this._callbacks || 0 === arguments.length)
              return (this._callbacks = {}), this;
            var n = this._callbacks[e];
            if (!n) return this;
            if (1 === arguments.length) return delete this._callbacks[e], this;
            for (var i = 0; i < n.length; i++) {
              if (n[i] === t) {
                n.splice(i, 1);
                break;
              }
            }
            return this;
          },
        },
      ]),
      e
    );
  })(),
  Dropzone = (function () {
    function C(e, t) {
      var n, i, r;
      if (
        (_classCallCheck(this, C),
        ((n = _possibleConstructorReturn(
          this,
          _getPrototypeOf(C).call(this)
        )).element = e),
        (n.version = C.version),
        (n.defaultOptions.previewTemplate =
          n.defaultOptions.previewTemplate.replace(/\n*/g, '')),
        (n.clickableElements = []),
        (n.listeners = []),
        (n.files = []),
        'string' == typeof n.element &&
          (n.element = document.querySelector(n.element)),
        !n.element || null == n.element.nodeType)
      )
        throw new Error('Invalid dropzone element.');
      if (n.element.dropzone) throw new Error('Dropzone already attached.');
      C.instances.push(_assertThisInitialized(n)),
        (n.element.dropzone = _assertThisInitialized(n));
      var o = null != (r = C.optionsForElement(n.element)) ? r : {};
      if (
        ((n.options = C.extend({}, n.defaultOptions, o, null != t ? t : {})),
        n.options.forceFallback || !C.isBrowserSupported())
      )
        return _possibleConstructorReturn(
          n,
          n.options.fallback.call(_assertThisInitialized(n))
        );
      if (
        (null == n.options.url &&
          (n.options.url = n.element.getAttribute('action')),
        !n.options.url)
      )
        throw new Error('No URL provided.');
      if (n.options.acceptedFiles && n.options.acceptedMimeTypes)
        throw new Error(
          "You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated."
        );
      if (n.options.uploadMultiple && n.options.chunking)
        throw new Error('You cannot set both: uploadMultiple and chunking.');
      return (
        n.options.acceptedMimeTypes &&
          ((n.options.acceptedFiles = n.options.acceptedMimeTypes),
          delete n.options.acceptedMimeTypes),
        null != n.options.renameFilename &&
          (n.options.renameFile = function (e) {
            return n.options.renameFilename.call(
              _assertThisInitialized(n),
              e.name,
              e
            );
          }),
        (n.options.method = n.options.method.toUpperCase()),
        (i = n.getExistingFallback()) &&
          i.parentNode &&
          i.parentNode.removeChild(i),
        !1 !== n.options.previewsContainer &&
          (n.options.previewsContainer
            ? (n.previewsContainer = C.getElement(
                n.options.previewsContainer,
                'previewsContainer'
              ))
            : (n.previewsContainer = n.element)),
        n.options.clickable &&
          (!0 === n.options.clickable
            ? (n.clickableElements = [n.element])
            : (n.clickableElements = C.getElements(
                n.options.clickable,
                'clickable'
              ))),
        n.init(),
        n
      );
    }
    return (
      _inherits(C, Emitter),
      _createClass(C, null, [
        {
          key: 'initClass',
          value: function () {
            (this.prototype.Emitter = Emitter),
              (this.prototype.events = [
                'drop',
                'dragstart',
                'dragend',
                'dragenter',
                'dragover',
                'dragleave',
                'addedfile',
                'addedfiles',
                'removedfile',
                'thumbnail',
                'error',
                'errormultiple',
                'processing',
                'processingmultiple',
                'uploadprogress',
                'totaluploadprogress',
                'sending',
                'sendingmultiple',
                'success',
                'successmultiple',
                'canceled',
                'canceledmultiple',
                'complete',
                'completemultiple',
                'reset',
                'maxfilesexceeded',
                'maxfilesreached',
                'queuecomplete',
              ]),
              (this.prototype.defaultOptions = {
                url: null,
                method: 'post',
                withCredentials: !1,
                timeout: 3e4,
                parallelUploads: 2,
                uploadMultiple: !1,
                chunking: !1,
                forceChunking: !1,
                chunkSize: 2e6,
                parallelChunkUploads: !1,
                retryChunks: !1,
                retryChunksLimit: 3,
                maxFilesize: 256,
                paramName: 'file',
                createImageThumbnails: !0,
                maxThumbnailFilesize: 10,
                thumbnailWidth: 120,
                thumbnailHeight: 120,
                thumbnailMethod: 'crop',
                resizeWidth: null,
                resizeHeight: null,
                resizeMimeType: null,
                resizeQuality: 0.8,
                resizeMethod: 'contain',
                filesizeBase: 1e3,
                maxFiles: null,
                headers: null,
                clickable: !0,
                ignoreHiddenFiles: !0,
                acceptedFiles: null,
                acceptedMimeTypes: null,
                autoProcessQueue: !0,
                autoQueue: !0,
                addRemoveLinks: !1,
                previewsContainer: null,
                hiddenInputContainer: 'body',
                capture: null,
                renameFilename: null,
                renameFile: null,
                forceFallback: !1,
                dictDefaultMessage: 'Drop files here to upload',
                dictFallbackMessage:
                  "Your browser does not support drag'n'drop file uploads.",
                dictFallbackText:
                  'Please use the fallback form below to upload your files like in the olden days.',
                dictFileTooBig:
                  'File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.',
                dictInvalidFileType: "You can't upload files of this type.",
                dictResponseError: 'Server responded with {{statusCode}} code.',
                dictCancelUpload: 'Cancel upload',
                dictUploadCanceled: 'Upload canceled.',
                dictCancelUploadConfirmation:
                  'Are you sure you want to cancel this upload?',
                dictRemoveFile: 'Remove file',
                dictRemoveFileConfirmation: null,
                dictMaxFilesExceeded: 'You can not upload any more files.',
                dictFileSizeUnits: {
                  tb: 'TB',
                  gb: 'GB',
                  mb: 'MB',
                  kb: 'KB',
                  b: 'b',
                },
                init: function () {},
                params: function (e, t, n) {
                  if (n)
                    return {
                      dzuuid: n.file.upload.uuid,
                      dzchunkindex: n.index,
                      dztotalfilesize: n.file.size,
                      dzchunksize: this.options.chunkSize,
                      dztotalchunkcount: n.file.upload.totalChunkCount,
                      dzchunkbyteoffset: n.index * this.options.chunkSize,
                    };
                },
                accept: function (e, t) {
                  return t();
                },
                chunksUploaded: function (e, t) {
                  t();
                },
                fallback: function () {
                  var e;
                  this.element.className = ''.concat(
                    this.element.className,
                    ' dz-browser-not-supported'
                  );
                  var t = !0,
                    n = !1,
                    i = void 0;
                  try {
                    for (
                      var r,
                        o = this.element
                          .getElementsByTagName('div')
                          [Symbol.iterator]();
                      !(t = (r = o.next()).done);
                      t = !0
                    ) {
                      var a = r.value;
                      if (/(^| )dz-message($| )/.test(a.className)) {
                        (e = a).className = 'dz-message';
                        break;
                      }
                    }
                  } catch (e) {
                    (n = !0), (i = e);
                  } finally {
                    try {
                      t || null == o.return || o.return();
                    } finally {
                      if (n) throw i;
                    }
                  }
                  e ||
                    ((e = C.createElement(
                      '<div class="dz-message"><span></span></div>'
                    )),
                    this.element.appendChild(e));
                  var l = e.getElementsByTagName('span')[0];
                  return (
                    l &&
                      (null != l.textContent
                        ? (l.textContent = this.options.dictFallbackMessage)
                        : null != l.innerText &&
                          (l.innerText = this.options.dictFallbackMessage)),
                    this.element.appendChild(this.getFallbackForm())
                  );
                },
                resize: function (e, t, n, i) {
                  var r = {
                      srcX: 0,
                      srcY: 0,
                      srcWidth: e.width,
                      srcHeight: e.height,
                    },
                    o = e.width / e.height;
                  null == t && null == n
                    ? ((t = r.srcWidth), (n = r.srcHeight))
                    : null == t
                    ? (t = n * o)
                    : null == n && (n = t / o);
                  var a =
                    (t = Math.min(t, r.srcWidth)) /
                    (n = Math.min(n, r.srcHeight));
                  if (r.srcWidth > t || r.srcHeight > n)
                    if ('crop' === i)
                      a < o
                        ? ((r.srcHeight = e.height),
                          (r.srcWidth = r.srcHeight * a))
                        : ((r.srcWidth = e.width),
                          (r.srcHeight = r.srcWidth / a));
                    else {
                      if ('contain' !== i)
                        throw new Error(
                          "Unknown resizeMethod '".concat(i, "'")
                        );
                      a < o ? (n = t / o) : (t = n * o);
                    }
                  return (
                    (r.srcX = (e.width - r.srcWidth) / 2),
                    (r.srcY = (e.height - r.srcHeight) / 2),
                    (r.trgWidth = t),
                    (r.trgHeight = n),
                    r
                  );
                },
                transformFile: function (e, t) {
                  return (this.options.resizeWidth ||
                    this.options.resizeHeight) &&
                    e.type.match(/image.*/)
                    ? this.resizeImage(
                        e,
                        this.options.resizeWidth,
                        this.options.resizeHeight,
                        this.options.resizeMethod,
                        t
                      )
                    : t(e);
                },
                previewTemplate:
                  '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      <title>Check</title>\n      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      <title>Error</title>\n      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',
                drop: function () {
                  return this.element.classList.remove('dz-drag-hover');
                },
                dragstart: function () {},
                dragend: function () {
                  return this.element.classList.remove('dz-drag-hover');
                },
                dragenter: function () {
                  return this.element.classList.add('dz-drag-hover');
                },
                dragover: function () {
                  return this.element.classList.add('dz-drag-hover');
                },
                dragleave: function () {
                  return this.element.classList.remove('dz-drag-hover');
                },
                paste: function () {},
                reset: function () {
                  return this.element.classList.remove('dz-started');
                },
                addedfile: function (t) {
                  var n = this;
                  if (
                    (this.element === this.previewsContainer &&
                      this.element.classList.add('dz-started'),
                    this.previewsContainer)
                  ) {
                    (t.previewElement = C.createElement(
                      this.options.previewTemplate.trim()
                    )),
                      (t.previewTemplate = t.previewElement),
                      this.previewsContainer.appendChild(t.previewElement);
                    var e = !0,
                      i = !1,
                      r = void 0;
                    try {
                      for (
                        var o,
                          a = t.previewElement
                            .querySelectorAll('[data-dz-name]')
                            [Symbol.iterator]();
                        !(e = (o = a.next()).done);
                        e = !0
                      ) {
                        var l = o.value;
                        l.textContent = t.name;
                      }
                    } catch (e) {
                      (i = !0), (r = e);
                    } finally {
                      try {
                        e || null == a.return || a.return();
                      } finally {
                        if (i) throw r;
                      }
                    }
                    var s = !0,
                      u = !1,
                      c = void 0;
                    try {
                      for (
                        var d,
                          p = t.previewElement
                            .querySelectorAll('[data-dz-size]')
                            [Symbol.iterator]();
                        !(s = (d = p.next()).done);
                        s = !0
                      )
                        (l = d.value).innerHTML = this.filesize(t.size);
                    } catch (e) {
                      (u = !0), (c = e);
                    } finally {
                      try {
                        s || null == p.return || p.return();
                      } finally {
                        if (u) throw c;
                      }
                    }
                    this.options.addRemoveLinks &&
                      ((t._removeLink = C.createElement(
                        '<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'.concat(
                          this.options.dictRemoveFile,
                          '</a>'
                        )
                      )),
                      t.previewElement.appendChild(t._removeLink));
                    var h = function (e) {
                        return (
                          e.preventDefault(),
                          e.stopPropagation(),
                          t.status === C.UPLOADING
                            ? C.confirm(
                                n.options.dictCancelUploadConfirmation,
                                function () {
                                  return n.removeFile(t);
                                }
                              )
                            : n.options.dictRemoveFileConfirmation
                            ? C.confirm(
                                n.options.dictRemoveFileConfirmation,
                                function () {
                                  return n.removeFile(t);
                                }
                              )
                            : n.removeFile(t)
                        );
                      },
                      f = !0,
                      v = !1,
                      m = void 0;
                    try {
                      for (
                        var y,
                          g = t.previewElement
                            .querySelectorAll('[data-dz-remove]')
                            [Symbol.iterator]();
                        !(f = (y = g.next()).done);
                        f = !0
                      ) {
                        y.value.addEventListener('click', h);
                      }
                    } catch (e) {
                      (v = !0), (m = e);
                    } finally {
                      try {
                        f || null == g.return || g.return();
                      } finally {
                        if (v) throw m;
                      }
                    }
                  }
                },
                removedfile: function (e) {
                  return (
                    null != e.previewElement &&
                      null != e.previewElement.parentNode &&
                      e.previewElement.parentNode.removeChild(e.previewElement),
                    this._updateMaxFilesReachedClass()
                  );
                },
                thumbnail: function (e, t) {
                  if (e.previewElement) {
                    e.previewElement.classList.remove('dz-file-preview');
                    var n = !0,
                      i = !1,
                      r = void 0;
                    try {
                      for (
                        var o,
                          a = e.previewElement
                            .querySelectorAll('[data-dz-thumbnail]')
                            [Symbol.iterator]();
                        !(n = (o = a.next()).done);
                        n = !0
                      ) {
                        var l = o.value;
                        (l.alt = e.name), (l.src = t);
                      }
                    } catch (e) {
                      (i = !0), (r = e);
                    } finally {
                      try {
                        n || null == a.return || a.return();
                      } finally {
                        if (i) throw r;
                      }
                    }
                    return setTimeout(function () {
                      return e.previewElement.classList.add('dz-image-preview');
                    }, 1);
                  }
                },
                error: function (e, t) {
                  if (e.previewElement) {
                    e.previewElement.classList.add('dz-error'),
                      'String' != typeof t && t.error && (t = t.error);
                    var n = !0,
                      i = !1,
                      r = void 0;
                    try {
                      for (
                        var o,
                          a = e.previewElement
                            .querySelectorAll('[data-dz-errormessage]')
                            [Symbol.iterator]();
                        !(n = (o = a.next()).done);
                        n = !0
                      ) {
                        o.value.textContent = t;
                      }
                    } catch (e) {
                      (i = !0), (r = e);
                    } finally {
                      try {
                        n || null == a.return || a.return();
                      } finally {
                        if (i) throw r;
                      }
                    }
                  }
                },
                errormultiple: function () {},
                processing: function (e) {
                  if (
                    e.previewElement &&
                    (e.previewElement.classList.add('dz-processing'),
                    e._removeLink)
                  )
                    return (e._removeLink.innerHTML =
                      this.options.dictCancelUpload);
                },
                processingmultiple: function () {},
                uploadprogress: function (e, t) {
                  if (e.previewElement) {
                    var n = !0,
                      i = !1,
                      r = void 0;
                    try {
                      for (
                        var o,
                          a = e.previewElement
                            .querySelectorAll('[data-dz-uploadprogress]')
                            [Symbol.iterator]();
                        !(n = (o = a.next()).done);
                        n = !0
                      ) {
                        var l = o.value;
                        'PROGRESS' === l.nodeName
                          ? (l.value = t)
                          : (l.style.width = ''.concat(t, '%'));
                      }
                    } catch (e) {
                      (i = !0), (r = e);
                    } finally {
                      try {
                        n || null == a.return || a.return();
                      } finally {
                        if (i) throw r;
                      }
                    }
                  }
                },
                totaluploadprogress: function () {},
                sending: function () {},
                sendingmultiple: function () {},
                success: function (e) {
                  if (e.previewElement)
                    return e.previewElement.classList.add('dz-success');
                },
                successmultiple: function () {},
                canceled: function (e) {
                  return this.emit('error', e, this.options.dictUploadCanceled);
                },
                canceledmultiple: function () {},
                complete: function (e) {
                  if (
                    (e._removeLink &&
                      (e._removeLink.innerHTML = this.options.dictRemoveFile),
                    e.previewElement)
                  )
                    return e.previewElement.classList.add('dz-complete');
                },
                completemultiple: function () {},
                maxfilesexceeded: function () {},
                maxfilesreached: function () {},
                queuecomplete: function () {},
                addedfiles: function () {},
              }),
              (this.prototype._thumbnailQueue = []),
              (this.prototype._processingThumbnail = !1);
          },
        },
        {
          key: 'extend',
          value: function (e) {
            for (
              var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), i = 1;
              i < t;
              i++
            )
              n[i - 1] = arguments[i];
            for (var r = 0, o = n; r < o.length; r++) {
              var a = o[r];
              for (var l in a) {
                var s = a[l];
                e[l] = s;
              }
            }
            return e;
          },
        },
      ]),
      _createClass(
        C,
        [
          {
            key: 'getAcceptedFiles',
            value: function () {
              return this.files
                .filter(function (e) {
                  return e.accepted;
                })
                .map(function (e) {
                  return e;
                });
            },
          },
          {
            key: 'getRejectedFiles',
            value: function () {
              return this.files
                .filter(function (e) {
                  return !e.accepted;
                })
                .map(function (e) {
                  return e;
                });
            },
          },
          {
            key: 'getFilesWithStatus',
            value: function (t) {
              return this.files
                .filter(function (e) {
                  return e.status === t;
                })
                .map(function (e) {
                  return e;
                });
            },
          },
          {
            key: 'getQueuedFiles',
            value: function () {
              return this.getFilesWithStatus(C.QUEUED);
            },
          },
          {
            key: 'getUploadingFiles',
            value: function () {
              return this.getFilesWithStatus(C.UPLOADING);
            },
          },
          {
            key: 'getAddedFiles',
            value: function () {
              return this.getFilesWithStatus(C.ADDED);
            },
          },
          {
            key: 'getActiveFiles',
            value: function () {
              return this.files
                .filter(function (e) {
                  return e.status === C.UPLOADING || e.status === C.QUEUED;
                })
                .map(function (e) {
                  return e;
                });
            },
          },
          {
            key: 'init',
            value: function () {
              var s = this;
              if (
                ('form' === this.element.tagName &&
                  this.element.setAttribute('enctype', 'multipart/form-data'),
                this.element.classList.contains('dropzone') &&
                  !this.element.querySelector('.dz-message') &&
                  this.element.appendChild(
                    C.createElement(
                      '<div class="dz-default dz-message"><button class="dz-button" type="button">'.concat(
                        this.options.dictDefaultMessage,
                        '</button></div>'
                      )
                    )
                  ),
                this.clickableElements.length)
              ) {
                !(function l() {
                  return (
                    s.hiddenFileInput &&
                      s.hiddenFileInput.parentNode.removeChild(
                        s.hiddenFileInput
                      ),
                    (s.hiddenFileInput = document.createElement('input')),
                    s.hiddenFileInput.setAttribute('type', 'file'),
                    (null === s.options.maxFiles || 1 < s.options.maxFiles) &&
                      s.hiddenFileInput.setAttribute('multiple', 'multiple'),
                    (s.hiddenFileInput.className = 'dz-hidden-input'),
                    null !== s.options.acceptedFiles &&
                      s.hiddenFileInput.setAttribute(
                        'accept',
                        s.options.acceptedFiles
                      ),
                    null !== s.options.capture &&
                      s.hiddenFileInput.setAttribute(
                        'capture',
                        s.options.capture
                      ),
                    (s.hiddenFileInput.style.visibility = 'hidden'),
                    (s.hiddenFileInput.style.position = 'absolute'),
                    (s.hiddenFileInput.style.top = '0'),
                    (s.hiddenFileInput.style.left = '0'),
                    (s.hiddenFileInput.style.height = '0'),
                    (s.hiddenFileInput.style.width = '0'),
                    C.getElement(
                      s.options.hiddenInputContainer,
                      'hiddenInputContainer'
                    ).appendChild(s.hiddenFileInput),
                    s.hiddenFileInput.addEventListener('change', function () {
                      var e = s.hiddenFileInput.files;
                      if (e.length) {
                        var t = !0,
                          n = !1,
                          i = void 0;
                        try {
                          for (
                            var r, o = e[Symbol.iterator]();
                            !(t = (r = o.next()).done);
                            t = !0
                          ) {
                            var a = r.value;
                            s.addFile(a);
                          }
                        } catch (e) {
                          (n = !0), (i = e);
                        } finally {
                          try {
                            t || null == o.return || o.return();
                          } finally {
                            if (n) throw i;
                          }
                        }
                      }
                      return s.emit('addedfiles', e), l();
                    })
                  );
                })();
              }
              this.URL = null !== window.URL ? window.URL : window.webkitURL;
              var e = !0,
                t = !1,
                n = void 0;
              try {
                for (
                  var i, r = this.events[Symbol.iterator]();
                  !(e = (i = r.next()).done);
                  e = !0
                ) {
                  var o = i.value;
                  this.on(o, this.options[o]);
                }
              } catch (e) {
                (t = !0), (n = e);
              } finally {
                try {
                  e || null == r.return || r.return();
                } finally {
                  if (t) throw n;
                }
              }
              this.on('uploadprogress', function () {
                return s.updateTotalUploadProgress();
              }),
                this.on('removedfile', function () {
                  return s.updateTotalUploadProgress();
                }),
                this.on('canceled', function (e) {
                  return s.emit('complete', e);
                }),
                this.on('complete', function (e) {
                  if (
                    0 === s.getAddedFiles().length &&
                    0 === s.getUploadingFiles().length &&
                    0 === s.getQueuedFiles().length
                  )
                    return setTimeout(function () {
                      return s.emit('queuecomplete');
                    }, 0);
                });
              function a(e) {
                var t;
                return (
                  (t = e).dataTransfer.types &&
                  t.dataTransfer.types.some(function (e) {
                    return 'Files' == e;
                  }) &&
                  (e.stopPropagation(),
                  e.preventDefault ? e.preventDefault() : (e.returnValue = !1))
                );
              }
              return (
                (this.listeners = [
                  {
                    element: this.element,
                    events: {
                      dragstart: function (e) {
                        return s.emit('dragstart', e);
                      },
                      dragenter: function (e) {
                        return a(e), s.emit('dragenter', e);
                      },
                      dragover: function (e) {
                        var t;
                        try {
                          t = e.dataTransfer.effectAllowed;
                        } catch (e) {}
                        return (
                          (e.dataTransfer.dropEffect =
                            'move' === t || 'linkMove' === t ? 'move' : 'copy'),
                          a(e),
                          s.emit('dragover', e)
                        );
                      },
                      dragleave: function (e) {
                        return s.emit('dragleave', e);
                      },
                      drop: function (e) {
                        return a(e), s.drop(e);
                      },
                      dragend: function (e) {
                        return s.emit('dragend', e);
                      },
                    },
                  },
                ]),
                this.clickableElements.forEach(function (t) {
                  return s.listeners.push({
                    element: t,
                    events: {
                      click: function (e) {
                        return (
                          (t === s.element &&
                            e.target !== s.element &&
                            !C.elementInside(
                              e.target,
                              s.element.querySelector('.dz-message')
                            )) ||
                            s.hiddenFileInput.click(),
                          !0
                        );
                      },
                    },
                  });
                }),
                this.enable(),
                this.options.init.call(this)
              );
            },
          },
          {
            key: 'destroy',
            value: function () {
              return (
                this.disable(),
                this.removeAllFiles(!0),
                null != this.hiddenFileInput &&
                  this.hiddenFileInput.parentNode &&
                  (this.hiddenFileInput.parentNode.removeChild(
                    this.hiddenFileInput
                  ),
                  (this.hiddenFileInput = null)),
                delete this.element.dropzone,
                C.instances.splice(C.instances.indexOf(this), 1)
              );
            },
          },
          {
            key: 'updateTotalUploadProgress',
            value: function () {
              var e,
                t = 0,
                n = 0;
              if (this.getActiveFiles().length) {
                var i = !0,
                  r = !1,
                  o = void 0;
                try {
                  for (
                    var a, l = this.getActiveFiles()[Symbol.iterator]();
                    !(i = (a = l.next()).done);
                    i = !0
                  ) {
                    var s = a.value;
                    (t += s.upload.bytesSent), (n += s.upload.total);
                  }
                } catch (e) {
                  (r = !0), (o = e);
                } finally {
                  try {
                    i || null == l.return || l.return();
                  } finally {
                    if (r) throw o;
                  }
                }
                e = (100 * t) / n;
              } else e = 100;
              return this.emit('totaluploadprogress', e, n, t);
            },
          },
          {
            key: '_getParamName',
            value: function (e) {
              return 'function' == typeof this.options.paramName
                ? this.options.paramName(e)
                : ''
                    .concat(this.options.paramName)
                    .concat(
                      this.options.uploadMultiple ? '['.concat(e, ']') : ''
                    );
            },
          },
          {
            key: '_renameFile',
            value: function (e) {
              return 'function' != typeof this.options.renameFile
                ? e.name
                : this.options.renameFile(e);
            },
          },
          {
            key: 'getFallbackForm',
            value: function () {
              var e, t;
              if ((e = this.getExistingFallback())) return e;
              var n = '<div class="dz-fallback">';
              this.options.dictFallbackText &&
                (n += '<p>'.concat(this.options.dictFallbackText, '</p>')),
                (n += '<input type="file" name="'
                  .concat(this._getParamName(0), '" ')
                  .concat(
                    this.options.uploadMultiple
                      ? 'multiple="multiple"'
                      : void 0,
                    ' /><input type="submit" value="Upload!"></div>'
                  ));
              var i = C.createElement(n);
              return (
                'FORM' !== this.element.tagName
                  ? (t = C.createElement(
                      '<form action="'
                        .concat(
                          this.options.url,
                          '" enctype="multipart/form-data" method="'
                        )
                        .concat(this.options.method, '"></form>')
                    )).appendChild(i)
                  : (this.element.setAttribute(
                      'enctype',
                      'multipart/form-data'
                    ),
                    this.element.setAttribute('method', this.options.method)),
                null != t ? t : i
              );
            },
          },
          {
            key: 'getExistingFallback',
            value: function () {
              for (
                var e = function (e) {
                    var t = !0,
                      n = !1,
                      i = void 0;
                    try {
                      for (
                        var r, o = e[Symbol.iterator]();
                        !(t = (r = o.next()).done);
                        t = !0
                      ) {
                        var a = r.value;
                        if (/(^| )fallback($| )/.test(a.className)) return a;
                      }
                    } catch (e) {
                      (n = !0), (i = e);
                    } finally {
                      try {
                        t || null == o.return || o.return();
                      } finally {
                        if (n) throw i;
                      }
                    }
                  },
                  t = 0,
                  n = ['div', 'form'];
                t < n.length;
                t++
              ) {
                var i,
                  r = n[t];
                if ((i = e(this.element.getElementsByTagName(r)))) return i;
              }
            },
          },
          {
            key: 'setupEventListeners',
            value: function () {
              return this.listeners.map(function (i) {
                return (function () {
                  var e = [];
                  for (var t in i.events) {
                    var n = i.events[t];
                    e.push(i.element.addEventListener(t, n, !1));
                  }
                  return e;
                })();
              });
            },
          },
          {
            key: 'removeEventListeners',
            value: function () {
              return this.listeners.map(function (i) {
                return (function () {
                  var e = [];
                  for (var t in i.events) {
                    var n = i.events[t];
                    e.push(i.element.removeEventListener(t, n, !1));
                  }
                  return e;
                })();
              });
            },
          },
          {
            key: 'disable',
            value: function () {
              var t = this;
              return (
                this.clickableElements.forEach(function (e) {
                  return e.classList.remove('dz-clickable');
                }),
                this.removeEventListeners(),
                (this.disabled = !0),
                this.files.map(function (e) {
                  return t.cancelUpload(e);
                })
              );
            },
          },
          {
            key: 'enable',
            value: function () {
              return (
                delete this.disabled,
                this.clickableElements.forEach(function (e) {
                  return e.classList.add('dz-clickable');
                }),
                this.setupEventListeners()
              );
            },
          },
          {
            key: 'filesize',
            value: function (e) {
              var t = 0,
                n = 'b';
              if (0 < e) {
                for (
                  var i = ['tb', 'gb', 'mb', 'kb', 'b'], r = 0;
                  r < i.length;
                  r++
                ) {
                  var o = i[r];
                  if (Math.pow(this.options.filesizeBase, 4 - r) / 10 <= e) {
                    (t = e / Math.pow(this.options.filesizeBase, 4 - r)),
                      (n = o);
                    break;
                  }
                }
                t = Math.round(10 * t) / 10;
              }
              return '<strong>'
                .concat(t, '</strong> ')
                .concat(this.options.dictFileSizeUnits[n]);
            },
          },
          {
            key: '_updateMaxFilesReachedClass',
            value: function () {
              return null != this.options.maxFiles &&
                this.getAcceptedFiles().length >= this.options.maxFiles
                ? (this.getAcceptedFiles().length === this.options.maxFiles &&
                    this.emit('maxfilesreached', this.files),
                  this.element.classList.add('dz-max-files-reached'))
                : this.element.classList.remove('dz-max-files-reached');
            },
          },
          {
            key: 'drop',
            value: function (e) {
              if (e.dataTransfer) {
                this.emit('drop', e);
                for (var t = [], n = 0; n < e.dataTransfer.files.length; n++)
                  t[n] = e.dataTransfer.files[n];
                if (t.length) {
                  var i = e.dataTransfer.items;
                  i && i.length && null != i[0].webkitGetAsEntry
                    ? this._addFilesFromItems(i)
                    : this.handleFiles(t);
                }
                this.emit('addedfiles', t);
              }
            },
          },
          {
            key: 'paste',
            value: function (e) {
              if (
                null !=
                __guard__(null != e ? e.clipboardData : void 0, function (e) {
                  return e.items;
                })
              ) {
                this.emit('paste', e);
                var t = e.clipboardData.items;
                return t.length ? this._addFilesFromItems(t) : void 0;
              }
            },
          },
          {
            key: 'handleFiles',
            value: function (e) {
              var t = !0,
                n = !1,
                i = void 0;
              try {
                for (
                  var r, o = e[Symbol.iterator]();
                  !(t = (r = o.next()).done);
                  t = !0
                ) {
                  var a = r.value;
                  this.addFile(a);
                }
              } catch (e) {
                (n = !0), (i = e);
              } finally {
                try {
                  t || null == o.return || o.return();
                } finally {
                  if (n) throw i;
                }
              }
            },
          },
          {
            key: '_addFilesFromItems',
            value: function (s) {
              var u = this;
              return (function () {
                var e = [],
                  t = !0,
                  n = !1,
                  i = void 0;
                try {
                  for (
                    var r, o = s[Symbol.iterator]();
                    !(t = (r = o.next()).done);
                    t = !0
                  ) {
                    var a,
                      l = r.value;
                    null != l.webkitGetAsEntry && (a = l.webkitGetAsEntry())
                      ? a.isFile
                        ? e.push(u.addFile(l.getAsFile()))
                        : a.isDirectory
                        ? e.push(u._addFilesFromDirectory(a, a.name))
                        : e.push(void 0)
                      : null != l.getAsFile &&
                        (null == l.kind || 'file' === l.kind)
                      ? e.push(u.addFile(l.getAsFile()))
                      : e.push(void 0);
                  }
                } catch (e) {
                  (n = !0), (i = e);
                } finally {
                  try {
                    t || null == o.return || o.return();
                  } finally {
                    if (n) throw i;
                  }
                }
                return e;
              })();
            },
          },
          {
            key: '_addFilesFromDirectory',
            value: function (e, s) {
              function t(t) {
                return __guardMethod__(console, 'log', function (e) {
                  return e.log(t);
                });
              }
              var u = this,
                n = e.createReader();
              return (function l() {
                return n.readEntries(function (e) {
                  if (0 < e.length) {
                    var t = !0,
                      n = !1,
                      i = void 0;
                    try {
                      for (
                        var r, o = e[Symbol.iterator]();
                        !(t = (r = o.next()).done);
                        t = !0
                      ) {
                        var a = r.value;
                        a.isFile
                          ? a.file(function (e) {
                              if (
                                !u.options.ignoreHiddenFiles ||
                                '.' !== e.name.substring(0, 1)
                              )
                                return (
                                  (e.fullPath = ''
                                    .concat(s, '/')
                                    .concat(e.name)),
                                  u.addFile(e)
                                );
                            })
                          : a.isDirectory &&
                            u._addFilesFromDirectory(
                              a,
                              ''.concat(s, '/').concat(a.name)
                            );
                      }
                    } catch (e) {
                      (n = !0), (i = e);
                    } finally {
                      try {
                        t || null == o.return || o.return();
                      } finally {
                        if (n) throw i;
                      }
                    }
                    l();
                  }
                  return null;
                }, t);
              })();
            },
          },
          {
            key: 'accept',
            value: function (e, t) {
              this.options.maxFilesize &&
              e.size > 1024 * this.options.maxFilesize * 1024
                ? t(
                    this.options.dictFileTooBig
                      .replace(
                        '{{filesize}}',
                        Math.round(e.size / 1024 / 10.24) / 100
                      )
                      .replace('{{maxFilesize}}', this.options.maxFilesize)
                  )
                : C.isValidFile(e, this.options.acceptedFiles)
                ? null != this.options.maxFiles &&
                  this.getAcceptedFiles().length >= this.options.maxFiles
                  ? (t(
                      this.options.dictMaxFilesExceeded.replace(
                        '{{maxFiles}}',
                        this.options.maxFiles
                      )
                    ),
                    this.emit('maxfilesexceeded', e))
                  : this.options.accept.call(this, e, t)
                : t(this.options.dictInvalidFileType);
            },
          },
          {
            key: 'addFile',
            value: function (t) {
              var n = this;
              (t.upload = {
                uuid: C.uuidv4(),
                progress: 0,
                total: t.size,
                bytesSent: 0,
                filename: this._renameFile(t),
              }),
                this.files.push(t),
                (t.status = C.ADDED),
                this.emit('addedfile', t),
                this._enqueueThumbnail(t),
                this.accept(t, function (e) {
                  e
                    ? ((t.accepted = !1), n._errorProcessing([t], e))
                    : ((t.accepted = !0),
                      n.options.autoQueue && n.enqueueFile(t)),
                    n._updateMaxFilesReachedClass();
                });
            },
          },
          {
            key: 'enqueueFiles',
            value: function (e) {
              var t = !0,
                n = !1,
                i = void 0;
              try {
                for (
                  var r, o = e[Symbol.iterator]();
                  !(t = (r = o.next()).done);
                  t = !0
                ) {
                  var a = r.value;
                  this.enqueueFile(a);
                }
              } catch (e) {
                (n = !0), (i = e);
              } finally {
                try {
                  t || null == o.return || o.return();
                } finally {
                  if (n) throw i;
                }
              }
              return null;
            },
          },
          {
            key: 'enqueueFile',
            value: function (e) {
              var t = this;
              if (e.status !== C.ADDED || !0 !== e.accepted)
                throw new Error(
                  "This file can't be queued because it has already been processed or was rejected."
                );
              if (((e.status = C.QUEUED), this.options.autoProcessQueue))
                return setTimeout(function () {
                  return t.processQueue();
                }, 0);
            },
          },
          {
            key: '_enqueueThumbnail',
            value: function (e) {
              var t = this;
              if (
                this.options.createImageThumbnails &&
                e.type.match(/image.*/) &&
                e.size <= 1024 * this.options.maxThumbnailFilesize * 1024
              )
                return (
                  this._thumbnailQueue.push(e),
                  setTimeout(function () {
                    return t._processThumbnailQueue();
                  }, 0)
                );
            },
          },
          {
            key: '_processThumbnailQueue',
            value: function () {
              var t = this;
              if (
                !this._processingThumbnail &&
                0 !== this._thumbnailQueue.length
              ) {
                this._processingThumbnail = !0;
                var n = this._thumbnailQueue.shift();
                return this.createThumbnail(
                  n,
                  this.options.thumbnailWidth,
                  this.options.thumbnailHeight,
                  this.options.thumbnailMethod,
                  !0,
                  function (e) {
                    return (
                      t.emit('thumbnail', n, e),
                      (t._processingThumbnail = !1),
                      t._processThumbnailQueue()
                    );
                  }
                );
              }
            },
          },
          {
            key: 'removeFile',
            value: function (e) {
              if (
                (e.status === C.UPLOADING && this.cancelUpload(e),
                (this.files = without(this.files, e)),
                this.emit('removedfile', e),
                0 === this.files.length)
              )
                return this.emit('reset');
            },
          },
          {
            key: 'removeAllFiles',
            value: function (e) {
              null == e && (e = !1);
              var t = !0,
                n = !1,
                i = void 0;
              try {
                for (
                  var r, o = this.files.slice()[Symbol.iterator]();
                  !(t = (r = o.next()).done);
                  t = !0
                ) {
                  var a = r.value;
                  (a.status === C.UPLOADING && !e) || this.removeFile(a);
                }
              } catch (e) {
                (n = !0), (i = e);
              } finally {
                try {
                  t || null == o.return || o.return();
                } finally {
                  if (n) throw i;
                }
              }
              return null;
            },
          },
          {
            key: 'resizeImage',
            value: function (r, e, t, n, o) {
              var a = this;
              return this.createThumbnail(r, e, t, n, !0, function (e, t) {
                if (null == t) return o(r);
                var n = a.options.resizeMimeType;
                null == n && (n = r.type);
                var i = t.toDataURL(n, a.options.resizeQuality);
                return (
                  ('image/jpeg' !== n && 'image/jpg' !== n) ||
                    (i = ExifRestore.restore(r.dataURL, i)),
                  o(C.dataURItoBlob(i))
                );
              });
            },
          },
          {
            key: 'createThumbnail',
            value: function (e, t, n, i, r, o) {
              var a = this,
                l = new FileReader();
              (l.onload = function () {
                (e.dataURL = l.result),
                  'image/svg+xml' !== e.type
                    ? a.createThumbnailFromUrl(e, t, n, i, r, o)
                    : null != o && o(l.result);
              }),
                l.readAsDataURL(e);
            },
          },
          {
            key: 'displayExistingFile',
            value: function (t, e, n, i, r) {
              var o = this,
                a = !(4 < arguments.length && void 0 !== r) || r;
              if ((this.emit('addedfile', t), this.emit('complete', t), a)) {
                (t.dataURL = e),
                  this.createThumbnailFromUrl(
                    t,
                    this.options.thumbnailWidth,
                    this.options.thumbnailHeight,
                    this.options.resizeMethod,
                    this.options.fixOrientation,
                    function (e) {
                      o.emit('thumbnail', t, e), n && n();
                    },
                    i
                  );
              } else this.emit('thumbnail', t, e), n && n();
            },
          },
          {
            key: 'createThumbnailFromUrl',
            value: function (o, a, l, s, t, u, e) {
              var c = this,
                d = document.createElement('img');
              return (
                e && (d.crossOrigin = e),
                (d.onload = function () {
                  var e = function (e) {
                    return e(1);
                  };
                  return (
                    'undefined' != typeof EXIF &&
                      null !== EXIF &&
                      t &&
                      (e = function (e) {
                        return EXIF.getData(d, function () {
                          return e(EXIF.getTag(this, 'Orientation'));
                        });
                      }),
                    e(function (e) {
                      (o.width = d.width), (o.height = d.height);
                      var t = c.options.resize.call(c, o, a, l, s),
                        n = document.createElement('canvas'),
                        i = n.getContext('2d');
                      switch (
                        ((n.width = t.trgWidth),
                        (n.height = t.trgHeight),
                        4 < e &&
                          ((n.width = t.trgHeight), (n.height = t.trgWidth)),
                        e)
                      ) {
                        case 2:
                          i.translate(n.width, 0), i.scale(-1, 1);
                          break;
                        case 3:
                          i.translate(n.width, n.height), i.rotate(Math.PI);
                          break;
                        case 4:
                          i.translate(0, n.height), i.scale(1, -1);
                          break;
                        case 5:
                          i.rotate(0.5 * Math.PI), i.scale(1, -1);
                          break;
                        case 6:
                          i.rotate(0.5 * Math.PI), i.translate(0, -n.width);
                          break;
                        case 7:
                          i.rotate(0.5 * Math.PI),
                            i.translate(n.height, -n.width),
                            i.scale(-1, 1);
                          break;
                        case 8:
                          i.rotate(-0.5 * Math.PI), i.translate(-n.height, 0);
                      }
                      drawImageIOSFix(
                        i,
                        d,
                        null != t.srcX ? t.srcX : 0,
                        null != t.srcY ? t.srcY : 0,
                        t.srcWidth,
                        t.srcHeight,
                        null != t.trgX ? t.trgX : 0,
                        null != t.trgY ? t.trgY : 0,
                        t.trgWidth,
                        t.trgHeight
                      );
                      var r = n.toDataURL('image/png');
                      if (null != u) return u(r, n);
                    })
                  );
                }),
                null != u && (d.onerror = u),
                (d.src = o.dataURL)
              );
            },
          },
          {
            key: 'processQueue',
            value: function () {
              var e = this.options.parallelUploads,
                t = this.getUploadingFiles().length,
                n = t;
              if (!(e <= t)) {
                var i = this.getQueuedFiles();
                if (0 < i.length) {
                  if (this.options.uploadMultiple)
                    return this.processFiles(i.slice(0, e - t));
                  for (; n < e; ) {
                    if (!i.length) return;
                    this.processFile(i.shift()), n++;
                  }
                }
              }
            },
          },
          {
            key: 'processFile',
            value: function (e) {
              return this.processFiles([e]);
            },
          },
          {
            key: 'processFiles',
            value: function (e) {
              var t = !0,
                n = !1,
                i = void 0;
              try {
                for (
                  var r, o = e[Symbol.iterator]();
                  !(t = (r = o.next()).done);
                  t = !0
                ) {
                  var a = r.value;
                  (a.processing = !0),
                    (a.status = C.UPLOADING),
                    this.emit('processing', a);
                }
              } catch (e) {
                (n = !0), (i = e);
              } finally {
                try {
                  t || null == o.return || o.return();
                } finally {
                  if (n) throw i;
                }
              }
              return (
                this.options.uploadMultiple &&
                  this.emit('processingmultiple', e),
                this.uploadFiles(e)
              );
            },
          },
          {
            key: '_getFilesWithXhr',
            value: function (t) {
              return this.files
                .filter(function (e) {
                  return e.xhr === t;
                })
                .map(function (e) {
                  return e;
                });
            },
          },
          {
            key: 'cancelUpload',
            value: function (e) {
              if (e.status === C.UPLOADING) {
                var t = this._getFilesWithXhr(e.xhr),
                  n = !0,
                  i = !1,
                  r = void 0;
                try {
                  for (
                    var o, a = t[Symbol.iterator]();
                    !(n = (o = a.next()).done);
                    n = !0
                  ) {
                    o.value.status = C.CANCELED;
                  }
                } catch (e) {
                  (i = !0), (r = e);
                } finally {
                  try {
                    n || null == a.return || a.return();
                  } finally {
                    if (i) throw r;
                  }
                }
                void 0 !== e.xhr && e.xhr.abort();
                var l = !0,
                  s = !1,
                  u = void 0;
                try {
                  for (
                    var c, d = t[Symbol.iterator]();
                    !(l = (c = d.next()).done);
                    l = !0
                  ) {
                    var p = c.value;
                    this.emit('canceled', p);
                  }
                } catch (e) {
                  (s = !0), (u = e);
                } finally {
                  try {
                    l || null == d.return || d.return();
                  } finally {
                    if (s) throw u;
                  }
                }
                this.options.uploadMultiple && this.emit('canceledmultiple', t);
              } else
                (e.status !== C.ADDED && e.status !== C.QUEUED) ||
                  ((e.status = C.CANCELED),
                  this.emit('canceled', e),
                  this.options.uploadMultiple &&
                    this.emit('canceledmultiple', [e]));
              if (this.options.autoProcessQueue) return this.processQueue();
            },
          },
          {
            key: 'resolveOption',
            value: function (e) {
              if ('function' != typeof e) return e;
              for (
                var t = arguments.length,
                  n = new Array(1 < t ? t - 1 : 0),
                  i = 1;
                i < t;
                i++
              )
                n[i - 1] = arguments[i];
              return e.apply(this, n);
            },
          },
          {
            key: 'uploadFile',
            value: function (e) {
              return this.uploadFiles([e]);
            },
          },
          {
            key: 'uploadFiles',
            value: function (s) {
              var u = this;
              this._transformFiles(s, function (e) {
                if (u.options.chunking) {
                  var t = e[0];
                  (s[0].upload.chunked =
                    u.options.chunking &&
                    (u.options.forceChunking || t.size > u.options.chunkSize)),
                    (s[0].upload.totalChunkCount = Math.ceil(
                      t.size / u.options.chunkSize
                    ));
                }
                if (s[0].upload.chunked) {
                  var r = s[0],
                    o = e[0];
                  r.upload.chunks = [];
                  var i = function () {
                    for (var e = 0; void 0 !== r.upload.chunks[e]; ) e++;
                    if (!(e >= r.upload.totalChunkCount)) {
                      0;
                      var t = e * u.options.chunkSize,
                        n = Math.min(t + u.options.chunkSize, r.size),
                        i = {
                          name: u._getParamName(0),
                          data: o.webkitSlice
                            ? o.webkitSlice(t, n)
                            : o.slice(t, n),
                          filename: r.upload.filename,
                          chunkIndex: e,
                        };
                      (r.upload.chunks[e] = {
                        file: r,
                        index: e,
                        dataBlock: i,
                        status: C.UPLOADING,
                        progress: 0,
                        retries: 0,
                      }),
                        u._uploadData(s, [i]);
                    }
                  };
                  if (
                    ((r.upload.finishedChunkUpload = function (e) {
                      var t = !0;
                      (e.status = C.SUCCESS),
                        (e.dataBlock = null),
                        (e.xhr = null);
                      for (var n = 0; n < r.upload.totalChunkCount; n++) {
                        if (void 0 === r.upload.chunks[n]) return i();
                        r.upload.chunks[n].status !== C.SUCCESS && (t = !1);
                      }
                      t &&
                        u.options.chunksUploaded(r, function () {
                          u._finished(s, '', null);
                        });
                    }),
                    u.options.parallelChunkUploads)
                  )
                    for (var n = 0; n < r.upload.totalChunkCount; n++) i();
                  else i();
                } else {
                  for (var a = [], l = 0; l < s.length; l++)
                    a[l] = {
                      name: u._getParamName(l),
                      data: e[l],
                      filename: s[l].upload.filename,
                    };
                  u._uploadData(s, a);
                }
              });
            },
          },
          {
            key: '_getChunk',
            value: function (e, t) {
              for (var n = 0; n < e.upload.totalChunkCount; n++)
                if (
                  void 0 !== e.upload.chunks[n] &&
                  e.upload.chunks[n].xhr === t
                )
                  return e.upload.chunks[n];
            },
          },
          {
            key: '_uploadData',
            value: function (t, e) {
              var n = this,
                i = new XMLHttpRequest(),
                r = !0,
                o = !1,
                a = void 0;
              try {
                for (
                  var l, s = t[Symbol.iterator]();
                  !(r = (l = s.next()).done);
                  r = !0
                ) {
                  l.value.xhr = i;
                }
              } catch (e) {
                (o = !0), (a = e);
              } finally {
                try {
                  r || null == s.return || s.return();
                } finally {
                  if (o) throw a;
                }
              }
              t[0].upload.chunked &&
                (t[0].upload.chunks[e[0].chunkIndex].xhr = i);
              var u = this.resolveOption(this.options.method, t),
                c = this.resolveOption(this.options.url, t);
              i.open(u, c, !0),
                (i.timeout = this.resolveOption(this.options.timeout, t)),
                (i.withCredentials = !!this.options.withCredentials),
                (i.onload = function (e) {
                  n._finishedUploading(t, i, e);
                }),
                (i.ontimeout = function () {
                  n._handleUploadError(
                    t,
                    i,
                    'Request timedout after '.concat(
                      n.options.timeout,
                      ' seconds'
                    )
                  );
                }),
                (i.onerror = function () {
                  n._handleUploadError(t, i);
                }),
                ((null != i.upload ? i.upload : i).onprogress = function (e) {
                  return n._updateFilesUploadProgress(t, i, e);
                });
              var d = {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'X-Requested-With': 'XMLHttpRequest',
              };
              for (var p in (this.options.headers &&
                C.extend(d, this.options.headers),
              d)) {
                var h = d[p];
                h && i.setRequestHeader(p, h);
              }
              var f = new FormData();
              if (this.options.params) {
                var v = this.options.params;
                for (var m in ('function' == typeof v &&
                  (v = v.call(
                    this,
                    t,
                    i,
                    t[0].upload.chunked ? this._getChunk(t[0], i) : null
                  )),
                v)) {
                  var y = v[m];
                  f.append(m, y);
                }
              }
              var g = !0,
                b = !1,
                k = void 0;
              try {
                for (
                  var w, F = t[Symbol.iterator]();
                  !(g = (w = F.next()).done);
                  g = !0
                ) {
                  var z = w.value;
                  this.emit('sending', z, i, f);
                }
              } catch (e) {
                (b = !0), (k = e);
              } finally {
                try {
                  g || null == F.return || F.return();
                } finally {
                  if (b) throw k;
                }
              }
              this.options.uploadMultiple &&
                this.emit('sendingmultiple', t, i, f),
                this._addFormElementData(f);
              for (var x = 0; x < e.length; x++) {
                var E = e[x];
                f.append(E.name, E.data, E.filename);
              }
              this.submitRequest(i, f, t);
            },
          },
          {
            key: '_transformFiles',
            value: function (n, i) {
              for (
                var e = this,
                  r = [],
                  o = 0,
                  t = function (t) {
                    e.options.transformFile.call(e, n[t], function (e) {
                      (r[t] = e), ++o === n.length && i(r);
                    });
                  },
                  a = 0;
                a < n.length;
                a++
              )
                t(a);
            },
          },
          {
            key: '_addFormElementData',
            value: function (e) {
              if ('FORM' === this.element.tagName) {
                var t = !0,
                  n = !1,
                  i = void 0;
                try {
                  for (
                    var r,
                      o = this.element
                        .querySelectorAll('input, textarea, select, button')
                        [Symbol.iterator]();
                    !(t = (r = o.next()).done);
                    t = !0
                  ) {
                    var a = r.value,
                      l = a.getAttribute('name'),
                      s = a.getAttribute('type');
                    if (((s = s && s.toLowerCase()), null != l))
                      if (
                        'SELECT' === a.tagName &&
                        a.hasAttribute('multiple')
                      ) {
                        var u = !0,
                          c = !1,
                          d = void 0;
                        try {
                          for (
                            var p, h = a.options[Symbol.iterator]();
                            !(u = (p = h.next()).done);
                            u = !0
                          ) {
                            var f = p.value;
                            f.selected && e.append(l, f.value);
                          }
                        } catch (e) {
                          (c = !0), (d = e);
                        } finally {
                          try {
                            u || null == h.return || h.return();
                          } finally {
                            if (c) throw d;
                          }
                        }
                      } else
                        (!s ||
                          ('checkbox' !== s && 'radio' !== s) ||
                          a.checked) &&
                          e.append(l, a.value);
                  }
                } catch (e) {
                  (n = !0), (i = e);
                } finally {
                  try {
                    t || null == o.return || o.return();
                  } finally {
                    if (n) throw i;
                  }
                }
              }
            },
          },
          {
            key: '_updateFilesUploadProgress',
            value: function (e, t, n) {
              var i;
              if (void 0 !== n) {
                if (((i = (100 * n.loaded) / n.total), e[0].upload.chunked)) {
                  var r = e[0],
                    o = this._getChunk(r, t);
                  (o.progress = i),
                    (o.total = n.total),
                    (o.bytesSent = n.loaded);
                  (r.upload.progress = 0), (r.upload.total = 0);
                  for (
                    var a = (r.upload.bytesSent = 0);
                    a < r.upload.totalChunkCount;
                    a++
                  )
                    void 0 !== r.upload.chunks[a] &&
                      void 0 !== r.upload.chunks[a].progress &&
                      ((r.upload.progress += r.upload.chunks[a].progress),
                      (r.upload.total += r.upload.chunks[a].total),
                      (r.upload.bytesSent += r.upload.chunks[a].bytesSent));
                  r.upload.progress =
                    r.upload.progress / r.upload.totalChunkCount;
                } else {
                  var l = !0,
                    s = !1,
                    u = void 0;
                  try {
                    for (
                      var c, d = e[Symbol.iterator]();
                      !(l = (c = d.next()).done);
                      l = !0
                    ) {
                      var p = c.value;
                      (p.upload.progress = i),
                        (p.upload.total = n.total),
                        (p.upload.bytesSent = n.loaded);
                    }
                  } catch (e) {
                    (s = !0), (u = e);
                  } finally {
                    try {
                      l || null == d.return || d.return();
                    } finally {
                      if (s) throw u;
                    }
                  }
                }
                var h = !0,
                  f = !1,
                  v = void 0;
                try {
                  for (
                    var m, y = e[Symbol.iterator]();
                    !(h = (m = y.next()).done);
                    h = !0
                  ) {
                    var g = m.value;
                    this.emit(
                      'uploadprogress',
                      g,
                      g.upload.progress,
                      g.upload.bytesSent
                    );
                  }
                } catch (e) {
                  (f = !0), (v = e);
                } finally {
                  try {
                    h || null == y.return || y.return();
                  } finally {
                    if (f) throw v;
                  }
                }
              } else {
                var b = !0,
                  k = !0,
                  w = !(i = 100),
                  F = void 0;
                try {
                  for (
                    var z, x = e[Symbol.iterator]();
                    !(k = (z = x.next()).done);
                    k = !0
                  ) {
                    var E = z.value;
                    (100 === E.upload.progress &&
                      E.upload.bytesSent === E.upload.total) ||
                      (b = !1),
                      (E.upload.progress = i),
                      (E.upload.bytesSent = E.upload.total);
                  }
                } catch (e) {
                  (w = !0), (F = e);
                } finally {
                  try {
                    k || null == x.return || x.return();
                  } finally {
                    if (w) throw F;
                  }
                }
                if (b) return;
                var C = !0,
                  _ = !1,
                  S = void 0;
                try {
                  for (
                    var D, T = e[Symbol.iterator]();
                    !(C = (D = T.next()).done);
                    C = !0
                  ) {
                    var L = D.value;
                    this.emit('uploadprogress', L, i, L.upload.bytesSent);
                  }
                } catch (e) {
                  (_ = !0), (S = e);
                } finally {
                  try {
                    C || null == T.return || T.return();
                  } finally {
                    if (_) throw S;
                  }
                }
              }
            },
          },
          {
            key: '_finishedUploading',
            value: function (e, t, n) {
              var i;
              if (e[0].status !== C.CANCELED && 4 === t.readyState) {
                if (
                  'arraybuffer' !== t.responseType &&
                  'blob' !== t.responseType &&
                  ((i = t.responseText),
                  t.getResponseHeader('content-type') &&
                    ~t
                      .getResponseHeader('content-type')
                      .indexOf('application/json'))
                )
                  try {
                    i = JSON.parse(i);
                  } catch (e) {
                    (n = e), (i = 'Invalid JSON response from server.');
                  }
                this._updateFilesUploadProgress(e),
                  200 <= t.status && t.status < 300
                    ? e[0].upload.chunked
                      ? e[0].upload.finishedChunkUpload(this._getChunk(e[0], t))
                      : this._finished(e, i, n)
                    : this._handleUploadError(e, t, i);
              }
            },
          },
          {
            key: '_handleUploadError',
            value: function (e, t, n) {
              if (e[0].status !== C.CANCELED) {
                if (e[0].upload.chunked && this.options.retryChunks) {
                  var i = this._getChunk(e[0], t);
                  if (i.retries++ < this.options.retryChunksLimit)
                    return void this._uploadData(e, [i.dataBlock]);
                  console.warn('Retried this chunk too often. Giving up.');
                }
                this._errorProcessing(
                  e,
                  n ||
                    this.options.dictResponseError.replace(
                      '{{statusCode}}',
                      t.status
                    ),
                  t
                );
              }
            },
          },
          {
            key: 'submitRequest',
            value: function (e, t) {
              e.send(t);
            },
          },
          {
            key: '_finished',
            value: function (e, t, n) {
              var i = !0,
                r = !1,
                o = void 0;
              try {
                for (
                  var a, l = e[Symbol.iterator]();
                  !(i = (a = l.next()).done);
                  i = !0
                ) {
                  var s = a.value;
                  (s.status = C.SUCCESS),
                    this.emit('success', s, t, n),
                    this.emit('complete', s);
                }
              } catch (e) {
                (r = !0), (o = e);
              } finally {
                try {
                  i || null == l.return || l.return();
                } finally {
                  if (r) throw o;
                }
              }
              if (
                (this.options.uploadMultiple &&
                  (this.emit('successmultiple', e, t, n),
                  this.emit('completemultiple', e)),
                this.options.autoProcessQueue)
              )
                return this.processQueue();
            },
          },
          {
            key: '_errorProcessing',
            value: function (e, t, n) {
              var i = !0,
                r = !1,
                o = void 0;
              try {
                for (
                  var a, l = e[Symbol.iterator]();
                  !(i = (a = l.next()).done);
                  i = !0
                ) {
                  var s = a.value;
                  (s.status = C.ERROR),
                    this.emit('error', s, t, n),
                    this.emit('complete', s);
                }
              } catch (e) {
                (r = !0), (o = e);
              } finally {
                try {
                  i || null == l.return || l.return();
                } finally {
                  if (r) throw o;
                }
              }
              if (
                (this.options.uploadMultiple &&
                  (this.emit('errormultiple', e, t, n),
                  this.emit('completemultiple', e)),
                this.options.autoProcessQueue)
              )
                return this.processQueue();
            },
          },
        ],
        [
          {
            key: 'uuidv4',
            value: function () {
              return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (e) {
                  var t = (16 * Math.random()) | 0;
                  return ('x' === e ? t : (3 & t) | 8).toString(16);
                }
              );
            },
          },
        ]
      ),
      C
    );
  })();
Dropzone.initClass(),
  (Dropzone.version = '5.7.0'),
  (Dropzone.options = {}),
  (Dropzone.optionsForElement = function (e) {
    return e.getAttribute('id')
      ? Dropzone.options[camelize(e.getAttribute('id'))]
      : void 0;
  }),
  (Dropzone.instances = []),
  (Dropzone.forElement = function (e) {
    if (
      ('string' == typeof e && (e = document.querySelector(e)),
      null == (null != e ? e.dropzone : void 0))
    )
      throw new Error(
        "No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone."
      );
    return e.dropzone;
  }),
  (Dropzone.autoDiscover = !0),
  (Dropzone.discover = function () {
    var s;
    if (document.querySelectorAll) s = document.querySelectorAll('.dropzone');
    else {
      s = [];
      var e = function (l) {
        return (function () {
          var e = [],
            t = !0,
            n = !1,
            i = void 0;
          try {
            for (
              var r, o = l[Symbol.iterator]();
              !(t = (r = o.next()).done);
              t = !0
            ) {
              var a = r.value;
              /(^| )dropzone($| )/.test(a.className)
                ? e.push(s.push(a))
                : e.push(void 0);
            }
          } catch (e) {
            (n = !0), (i = e);
          } finally {
            try {
              t || null == o.return || o.return();
            } finally {
              if (n) throw i;
            }
          }
          return e;
        })();
      };
      e(document.getElementsByTagName('div')),
        e(document.getElementsByTagName('form'));
    }
    return (function () {
      var e = [],
        t = !0,
        n = !1,
        i = void 0;
      try {
        for (
          var r, o = s[Symbol.iterator]();
          !(t = (r = o.next()).done);
          t = !0
        ) {
          var a = r.value;
          !1 !== Dropzone.optionsForElement(a)
            ? e.push(new Dropzone(a))
            : e.push(void 0);
        }
      } catch (e) {
        (n = !0), (i = e);
      } finally {
        try {
          t || null == o.return || o.return();
        } finally {
          if (n) throw i;
        }
      }
      return e;
    })();
  }),
  (Dropzone.blacklistedBrowsers = [
    /opera.*(Macintosh|Windows Phone).*version\/12/i,
  ]),
  (Dropzone.isBrowserSupported = function () {
    var e = !0;
    if (
      window.File &&
      window.FileReader &&
      window.FileList &&
      window.Blob &&
      window.FormData &&
      document.querySelector
    )
      if ('classList' in document.createElement('a')) {
        var t = !0,
          n = !1,
          i = void 0;
        try {
          for (
            var r, o = Dropzone.blacklistedBrowsers[Symbol.iterator]();
            !(t = (r = o.next()).done);
            t = !0
          ) {
            r.value.test(navigator.userAgent) && (e = !1);
          }
        } catch (e) {
          (n = !0), (i = e);
        } finally {
          try {
            t || null == o.return || o.return();
          } finally {
            if (n) throw i;
          }
        }
      } else e = !1;
    else e = !1;
    return e;
  }),
  (Dropzone.dataURItoBlob = function (e) {
    for (
      var t = atob(e.split(',')[1]),
        n = e.split(',')[0].split(':')[1].split(';')[0],
        i = new ArrayBuffer(t.length),
        r = new Uint8Array(i),
        o = 0,
        a = t.length,
        l = 0 <= a;
      l ? o <= a : a <= o;
      l ? o++ : o--
    )
      r[o] = t.charCodeAt(o);
    return new Blob([i], { type: n });
  });
var without = function (e, t) {
    return e
      .filter(function (e) {
        return e !== t;
      })
      .map(function (e) {
        return e;
      });
  },
  camelize = function (e) {
    return e.replace(/[\-_](\w)/g, function (e) {
      return e.charAt(1).toUpperCase();
    });
  };
(Dropzone.createElement = function (e) {
  var t = document.createElement('div');
  return (t.innerHTML = e), t.childNodes[0];
}),
  (Dropzone.elementInside = function (e, t) {
    if (e === t) return !0;
    for (; (e = e.parentNode); ) if (e === t) return !0;
    return !1;
  }),
  (Dropzone.getElement = function (e, t) {
    var n;
    if (
      ('string' == typeof e
        ? (n = document.querySelector(e))
        : null != e.nodeType && (n = e),
      null == n)
    )
      throw new Error(
        'Invalid `'.concat(
          t,
          '` option provided. Please provide a CSS selector or a plain HTML element.'
        )
      );
    return n;
  }),
  (Dropzone.getElements = function (e, t) {
    var n, i;
    if (e instanceof Array) {
      i = [];
      try {
        var r = !0,
          o = !1,
          a = void 0;
        try {
          for (
            var l, s = e[Symbol.iterator]();
            !(r = (l = s.next()).done);
            r = !0
          )
            (n = l.value), i.push(this.getElement(n, t));
        } catch (e) {
          (o = !0), (a = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw a;
          }
        }
      } catch (e) {
        i = null;
      }
    } else if ('string' == typeof e) {
      var u = !0,
        c = !(i = []),
        d = void 0;
      try {
        for (
          var p, h = document.querySelectorAll(e)[Symbol.iterator]();
          !(u = (p = h.next()).done);
          u = !0
        )
          (n = p.value), i.push(n);
      } catch (e) {
        (c = !0), (d = e);
      } finally {
        try {
          u || null == h.return || h.return();
        } finally {
          if (c) throw d;
        }
      }
    } else null != e.nodeType && (i = [e]);
    if (null == i || !i.length)
      throw new Error(
        'Invalid `'.concat(
          t,
          '` option provided. Please provide a CSS selector, a plain HTML element or a list of those.'
        )
      );
    return i;
  }),
  (Dropzone.confirm = function (e, t, n) {
    return window.confirm(e) ? t() : null != n ? n() : void 0;
  }),
  (Dropzone.isValidFile = function (e, t) {
    if (!t) return !0;
    t = t.split(',');
    var n = e.type,
      i = n.replace(/\/.*$/, ''),
      r = !0,
      o = !1,
      a = void 0;
    try {
      for (
        var l, s = t[Symbol.iterator]();
        !(r = (l = s.next()).done);
        r = !0
      ) {
        var u = l.value;
        if ('.' === (u = u.trim()).charAt(0)) {
          if (
            -1 !==
            e.name
              .toLowerCase()
              .indexOf(u.toLowerCase(), e.name.length - u.length)
          )
            return !0;
        } else if (/\/\*$/.test(u)) {
          if (i === u.replace(/\/.*$/, '')) return !0;
        } else if (n === u) return !0;
      }
    } catch (e) {
      (o = !0), (a = e);
    } finally {
      try {
        r || null == s.return || s.return();
      } finally {
        if (o) throw a;
      }
    }
    return !1;
  }),
  'undefined' != typeof jQuery &&
    null !== jQuery &&
    (jQuery.fn.dropzone = function (e) {
      return this.each(function () {
        return new Dropzone(this, e);
      });
    }),
  'undefined' != typeof module && null !== module
    ? (module.exports = Dropzone)
    : (window.Dropzone = Dropzone),
  (Dropzone.ADDED = 'added'),
  (Dropzone.QUEUED = 'queued'),
  (Dropzone.ACCEPTED = Dropzone.QUEUED),
  (Dropzone.UPLOADING = 'uploading'),
  (Dropzone.PROCESSING = Dropzone.UPLOADING),
  (Dropzone.CANCELED = 'canceled'),
  (Dropzone.ERROR = 'error'),
  (Dropzone.SUCCESS = 'success');
var detectVerticalSquash = function (e) {
    e.naturalWidth;
    var t = e.naturalHeight,
      n = document.createElement('canvas');
    (n.width = 1), (n.height = t);
    var i = n.getContext('2d');
    i.drawImage(e, 0, 0);
    for (
      var r = i.getImageData(1, 0, 1, t).data, o = 0, a = t, l = t;
      o < l;

    ) {
      0 === r[4 * (l - 1) + 3] ? (a = l) : (o = l), (l = (a + o) >> 1);
    }
    var s = l / t;
    return 0 == s ? 1 : s;
  },
  drawImageIOSFix = function (e, t, n, i, r, o, a, l, s, u) {
    var c = detectVerticalSquash(t);
    return e.drawImage(t, n, i, r, o, a, l, s, u / c);
  },
  ExifRestore = (function () {
    function e() {
      _classCallCheck(this, e);
    }
    return (
      _createClass(e, null, [
        {
          key: 'initClass',
          value: function () {
            this.KEY_STR =
              'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
          },
        },
        {
          key: 'encode64',
          value: function (e) {
            for (
              var t = '',
                n = void 0,
                i = void 0,
                r = '',
                o = void 0,
                a = void 0,
                l = void 0,
                s = '',
                u = 0;
              (o = (n = e[u++]) >> 2),
                (a = ((3 & n) << 4) | ((i = e[u++]) >> 4)),
                (l = ((15 & i) << 2) | ((r = e[u++]) >> 6)),
                (s = 63 & r),
                isNaN(i) ? (l = s = 64) : isNaN(r) && (s = 64),
                (t =
                  t +
                  this.KEY_STR.charAt(o) +
                  this.KEY_STR.charAt(a) +
                  this.KEY_STR.charAt(l) +
                  this.KEY_STR.charAt(s)),
                (n = i = r = ''),
                (o = a = l = s = ''),
                u < e.length;

            );
            return t;
          },
        },
        {
          key: 'restore',
          value: function (e, t) {
            if (!e.match('data:image/jpeg;base64,')) return t;
            var n = this.decode64(e.replace('data:image/jpeg;base64,', '')),
              i = this.slice2Segments(n),
              r = this.exifManipulation(t, i);
            return 'data:image/jpeg;base64,'.concat(this.encode64(r));
          },
        },
        {
          key: 'exifManipulation',
          value: function (e, t) {
            var n = this.getExifArray(t),
              i = this.insertExif(e, n);
            return new Uint8Array(i);
          },
        },
        {
          key: 'getExifArray',
          value: function (e) {
            for (var t = void 0, n = 0; n < e.length; ) {
              if ((255 === (t = e[n])[0]) & (225 === t[1])) return t;
              n++;
            }
            return [];
          },
        },
        {
          key: 'insertExif',
          value: function (e, t) {
            var n = e.replace('data:image/jpeg;base64,', ''),
              i = this.decode64(n),
              r = i.indexOf(255, 3),
              o = i.slice(0, r),
              a = i.slice(r),
              l = o;
            return (l = (l = l.concat(t)).concat(a));
          },
        },
        {
          key: 'slice2Segments',
          value: function (e) {
            for (var t = 0, n = []; ; ) {
              if ((255 === e[t]) & (218 === e[t + 1])) break;
              if ((255 === e[t]) & (216 === e[t + 1])) t += 2;
              else {
                var i = t + (256 * e[t + 2] + e[t + 3]) + 2,
                  r = e.slice(t, i);
                n.push(r), (t = i);
              }
              if (t > e.length) break;
            }
            return n;
          },
        },
        {
          key: 'decode64',
          value: function (e) {
            var t = void 0,
              n = void 0,
              i = '',
              r = void 0,
              o = void 0,
              a = '',
              l = 0,
              s = [];
            for (
              /[^A-Za-z0-9\+\/\=]/g.exec(e) &&
                console.warn(
                  "There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."
                ),
                e = e.replace(/[^A-Za-z0-9\+\/\=]/g, '');
              (t =
                (this.KEY_STR.indexOf(e.charAt(l++)) << 2) |
                ((r = this.KEY_STR.indexOf(e.charAt(l++))) >> 4)),
                (n =
                  ((15 & r) << 4) |
                  ((o = this.KEY_STR.indexOf(e.charAt(l++))) >> 2)),
                (i =
                  ((3 & o) << 6) | (a = this.KEY_STR.indexOf(e.charAt(l++)))),
                s.push(t),
                64 !== o && s.push(n),
                64 !== a && s.push(i),
                (t = n = i = ''),
                (r = o = a = ''),
                l < e.length;

            );
            return s;
          },
        },
      ]),
      e
    );
  })();
ExifRestore.initClass();
var contentLoaded = function (t, n) {
  function i(e) {
    if ('readystatechange' !== e.type || 'complete' === o.readyState)
      return (
        ('load' === e.type ? t : o)[s](u + e.type, i, !1),
        !r && (r = !0) ? n.call(t, e.type || e) : void 0
      );
  }
  var r = !1,
    e = !0,
    o = t.document,
    a = o.documentElement,
    l = o.addEventListener ? 'addEventListener' : 'attachEvent',
    s = o.addEventListener ? 'removeEventListener' : 'detachEvent',
    u = o.addEventListener ? '' : 'on';
  if ('complete' !== o.readyState) {
    if (o.createEventObject && a.doScroll) {
      try {
        e = !t.frameElement;
      } catch (e) {}
      e &&
        !(function t() {
          try {
            a.doScroll('left');
          } catch (e) {
            return void setTimeout(t, 50);
          }
          return i('poll');
        })();
    }
    return (
      o[l](u + 'DOMContentLoaded', i, !1),
      o[l](u + 'readystatechange', i, !1),
      t[l](u + 'load', i, !1)
    );
  }
};
function __guard__(e, t) {
  return null != e ? t(e) : void 0;
}
function __guardMethod__(e, t, n) {
  return null != e && 'function' == typeof e[t] ? n(e, t) : void 0;
}
(Dropzone._autoDiscoverFunction = function () {
  if (Dropzone.autoDiscover) return Dropzone.discover();
}),
  contentLoaded(window, Dropzone._autoDiscoverFunction);

/**
 * Slidebars - A jQuery Framework for Off-Canvas Menus and Sidebars
 * Version: 2.0.2
 * Url: http://www.adchsm.com/slidebars/
 * Author: Adam Charles Smith
 * Author url: http://www.adchsm.com/
 * License: MIT
 * License url: http://www.adchsm.com/slidebars/license/
 *
 * Modified by: Jory Hogeveen
 * Version numbers and info below is related to Off-Canvas Sidebars, not Slidebars.
 *
 * @package Off_Canvas_Sidebars
 * @author  Jory Hogeveen <info@keraweb.nl>
 *
 * @since   0.4    Add scope for this reference + Add legacy CSS support (no hardware acceleration)
 * @since   0.4.2  Parse slidebar widths/heights are rounded pixels (like jQuery does) to prevent 1px differences
 * @version 0.4.2
 * @global  slidebars
 * @preserve
 */
var slidebars;
(function ($) {
  slidebars = function () {
    var canvas = $('[canvas]'),
      canvas_fixed = $('[canvas-fixed]');
    (offCanvas = {}),
      (self = this),
      (init = false),
      (registered = false),
      (sides = ['top', 'right', 'bottom', 'left']),
      (styles = ['reveal', 'push', 'overlay', 'shift']),
      (getAnimationProperties = function (id) {
        var elements = $(),
          amount = '0px, 0px',
          size = '0px',
          duration =
            parseFloat(offCanvas[id].element.css('transitionDuration')) * 1e3;
        if (
          'reveal' === offCanvas[id].style ||
          'push' === offCanvas[id].style ||
          'shift' === offCanvas[id].style
        ) {
          elements = elements.add(canvas);
        }
        if (
          'reveal' === offCanvas[id].style &&
          ('top' === offCanvas[id].side || 'bottom' === offCanvas[id].side)
        ) {
          elements = elements.add(offCanvas[id].element);
        }
        if (
          'push' === offCanvas[id].style ||
          'overlay' === offCanvas[id].style ||
          'shift' === offCanvas[id].style
        ) {
          elements = elements.add(offCanvas[id].element);
        }
        if (offCanvas[id].active || self.legacy) {
          if ('top' === offCanvas[id].side || 'bottom' === offCanvas[id].side) {
            size = offCanvas[id].element.css('height');
          } else {
            size = offCanvas[id].element.css('width');
          }
          if (self.legacy) {
            amount = size;
          } else {
            if ('top' === offCanvas[id].side) {
              amount = '0px, ' + size;
            } else if ('right' === offCanvas[id].side) {
              amount = '-' + size + ', 0px';
            } else if ('bottom' === offCanvas[id].side) {
              amount = '0px, -' + size;
            } else if ('left' === offCanvas[id].side) {
              amount = size + ', 0px';
            }
          }
        }
        return { elements: elements, amount: amount, duration: duration };
      }),
      (registerSlidebar = function (id, side, style, element) {
        if (isRegisteredSlidebar(id)) {
          throw (
            "Error registering Slidebar, a Slidebar with id '" +
            id +
            "' already exists."
          );
        }
        offCanvas[id] = {
          id: id,
          side: side,
          style: style,
          element: element,
          active: false,
        };
      }),
      (isRegisteredSlidebar = function (id) {
        return offCanvas.hasOwnProperty(id);
      });
    this.legacy = false;
    this.init = function (callback) {
      if (init) {
        throw 'Slidebars has already been initialized.';
      }
      if (!registered) {
        $('[off-canvas]').each(function () {
          var parameters = $(this).attr('off-canvas').split(' ', 3);
          if (
            !parameters ||
            !parameters[0] ||
            -1 === sides.indexOf(parameters[1]) ||
            -1 === styles.indexOf(parameters[2])
          ) {
            throw "Error registering Slidebar, please specify a valid id, side and style'.";
          }
          registerSlidebar(
            parameters[0],
            parameters[1],
            parameters[2],
            $(this)
          );
        });
        registered = true;
      }
      init = true;
      this.css();
      $(events).trigger('init');
      if ('function' === typeof callback) {
        callback();
      }
    };
    this.exit = function (callback) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      var exit = function () {
        init = false;
        $(events).trigger('exit');
        if ('function' === typeof callback) {
          callback();
        }
      };
      if (this.getActiveSlidebar()) {
        this.close(exit);
      } else {
        exit();
      }
    };
    this.css = function (callback) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      for (var id in offCanvas) {
        if (offCanvas.hasOwnProperty(id) && isRegisteredSlidebar(id)) {
          var offset;
          if ('top' === offCanvas[id].side || 'bottom' === offCanvas[id].side) {
            offCanvas[id].element.css('height', '');
            offset = offCanvas[id].element.css('height');
            offCanvas[id].element.css('height', offset);
          } else {
            offCanvas[id].element.css('width', '');
            offset = offCanvas[id].element.css('width');
            offCanvas[id].element.css('width', offset);
          }
          var do_offset = false;
          if (
            'push' === offCanvas[id].style ||
            'overlay' === offCanvas[id].style ||
            'shift' === offCanvas[id].style
          ) {
            do_offset = true;
          } else if (
            'reveal' === offCanvas[id].style &&
            ('top' === offCanvas[id].side || 'bottom' === offCanvas[id].side)
          ) {
            do_offset = true;
          }
          if (do_offset) {
            offCanvas[id].element.css(
              'margin-' + offCanvas[id].side,
              '-' + offset
            );
            if (self.legacy && 'shift' === offCanvas[id].style) {
              var shiftPos;
              if (
                'top' === offCanvas[id].side ||
                'bottom' === offCanvas[id].side
              ) {
                shiftPos = offCanvas[id].element.height() / 1.9;
              } else if (
                'left' === offCanvas[id].side ||
                'right' === offCanvas[id].side
              ) {
                shiftPos = offCanvas[id].element.width() / 1.9;
              }
              if (
                'left' === offCanvas[id].side ||
                'right' === offCanvas[id].side
              ) {
                offCanvas[id].element.css(offCanvas[id].side, shiftPos + 'px');
              }
            }
          }
        }
      }
      if (this.getActiveSlidebar()) {
        this.open(this.getActiveSlidebar());
      }
      $(events).trigger('css');
      if ('function' === typeof callback) {
        callback();
      }
    };
    this.open = function (id, callback) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      if (!id || !isRegisteredSlidebar(id)) {
        throw (
          "Error opening Slidebar, there is no Slidebar with id '" + id + "'."
        );
      }
      var open = function () {
        offCanvas[id].active = true;
        offCanvas[id].element.css('display', 'block');
        $(events).trigger('opening', [offCanvas[id].id]);
        var animationProperties = getAnimationProperties(id);
        var css = {
          '-webkit-transition-duration': animationProperties.duration + 'ms',
          '-moz-transition-duration': animationProperties.duration + 'ms',
          '-o-transition-duration': animationProperties.duration + 'ms',
          'transition-duration': animationProperties.duration + 'ms',
        };
        if (self.legacy) {
          css[offCanvas[id].side] = animationProperties.amount;
          var canvasSide;
          if (
            'right' === offCanvas[id].side ||
            'bottom' === offCanvas[id].side
          ) {
            if ('right' === offCanvas[id].side) {
              canvasSide = 'left';
            } else if ('bottom' === offCanvas[id].side) {
              canvasSide = 'top';
            }
            var canvasCss = {
              '-webkit-transition-duration':
                animationProperties.duration + 'ms',
              '-moz-transition-duration': animationProperties.duration + 'ms',
              '-o-transition-duration': animationProperties.duration + 'ms',
              'transition-duration': animationProperties.duration + 'ms',
            };
            canvasCss[canvasSide] = '-' + animationProperties.amount;
            if ('overlay' !== offCanvas[id].style) {
              canvas.css(canvasCss);
            }
            animationProperties.elements.not(canvas).css(css);
          } else {
            animationProperties.elements.css(css);
          }
        } else {
          css.transform = 'translate(' + animationProperties.amount + ')';
          animationProperties.elements.css(css);
        }
        setTimeout(function () {
          $(events).trigger('opened', [offCanvas[id].id]);
          if ('function' === typeof callback) {
            callback();
          }
        }, animationProperties.duration);
      };
      if (this.getActiveSlidebar() && this.getActiveSlidebar() !== id) {
        this.close(open);
      } else {
        open();
      }
    };
    this.close = function (id, callback) {
      if ('function' === typeof id) {
        callback = id;
        id = null;
      }
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      if (id && !isRegisteredSlidebar(id)) {
        throw (
          "Error closing Slidebar, there is no Slidebar with id '" + id + "'."
        );
      }
      if (!id) {
        id = this.getActiveSlidebar();
      }
      if (id && offCanvas[id].active) {
        offCanvas[id].active = false;
        $(events).trigger('closing', [offCanvas[id].id]);
        var animationProperties = getAnimationProperties(id);
        if (self.legacy) {
          var css = {};
          var canvasSide;
          if (
            'right' === offCanvas[id].side ||
            'bottom' === offCanvas[id].side
          ) {
            if ('right' === offCanvas[id].side) {
              canvasSide = 'left';
            } else if ('bottom' === offCanvas[id].side) {
              canvasSide = 'top';
            }
            canvas.css(canvasSide, '');
            animationProperties.elements
              .not(canvas)
              .css(offCanvas[id].side, '');
          } else {
            animationProperties.elements.css(offCanvas[id].side, '');
          }
          if ('shift' === offCanvas[id].style) {
            var shiftPos;
            if (
              'top' === offCanvas[id].side ||
              'bottom' === offCanvas[id].side
            ) {
              shiftPos = offCanvas[id].element.height() / 1.9;
            } else if (
              'left' === offCanvas[id].side ||
              'right' === offCanvas[id].side
            ) {
              shiftPos = offCanvas[id].element.width() / 1.9;
            }
            if (
              'left' === offCanvas[id].side ||
              'right' === offCanvas[id].side
            ) {
              offCanvas[id].element.css(offCanvas[id].side, shiftPos + 'px');
            }
          }
        } else {
          animationProperties.elements.css('transform', '');
        }
        setTimeout(function () {
          animationProperties.elements.css({
            '-webkit-transition-duration': '',
            '-moz-transition-duration': '',
            '-o-transition-duration': '',
            'transition-duration': '',
          });
          offCanvas[id].element.css('display', '');
          $(events).trigger('closed', [offCanvas[id].id]);
          if ('function' === typeof callback) {
            callback();
          }
        }, animationProperties.duration);
      }
    };
    this.toggle = function (id, callback) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      if (!id || !isRegisteredSlidebar(id)) {
        throw (
          "Error toggling Slidebar, there is no Slidebar with id '" + id + "'."
        );
      }
      if (offCanvas[id].active) {
        this.close(id, function () {
          if ('function' === typeof callback) {
            callback();
          }
        });
      } else {
        this.open(id, function () {
          if ('function' === typeof callback) {
            callback();
          }
        });
      }
    };
    this.isActive = function (id) {
      return init;
    };
    this.isActiveSlidebar = function (id) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      if (!id) {
        throw 'You must provide a Slidebar id.';
      }
      if (!isRegisteredSlidebar(id)) {
        throw (
          "Error retrieving Slidebar, there is no Slidebar with id '" +
          id +
          "'."
        );
      }
      return offCanvas[id].active;
    };
    this.getActiveSlidebar = function () {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      var active = false;
      for (var id in offCanvas) {
        if (isRegisteredSlidebar(id)) {
          if (offCanvas[id].active) {
            active = offCanvas[id].id;
            break;
          }
        }
      }
      return active;
    };
    this.getSlidebars = function () {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      var slidebarsArray = [];
      for (var id in offCanvas) {
        if (isRegisteredSlidebar(id)) {
          slidebarsArray.push(offCanvas[id].id);
        }
      }
      return slidebarsArray;
    };
    this.getSlidebar = function (id) {
      if (!init) {
        throw "Slidebars hasn't been initialized.";
      }
      if (!id) {
        throw 'You must pass a Slidebar id.';
      }
      if (!id || !isRegisteredSlidebar(id)) {
        throw (
          "Error retrieving Slidebar, there is no Slidebar with id '" +
          id +
          "'."
        );
      }
      return offCanvas[id];
    };
    this.events = {};
    var events = this.events;
    $(window).on('resize', this.css.bind(this));
  };
})(jQuery);

/*!
 * Parsley.js
 * Version 2.9.2 - built Tue, Dec 10th 2019, 6:18 pm
 * http://parsleyjs.org
 * Guillaume Potier - <guillaume@wisembly.com>
 * Marc-Andre Lafortune - <petroselinum@marc-andre.ca>
 * MIT Licensed
 */

// The source code below is generated by babel as
// Parsley is written in ECMAScript 6
//

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = factory(require('jquery')))
    : typeof define === 'function' && define.amd
    ? define(['jquery'], factory)
    : ((global = global || self), (global.parsley = factory(global.jQuery)));
})(this, function ($) {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj &&
          typeof Symbol === 'function' &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? 'symbol'
          : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends =
      Object.assign ||
      function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

    return _extends.apply(this, arguments);
  }

  function _slicedToArray(arr, i) {
    return (
      _arrayWithHoles(arr) ||
      _iterableToArrayLimit(arr, i) ||
      _nonIterableRest()
    );
  }

  function _toConsumableArray(arr) {
    return (
      _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread()
    );
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
        arr2[i] = arr[i];

      return arr2;
    }
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (
      Symbol.iterator in Object(iter) ||
      Object.prototype.toString.call(iter) === '[object Arguments]'
    )
      return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    if (
      !(
        Symbol.iterator in Object(arr) ||
        Object.prototype.toString.call(arr) === '[object Arguments]'
      )
    ) {
      return;
    }

    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i['return'] != null) _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance');
  }

  function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  }

  var globalID = 1;
  var pastWarnings = {};
  var Utils = {
    // Parsley DOM-API
    // returns object from dom attributes and values
    attr: function attr(element, namespace, obj) {
      var i;
      var attribute;
      var attributes;
      var regex = new RegExp('^' + namespace, 'i');
      if ('undefined' === typeof obj) obj = {};
      else {
        // Clear all own properties. This won't affect prototype's values
        for (i in obj) {
          if (obj.hasOwnProperty(i)) delete obj[i];
        }
      }
      if (!element) return obj;
      attributes = element.attributes;

      for (i = attributes.length; i--; ) {
        attribute = attributes[i];

        if (attribute && attribute.specified && regex.test(attribute.name)) {
          obj[this.camelize(attribute.name.slice(namespace.length))] =
            this.deserializeValue(attribute.value);
        }
      }

      return obj;
    },
    checkAttr: function checkAttr(element, namespace, _checkAttr) {
      return element.hasAttribute(namespace + _checkAttr);
    },
    setAttr: function setAttr(element, namespace, attr, value) {
      element.setAttribute(this.dasherize(namespace + attr), String(value));
    },
    getType: function getType(element) {
      return element.getAttribute('type') || 'text';
    },
    generateID: function generateID() {
      return '' + globalID++;
    },

    /** Third party functions **/
    deserializeValue: function deserializeValue(value) {
      var num;

      try {
        return value
          ? value == 'true' ||
              (value == 'false'
                ? false
                : value == 'null'
                ? null
                : !isNaN((num = Number(value)))
                ? num
                : /^[\[\{]/.test(value)
                ? JSON.parse(value)
                : value)
          : value;
      } catch (e) {
        return value;
      }
    },
    // Zepto camelize function
    camelize: function camelize(str) {
      return str.replace(/-+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
    },
    // Zepto dasherize function
    dasherize: function dasherize(str) {
      return str
        .replace(/::/g, '/')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        .replace(/_/g, '-')
        .toLowerCase();
    },
    warn: function warn() {
      var _window$console;

      if (window.console && 'function' === typeof window.console.warn)
        (_window$console = window.console).warn.apply(
          _window$console,
          arguments
        );
    },
    warnOnce: function warnOnce(msg) {
      if (!pastWarnings[msg]) {
        pastWarnings[msg] = true;
        this.warn.apply(this, arguments);
      }
    },
    _resetWarnings: function _resetWarnings() {
      pastWarnings = {};
    },
    trimString: function trimString(string) {
      return string.replace(/^\s+|\s+$/g, '');
    },
    parse: {
      date: function date(string) {
        var parsed = string.match(/^(\d{4,})-(\d\d)-(\d\d)$/);
        if (!parsed) return null;

        var _parsed$map = parsed.map(function (x) {
            return parseInt(x, 10);
          }),
          _parsed$map2 = _slicedToArray(_parsed$map, 4),
          _ = _parsed$map2[0],
          year = _parsed$map2[1],
          month = _parsed$map2[2],
          day = _parsed$map2[3];

        var date = new Date(year, month - 1, day);
        if (
          date.getFullYear() !== year ||
          date.getMonth() + 1 !== month ||
          date.getDate() !== day
        )
          return null;
        return date;
      },
      string: function string(_string) {
        return _string;
      },
      integer: function integer(string) {
        if (isNaN(string)) return null;
        return parseInt(string, 10);
      },
      number: function number(string) {
        if (isNaN(string)) throw null;
        return parseFloat(string);
      },
      boolean: function _boolean(string) {
        return !/^\s*false\s*$/i.test(string);
      },
      object: function object(string) {
        return Utils.deserializeValue(string);
      },
      regexp: function regexp(_regexp) {
        var flags = ''; // Test if RegExp is literal, if not, nothing to be done, otherwise, we need to isolate flags and pattern

        if (/^\/.*\/(?:[gimy]*)$/.test(_regexp)) {
          // Replace the regexp literal string with the first match group: ([gimy]*)
          // If no flag is present, this will be a blank string
          flags = _regexp.replace(/.*\/([gimy]*)$/, '$1'); // Again, replace the regexp literal string with the first match group:
          // everything excluding the opening and closing slashes and the flags

          _regexp = _regexp.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1');
        } else {
          // Anchor regexp:
          _regexp = '^' + _regexp + '$';
        }

        return new RegExp(_regexp, flags);
      },
    },
    parseRequirement: function parseRequirement(requirementType, string) {
      var converter = this.parse[requirementType || 'string'];
      if (!converter)
        throw 'Unknown requirement specification: "' + requirementType + '"';
      var converted = converter(string);
      if (converted === null)
        throw 'Requirement is not a '
          .concat(requirementType, ': "')
          .concat(string, '"');
      return converted;
    },
    namespaceEvents: function namespaceEvents(events, namespace) {
      events = this.trimString(events || '').split(/\s+/);
      if (!events[0]) return '';
      return $.map(events, function (evt) {
        return ''.concat(evt, '.').concat(namespace);
      }).join(' ');
    },
    difference: function difference(array, remove) {
      // This is O(N^2), should be optimized
      var result = [];
      $.each(array, function (_, elem) {
        if (remove.indexOf(elem) == -1) result.push(elem);
      });
      return result;
    },
    // Alter-ego to native Promise.all, but for jQuery
    all: function all(promises) {
      // jQuery treats $.when() and $.when(singlePromise) differently; let's avoid that and add spurious elements
      return $.when.apply($, _toConsumableArray(promises).concat([42, 42]));
    },
    // Object.create polyfill, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create#Polyfill
    objectCreate:
      Object.create ||
      (function () {
        var Object = function Object() {};

        return function (prototype) {
          if (arguments.length > 1) {
            throw Error('Second argument not supported');
          }

          if (_typeof(prototype) != 'object') {
            throw TypeError('Argument must be an object');
          }

          Object.prototype = prototype;
          var result = new Object();
          Object.prototype = null;
          return result;
        };
      })(),
    _SubmitSelector: 'input[type="submit"], button:submit',
  };

  // All these options could be overriden and specified directly in DOM using
  // `data-parsley-` default DOM-API
  // eg: `inputs` can be set in DOM using `data-parsley-inputs="input, textarea"`
  // eg: `data-parsley-stop-on-first-failing-constraint="false"`
  var Defaults = {
    // ### General
    // Default data-namespace for DOM API
    namespace: 'data-parsley-',
    // Supported inputs by default
    inputs: 'input, textarea, select',
    // Excluded inputs by default
    excluded:
      'input[type=button], input[type=submit], input[type=reset], input[type=hidden]',
    // Stop validating field on highest priority failing constraint
    priorityEnabled: true,
    // ### Field only
    // identifier used to group together inputs (e.g. radio buttons...)
    multiple: null,
    // identifier (or array of identifiers) used to validate only a select group of inputs
    group: null,
    // ### UI
    // Enable\Disable error messages
    uiEnabled: true,
    // Key events threshold before validation
    validationThreshold: 3,
    // Focused field on form validation error. 'first'|'last'|'none'
    focus: 'first',
    // event(s) that will trigger validation before first failure. eg: `input`...
    trigger: false,
    // event(s) that will trigger validation after first failure.
    triggerAfterFailure: 'input',
    // Class that would be added on every failing validation Parsley field
    errorClass: 'parsley-error',
    // Same for success validation
    successClass: 'parsley-success',
    // Return the `$element` that will receive these above success or error classes
    // Could also be (and given directly from DOM) a valid selector like `'#div'`
    classHandler: function classHandler(Field) {},
    // Return the `$element` where errors will be appended
    // Could also be (and given directly from DOM) a valid selector like `'#div'`
    errorsContainer: function errorsContainer(Field) {},
    // ul elem that would receive errors' list
    errorsWrapper: '<ul class="parsley-errors-list"></ul>',
    // li elem that would receive error message
    errorTemplate: '<li></li>',
  };

  var Base = function Base() {
    this.__id__ = Utils.generateID();
  };

  Base.prototype = {
    asyncSupport: true,
    // Deprecated
    _pipeAccordingToValidationResult:
      function _pipeAccordingToValidationResult() {
        var _this = this;

        var pipe = function pipe() {
          var r = $.Deferred();
          if (true !== _this.validationResult) r.reject();
          return r.resolve().promise();
        };

        return [pipe, pipe];
      },
    actualizeOptions: function actualizeOptions() {
      Utils.attr(this.element, this.options.namespace, this.domOptions);
      if (this.parent && this.parent.actualizeOptions)
        this.parent.actualizeOptions();
      return this;
    },
    _resetOptions: function _resetOptions(initOptions) {
      this.domOptions = Utils.objectCreate(this.parent.options);
      this.options = Utils.objectCreate(this.domOptions); // Shallow copy of ownProperties of initOptions:

      for (var i in initOptions) {
        if (initOptions.hasOwnProperty(i)) this.options[i] = initOptions[i];
      }

      this.actualizeOptions();
    },
    _listeners: null,
    // Register a callback for the given event name
    // Callback is called with context as the first argument and the `this`
    // The context is the current parsley instance, or window.Parsley if global
    // A return value of `false` will interrupt the calls
    on: function on(name, fn) {
      this._listeners = this._listeners || {};
      var queue = (this._listeners[name] = this._listeners[name] || []);
      queue.push(fn);
      return this;
    },
    // Deprecated. Use `on` instead
    subscribe: function subscribe(name, fn) {
      $.listenTo(this, name.toLowerCase(), fn);
    },
    // Unregister a callback (or all if none is given) for the given event name
    off: function off(name, fn) {
      var queue = this._listeners && this._listeners[name];

      if (queue) {
        if (!fn) {
          delete this._listeners[name];
        } else {
          for (var i = queue.length; i--; ) {
            if (queue[i] === fn) queue.splice(i, 1);
          }
        }
      }

      return this;
    },
    // Deprecated. Use `off`
    unsubscribe: function unsubscribe(name, fn) {
      $.unsubscribeTo(this, name.toLowerCase());
    },
    // Trigger an event of the given name
    // A return value of `false` interrupts the callback chain
    // Returns false if execution was interrupted
    trigger: function trigger(name, target, extraArg) {
      target = target || this;
      var queue = this._listeners && this._listeners[name];
      var result;

      if (queue) {
        for (var i = queue.length; i--; ) {
          result = queue[i].call(target, target, extraArg);
          if (result === false) return result;
        }
      }

      if (this.parent) {
        return this.parent.trigger(name, target, extraArg);
      }

      return true;
    },
    asyncIsValid: function asyncIsValid(group, force) {
      Utils.warnOnce(
        'asyncIsValid is deprecated; please use whenValid instead'
      );
      return this.whenValid({
        group: group,
        force: force,
      });
    },
    _findRelated: function _findRelated() {
      return this.options.multiple
        ? $(
            this.parent.element.querySelectorAll(
              '['
                .concat(this.options.namespace, 'multiple="')
                .concat(this.options.multiple, '"]')
            )
          )
        : this.$element;
    },
  };

  var convertArrayRequirement = function convertArrayRequirement(
    string,
    length
  ) {
    var m = string.match(/^\s*\[(.*)\]\s*$/);
    if (!m) throw 'Requirement is not an array: "' + string + '"';
    var values = m[1].split(',').map(Utils.trimString);
    if (values.length !== length)
      throw (
        'Requirement has ' +
        values.length +
        ' values when ' +
        length +
        ' are needed'
      );
    return values;
  };

  var convertExtraOptionRequirement = function convertExtraOptionRequirement(
    requirementSpec,
    string,
    extraOptionReader
  ) {
    var main = null;
    var extra = {};

    for (var key in requirementSpec) {
      if (key) {
        var value = extraOptionReader(key);
        if ('string' === typeof value)
          value = Utils.parseRequirement(requirementSpec[key], value);
        extra[key] = value;
      } else {
        main = Utils.parseRequirement(requirementSpec[key], string);
      }
    }

    return [main, extra];
  }; // A Validator needs to implement the methods `validate` and `parseRequirements`

  var Validator = function Validator(spec) {
    $.extend(true, this, spec);
  };

  Validator.prototype = {
    // Returns `true` iff the given `value` is valid according the given requirements.
    validate: function validate(value, requirementFirstArg) {
      if (this.fn) {
        // Legacy style validator
        if (arguments.length > 3)
          // If more args then value, requirement, instance...
          requirementFirstArg = [].slice.call(arguments, 1, -1); // Skip first arg (value) and last (instance), combining the rest

        return this.fn(value, requirementFirstArg);
      }

      if (Array.isArray(value)) {
        if (!this.validateMultiple)
          throw 'Validator `' + this.name + '` does not handle multiple values';
        return this.validateMultiple.apply(this, arguments);
      } else {
        var instance = arguments[arguments.length - 1];

        if (this.validateDate && instance._isDateInput()) {
          arguments[0] = Utils.parse.date(arguments[0]);
          if (arguments[0] === null) return false;
          return this.validateDate.apply(this, arguments);
        }

        if (this.validateNumber) {
          if (!value)
            // Builtin validators all accept empty strings, except `required` of course
            return true;
          if (isNaN(value)) return false;
          arguments[0] = parseFloat(arguments[0]);
          return this.validateNumber.apply(this, arguments);
        }

        if (this.validateString) {
          return this.validateString.apply(this, arguments);
        }

        throw 'Validator `' + this.name + '` only handles multiple values';
      }
    },
    // Parses `requirements` into an array of arguments,
    // according to `this.requirementType`
    parseRequirements: function parseRequirements(
      requirements,
      extraOptionReader
    ) {
      if ('string' !== typeof requirements) {
        // Assume requirement already parsed
        // but make sure we return an array
        return Array.isArray(requirements) ? requirements : [requirements];
      }

      var type = this.requirementType;

      if (Array.isArray(type)) {
        var values = convertArrayRequirement(requirements, type.length);

        for (var i = 0; i < values.length; i++) {
          values[i] = Utils.parseRequirement(type[i], values[i]);
        }

        return values;
      } else if ($.isPlainObject(type)) {
        return convertExtraOptionRequirement(
          type,
          requirements,
          extraOptionReader
        );
      } else {
        return [Utils.parseRequirement(type, requirements)];
      }
    },
    // Defaults:
    requirementType: 'string',
    priority: 2,
  };

  var ValidatorRegistry = function ValidatorRegistry(validators, catalog) {
    this.__class__ = 'ValidatorRegistry'; // Default Parsley locale is en

    this.locale = 'en';
    this.init(validators || {}, catalog || {});
  };

  var typeTesters = {
    email:
      /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))$/,
    // Follow https://www.w3.org/TR/html5/infrastructure.html#floating-point-numbers
    number: /^-?(\d*\.)?\d+(e[-+]?\d+)?$/i,
    integer: /^-?\d+$/,
    digits: /^\d+$/,
    alphanum: /^\w+$/i,
    date: {
      test: function test(value) {
        return Utils.parse.date(value) !== null;
      },
    },
    url: new RegExp(
      '^' + // protocol identifier
        '(?:(?:https?|ftp)://)?' + // ** mod: make scheme optional
        // user:pass authentication
        '(?:\\S+(?::\\S*)?@)?' +
        '(?:' + // IP address exclusion
        // private & local networks
        // "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +   // ** mod: allow local networks
        // "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +  // ** mod: allow local networks
        // "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +  // ** mod: allow local networks
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broacast addresses
        // (first & last IP address of each class)
        '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
        '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
        '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
        '|' + // host name
        '(?:(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)' + // domain name
        '(?:\\.(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)*' + // TLD identifier
        '(?:\\.(?:[a-zA-Z\\u00a1-\\uffff]{2,}))' +
        ')' + // port number
        '(?::\\d{2,5})?' + // resource path
        '(?:/\\S*)?' +
        '$'
    ),
  };
  typeTesters.range = typeTesters.number; // See http://stackoverflow.com/a/10454560/8279

  var decimalPlaces = function decimalPlaces(num) {
    var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

    if (!match) {
      return 0;
    }

    return Math.max(
      0, // Number of digits right of decimal point.
      (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
        (match[2] ? +match[2] : 0)
    );
  }; // parseArguments('number', ['1', '2']) => [1, 2]

  var parseArguments = function parseArguments(type, args) {
    return args.map(Utils.parse[type]);
  }; // operatorToValidator returns a validating function for an operator function, applied to the given type

  var operatorToValidator = function operatorToValidator(type, operator) {
    return function (value) {
      for (
        var _len = arguments.length,
          requirementsAndInput = new Array(_len > 1 ? _len - 1 : 0),
          _key = 1;
        _key < _len;
        _key++
      ) {
        requirementsAndInput[_key - 1] = arguments[_key];
      }

      requirementsAndInput.pop(); // Get rid of `input` argument

      return operator.apply(
        void 0,
        [value].concat(
          _toConsumableArray(parseArguments(type, requirementsAndInput))
        )
      );
    };
  };

  var comparisonOperator = function comparisonOperator(operator) {
    return {
      validateDate: operatorToValidator('date', operator),
      validateNumber: operatorToValidator('number', operator),
      requirementType: operator.length <= 2 ? 'string' : ['string', 'string'],
      // Support operators with a 1 or 2 requirement(s)
      priority: 30,
    };
  };

  ValidatorRegistry.prototype = {
    init: function init(validators, catalog) {
      this.catalog = catalog; // Copy prototype's validators:

      this.validators = _extends({}, this.validators);

      for (var name in validators) {
        this.addValidator(name, validators[name].fn, validators[name].priority);
      }

      window.Parsley.trigger('parsley:validator:init');
    },
    // Set new messages locale if we have dictionary loaded in ParsleyConfig.i18n
    setLocale: function setLocale(locale) {
      if ('undefined' === typeof this.catalog[locale])
        throw new Error(locale + ' is not available in the catalog');
      this.locale = locale;
      return this;
    },
    // Add a new messages catalog for a given locale. Set locale for this catalog if set === `true`
    addCatalog: function addCatalog(locale, messages, set) {
      if ('object' === _typeof(messages)) this.catalog[locale] = messages;
      if (true === set) return this.setLocale(locale);
      return this;
    },
    // Add a specific message for a given constraint in a given locale
    addMessage: function addMessage(locale, name, message) {
      if ('undefined' === typeof this.catalog[locale])
        this.catalog[locale] = {};
      this.catalog[locale][name] = message;
      return this;
    },
    // Add messages for a given locale
    addMessages: function addMessages(locale, nameMessageObject) {
      for (var name in nameMessageObject) {
        this.addMessage(locale, name, nameMessageObject[name]);
      }

      return this;
    },
    // Add a new validator
    //
    //    addValidator('custom', {
    //        requirementType: ['integer', 'integer'],
    //        validateString: function(value, from, to) {},
    //        priority: 22,
    //        messages: {
    //          en: "Hey, that's no good",
    //          fr: "Aye aye, pas bon du tout",
    //        }
    //    })
    //
    // Old API was addValidator(name, function, priority)
    //
    addValidator: function addValidator(name, arg1, arg2) {
      if (this.validators[name])
        Utils.warn('Validator "' + name + '" is already defined.');
      else if (Defaults.hasOwnProperty(name)) {
        Utils.warn(
          '"' +
            name +
            '" is a restricted keyword and is not a valid validator name.'
        );
        return;
      }
      return this._setValidator.apply(this, arguments);
    },
    hasValidator: function hasValidator(name) {
      return !!this.validators[name];
    },
    updateValidator: function updateValidator(name, arg1, arg2) {
      if (!this.validators[name]) {
        Utils.warn('Validator "' + name + '" is not already defined.');
        return this.addValidator.apply(this, arguments);
      }

      return this._setValidator.apply(this, arguments);
    },
    removeValidator: function removeValidator(name) {
      if (!this.validators[name])
        Utils.warn('Validator "' + name + '" is not defined.');
      delete this.validators[name];
      return this;
    },
    _setValidator: function _setValidator(name, validator, priority) {
      if ('object' !== _typeof(validator)) {
        // Old style validator, with `fn` and `priority`
        validator = {
          fn: validator,
          priority: priority,
        };
      }

      if (!validator.validate) {
        validator = new Validator(validator);
      }

      this.validators[name] = validator;

      for (var locale in validator.messages || {}) {
        this.addMessage(locale, name, validator.messages[locale]);
      }

      return this;
    },
    getErrorMessage: function getErrorMessage(constraint) {
      var message; // Type constraints are a bit different, we have to match their requirements too to find right error message

      if ('type' === constraint.name) {
        var typeMessages = this.catalog[this.locale][constraint.name] || {};
        message = typeMessages[constraint.requirements];
      } else
        message = this.formatMessage(
          this.catalog[this.locale][constraint.name],
          constraint.requirements
        );

      return (
        message ||
        this.catalog[this.locale].defaultMessage ||
        this.catalog.en.defaultMessage
      );
    },
    // Kind of light `sprintf()` implementation
    formatMessage: function formatMessage(string, parameters) {
      if ('object' === _typeof(parameters)) {
        for (var i in parameters) {
          string = this.formatMessage(string, parameters[i]);
        }

        return string;
      }

      return 'string' === typeof string
        ? string.replace(/%s/i, parameters)
        : '';
    },
    // Here is the Parsley default validators list.
    // A validator is an object with the following key values:
    //  - priority: an integer
    //  - requirement: 'string' (default), 'integer', 'number', 'regexp' or an Array of these
    //  - validateString, validateMultiple, validateNumber: functions returning `true`, `false` or a promise
    // Alternatively, a validator can be a function that returns such an object
    //
    validators: {
      notblank: {
        validateString: function validateString(value) {
          return /\S/.test(value);
        },
        priority: 2,
      },
      required: {
        validateMultiple: function validateMultiple(values) {
          return values.length > 0;
        },
        validateString: function validateString(value) {
          return /\S/.test(value);
        },
        priority: 512,
      },
      type: {
        validateString: function validateString(value, type) {
          var _ref =
              arguments.length > 2 && arguments[2] !== undefined
                ? arguments[2]
                : {},
            _ref$step = _ref.step,
            step = _ref$step === void 0 ? 'any' : _ref$step,
            _ref$base = _ref.base,
            base = _ref$base === void 0 ? 0 : _ref$base;

          var tester = typeTesters[type];

          if (!tester) {
            throw new Error('validator type `' + type + '` is not supported');
          }

          if (!value) return true; // Builtin validators all accept empty strings, except `required` of course

          if (!tester.test(value)) return false;

          if ('number' === type) {
            if (!/^any$/i.test(step || '')) {
              var nb = Number(value);
              var decimals = Math.max(decimalPlaces(step), decimalPlaces(base));
              if (decimalPlaces(nb) > decimals)
                // Value can't have too many decimals
                return false; // Be careful of rounding errors by using integers.

              var toInt = function toInt(f) {
                return Math.round(f * Math.pow(10, decimals));
              };

              if ((toInt(nb) - toInt(base)) % toInt(step) != 0) return false;
            }
          }

          return true;
        },
        requirementType: {
          '': 'string',
          step: 'string',
          base: 'number',
        },
        priority: 256,
      },
      pattern: {
        validateString: function validateString(value, regexp) {
          if (!value) return true; // Builtin validators all accept empty strings, except `required` of course

          return regexp.test(value);
        },
        requirementType: 'regexp',
        priority: 64,
      },
      minlength: {
        validateString: function validateString(value, requirement) {
          if (!value) return true; // Builtin validators all accept empty strings, except `required` of course

          return value.length >= requirement;
        },
        requirementType: 'integer',
        priority: 30,
      },
      maxlength: {
        validateString: function validateString(value, requirement) {
          return value.length <= requirement;
        },
        requirementType: 'integer',
        priority: 30,
      },
      length: {
        validateString: function validateString(value, min, max) {
          if (!value) return true; // Builtin validators all accept empty strings, except `required` of course

          return value.length >= min && value.length <= max;
        },
        requirementType: ['integer', 'integer'],
        priority: 30,
      },
      mincheck: {
        validateMultiple: function validateMultiple(values, requirement) {
          return values.length >= requirement;
        },
        requirementType: 'integer',
        priority: 30,
      },
      maxcheck: {
        validateMultiple: function validateMultiple(values, requirement) {
          return values.length <= requirement;
        },
        requirementType: 'integer',
        priority: 30,
      },
      check: {
        validateMultiple: function validateMultiple(values, min, max) {
          return values.length >= min && values.length <= max;
        },
        requirementType: ['integer', 'integer'],
        priority: 30,
      },
      min: comparisonOperator(function (value, requirement) {
        return value >= requirement;
      }),
      max: comparisonOperator(function (value, requirement) {
        return value <= requirement;
      }),
      range: comparisonOperator(function (value, min, max) {
        return value >= min && value <= max;
      }),
      equalto: {
        validateString: function validateString(value, refOrValue) {
          if (!value) return true; // Builtin validators all accept empty strings, except `required` of course

          var $reference = $(refOrValue);
          if ($reference.length) return value === $reference.val();
          else return value === refOrValue;
        },
        priority: 256,
      },
      euvatin: {
        validateString: function validateString(value, refOrValue) {
          if (!value) {
            return true; // Builtin validators all accept empty strings, except `required` of course
          }

          var re = /^[A-Z][A-Z][A-Za-z0-9 -]{2,}$/;
          return re.test(value);
        },
        priority: 30,
      },
    },
  };

  var UI = {};

  var diffResults = function diffResults(newResult, oldResult, deep) {
    var added = [];
    var kept = [];

    for (var i = 0; i < newResult.length; i++) {
      var found = false;

      for (var j = 0; j < oldResult.length; j++) {
        if (newResult[i].assert.name === oldResult[j].assert.name) {
          found = true;
          break;
        }
      }

      if (found) kept.push(newResult[i]);
      else added.push(newResult[i]);
    }

    return {
      kept: kept,
      added: added,
      removed: !deep ? diffResults(oldResult, newResult, true).added : [],
    };
  };

  UI.Form = {
    _actualizeTriggers: function _actualizeTriggers() {
      var _this = this;

      this.$element.on('submit.Parsley', function (evt) {
        _this.onSubmitValidate(evt);
      });
      this.$element.on('click.Parsley', Utils._SubmitSelector, function (evt) {
        _this.onSubmitButton(evt);
      }); // UI could be disabled

      if (false === this.options.uiEnabled) return;
      this.element.setAttribute('novalidate', '');
    },
    focus: function focus() {
      this._focusedField = null;
      if (true === this.validationResult || 'none' === this.options.focus)
        return null;

      for (var i = 0; i < this.fields.length; i++) {
        var field = this.fields[i];

        if (
          true !== field.validationResult &&
          field.validationResult.length > 0 &&
          'undefined' === typeof field.options.noFocus
        ) {
          this._focusedField = field.$element;
          if ('first' === this.options.focus) break;
        }
      }

      if (null === this._focusedField) return null;
      return this._focusedField.focus();
    },
    _destroyUI: function _destroyUI() {
      // Reset all event listeners
      this.$element.off('.Parsley');
    },
  };
  UI.Field = {
    _reflowUI: function _reflowUI() {
      this._buildUI(); // If this field doesn't have an active UI don't bother doing something

      if (!this._ui) return; // Diff between two validation results

      var diff = diffResults(
        this.validationResult,
        this._ui.lastValidationResult
      ); // Then store current validation result for next reflow

      this._ui.lastValidationResult = this.validationResult; // Handle valid / invalid / none field class

      this._manageStatusClass(); // Add, remove, updated errors messages

      this._manageErrorsMessages(diff); // Triggers impl

      this._actualizeTriggers(); // If field is not valid for the first time, bind keyup trigger to ease UX and quickly inform user

      if ((diff.kept.length || diff.added.length) && !this._failedOnce) {
        this._failedOnce = true;

        this._actualizeTriggers();
      }
    },
    // Returns an array of field's error message(s)
    getErrorsMessages: function getErrorsMessages() {
      // No error message, field is valid
      if (true === this.validationResult) return [];
      var messages = [];

      for (var i = 0; i < this.validationResult.length; i++) {
        messages.push(
          this.validationResult[i].errorMessage ||
            this._getErrorMessage(this.validationResult[i].assert)
        );
      }

      return messages;
    },
    // It's a goal of Parsley that this method is no longer required [#1073]
    addError: function addError(name) {
      var _ref =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {},
        message = _ref.message,
        assert = _ref.assert,
        _ref$updateClass = _ref.updateClass,
        updateClass = _ref$updateClass === void 0 ? true : _ref$updateClass;

      this._buildUI();

      this._addError(name, {
        message: message,
        assert: assert,
      });

      if (updateClass) this._errorClass();
    },
    // It's a goal of Parsley that this method is no longer required [#1073]
    updateError: function updateError(name) {
      var _ref2 =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {},
        message = _ref2.message,
        assert = _ref2.assert,
        _ref2$updateClass = _ref2.updateClass,
        updateClass = _ref2$updateClass === void 0 ? true : _ref2$updateClass;

      this._buildUI();

      this._updateError(name, {
        message: message,
        assert: assert,
      });

      if (updateClass) this._errorClass();
    },
    // It's a goal of Parsley that this method is no longer required [#1073]
    removeError: function removeError(name) {
      var _ref3 =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {},
        _ref3$updateClass = _ref3.updateClass,
        updateClass = _ref3$updateClass === void 0 ? true : _ref3$updateClass;

      this._buildUI();

      this._removeError(name); // edge case possible here: remove a standard Parsley error that is still failing in this.validationResult
      // but highly improbable cuz' manually removing a well Parsley handled error makes no sense.

      if (updateClass) this._manageStatusClass();
    },
    _manageStatusClass: function _manageStatusClass() {
      if (
        this.hasConstraints() &&
        this.needsValidation() &&
        true === this.validationResult
      )
        this._successClass();
      else if (this.validationResult.length > 0) this._errorClass();
      else this._resetClass();
    },
    _manageErrorsMessages: function _manageErrorsMessages(diff) {
      if ('undefined' !== typeof this.options.errorsMessagesDisabled) return; // Case where we have errorMessage option that configure an unique field error message, regardless failing validators

      if ('undefined' !== typeof this.options.errorMessage) {
        if (diff.added.length || diff.kept.length) {
          this._insertErrorWrapper();

          if (
            0 ===
            this._ui.$errorsWrapper.find('.parsley-custom-error-message').length
          )
            this._ui.$errorsWrapper.append(
              $(this.options.errorTemplate).addClass(
                'parsley-custom-error-message'
              )
            );

          this._ui.$errorClassHandler.attr(
            'aria-describedby',
            this._ui.errorsWrapperId
          );

          return this._ui.$errorsWrapper
            .addClass('filled')
            .attr('aria-hidden', 'false')
            .find('.parsley-custom-error-message')
            .html(this.options.errorMessage);
        }

        this._ui.$errorClassHandler.removeAttr('aria-describedby');

        return this._ui.$errorsWrapper
          .removeClass('filled')
          .attr('aria-hidden', 'true')
          .find('.parsley-custom-error-message')
          .remove();
      } // Show, hide, update failing constraints messages

      for (var i = 0; i < diff.removed.length; i++) {
        this._removeError(diff.removed[i].assert.name);
      }

      for (i = 0; i < diff.added.length; i++) {
        this._addError(diff.added[i].assert.name, {
          message: diff.added[i].errorMessage,
          assert: diff.added[i].assert,
        });
      }

      for (i = 0; i < diff.kept.length; i++) {
        this._updateError(diff.kept[i].assert.name, {
          message: diff.kept[i].errorMessage,
          assert: diff.kept[i].assert,
        });
      }
    },
    _addError: function _addError(name, _ref4) {
      var message = _ref4.message,
        assert = _ref4.assert;

      this._insertErrorWrapper();

      this._ui.$errorClassHandler.attr(
        'aria-describedby',
        this._ui.errorsWrapperId
      );

      this._ui.$errorsWrapper
        .addClass('filled')
        .attr('aria-hidden', 'false')
        .append(
          $(this.options.errorTemplate)
            .addClass('parsley-' + name)
            .html(message || this._getErrorMessage(assert))
        );
    },
    _updateError: function _updateError(name, _ref5) {
      var message = _ref5.message,
        assert = _ref5.assert;

      this._ui.$errorsWrapper
        .addClass('filled')
        .find('.parsley-' + name)
        .html(message || this._getErrorMessage(assert));
    },
    _removeError: function _removeError(name) {
      this._ui.$errorClassHandler.removeAttr('aria-describedby');

      this._ui.$errorsWrapper
        .removeClass('filled')
        .attr('aria-hidden', 'true')
        .find('.parsley-' + name)
        .remove();
    },
    _getErrorMessage: function _getErrorMessage(constraint) {
      var customConstraintErrorMessage = constraint.name + 'Message';
      if ('undefined' !== typeof this.options[customConstraintErrorMessage])
        return window.Parsley.formatMessage(
          this.options[customConstraintErrorMessage],
          constraint.requirements
        );
      return window.Parsley.getErrorMessage(constraint);
    },
    _buildUI: function _buildUI() {
      // UI could be already built or disabled
      if (this._ui || false === this.options.uiEnabled) return;
      var _ui = {}; // Give field its Parsley id in DOM

      this.element.setAttribute(this.options.namespace + 'id', this.__id__);
      /** Generate important UI elements and store them in this **/
      // $errorClassHandler is the $element that woul have parsley-error and parsley-success classes

      _ui.$errorClassHandler = this._manageClassHandler(); // $errorsWrapper is a div that would contain the various field errors, it will be appended into $errorsContainer

      _ui.errorsWrapperId =
        'parsley-id-' +
        (this.options.multiple
          ? 'multiple-' + this.options.multiple
          : this.__id__);
      _ui.$errorsWrapper = $(this.options.errorsWrapper).attr(
        'id',
        _ui.errorsWrapperId
      ); // ValidationResult UI storage to detect what have changed bwt two validations, and update DOM accordingly

      _ui.lastValidationResult = [];
      _ui.validationInformationVisible = false; // Store it in this for later

      this._ui = _ui;
    },
    // Determine which element will have `parsley-error` and `parsley-success` classes
    _manageClassHandler: function _manageClassHandler() {
      // Class handled could also be determined by function given in Parsley options
      if (
        'string' === typeof this.options.classHandler &&
        $(this.options.classHandler).length
      )
        return $(this.options.classHandler); // Class handled could also be determined by function given in Parsley options

      var $handlerFunction = this.options.classHandler; // It might also be the function name of a global function

      if (
        'string' === typeof this.options.classHandler &&
        'function' === typeof window[this.options.classHandler]
      )
        $handlerFunction = window[this.options.classHandler];

      if ('function' === typeof $handlerFunction) {
        var $handler = $handlerFunction.call(this, this); // If this function returned a valid existing DOM element, go for it

        if ('undefined' !== typeof $handler && $handler.length) return $handler;
      } else if (
        'object' === _typeof($handlerFunction) &&
        $handlerFunction instanceof jQuery &&
        $handlerFunction.length
      ) {
        return $handlerFunction;
      } else if ($handlerFunction) {
        Utils.warn(
          'The class handler `' +
            $handlerFunction +
            '` does not exist in DOM nor as a global JS function'
        );
      }

      return this._inputHolder();
    },
    _inputHolder: function _inputHolder() {
      // if simple element (input, texatrea, select...) it will perfectly host the classes and precede the error container
      if (!this.options.multiple || this.element.nodeName === 'SELECT')
        return this.$element; // But if multiple element (radio, checkbox), that would be their parent

      return this.$element.parent();
    },
    _insertErrorWrapper: function _insertErrorWrapper() {
      var $errorsContainer = this.options.errorsContainer; // Nothing to do if already inserted

      if (0 !== this._ui.$errorsWrapper.parent().length)
        return this._ui.$errorsWrapper.parent();

      if ('string' === typeof $errorsContainer) {
        if ($($errorsContainer).length)
          return $($errorsContainer).append(this._ui.$errorsWrapper);
        else if ('function' === typeof window[$errorsContainer])
          $errorsContainer = window[$errorsContainer];
        else
          Utils.warn(
            'The errors container `' +
              $errorsContainer +
              '` does not exist in DOM nor as a global JS function'
          );
      }

      if ('function' === typeof $errorsContainer)
        $errorsContainer = $errorsContainer.call(this, this);
      if ('object' === _typeof($errorsContainer) && $errorsContainer.length)
        return $errorsContainer.append(this._ui.$errorsWrapper);
      return this._inputHolder().after(this._ui.$errorsWrapper);
    },
    _actualizeTriggers: function _actualizeTriggers() {
      var _this2 = this;

      var $toBind = this._findRelated();

      var trigger; // Remove Parsley events already bound on this field

      $toBind.off('.Parsley');
      if (this._failedOnce)
        $toBind.on(
          Utils.namespaceEvents(this.options.triggerAfterFailure, 'Parsley'),
          function () {
            _this2._validateIfNeeded();
          }
        );
      else if (
        (trigger = Utils.namespaceEvents(this.options.trigger, 'Parsley'))
      ) {
        $toBind.on(trigger, function (event) {
          _this2._validateIfNeeded(event);
        });
      }
    },
    _validateIfNeeded: function _validateIfNeeded(event) {
      var _this3 = this;

      // For keyup, keypress, keydown, input... events that could be a little bit obstrusive
      // do not validate if val length < min threshold on first validation. Once field have been validated once and info
      // about success or failure have been displayed, always validate with this trigger to reflect every yalidation change.
      if (event && /key|input/.test(event.type))
        if (
          !(this._ui && this._ui.validationInformationVisible) &&
          this.getValue().length <= this.options.validationThreshold
        )
          return;

      if (this.options.debounce) {
        window.clearTimeout(this._debounced);
        this._debounced = window.setTimeout(function () {
          return _this3.validate();
        }, this.options.debounce);
      } else this.validate();
    },
    _resetUI: function _resetUI() {
      // Reset all event listeners
      this._failedOnce = false;

      this._actualizeTriggers(); // Nothing to do if UI never initialized for this field

      if ('undefined' === typeof this._ui) return; // Reset all errors' li

      this._ui.$errorsWrapper.removeClass('filled').children().remove(); // Reset validation class

      this._resetClass(); // Reset validation flags and last validation result

      this._ui.lastValidationResult = [];
      this._ui.validationInformationVisible = false;
    },
    _destroyUI: function _destroyUI() {
      this._resetUI();

      if ('undefined' !== typeof this._ui) this._ui.$errorsWrapper.remove();
      delete this._ui;
    },
    _successClass: function _successClass() {
      this._ui.validationInformationVisible = true;

      this._ui.$errorClassHandler
        .removeClass(this.options.errorClass)
        .addClass(this.options.successClass);
    },
    _errorClass: function _errorClass() {
      this._ui.validationInformationVisible = true;

      this._ui.$errorClassHandler
        .removeClass(this.options.successClass)
        .addClass(this.options.errorClass);
    },
    _resetClass: function _resetClass() {
      this._ui.$errorClassHandler
        .removeClass(this.options.successClass)
        .removeClass(this.options.errorClass);
    },
  };

  var Form = function Form(element, domOptions, options) {
    this.__class__ = 'Form';
    this.element = element;
    this.$element = $(element);
    this.domOptions = domOptions;
    this.options = options;
    this.parent = window.Parsley;
    this.fields = [];
    this.validationResult = null;
  };

  var statusMapping = {
    pending: null,
    resolved: true,
    rejected: false,
  };
  Form.prototype = {
    onSubmitValidate: function onSubmitValidate(event) {
      var _this = this;

      // This is a Parsley generated submit event, do not validate, do not prevent, simply exit and keep normal behavior
      if (true === event.parsley) return; // If we didn't come here through a submit button, use the first one in the form

      var submitSource =
        this._submitSource || this.$element.find(Utils._SubmitSelector)[0];
      this._submitSource = null;
      this.$element
        .find('.parsley-synthetic-submit-button')
        .prop('disabled', true);
      if (submitSource && null !== submitSource.getAttribute('formnovalidate'))
        return;
      window.Parsley._remoteCache = {};
      var promise = this.whenValidate({
        event: event,
      });

      if ('resolved' === promise.state() && false !== this._trigger('submit'));
      else {
        // Rejected or pending: cancel this submit
        event.stopImmediatePropagation();
        event.preventDefault();
        if ('pending' === promise.state())
          promise.done(function () {
            _this._submit(submitSource);
          });
      }
    },
    onSubmitButton: function onSubmitButton(event) {
      this._submitSource = event.currentTarget;
    },
    // internal
    // _submit submits the form, this time without going through the validations.
    // Care must be taken to "fake" the actual submit button being clicked.
    _submit: function _submit(submitSource) {
      if (false === this._trigger('submit')) return; // Add submit button's data

      if (submitSource) {
        var $synthetic = this.$element
          .find('.parsley-synthetic-submit-button')
          .prop('disabled', false);
        if (0 === $synthetic.length)
          $synthetic = $(
            '<input class="parsley-synthetic-submit-button" type="hidden">'
          ).appendTo(this.$element);
        $synthetic.attr({
          name: submitSource.getAttribute('name'),
          value: submitSource.getAttribute('value'),
        });
      }

      this.$element.trigger(
        _extends($.Event('submit'), {
          parsley: true,
        })
      );
    },
    // Performs validation on fields while triggering events.
    // @returns `true` if all validations succeeds, `false`
    // if a failure is immediately detected, or `null`
    // if dependant on a promise.
    // Consider using `whenValidate` instead.
    validate: function validate(options) {
      if (arguments.length >= 1 && !$.isPlainObject(options)) {
        Utils.warnOnce(
          'Calling validate on a parsley form without passing arguments as an object is deprecated.'
        );

        var _arguments = Array.prototype.slice.call(arguments),
          group = _arguments[0],
          force = _arguments[1],
          event = _arguments[2];

        options = {
          group: group,
          force: force,
          event: event,
        };
      }

      return statusMapping[this.whenValidate(options).state()];
    },
    whenValidate: function whenValidate() {
      var _this2 = this,
        _Utils$all$done$fail$;

      var _ref =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : {},
        group = _ref.group,
        force = _ref.force,
        event = _ref.event;

      this.submitEvent = event;

      if (event) {
        this.submitEvent = _extends({}, event, {
          preventDefault: function preventDefault() {
            Utils.warnOnce(
              'Using `this.submitEvent.preventDefault()` is deprecated; instead, call `this.validationResult = false`'
            );
            _this2.validationResult = false;
          },
        });
      }

      this.validationResult = true; // fire validate event to eventually modify things before every validation

      this._trigger('validate'); // Refresh form DOM options and form's fields that could have changed

      this._refreshFields();

      var promises = this._withoutReactualizingFormOptions(function () {
        return $.map(_this2.fields, function (field) {
          return field.whenValidate({
            force: force,
            group: group,
          });
        });
      });

      return (_Utils$all$done$fail$ = Utils.all(promises)
        .done(function () {
          _this2._trigger('success');
        })
        .fail(function () {
          _this2.validationResult = false;

          _this2.focus();

          _this2._trigger('error');
        })
        .always(function () {
          _this2._trigger('validated');
        })).pipe.apply(
        _Utils$all$done$fail$,
        _toConsumableArray(this._pipeAccordingToValidationResult())
      );
    },
    // Iterate over refreshed fields, and stop on first failure.
    // Returns `true` if all fields are valid, `false` if a failure is detected
    // or `null` if the result depends on an unresolved promise.
    // Prefer using `whenValid` instead.
    isValid: function isValid(options) {
      if (arguments.length >= 1 && !$.isPlainObject(options)) {
        Utils.warnOnce(
          'Calling isValid on a parsley form without passing arguments as an object is deprecated.'
        );

        var _arguments2 = Array.prototype.slice.call(arguments),
          group = _arguments2[0],
          force = _arguments2[1];

        options = {
          group: group,
          force: force,
        };
      }

      return statusMapping[this.whenValid(options).state()];
    },
    // Iterate over refreshed fields and validate them.
    // Returns a promise.
    // A validation that immediately fails will interrupt the validations.
    whenValid: function whenValid() {
      var _this3 = this;

      var _ref2 =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : {},
        group = _ref2.group,
        force = _ref2.force;

      this._refreshFields();

      var promises = this._withoutReactualizingFormOptions(function () {
        return $.map(_this3.fields, function (field) {
          return field.whenValid({
            group: group,
            force: force,
          });
        });
      });

      return Utils.all(promises);
    },
    refresh: function refresh() {
      this._refreshFields();

      return this;
    },
    // Reset UI
    reset: function reset() {
      // Form case: emit a reset event for each field
      for (var i = 0; i < this.fields.length; i++) {
        this.fields[i].reset();
      }

      this._trigger('reset');
    },
    // Destroy Parsley instance (+ UI)
    destroy: function destroy() {
      // Field case: emit destroy event to clean UI and then destroy stored instance
      this._destroyUI(); // Form case: destroy all its fields and then destroy stored instance

      for (var i = 0; i < this.fields.length; i++) {
        this.fields[i].destroy();
      }

      this.$element.removeData('Parsley');

      this._trigger('destroy');
    },
    _refreshFields: function _refreshFields() {
      return this.actualizeOptions()._bindFields();
    },
    _bindFields: function _bindFields() {
      var _this4 = this;

      var oldFields = this.fields;
      this.fields = [];
      this.fieldsMappedById = {};

      this._withoutReactualizingFormOptions(function () {
        _this4.$element
          .find(_this4.options.inputs)
          .not(_this4.options.excluded)
          .not('['.concat(_this4.options.namespace, 'excluded=true]'))
          .each(function (_, element) {
            var fieldInstance = new window.Parsley.Factory(element, {}, _this4); // Only add valid and not excluded `Field` and `FieldMultiple` children

            if (
              'Field' === fieldInstance.__class__ ||
              'FieldMultiple' === fieldInstance.__class__
            ) {
              var uniqueId =
                fieldInstance.__class__ + '-' + fieldInstance.__id__;

              if ('undefined' === typeof _this4.fieldsMappedById[uniqueId]) {
                _this4.fieldsMappedById[uniqueId] = fieldInstance;

                _this4.fields.push(fieldInstance);
              }
            }
          });

        $.each(Utils.difference(oldFields, _this4.fields), function (_, field) {
          field.reset();
        });
      });

      return this;
    },
    // Internal only.
    // Looping on a form's fields to do validation or similar
    // will trigger reactualizing options on all of them, which
    // in turn will reactualize the form's options.
    // To avoid calling actualizeOptions so many times on the form
    // for nothing, _withoutReactualizingFormOptions temporarily disables
    // the method actualizeOptions on this form while `fn` is called.
    _withoutReactualizingFormOptions: function _withoutReactualizingFormOptions(
      fn
    ) {
      var oldActualizeOptions = this.actualizeOptions;

      this.actualizeOptions = function () {
        return this;
      };

      var result = fn();
      this.actualizeOptions = oldActualizeOptions;
      return result;
    },
    // Internal only.
    // Shortcut to trigger an event
    // Returns true iff event is not interrupted and default not prevented.
    _trigger: function _trigger(eventName) {
      return this.trigger('form:' + eventName);
    },
  };

  var Constraint = function Constraint(
    parsleyField,
    name,
    requirements,
    priority,
    isDomConstraint
  ) {
    var validatorSpec = window.Parsley._validatorRegistry.validators[name];
    var validator = new Validator(validatorSpec);
    priority =
      priority || parsleyField.options[name + 'Priority'] || validator.priority;
    isDomConstraint = true === isDomConstraint;

    _extends(this, {
      validator: validator,
      name: name,
      requirements: requirements,
      priority: priority,
      isDomConstraint: isDomConstraint,
    });

    this._parseRequirements(parsleyField.options);
  };

  var capitalize = function capitalize(str) {
    var cap = str[0].toUpperCase();
    return cap + str.slice(1);
  };

  Constraint.prototype = {
    validate: function validate(value, instance) {
      var _this$validator;

      return (_this$validator = this.validator).validate.apply(
        _this$validator,
        [value].concat(_toConsumableArray(this.requirementList), [instance])
      );
    },
    _parseRequirements: function _parseRequirements(options) {
      var _this = this;

      this.requirementList = this.validator.parseRequirements(
        this.requirements,
        function (key) {
          return options[_this.name + capitalize(key)];
        }
      );
    },
  };

  var Field = function Field(field, domOptions, options, parsleyFormInstance) {
    this.__class__ = 'Field';
    this.element = field;
    this.$element = $(field); // Set parent if we have one

    if ('undefined' !== typeof parsleyFormInstance) {
      this.parent = parsleyFormInstance;
    }

    this.options = options;
    this.domOptions = domOptions; // Initialize some properties

    this.constraints = [];
    this.constraintsByName = {};
    this.validationResult = true; // Bind constraints

    this._bindConstraints();
  };

  var statusMapping$1 = {
    pending: null,
    resolved: true,
    rejected: false,
  };
  Field.prototype = {
    // # Public API
    // Validate field and trigger some events for mainly `UI`
    // @returns `true`, an array of the validators that failed, or
    // `null` if validation is not finished. Prefer using whenValidate
    validate: function validate(options) {
      if (arguments.length >= 1 && !$.isPlainObject(options)) {
        Utils.warnOnce(
          'Calling validate on a parsley field without passing arguments as an object is deprecated.'
        );
        options = {
          options: options,
        };
      }

      var promise = this.whenValidate(options);
      if (!promise)
        // If excluded with `group` option
        return true;

      switch (promise.state()) {
        case 'pending':
          return null;

        case 'resolved':
          return true;

        case 'rejected':
          return this.validationResult;
      }
    },
    // Validate field and trigger some events for mainly `UI`
    // @returns a promise that succeeds only when all validations do
    // or `undefined` if field is not in the given `group`.
    whenValidate: function whenValidate() {
      var _this$whenValid$alway,
        _this = this;

      var _ref =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : {},
        force = _ref.force,
        group = _ref.group;

      // do not validate a field if not the same as given validation group
      this.refresh();
      if (group && !this._isInGroup(group)) return;
      this.value = this.getValue(); // Field Validate event. `this.value` could be altered for custom needs

      this._trigger('validate');

      return (_this$whenValid$alway = this.whenValid({
        force: force,
        value: this.value,
        _refreshed: true,
      })
        .always(function () {
          _this._reflowUI();
        })
        .done(function () {
          _this._trigger('success');
        })
        .fail(function () {
          _this._trigger('error');
        })
        .always(function () {
          _this._trigger('validated');
        })).pipe.apply(
        _this$whenValid$alway,
        _toConsumableArray(this._pipeAccordingToValidationResult())
      );
    },
    hasConstraints: function hasConstraints() {
      return 0 !== this.constraints.length;
    },
    // An empty optional field does not need validation
    needsValidation: function needsValidation(value) {
      if ('undefined' === typeof value) value = this.getValue(); // If a field is empty and not required, it is valid
      // Except if `data-parsley-validate-if-empty` explicitely added, useful for some custom validators

      if (
        !value.length &&
        !this._isRequired() &&
        'undefined' === typeof this.options.validateIfEmpty
      )
        return false;
      return true;
    },
    _isInGroup: function _isInGroup(group) {
      if (Array.isArray(this.options.group))
        return -1 !== $.inArray(group, this.options.group);
      return this.options.group === group;
    },
    // Just validate field. Do not trigger any event.
    // Returns `true` iff all constraints pass, `false` if there are failures,
    // or `null` if the result can not be determined yet (depends on a promise)
    // See also `whenValid`.
    isValid: function isValid(options) {
      if (arguments.length >= 1 && !$.isPlainObject(options)) {
        Utils.warnOnce(
          'Calling isValid on a parsley field without passing arguments as an object is deprecated.'
        );

        var _arguments = Array.prototype.slice.call(arguments),
          force = _arguments[0],
          value = _arguments[1];

        options = {
          force: force,
          value: value,
        };
      }

      var promise = this.whenValid(options);
      if (!promise)
        // Excluded via `group`
        return true;
      return statusMapping$1[promise.state()];
    },
    // Just validate field. Do not trigger any event.
    // @returns a promise that succeeds only when all validations do
    // or `undefined` if the field is not in the given `group`.
    // The argument `force` will force validation of empty fields.
    // If a `value` is given, it will be validated instead of the value of the input.
    whenValid: function whenValid() {
      var _this2 = this;

      var _ref2 =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : {},
        _ref2$force = _ref2.force,
        force = _ref2$force === void 0 ? false : _ref2$force,
        value = _ref2.value,
        group = _ref2.group,
        _refreshed = _ref2._refreshed;

      // Recompute options and rebind constraints to have latest changes
      if (!_refreshed) this.refresh(); // do not validate a field if not the same as given validation group

      if (group && !this._isInGroup(group)) return;
      this.validationResult = true; // A field without constraint is valid

      if (!this.hasConstraints()) return $.when(); // Value could be passed as argument, needed to add more power to 'field:validate'

      if ('undefined' === typeof value || null === value)
        value = this.getValue();
      if (!this.needsValidation(value) && true !== force) return $.when();

      var groupedConstraints = this._getGroupedConstraints();

      var promises = [];
      $.each(groupedConstraints, function (_, constraints) {
        // Process one group of constraints at a time, we validate the constraints
        // and combine the promises together.
        var promise = Utils.all(
          $.map(constraints, function (constraint) {
            return _this2._validateConstraint(value, constraint);
          })
        );
        promises.push(promise);
        if (promise.state() === 'rejected') return false; // Interrupt processing if a group has already failed
      });
      return Utils.all(promises);
    },
    // @returns a promise
    _validateConstraint: function _validateConstraint(value, constraint) {
      var _this3 = this;

      var result = constraint.validate(value, this); // Map false to a failed promise

      if (false === result) result = $.Deferred().reject(); // Make sure we return a promise and that we record failures

      return Utils.all([result]).fail(function (errorMessage) {
        if (!(_this3.validationResult instanceof Array))
          _this3.validationResult = [];

        _this3.validationResult.push({
          assert: constraint,
          errorMessage: 'string' === typeof errorMessage && errorMessage,
        });
      });
    },
    // @returns Parsley field computed value that could be overrided or configured in DOM
    getValue: function getValue() {
      var value; // Value could be overriden in DOM or with explicit options

      if ('function' === typeof this.options.value)
        value = this.options.value(this);
      else if ('undefined' !== typeof this.options.value)
        value = this.options.value;
      else value = this.$element.val(); // Handle wrong DOM or configurations

      if ('undefined' === typeof value || null === value) return '';
      return this._handleWhitespace(value);
    },
    // Reset UI
    reset: function reset() {
      this._resetUI();

      return this._trigger('reset');
    },
    // Destroy Parsley instance (+ UI)
    destroy: function destroy() {
      // Field case: emit destroy event to clean UI and then destroy stored instance
      this._destroyUI();

      this.$element.removeData('Parsley');
      this.$element.removeData('FieldMultiple');

      this._trigger('destroy');
    },
    // Actualize options and rebind constraints
    refresh: function refresh() {
      this._refreshConstraints();

      return this;
    },
    _refreshConstraints: function _refreshConstraints() {
      return this.actualizeOptions()._bindConstraints();
    },
    refreshConstraints: function refreshConstraints() {
      Utils.warnOnce(
        "Parsley's refreshConstraints is deprecated. Please use refresh"
      );
      return this.refresh();
    },

    /**
     * Add a new constraint to a field
     *
     * @param {String}   name
     * @param {Mixed}    requirements      optional
     * @param {Number}   priority          optional
     * @param {Boolean}  isDomConstraint   optional
     */
    addConstraint: function addConstraint(
      name,
      requirements,
      priority,
      isDomConstraint
    ) {
      if (window.Parsley._validatorRegistry.validators[name]) {
        var constraint = new Constraint(
          this,
          name,
          requirements,
          priority,
          isDomConstraint
        ); // if constraint already exist, delete it and push new version

        if ('undefined' !== this.constraintsByName[constraint.name])
          this.removeConstraint(constraint.name);
        this.constraints.push(constraint);
        this.constraintsByName[constraint.name] = constraint;
      }

      return this;
    },
    // Remove a constraint
    removeConstraint: function removeConstraint(name) {
      for (var i = 0; i < this.constraints.length; i++) {
        if (name === this.constraints[i].name) {
          this.constraints.splice(i, 1);
          break;
        }
      }

      delete this.constraintsByName[name];
      return this;
    },
    // Update a constraint (Remove + re-add)
    updateConstraint: function updateConstraint(name, parameters, priority) {
      return this.removeConstraint(name).addConstraint(
        name,
        parameters,
        priority
      );
    },
    // # Internals
    // Internal only.
    // Bind constraints from config + options + DOM
    _bindConstraints: function _bindConstraints() {
      var constraints = [];
      var constraintsByName = {}; // clean all existing DOM constraints to only keep javascript user constraints

      for (var i = 0; i < this.constraints.length; i++) {
        if (false === this.constraints[i].isDomConstraint) {
          constraints.push(this.constraints[i]);
          constraintsByName[this.constraints[i].name] = this.constraints[i];
        }
      }

      this.constraints = constraints;
      this.constraintsByName = constraintsByName; // then re-add Parsley DOM-API constraints

      for (var name in this.options) {
        this.addConstraint(name, this.options[name], undefined, true);
      } // finally, bind special HTML5 constraints

      return this._bindHtml5Constraints();
    },
    // Internal only.
    // Bind specific HTML5 constraints to be HTML5 compliant
    _bindHtml5Constraints: function _bindHtml5Constraints() {
      // html5 required
      if (null !== this.element.getAttribute('required'))
        this.addConstraint('required', true, undefined, true); // html5 pattern

      if (null !== this.element.getAttribute('pattern'))
        this.addConstraint(
          'pattern',
          this.element.getAttribute('pattern'),
          undefined,
          true
        ); // range

      var min = this.element.getAttribute('min');
      var max = this.element.getAttribute('max');
      if (null !== min && null !== max)
        this.addConstraint('range', [min, max], undefined, true);
      // HTML5 min
      else if (null !== min) this.addConstraint('min', min, undefined, true);
      // HTML5 max
      else if (null !== max) this.addConstraint('max', max, undefined, true); // length

      if (
        null !== this.element.getAttribute('minlength') &&
        null !== this.element.getAttribute('maxlength')
      )
        this.addConstraint(
          'length',
          [
            this.element.getAttribute('minlength'),
            this.element.getAttribute('maxlength'),
          ],
          undefined,
          true
        );
      // HTML5 minlength
      else if (null !== this.element.getAttribute('minlength'))
        this.addConstraint(
          'minlength',
          this.element.getAttribute('minlength'),
          undefined,
          true
        );
      // HTML5 maxlength
      else if (null !== this.element.getAttribute('maxlength'))
        this.addConstraint(
          'maxlength',
          this.element.getAttribute('maxlength'),
          undefined,
          true
        ); // html5 types

      var type = Utils.getType(this.element); // Small special case here for HTML5 number: integer validator if step attribute is undefined or an integer value, number otherwise

      if ('number' === type) {
        return this.addConstraint(
          'type',
          [
            'number',
            {
              step: this.element.getAttribute('step') || '1',
              base: min || this.element.getAttribute('value'),
            },
          ],
          undefined,
          true
        ); // Regular other HTML5 supported types
      } else if (/^(email|url|range|date)$/i.test(type)) {
        return this.addConstraint('type', type, undefined, true);
      }

      return this;
    },
    // Internal only.
    // Field is required if have required constraint without `false` value
    _isRequired: function _isRequired() {
      if ('undefined' === typeof this.constraintsByName.required) return false;
      return false !== this.constraintsByName.required.requirements;
    },
    // Internal only.
    // Shortcut to trigger an event
    _trigger: function _trigger(eventName) {
      return this.trigger('field:' + eventName);
    },
    // Internal only
    // Handles whitespace in a value
    // Use `data-parsley-whitespace="squish"` to auto squish input value
    // Use `data-parsley-whitespace="trim"` to auto trim input value
    _handleWhitespace: function _handleWhitespace(value) {
      if (true === this.options.trimValue)
        Utils.warnOnce(
          'data-parsley-trim-value="true" is deprecated, please use data-parsley-whitespace="trim"'
        );
      if ('squish' === this.options.whitespace)
        value = value.replace(/\s{2,}/g, ' ');
      if (
        'trim' === this.options.whitespace ||
        'squish' === this.options.whitespace ||
        true === this.options.trimValue
      )
        value = Utils.trimString(value);
      return value;
    },
    _isDateInput: function _isDateInput() {
      var c = this.constraintsByName.type;
      return c && c.requirements === 'date';
    },
    // Internal only.
    // Returns the constraints, grouped by descending priority.
    // The result is thus an array of arrays of constraints.
    _getGroupedConstraints: function _getGroupedConstraints() {
      if (false === this.options.priorityEnabled) return [this.constraints];
      var groupedConstraints = [];
      var index = {}; // Create array unique of priorities

      for (var i = 0; i < this.constraints.length; i++) {
        var p = this.constraints[i].priority;
        if (!index[p]) groupedConstraints.push((index[p] = []));
        index[p].push(this.constraints[i]);
      } // Sort them by priority DESC

      groupedConstraints.sort(function (a, b) {
        return b[0].priority - a[0].priority;
      });
      return groupedConstraints;
    },
  };

  var Multiple = function Multiple() {
    this.__class__ = 'FieldMultiple';
  };

  Multiple.prototype = {
    // Add new `$element` sibling for multiple field
    addElement: function addElement($element) {
      this.$elements.push($element);
      return this;
    },
    // See `Field._refreshConstraints()`
    _refreshConstraints: function _refreshConstraints() {
      var fieldConstraints;
      this.constraints = []; // Select multiple special treatment

      if (this.element.nodeName === 'SELECT') {
        this.actualizeOptions()._bindConstraints();

        return this;
      } // Gather all constraints for each input in the multiple group

      for (var i = 0; i < this.$elements.length; i++) {
        // Check if element have not been dynamically removed since last binding
        if (!$('html').has(this.$elements[i]).length) {
          this.$elements.splice(i, 1);
          continue;
        }

        fieldConstraints = this.$elements[i]
          .data('FieldMultiple')
          ._refreshConstraints().constraints;

        for (var j = 0; j < fieldConstraints.length; j++) {
          this.addConstraint(
            fieldConstraints[j].name,
            fieldConstraints[j].requirements,
            fieldConstraints[j].priority,
            fieldConstraints[j].isDomConstraint
          );
        }
      }

      return this;
    },
    // See `Field.getValue()`
    getValue: function getValue() {
      // Value could be overriden in DOM
      if ('function' === typeof this.options.value)
        return this.options.value(this);
      else if ('undefined' !== typeof this.options.value)
        return this.options.value; // Radio input case

      if (this.element.nodeName === 'INPUT') {
        var type = Utils.getType(this.element);
        if (type === 'radio')
          return this._findRelated().filter(':checked').val() || ''; // checkbox input case

        if (type === 'checkbox') {
          var values = [];

          this._findRelated()
            .filter(':checked')
            .each(function () {
              values.push($(this).val());
            });

          return values;
        }
      } // Select multiple case

      if (this.element.nodeName === 'SELECT' && null === this.$element.val())
        return []; // Default case that should never happen

      return this.$element.val();
    },
    _init: function _init() {
      this.$elements = [this.$element];
      return this;
    },
  };

  var Factory = function Factory(element, options, parsleyFormInstance) {
    this.element = element;
    this.$element = $(element); // If the element has already been bound, returns its saved Parsley instance

    var savedparsleyFormInstance = this.$element.data('Parsley');

    if (savedparsleyFormInstance) {
      // If the saved instance has been bound without a Form parent and there is one given in this call, add it
      if (
        'undefined' !== typeof parsleyFormInstance &&
        savedparsleyFormInstance.parent === window.Parsley
      ) {
        savedparsleyFormInstance.parent = parsleyFormInstance;

        savedparsleyFormInstance._resetOptions(
          savedparsleyFormInstance.options
        );
      }

      if ('object' === _typeof(options)) {
        _extends(savedparsleyFormInstance.options, options);
      }

      return savedparsleyFormInstance;
    } // Parsley must be instantiated with a DOM element or jQuery $element

    if (!this.$element.length)
      throw new Error('You must bind Parsley on an existing element.');
    if (
      'undefined' !== typeof parsleyFormInstance &&
      'Form' !== parsleyFormInstance.__class__
    )
      throw new Error('Parent instance must be a Form instance');
    this.parent = parsleyFormInstance || window.Parsley;
    return this.init(options);
  };

  Factory.prototype = {
    init: function init(options) {
      this.__class__ = 'Parsley';
      this.__version__ = '2.9.2';
      this.__id__ = Utils.generateID(); // Pre-compute options

      this._resetOptions(options); // A Form instance is obviously a `<form>` element but also every node that is not an input and has the `data-parsley-validate` attribute

      if (
        this.element.nodeName === 'FORM' ||
        (Utils.checkAttr(this.element, this.options.namespace, 'validate') &&
          !this.$element.is(this.options.inputs))
      )
        return this.bind('parsleyForm'); // Every other element is bound as a `Field` or `FieldMultiple`

      return this.isMultiple()
        ? this.handleMultiple()
        : this.bind('parsleyField');
    },
    isMultiple: function isMultiple() {
      var type = Utils.getType(this.element);
      return (
        type === 'radio' ||
        type === 'checkbox' ||
        (this.element.nodeName === 'SELECT' &&
          null !== this.element.getAttribute('multiple'))
      );
    },
    // Multiples fields are a real nightmare :(
    // Maybe some refactoring would be appreciated here...
    handleMultiple: function handleMultiple() {
      var _this = this;

      var name;
      var parsleyMultipleInstance; // Handle multiple name

      this.options.multiple =
        this.options.multiple ||
        (name = this.element.getAttribute('name')) ||
        this.element.getAttribute('id'); // Special select multiple input

      if (
        this.element.nodeName === 'SELECT' &&
        null !== this.element.getAttribute('multiple')
      ) {
        this.options.multiple = this.options.multiple || this.__id__;
        return this.bind('parsleyFieldMultiple'); // Else for radio / checkboxes, we need a `name` or `data-parsley-multiple` to properly bind it
      } else if (!this.options.multiple) {
        Utils.warn(
          'To be bound by Parsley, a radio, a checkbox and a multiple select input must have either a name or a multiple option.',
          this.$element
        );
        return this;
      } // Remove special chars

      this.options.multiple = this.options.multiple.replace(
        /(:|\.|\[|\]|\{|\}|\$)/g,
        ''
      ); // Add proper `data-parsley-multiple` to siblings if we have a valid multiple name

      if (name) {
        $('input[name="' + name + '"]').each(function (i, input) {
          var type = Utils.getType(input);
          if (type === 'radio' || type === 'checkbox')
            input.setAttribute(
              _this.options.namespace + 'multiple',
              _this.options.multiple
            );
        });
      } // Check here if we don't already have a related multiple instance saved

      var $previouslyRelated = this._findRelated();

      for (var i = 0; i < $previouslyRelated.length; i++) {
        parsleyMultipleInstance = $($previouslyRelated.get(i)).data('Parsley');

        if ('undefined' !== typeof parsleyMultipleInstance) {
          if (!this.$element.data('FieldMultiple')) {
            parsleyMultipleInstance.addElement(this.$element);
          }

          break;
        }
      } // Create a secret Field instance for every multiple field. It will be stored in `data('FieldMultiple')`
      // And will be useful later to access classic `Field` stuff while being in a `FieldMultiple` instance

      this.bind('parsleyField', true);
      return parsleyMultipleInstance || this.bind('parsleyFieldMultiple');
    },
    // Return proper `Form`, `Field` or `FieldMultiple`
    bind: function bind(type, doNotStore) {
      var parsleyInstance;

      switch (type) {
        case 'parsleyForm':
          parsleyInstance = $.extend(
            new Form(this.element, this.domOptions, this.options),
            new Base(),
            window.ParsleyExtend
          )._bindFields();
          break;

        case 'parsleyField':
          parsleyInstance = $.extend(
            new Field(this.element, this.domOptions, this.options, this.parent),
            new Base(),
            window.ParsleyExtend
          );
          break;

        case 'parsleyFieldMultiple':
          parsleyInstance = $.extend(
            new Field(this.element, this.domOptions, this.options, this.parent),
            new Multiple(),
            new Base(),
            window.ParsleyExtend
          )._init();
          break;

        default:
          throw new Error(type + 'is not a supported Parsley type');
      }

      if (this.options.multiple)
        Utils.setAttr(
          this.element,
          this.options.namespace,
          'multiple',
          this.options.multiple
        );

      if ('undefined' !== typeof doNotStore) {
        this.$element.data('FieldMultiple', parsleyInstance);
        return parsleyInstance;
      } // Store the freshly bound instance in a DOM element for later access using jQuery `data()`

      this.$element.data('Parsley', parsleyInstance); // Tell the world we have a new Form or Field instance!

      parsleyInstance._actualizeTriggers();

      parsleyInstance._trigger('init');

      return parsleyInstance;
    },
  };

  var vernums = $.fn.jquery.split('.');

  if (parseInt(vernums[0]) <= 1 && parseInt(vernums[1]) < 8) {
    throw 'The loaded version of jQuery is too old. Please upgrade to 1.8.x or better.';
  }

  if (!vernums.forEach) {
    Utils.warn(
      'Parsley requires ES5 to run properly. Please include https://github.com/es-shims/es5-shim'
    );
  } // Inherit `on`, `off` & `trigger` to Parsley:

  var Parsley = _extends(new Base(), {
    element: document,
    $element: $(document),
    actualizeOptions: null,
    _resetOptions: null,
    Factory: Factory,
    version: '2.9.2',
  }); // Supplement Field and Form with Base
  // This way, the constructors will have access to those methods

  _extends(Field.prototype, UI.Field, Base.prototype);

  _extends(Form.prototype, UI.Form, Base.prototype); // Inherit actualizeOptions and _resetOptions:

  _extends(Factory.prototype, Base.prototype); // ### jQuery API
  // `$('.elem').parsley(options)` or `$('.elem').psly(options)`

  $.fn.parsley = $.fn.psly = function (options) {
    if (this.length > 1) {
      var instances = [];
      this.each(function () {
        instances.push($(this).parsley(options));
      });
      return instances;
    } // Return undefined if applied to non existing DOM element

    if (this.length == 0) {
      return;
    }

    return new Factory(this[0], options);
  }; // ### Field and Form extension
  // Ensure the extension is now defined if it wasn't previously

  if ('undefined' === typeof window.ParsleyExtend) window.ParsleyExtend = {}; // ### Parsley config
  // Inherit from ParsleyDefault, and copy over any existing values

  Parsley.options = _extends(
    Utils.objectCreate(Defaults),
    window.ParsleyConfig
  );
  window.ParsleyConfig = Parsley.options; // Old way of accessing global options
  // ### Globals

  window.Parsley = window.psly = Parsley;
  Parsley.Utils = Utils;
  window.ParsleyUtils = {};
  $.each(Utils, function (key, value) {
    if ('function' === typeof value) {
      window.ParsleyUtils[key] = function () {
        Utils.warnOnce(
          'Accessing `window.ParsleyUtils` is deprecated. Use `window.Parsley.Utils` instead.'
        );
        return Utils[key].apply(Utils, arguments);
      };
    }
  }); // ### Define methods that forward to the registry, and deprecate all access except through window.Parsley

  var registry = (window.Parsley._validatorRegistry = new ValidatorRegistry(
    window.ParsleyConfig.validators,
    window.ParsleyConfig.i18n
  ));
  window.ParsleyValidator = {};
  $.each(
    'setLocale addCatalog addMessage addMessages getErrorMessage formatMessage addValidator updateValidator removeValidator hasValidator'.split(
      ' '
    ),
    function (i, method) {
      window.Parsley[method] = function () {
        return registry[method].apply(registry, arguments);
      };

      window.ParsleyValidator[method] = function () {
        var _window$Parsley;

        Utils.warnOnce(
          "Accessing the method '"
            .concat(
              method,
              "' through Validator is deprecated. Simply call 'window.Parsley."
            )
            .concat(method, "(...)'")
        );
        return (_window$Parsley = window.Parsley)[method].apply(
          _window$Parsley,
          arguments
        );
      };
    }
  ); // ### UI
  // Deprecated global object

  window.Parsley.UI = UI;
  window.ParsleyUI = {
    removeError: function removeError(instance, name, doNotUpdateClass) {
      var updateClass = true !== doNotUpdateClass;
      Utils.warnOnce(
        "Accessing UI is deprecated. Call 'removeError' on the instance directly. Please comment in issue 1073 as to your need to call this method."
      );
      return instance.removeError(name, {
        updateClass: updateClass,
      });
    },
    getErrorsMessages: function getErrorsMessages(instance) {
      Utils.warnOnce(
        "Accessing UI is deprecated. Call 'getErrorsMessages' on the instance directly."
      );
      return instance.getErrorsMessages();
    },
  };
  $.each('addError updateError'.split(' '), function (i, method) {
    window.ParsleyUI[method] = function (
      instance,
      name,
      message,
      assert,
      doNotUpdateClass
    ) {
      var updateClass = true !== doNotUpdateClass;
      Utils.warnOnce(
        "Accessing UI is deprecated. Call '".concat(
          method,
          "' on the instance directly. Please comment in issue 1073 as to your need to call this method."
        )
      );
      return instance[method](name, {
        message: message,
        assert: assert,
        updateClass: updateClass,
      });
    };
  }); // ### PARSLEY auto-binding
  // Prevent it by setting `ParsleyConfig.autoBind` to `false`

  if (false !== window.ParsleyConfig.autoBind) {
    $(function () {
      // Works only on `data-parsley-validate`.
      if ($('[data-parsley-validate]').length)
        $('[data-parsley-validate]').parsley();
    });
  }

  var o = $({});

  var deprecated = function deprecated() {
    Utils.warnOnce(
      "Parsley's pubsub module is deprecated; use the 'on' and 'off' methods on parsley instances or window.Parsley"
    );
  }; // Returns an event handler that calls `fn` with the arguments it expects

  function adapt(fn, context) {
    // Store to allow unbinding
    if (!fn.parsleyAdaptedCallback) {
      fn.parsleyAdaptedCallback = function () {
        var args = Array.prototype.slice.call(arguments, 0);
        args.unshift(this);
        fn.apply(context || o, args);
      };
    }

    return fn.parsleyAdaptedCallback;
  }

  var eventPrefix = 'parsley:'; // Converts 'parsley:form:validate' into 'form:validate'

  function eventName(name) {
    if (name.lastIndexOf(eventPrefix, 0) === 0)
      return name.substr(eventPrefix.length);
    return name;
  } // $.listen is deprecated. Use Parsley.on instead.

  $.listen = function (name, callback) {
    var context;
    deprecated();

    if (
      'object' === _typeof(arguments[1]) &&
      'function' === typeof arguments[2]
    ) {
      context = arguments[1];
      callback = arguments[2];
    }

    if ('function' !== typeof callback) throw new Error('Wrong parameters');
    window.Parsley.on(eventName(name), adapt(callback, context));
  };

  $.listenTo = function (instance, name, fn) {
    deprecated();
    if (!(instance instanceof Field) && !(instance instanceof Form))
      throw new Error('Must give Parsley instance');
    if ('string' !== typeof name || 'function' !== typeof fn)
      throw new Error('Wrong parameters');
    instance.on(eventName(name), adapt(fn));
  };

  $.unsubscribe = function (name, fn) {
    deprecated();
    if ('string' !== typeof name || 'function' !== typeof fn)
      throw new Error('Wrong arguments');
    window.Parsley.off(eventName(name), fn.parsleyAdaptedCallback);
  };

  $.unsubscribeTo = function (instance, name) {
    deprecated();
    if (!(instance instanceof Field) && !(instance instanceof Form))
      throw new Error('Must give Parsley instance');
    instance.off(eventName(name));
  };

  $.unsubscribeAll = function (name) {
    deprecated();
    window.Parsley.off(eventName(name));
    $('form,input,textarea,select').each(function () {
      var instance = $(this).data('Parsley');

      if (instance) {
        instance.off(eventName(name));
      }
    });
  }; // $.emit is deprecated. Use jQuery events instead.

  $.emit = function (name, instance) {
    var _instance;

    deprecated();
    var instanceGiven = instance instanceof Field || instance instanceof Form;
    var args = Array.prototype.slice.call(arguments, instanceGiven ? 2 : 1);
    args.unshift(eventName(name));

    if (!instanceGiven) {
      instance = window.Parsley;
    }

    (_instance = instance).trigger.apply(_instance, _toConsumableArray(args));
  };

  $.extend(true, Parsley, {
    asyncValidators: {
      default: {
        fn: function fn(xhr) {
          // By default, only status 2xx are deemed successful.
          // Note: we use status instead of state() because responses with status 200
          // but invalid messages (e.g. an empty body for content type set to JSON) will
          // result in state() === 'rejected'.
          return xhr.status >= 200 && xhr.status < 300;
        },
        url: false,
      },
      reverse: {
        fn: function fn(xhr) {
          // If reverse option is set, a failing ajax request is considered successful
          return xhr.status < 200 || xhr.status >= 300;
        },
        url: false,
      },
    },
    addAsyncValidator: function addAsyncValidator(name, fn, url, options) {
      Parsley.asyncValidators[name] = {
        fn: fn,
        url: url || false,
        options: options || {},
      };
      return this;
    },
  });
  Parsley.addValidator('remote', {
    requirementType: {
      '': 'string',
      validator: 'string',
      reverse: 'boolean',
      options: 'object',
    },
    validateString: function validateString(value, url, options, instance) {
      var data = {};
      var ajaxOptions;
      var csr;
      var validator =
        options.validator || (true === options.reverse ? 'reverse' : 'default');
      if ('undefined' === typeof Parsley.asyncValidators[validator])
        throw new Error(
          'Calling an undefined async validator: `' + validator + '`'
        );
      url = Parsley.asyncValidators[validator].url || url; // Fill current value

      if (url.indexOf('{value}') > -1) {
        url = url.replace('{value}', encodeURIComponent(value));
      } else {
        data[
          instance.element.getAttribute('name') ||
            instance.element.getAttribute('id')
        ] = value;
      } // Merge options passed in from the function with the ones in the attribute

      var remoteOptions = $.extend(
        true,
        options.options || {},
        Parsley.asyncValidators[validator].options
      ); // All `$.ajax(options)` could be overridden or extended directly from DOM in `data-parsley-remote-options`

      ajaxOptions = $.extend(
        true,
        {},
        {
          url: url,
          data: data,
          type: 'GET',
        },
        remoteOptions
      ); // Generate store key based on ajax options

      instance.trigger('field:ajaxoptions', instance, ajaxOptions);
      csr = $.param(ajaxOptions); // Initialise querry cache

      if ('undefined' === typeof Parsley._remoteCache)
        Parsley._remoteCache = {}; // Try to retrieve stored xhr

      var xhr = (Parsley._remoteCache[csr] =
        Parsley._remoteCache[csr] || $.ajax(ajaxOptions));

      var handleXhr = function handleXhr() {
        var result = Parsley.asyncValidators[validator].fn.call(
          instance,
          xhr,
          url,
          options
        );
        if (!result)
          // Map falsy results to rejected promise
          result = $.Deferred().reject();
        return $.when(result);
      };

      return xhr.then(handleXhr, handleXhr);
    },
    priority: -1,
  });
  Parsley.on('form:submit', function () {
    Parsley._remoteCache = {};
  });

  Base.prototype.addAsyncValidator = function () {
    Utils.warnOnce(
      'Accessing the method `addAsyncValidator` through an instance is deprecated. Simply call `Parsley.addAsyncValidator(...)`'
    );
    return Parsley.addAsyncValidator.apply(Parsley, arguments);
  };

  // This is included with the Parsley library itself,
  Parsley.addMessages('en', {
    defaultMessage: 'This value seems to be invalid.',
    type: {
      email: 'This value should be a valid email.',
      url: 'This value should be a valid url.',
      number: 'This value should be a valid number.',
      integer: 'This value should be a valid integer.',
      digits: 'This value should be digits.',
      alphanum: 'This value should be alphanumeric.',
    },
    notblank: 'This value should not be blank.',
    required: 'This value is required.',
    pattern: 'This value seems to be invalid.',
    min: 'This value should be greater than or equal to %s.',
    max: 'This value should be lower than or equal to %s.',
    range: 'This value should be between %s and %s.',
    minlength: 'This value is too short. It should have %s characters or more.',
    maxlength: 'This value is too long. It should have %s characters or fewer.',
    length:
      'This value length is invalid. It should be between %s and %s characters long.',
    mincheck: 'You must select at least %s choices.',
    maxcheck: 'You must select %s choices or fewer.',
    check: 'You must select between %s and %s choices.',
    equalto: 'This value should be the same.',
    euvatin: "It's not a valid VAT Identification Number.",
  });
  Parsley.setLocale('en');

  function InputEvent() {
    var _this = this;

    var globals = window || global; // Slightly odd way construct our object. This way methods are force bound.
    // Used to test for duplicate library.

    _extends(this, {
      // For browsers that do not support isTrusted, assumes event is native.
      isNativeEvent: function isNativeEvent(evt) {
        return evt.originalEvent && evt.originalEvent.isTrusted !== false;
      },
      fakeInputEvent: function fakeInputEvent(evt) {
        if (_this.isNativeEvent(evt)) {
          $(evt.target).trigger('input');
        }
      },
      misbehaves: function misbehaves(evt) {
        if (_this.isNativeEvent(evt)) {
          _this.behavesOk(evt);

          $(document).on(
            'change.inputevent',
            evt.data.selector,
            _this.fakeInputEvent
          );

          _this.fakeInputEvent(evt);
        }
      },
      behavesOk: function behavesOk(evt) {
        if (_this.isNativeEvent(evt)) {
          $(document) // Simply unbinds the testing handler
            .off('input.inputevent', evt.data.selector, _this.behavesOk)
            .off('change.inputevent', evt.data.selector, _this.misbehaves);
        }
      },
      // Bind the testing handlers
      install: function install() {
        if (globals.inputEventPatched) {
          return;
        }

        globals.inputEventPatched = '0.0.3';

        for (
          var _i = 0,
            _arr = [
              'select',
              'input[type="checkbox"]',
              'input[type="radio"]',
              'input[type="file"]',
            ];
          _i < _arr.length;
          _i++
        ) {
          var selector = _arr[_i];
          $(document)
            .on(
              'input.inputevent',
              selector,
              {
                selector: selector,
              },
              _this.behavesOk
            )
            .on(
              'change.inputevent',
              selector,
              {
                selector: selector,
              },
              _this.misbehaves
            );
        }
      },
      uninstall: function uninstall() {
        delete globals.inputEventPatched;
        $(document).off('.inputevent');
      },
    });
  }
  var inputevent = new InputEvent();

  inputevent.install();

  return Parsley;
});
//# sourceMappingURL=parsley.js.map

$('[id^="form-button-"]').each(function () {
  var $form = $(this).closest('form');
  var $captchaId = $(this).attr('id');
  var captchaRednered = false;

  $form.parsley().on('form:validate', function (formInstance) {
    if (!captchaRednered && formInstance.isValid()) {
      formInstance.validationResult = false;

      var widget = grecaptcha.render($captchaId, {
        sitekey: RECAPTCHA_SITE_KEY, // eslint-disable-line
        size: 'invisible',
        callback: function () {
          formInstance.validationResult = true;
          $form.submit();
        },
      });

      grecaptcha.reset(widget);
      grecaptcha.execute(widget);

      captchaRednered = true;
    }
  });
});

/*!
 * CookieConsent v2.7.1
 * https://www.github.com/orestbida/cookieconsent
 * Author Orest Bida
 * Released under the MIT License
 */
(function () {
  'use strict';
  /**
   * @param {HTMLElement} [root] - [optional] element where the cookieconsent will be appended
   * @returns {Object} cookieconsent object with API
   */
  var CookieConsent = function (root) {
    /**
     * CHANGE THIS FLAG FALSE TO DISABLE console.log()
     */
    var ENABLE_LOGS = false;

    var _config = {
      current_lang: 'en',
      auto_language: null,
      autorun: true, // run as soon as loaded
      cookie_name: 'cc_cookie',
      cookie_expiration: 182, // default: 6 months (in days)
      cookie_domain: window.location.hostname, // default: current domain
      cookie_path: '/',
      cookie_same_site: 'Lax',
      use_rfc_cookie: false,
      autoclear_cookies: true,
      revision: 0,
      script_selector: 'data-cookiecategory',
    };

    /**
     * Object which holds the main methods/API (.show, .run, ...)
     */
    var _cookieconsent = {};

    /**
     * Internal state variables
     */
    var saved_cookie_content = {};
    var consent_modal_exists = false;
    var cookie_consent_accepted = false;
    var consent_modal_visible = false;
    var settings_modal_visible = false;
    var clicked_inside_modal = false;
    var current_modal_focusable;
    var all_table_headers, all_blocks, onAccept, onChange, onFirstAction;
    var valid_revision = true,
      revision_enabled = false,
      data = null;

    /**
     * Accept type:
     *  - "all"
     *  - "necessary"
     *  - "custom"
     * @type {string}
     */
    var accept_type;

    /**
     * Contains all accepted categories
     * @type {string[]}
     */
    var accepted_categories = [];

    /**
     * Contains all non-accepted (rejected) categories
     * @type {string[]}
     */
    var rejected_categories = [];

    // Don't run plugin (to avoid indexing its text content) if bot detected
    var is_bot = false;

    /**
     * Save reference to the last focused element on the page
     * (used later to restore focus when both modals are closed)
     */
    var last_elem_before_modal;
    var last_consent_modal_btn_focus;

    /**
     * Both of the arrays below have the same structure:
     * [0] => holds reference to the FIRST focusable element inside modal
     * [1] => holds reference to the LAST focusable element inside modal
     */
    var consent_modal_focusable = [];
    var settings_modal_focusable = [];

    /**
     * Keep track of enabled/disabled categories
     * @type {boolean[]}
     */
    var toggle_states = [];

    /**
     * Stores all available categories
     * @type {string[]}
     */
    var toggle_categories = [];

    /**
     * Keep track of readonly toggles
     * @type {boolean[]}
     */
    var toggle_readonly = [];

    /**
     * Pointers to main dom elements (to avoid retrieving them later using document.getElementById)
     */
    var html_dom = document.documentElement;
    var main_container;
    var consent_modal;
    var settings_container, settings_inner;

    /**
     * Update config settings
     * @param {Object} conf_params
     */
    var _setConfig = function (conf_params) {
      _log('CookieConsent [CONFIG]: received_config_settings ', conf_params);

      if (typeof conf_params['cookie_expiration'] === 'number')
        _config.cookie_expiration = conf_params['cookie_expiration'];

      if (typeof conf_params['cookie_necessary_only_expiration'] === 'number')
        _config.cookie_necessary_only_expiration =
          conf_params['cookie_necessary_only_expiration'];

      if (typeof conf_params['autorun'] === 'boolean')
        _config.autorun = conf_params['autorun'];

      if (typeof conf_params['cookie_domain'] === 'string')
        _config.cookie_domain = conf_params['cookie_domain'];

      if (typeof conf_params['cookie_same_site'] === 'string')
        _config.cookie_same_site = conf_params['cookie_same_site'];

      if (typeof conf_params['cookie_path'] === 'string')
        _config.cookie_path = conf_params['cookie_path'];

      if (typeof conf_params['cookie_name'] === 'string')
        _config.cookie_name = conf_params['cookie_name'];

      if (typeof conf_params['onAccept'] === 'function')
        onAccept = conf_params['onAccept'];

      if (typeof conf_params['onFirstAction'] === 'function')
        onFirstAction = conf_params['onFirstAction'];

      if (typeof conf_params['onChange'] === 'function')
        onChange = conf_params['onChange'];

      if (typeof conf_params['revision'] === 'number') {
        conf_params['revision'] > -1 &&
          (_config.revision = conf_params['revision']);
        revision_enabled = true;
      }

      if (conf_params['autoclear_cookies'] === true)
        _config.autoclear_cookies = true;

      if (conf_params['use_rfc_cookie'] === true) _config.use_rfc_cookie = true;

      if (conf_params['hide_from_bots'] === true) {
        is_bot =
          navigator &&
          ((navigator.userAgent &&
            /bot|crawl|spider|slurp|teoma/i.test(navigator.userAgent)) ||
            navigator.webdriver);
      }

      _config.page_scripts = conf_params['page_scripts'] === true;
      _config.page_scripts_order = conf_params['page_scripts_order'] !== false;

      if (
        conf_params['auto_language'] === 'browser' ||
        conf_params['auto_language'] === true
      ) {
        _config.auto_language = 'browser';
      } else if (conf_params['auto_language'] === 'document') {
        _config.auto_language = 'document';
      }

      _config.current_lang = _resolveCurrentLang(
        conf_params.languages,
        conf_params['current_lang']
      );
    };

    /**
     * Search for all occurrences in the current page and add an onClick listener :
     * when clicked => open settings modal
     */
    var _addCookieSettingsButtonListener = function () {
      var all_links = document.querySelectorAll(
        'a[data-cc="c-settings"], button[data-cc="c-settings"]'
      );
      for (var x = 0; x < all_links.length; x++) {
        all_links[x].setAttribute('aria-haspopup', 'dialog');
        _addEvent(all_links[x], 'click', function (event) {
          _cookieconsent.showSettings(0);
          event.preventDefault
            ? event.preventDefault()
            : (event.returnValue = false);
        });
      }
    };

    /**
     * Get a valid language (at least 1 must be defined)
     * @param {string} lang - desired language
     * @param {Object} all_languages - all defined languages
     * @returns {string} validated language
     */
    var _getValidatedLanguage = function (lang, all_languages) {
      if (Object.prototype.hasOwnProperty.call(all_languages, lang)) {
        return lang;
      } else if (_getKeys(all_languages).length > 0) {
        if (
          Object.prototype.hasOwnProperty.call(
            all_languages,
            _config.current_lang
          )
        ) {
          return _config.current_lang;
        } else {
          return _getKeys(all_languages)[0];
        }
      }
    };

    /**
     * Save reference to first and last focusable elements inside each modal
     * to prevent losing focus while navigating with TAB
     */
    var _getModalFocusableData = function () {
      /**
       * Note: any of the below focusable elements, which has the attribute tabindex="-1" AND is either
       * the first or last element of the modal, won't receive focus during "open/close" modal
       */
      var allowed_focusable_types = [
        '[href]',
        'button',
        'input',
        'details',
        '[tabindex="0"]',
      ];

      function _getAllFocusableElements(modal, _array) {
        var focus_later = false,
          focus_first = false;

        // ie might throw exception due to complex unsupported selector => a:not([tabindex="-1"])
        try {
          var focusable_elems = modal.querySelectorAll(
            allowed_focusable_types.join(':not([tabindex="-1"]), ')
          );
          var attr,
            len = focusable_elems.length,
            i = 0;

          while (i < len) {
            attr = focusable_elems[i].getAttribute('data-focus');

            if (!focus_first && attr === '1') {
              focus_first = focusable_elems[i];
            } else if (attr === '0') {
              focus_later = focusable_elems[i];
              if (
                !focus_first &&
                focusable_elems[i + 1].getAttribute('data-focus') !== '0'
              ) {
                focus_first = focusable_elems[i + 1];
              }
            }

            i++;
          }
        } catch (e) {
          return modal.querySelectorAll(allowed_focusable_types.join(', '));
        }

        /**
         * Save first and last elements (used to lock/trap focus inside modal)
         */
        _array[0] = focusable_elems[0];
        _array[1] = focusable_elems[focusable_elems.length - 1];
        _array[2] = focus_later;
        _array[3] = focus_first;
      }

      /**
       * Get settings modal'S all focusable elements
       * Save first and last elements (used to lock/trap focus inside modal)
       */
      _getAllFocusableElements(settings_inner, settings_modal_focusable);

      /**
       * If consent modal exists, do the same
       */
      if (consent_modal_exists) {
        _getAllFocusableElements(consent_modal, consent_modal_focusable);
      }
    };

    var _conf_params,
      _createConsentModal,
      revision_message = '',
      consent_text;

    /**
     * Generate cookie consent html based on config settings
     * @param {boolean} never_accepted - used to know whether to create both modals or not
     * @param {Object} conf_params - user configuration parameters
     */
    var _createCookieConsentHTML = function (never_accepted, conf_params) {
      // Create main container which holds both consent modal & settings modal
      main_container = _createNode('div');
      main_container.id = 'cc--main';

      // Fix layout flash
      main_container.style.position = 'fixed';
      main_container.style.zIndex = '1000000';
      main_container.innerHTML =
        '<!--[if lt IE 9 ]><div id="cc_div" class="cc_div ie"></div><![endif]--><!--[if (gt IE 8)|!(IE)]><!--><div id="cc_div" class="cc_div"></div><!--<![endif]-->';
      var all_modals_container = main_container.children[0];

      // Get current language
      var lang = _config.current_lang;

      // Feature detection :=> avoid IE exception since .textContent is not always supported
      var innerText =
        typeof html_dom.textContent === 'string' ? 'textContent' : 'innerText';

      _conf_params = conf_params;
      _createConsentModal = function (conf_params) {
        if (conf_params['force_consent'] === true) {
          _addClass(html_dom, 'force--consent');
        }

        var description =
          conf_params.languages[lang]['consent_modal']['description'];

        if (revision_enabled) {
          if (!valid_revision) {
            description = description.replace(
              '{{revision_message}}',
              revision_message ||
                conf_params.languages[lang]['consent_modal'][
                  'revision_message'
                ] ||
                ''
            );
          } else {
            description = description.replace('{{revision_message}}', '');
          }
        }

        if (consent_modal) {
          consent_text.innerHTML = description;
          return;
        }

        consent_modal = _createNode('div');
        var consent_modal_inner = _createNode('div');
        var consent_modal_inner_inner = _createNode('div');

        consent_text = _createNode('div');
        var consent_buttons = _createNode('div');
        var overlay = _createNode('div');

        consent_modal.id = 'cm';
        consent_modal_inner.id = 'c-inr';
        consent_modal_inner_inner.id = 'c-inr-i';

        consent_text.id = 'c-txt';
        consent_buttons.id = 'c-bns';
        overlay.id = 'cm-ov';

        consent_modal.setAttribute('role', 'dialog');
        consent_modal.setAttribute('aria-modal', 'true');
        consent_modal.setAttribute('aria-hidden', 'false');
        consent_modal.setAttribute('aria-labelledby', 'c-ttl');
        consent_modal.setAttribute('aria-describedby', 'c-txt');

        /**
         * Make modal by default hidden to prevent weird page jumps/flashes (shown only once css is loaded)
         */
        consent_modal.style.visibility = overlay.style.visibility = 'hidden';
        overlay.style.opacity = 0;

        // Use insertAdjacentHTML instead of innerHTML
        var consent_modal_title_value =
          conf_params.languages[lang]['consent_modal']['title'];

        // Add title (if valid)
        if (consent_modal_title_value) {
          var consent_title = _createNode('div');
          consent_title.id = 'c-ttl';
          consent_title.setAttribute('role', 'heading');
          consent_title.setAttribute('aria-level', '2');
          consent_title.insertAdjacentHTML(
            'beforeend',
            consent_modal_title_value
          );
          consent_modal_inner_inner.appendChild(consent_title);
        }

        consent_text.insertAdjacentHTML('beforeend', description);
        consent_modal_inner_inner.appendChild(consent_text);

        var primary_btn_data =
            conf_params.languages[lang]['consent_modal']['primary_btn'], // accept current selection
          secondary_btn_data =
            conf_params.languages[lang]['consent_modal']['secondary_btn'];

        // Add primary button if not falsy
        if (primary_btn_data) {
          var consent_primary_btn = _createNode('button');
          consent_primary_btn.id = 'c-p-bn';
          consent_primary_btn.className = 'c-bn';
          consent_primary_btn[innerText] =
            conf_params.languages[lang]['consent_modal']['primary_btn']['text'];

          var _accept_type;

          if (primary_btn_data['role'] === 'accept_all') _accept_type = 'all';

          _addEvent(consent_primary_btn, 'click', function () {
            _cookieconsent.hide();
            _log('CookieConsent [ACCEPT]: cookie_consent was accepted!');
            _cookieconsent.accept(_accept_type);
          });
        }

        // Add secondary button if not falsy
        if (secondary_btn_data) {
          var consent_secondary_btn = _createNode('button');
          consent_secondary_btn.id = 'c-s-bn';
          consent_secondary_btn.className = 'c-bn c_link';
          consent_secondary_btn[innerText] =
            conf_params.languages[lang]['consent_modal']['secondary_btn'][
              'text'
            ];

          if (secondary_btn_data['role'] === 'accept_necessary') {
            _addEvent(consent_secondary_btn, 'click', function () {
              _cookieconsent.hide();
              _cookieconsent.accept([]); // accept necessary only
            });
          } else {
            _addEvent(consent_secondary_btn, 'click', function () {
              _cookieconsent.showSettings(0);
            });
          }
        }

        // Swap buttons
        var gui_options_data = conf_params['gui_options'];
        if (
          gui_options_data &&
          gui_options_data['consent_modal'] &&
          gui_options_data['consent_modal']['swap_buttons'] === true
        ) {
          secondary_btn_data &&
            consent_buttons.appendChild(consent_secondary_btn);
          primary_btn_data && consent_buttons.appendChild(consent_primary_btn);
          consent_buttons.className = 'swap';
        } else {
          primary_btn_data && consent_buttons.appendChild(consent_primary_btn);
          secondary_btn_data &&
            consent_buttons.appendChild(consent_secondary_btn);
        }

        consent_modal_inner.appendChild(consent_modal_inner_inner);
        (primary_btn_data || secondary_btn_data) &&
          consent_modal_inner.appendChild(consent_buttons);
        consent_modal.appendChild(consent_modal_inner);

        // Append consent modal to main container
        all_modals_container.appendChild(consent_modal);
        all_modals_container.appendChild(overlay);

        consent_modal_exists = true;
      };

      // Create consent modal
      if (!never_accepted) _createConsentModal(conf_params);

      /**
       * Create all consent_modal elements
       */
      settings_container = _createNode('div');
      var settings_container_valign = _createNode('div');
      var settings = _createNode('div');
      var settings_container_inner = _createNode('div');
      settings_inner = _createNode('div');
      var settings_title = _createNode('div');
      var settings_header = _createNode('div');
      var settings_close_btn = _createNode('button');
      var settings_close_btn_container = _createNode('div');
      var settings_blocks = _createNode('div');
      var overlay = _createNode('div');

      /**
       * Set ids
       */
      settings_container.id = 's-cnt';
      settings_container_valign.id = 'c-vln';
      settings_container_inner.id = 'c-s-in';
      settings.id = 'cs';
      settings_title.id = 's-ttl';
      settings_inner.id = 's-inr';
      settings_header.id = 's-hdr';
      settings_blocks.id = 's-bl';
      settings_close_btn.id = 's-c-bn';
      overlay.id = 'cs-ov';
      settings_close_btn_container.id = 's-c-bnc';
      settings_close_btn.className = 'c-bn';

      settings_close_btn.setAttribute(
        'aria-label',
        conf_params.languages[lang]['settings_modal']['close_btn_label'] ||
          'Close'
      );
      settings_container.setAttribute('role', 'dialog');
      settings_container.setAttribute('aria-modal', 'true');
      settings_container.setAttribute('aria-hidden', 'true');
      settings_container.setAttribute('aria-labelledby', 's-ttl');
      settings_title.setAttribute('role', 'heading');
      settings_container.style.visibility = overlay.style.visibility = 'hidden';
      overlay.style.opacity = 0;

      settings_close_btn_container.appendChild(settings_close_btn);

      // If 'esc' key is pressed inside settings_container div => hide settings
      _addEvent(
        settings_container_valign,
        'keydown',
        function (evt) {
          evt = evt || window.event;
          if (evt.keyCode === 27) {
            _cookieconsent.hideSettings(0);
          }
        },
        true
      );

      _addEvent(settings_close_btn, 'click', function () {
        _cookieconsent.hideSettings(0);
      });

      all_blocks =
        conf_params.languages[_config.current_lang]['settings_modal']['blocks'];
      all_table_headers =
        conf_params.languages[_config.current_lang]['settings_modal'][
          'cookie_table_headers'
        ];

      var n_blocks = all_blocks.length;

      // Set settings modal title
      settings_title.insertAdjacentHTML(
        'beforeend',
        conf_params.languages[_config.current_lang]['settings_modal']['title']
      );

      // Create settings modal content (blocks)
      for (var i = 0; i < n_blocks; ++i) {
        var title_data = all_blocks[i]['title'],
          description_data = all_blocks[i]['description'],
          toggle_data = all_blocks[i]['toggle'],
          cookie_table_data = all_blocks[i]['cookie_table'],
          remove_cookie_tables = conf_params['remove_cookie_tables'] === true,
          isExpandable =
            (description_data && 'truthy') ||
            (!remove_cookie_tables && cookie_table_data && 'truthy');

        // Create title
        var block_section = _createNode('div');
        var block_table_container = _createNode('div');

        // Create description
        if (description_data) {
          var block_desc = _createNode('div');
          block_desc.className = 'p';
          block_desc.insertAdjacentHTML('beforeend', description_data);
        }

        var block_title_container = _createNode('div');
        block_title_container.className = 'title';

        block_section.className = 'c-bl';
        block_table_container.className = 'desc';

        // Create toggle if specified (opt in/out)
        if (typeof toggle_data !== 'undefined') {
          var accordion_id = 'c-ac-' + i;

          // Create button (to collapse/expand block description)
          var block_title_btn = isExpandable
            ? _createNode('button')
            : _createNode('div');
          var block_switch_label = _createNode('label');
          var block_switch = _createNode('input');
          var block_switch_span = _createNode('span');
          var label_text_span = _createNode('span');

          // These 2 spans will contain each 2 pseudo-elements to generate 'tick' and 'x' icons
          var block_switch_span_on_icon = _createNode('span');
          var block_switch_span_off_icon = _createNode('span');

          block_title_btn.className = isExpandable ? 'b-tl exp' : 'b-tl';
          block_switch_label.className = 'b-tg';
          block_switch.className = 'c-tgl';
          block_switch_span_on_icon.className = 'on-i';
          block_switch_span_off_icon.className = 'off-i';
          block_switch_span.className = 'c-tg';
          label_text_span.className = 't-lb';

          if (isExpandable) {
            block_title_btn.setAttribute('aria-expanded', 'false');
            block_title_btn.setAttribute('aria-controls', accordion_id);
          }

          block_switch.type = 'checkbox';
          block_switch_span.setAttribute('aria-hidden', 'true');

          var cookie_category = toggle_data.value;
          block_switch.value = cookie_category;

          label_text_span[innerText] = title_data;
          block_title_btn.insertAdjacentHTML('beforeend', title_data);

          block_title_container.appendChild(block_title_btn);
          block_switch_span.appendChild(block_switch_span_on_icon);
          block_switch_span.appendChild(block_switch_span_off_icon);

          /**
           * If never accepted => generate toggles with the states defined in the config. object
           * Otherwise, retrieve values from saved cookie
           */
          if (never_accepted) {
            if (_inArray(saved_cookie_content['level'], cookie_category) > -1) {
              block_switch.checked = true;
              toggle_states.push(true);
            } else {
              toggle_states.push(false);
            }
          } else if (toggle_data['enabled']) {
            block_switch.checked = true;
            toggle_states.push(true);
          } else {
            toggle_states.push(false);
          }

          toggle_categories.push(cookie_category);

          /**
           * Set toggle as readonly if true (disable checkbox)
           */
          if (toggle_data['readonly']) {
            block_switch.disabled = true;
            _addClass(block_switch_span, 'c-ro');
            toggle_readonly.push(true);
          } else {
            toggle_readonly.push(false);
          }

          _addClass(block_table_container, 'b-acc');
          _addClass(block_title_container, 'b-bn');
          _addClass(block_section, 'b-ex');

          block_table_container.id = accordion_id;
          block_table_container.setAttribute('aria-hidden', 'true');

          block_switch_label.appendChild(block_switch);
          block_switch_label.appendChild(block_switch_span);
          block_switch_label.appendChild(label_text_span);
          block_title_container.appendChild(block_switch_label);

          /**
           * On button click handle the following :=> aria-expanded, aria-hidden and act class for current block
           */
          isExpandable &&
            (function (accordion, block_section, btn) {
              _addEvent(
                block_title_btn,
                'click',
                function () {
                  if (!_hasClass(block_section, 'act')) {
                    _addClass(block_section, 'act');
                    btn.setAttribute('aria-expanded', 'true');
                    accordion.setAttribute('aria-hidden', 'false');
                  } else {
                    _removeClass(block_section, 'act');
                    btn.setAttribute('aria-expanded', 'false');
                    accordion.setAttribute('aria-hidden', 'true');
                  }
                },
                false
              );
            })(block_table_container, block_section, block_title_btn);
        } else {
          /**
           * If block is not a button (no toggle defined),
           * create a simple div instead
           */
          if (title_data) {
            var block_title = _createNode('div');
            block_title.className = 'b-tl';
            block_title.setAttribute('role', 'heading');
            block_title.setAttribute('aria-level', '3');
            block_title.insertAdjacentHTML('beforeend', title_data);
            block_title_container.appendChild(block_title);
          }
        }

        title_data && block_section.appendChild(block_title_container);
        description_data && block_table_container.appendChild(block_desc);

        // if cookie table found, generate table for this block
        if (!remove_cookie_tables && typeof cookie_table_data !== 'undefined') {
          var tr_tmp_fragment = document.createDocumentFragment();

          /**
           * Use custom table headers
           */
          for (var p = 0; p < all_table_headers.length; ++p) {
            // create new header
            var th1 = _createNode('th');
            var obj = all_table_headers[p];
            th1.setAttribute('scope', 'col');

            // get custom header content
            if (obj) {
              var new_column_key = obj && _getKeys(obj)[0];
              th1[innerText] = all_table_headers[p][new_column_key];
              tr_tmp_fragment.appendChild(th1);
            }
          }

          var tr_tmp = _createNode('tr');
          tr_tmp.appendChild(tr_tmp_fragment);

          // create table header & append fragment
          var thead = _createNode('thead');
          thead.appendChild(tr_tmp);

          // append header to table
          var block_table = _createNode('table');
          block_table.appendChild(thead);

          var tbody_fragment = document.createDocumentFragment();

          // create table content
          for (var n = 0; n < cookie_table_data.length; n++) {
            var tr = _createNode('tr');

            for (var g = 0; g < all_table_headers.length; ++g) {
              // get custom header content
              obj = all_table_headers[g];
              if (obj) {
                new_column_key = _getKeys(obj)[0];

                var td_tmp = _createNode('td');

                // Allow html inside table cells
                td_tmp.insertAdjacentHTML(
                  'beforeend',
                  cookie_table_data[n][new_column_key]
                );
                td_tmp.setAttribute('data-column', obj[new_column_key]);

                tr.appendChild(td_tmp);
              }
            }

            tbody_fragment.appendChild(tr);
          }

          // append tbody_fragment to tbody & append the latter into the table
          var tbody = _createNode('tbody');
          tbody.appendChild(tbody_fragment);
          block_table.appendChild(tbody);

          block_table_container.appendChild(block_table);
        }

        /**
         * Append only if is either:
         * - togglable div with title
         * - a simple div with at least a title or description
         */
        if (
          (toggle_data && title_data) ||
          (!toggle_data && (title_data || description_data))
        ) {
          block_section.appendChild(block_table_container);
          settings_blocks.appendChild(block_section);
        }
      }

      // Create settings buttons
      var settings_buttons = _createNode('div');
      var settings_save_btn = _createNode('button');
      var settings_accept_all_btn = _createNode('button');

      settings_buttons.id = 's-bns';
      settings_save_btn.id = 's-sv-bn';
      settings_accept_all_btn.id = 's-all-bn';
      settings_save_btn.className = 'c-bn';
      settings_accept_all_btn.className = 'c-bn';
      settings_save_btn.insertAdjacentHTML(
        'beforeend',
        conf_params.languages[_config.current_lang]['settings_modal'][
          'save_settings_btn'
        ]
      );
      settings_accept_all_btn.insertAdjacentHTML(
        'beforeend',
        conf_params.languages[_config.current_lang]['settings_modal'][
          'accept_all_btn'
        ]
      );

      settings_buttons.appendChild(settings_accept_all_btn);

      var reject_all_btn_text =
        conf_params.languages[_config.current_lang]['settings_modal'][
          'reject_all_btn'
        ];

      // Add third [optional] reject all button if provided
      if (reject_all_btn_text) {
        var reject_all_btn = _createNode('button');
        reject_all_btn.id = 's-rall-bn';
        reject_all_btn.className = 'c-bn';
        reject_all_btn.insertAdjacentHTML('beforeend', reject_all_btn_text);

        _addEvent(reject_all_btn, 'click', function () {
          _cookieconsent.hideSettings();
          _cookieconsent.hide();
          _cookieconsent.accept([]);
        });

        settings_inner.className = 'bns-t';
        settings_buttons.appendChild(reject_all_btn);
      }

      settings_buttons.appendChild(settings_save_btn);

      // Add save preferences button onClick event
      // Hide both settings modal and consent modal
      _addEvent(settings_save_btn, 'click', function () {
        _cookieconsent.hideSettings();
        _cookieconsent.hide();
        _cookieconsent.accept();
      });

      _addEvent(settings_accept_all_btn, 'click', function () {
        _cookieconsent.hideSettings();
        _cookieconsent.hide();
        _cookieconsent.accept('all');
      });

      settings_header.appendChild(settings_title);
      settings_header.appendChild(settings_close_btn_container);

      settings_inner.appendChild(settings_header);
      settings_inner.appendChild(settings_blocks);
      settings_inner.appendChild(settings_buttons);
      settings_container_inner.appendChild(settings_inner);

      settings.appendChild(settings_container_inner);
      settings_container_valign.appendChild(settings);
      settings_container.appendChild(settings_container_valign);

      all_modals_container.appendChild(settings_container);
      all_modals_container.appendChild(overlay);

      // Finally append everything to body (main_container holds both modals)
      (root || document.body).appendChild(main_container);
    };

    /**
     * Set toggles/checkboxes based on accepted categories and save cookie
     * @param {string[]} accepted_categories - Array of categories to accept
     */
    var _saveCookiePreferences = function (accepted_categories) {
      // Retrieve all toggle/checkbox values
      var category_toggles = document.querySelectorAll('.c-tgl') || [];
      var changedSettings = [],
        must_reload = false;

      // If there are opt in/out toggles ...
      if (category_toggles.length > 0) {
        for (var i = 0; i < category_toggles.length; i++) {
          if (_inArray(accepted_categories, toggle_categories[i]) !== -1) {
            category_toggles[i].checked = true;
            if (!toggle_states[i]) {
              changedSettings.push(toggle_categories[i]);
              toggle_states[i] = true;
            }
          } else {
            category_toggles[i].checked = false;
            if (toggle_states[i]) {
              changedSettings.push(toggle_categories[i]);
              toggle_states[i] = false;
            }
          }
        }

        /**
         * If autoclear_cookies==true -> delete all cookies which are unused (based on selected preferences)
         */
        if (
          _config.autoclear_cookies &&
          cookie_consent_accepted &&
          changedSettings.length > 0
        ) {
          // Get number of blocks
          var len = all_blocks.length;
          var count = -1;

          // Retrieve all cookies
          var all_cookies_array = _getCookie('', 'all');

          // delete cookies on 'www.domain.com' and '.www.domain.com' (can also be without www)
          var domains = [_config.cookie_domain, '.' + _config.cookie_domain];

          // if domain has www, delete cookies also for 'domain.com' and '.domain.com'
          if (_config.cookie_domain.slice(0, 4) === 'www.') {
            var non_www_domain = _config.cookie_domain.substr(4); // remove first 4 chars (www.)
            domains.push(non_www_domain);
            domains.push('.' + non_www_domain);
          }

          // For each block
          for (var jk = 0; jk < len; jk++) {
            // Save current block (local scope & less accesses -> ~faster value retrieval)
            var curr_block = all_blocks[jk];

            // If current block has a toggle for opt in/out
            if (Object.prototype.hasOwnProperty.call(curr_block, 'toggle')) {
              // if current block has a cookie table, an off toggle,
              // and its preferences were just changed => delete cookies
              if (
                !toggle_states[++count] &&
                Object.prototype.hasOwnProperty.call(
                  curr_block,
                  'cookie_table'
                ) &&
                _inArray(changedSettings, curr_block['toggle']['value']) > -1
              ) {
                var curr_cookie_table = curr_block['cookie_table'];

                // Get first property name
                var ckey = _getKeys(all_table_headers[0])[0];

                // Get number of cookies defined in cookie_table
                var clen = curr_cookie_table.length;

                // set "must_reload" to true if reload=on_disable
                if (curr_block['toggle']['reload'] === 'on_disable')
                  must_reload = true;

                // for each row defined in the cookie table
                for (var hk = 0; hk < clen; hk++) {
                  // Get current row of table (corresponds to all cookie params)
                  var curr_row = curr_cookie_table[hk],
                    found_cookies = [];
                  var curr_cookie_name = curr_row[ckey];
                  var is_regex = curr_row['is_regex'] || false;
                  var curr_cookie_domain = curr_row['domain'] || null;
                  var curr_cookie_path = curr_row['path'] || false;

                  // set domain to the specified domain
                  curr_cookie_domain &&
                    (domains = [curr_cookie_domain, '.' + curr_cookie_domain]);

                  // If regex provided => filter cookie array
                  if (is_regex) {
                    for (var n = 0; n < all_cookies_array.length; n++) {
                      if (all_cookies_array[n].match(curr_cookie_name)) {
                        found_cookies.push(all_cookies_array[n]);
                      }
                    }
                  } else {
                    var found_index = _inArray(
                      all_cookies_array,
                      curr_cookie_name
                    );
                    if (found_index > -1)
                      found_cookies.push(all_cookies_array[found_index]);
                  }

                  _log(
                    "CookieConsent [AUTOCLEAR]: search cookie: '" +
                      curr_cookie_name +
                      "', found:",
                    found_cookies
                  );

                  // If cookie exists -> delete it
                  if (found_cookies.length > 0) {
                    _eraseCookies(found_cookies, curr_cookie_path, domains);
                    curr_block['toggle']['reload'] === 'on_clear' &&
                      (must_reload = true);
                  }
                }
              }
            }
          }
        }
      }

      saved_cookie_content = {
        level: accepted_categories,
        revision: _config.revision,
        data: data,
        rfc_cookie: _config.use_rfc_cookie,
      };

      // save cookie with preferences 'level' (only if never accepted or settings were updated)
      if (
        !cookie_consent_accepted ||
        changedSettings.length > 0 ||
        !valid_revision
      ) {
        valid_revision = true;
        _setCookie(_config.cookie_name, JSON.stringify(saved_cookie_content));
        _manageExistingScripts();
      }

      if (!cookie_consent_accepted) {
        if (typeof onFirstAction === 'function')
          onFirstAction(
            _cookieconsent.getUserPreferences(),
            saved_cookie_content
          );

        if (typeof onAccept === 'function') onAccept(saved_cookie_content);

        cookie_consent_accepted = true;

        return;
      }

      // fire onChange only if settings were changed
      if (typeof onChange === 'function' && changedSettings.length > 0) {
        onChange(saved_cookie_content, changedSettings);
      }

      /**
       * reload page if needed
       */
      if (must_reload) {
        window.location.reload();
      }
    };

    /**
     * Function to run after css load
     * @callback cssLoaded
     */

    /**
     * Load style via ajax in background (and then show modal)
     * @param {string} css_path
     * @param {cssLoaded} callback
     */
    var _loadCSS = function (css_path, callback) {
      // Enable if given path is string and non empty
      var enable = typeof css_path === 'string' && css_path !== '';

      if (enable && !document.getElementById('cc--style')) {
        // Create style tag
        var style = _createNode('style');

        // ad an id so that in SPA apps (react-like) the style doesn't get loaded multiple times when plugin is called
        style.id = 'cc--style';

        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            // Necessary for <IE9
            style.setAttribute('type', 'text/css');

            if (style.styleSheet) {
              // if <IE9
              style.styleSheet.cssText = this.responseText;
            } else {
              // all other browsers
              style.appendChild(document.createTextNode(this.responseText));
            }

            // Append css text content
            document.getElementsByTagName('head')[0].appendChild(style);
            _log(
              "CookieConsent [AUTOLOAD_CSS]: loaded style = '" + css_path + "'"
            );

            callback();
          }
        };

        xhr.open('GET', css_path);
        xhr.send();
      } else {
        callback();
      }
    };

    /**
     * Returns index of found element inside array, otherwise -1
     * @param {Array} arr
     * @param {Object} value
     * @returns {number}
     */
    var _inArray = function (arr, value) {
      var len = arr.length;
      for (var i = 0; i < len; i++) {
        if (arr[i] === value) return i;
      }
      return -1;
    };

    /**
     * Helper function which prints info (console.log())
     * @param {Object} print_msg
     * @param {Object} [optional_param]
     */
    var _log = function (print_msg, optional_param, error) {
      ENABLE_LOGS &&
        (!error
          ? console.log(
              print_msg,
              optional_param !== undefined ? optional_param : ' '
            )
          : console.error(print_msg, optional_param || ''));
    };

    /**
     * Helper function which creates an HTMLElement object based on 'type' and returns it.
     * @param {string} type
     * @returns {HTMLElement}
     */
    var _createNode = function (type) {
      var el = document.createElement(type);
      if (type === 'button') {
        el.setAttribute('type', type);
      }
      return el;
    };

    /**
     * Resolve which language should be used.
     *
     * @param {Object} languages Object with language translations
     * @param {string} [requested_language] Language specified by given configuration parameters
     * @returns {string}
     */
    var _resolveCurrentLang = function (languages, requested_language) {
      _log(
        "CookieConsent [LANG]: auto_language strategy is '" +
          _config.auto_language +
          "'"
      );

      if (_config.auto_language === 'browser') {
        return _getValidatedLanguage(_getBrowserLang(), languages);
      } else if (_config.auto_language === 'document') {
        return _getValidatedLanguage(document.documentElement.lang, languages);
      } else {
        if (typeof requested_language === 'string') {
          return (_config.current_lang = _getValidatedLanguage(
            requested_language,
            languages
          ));
        }
      }

      _log(
        "CookieConsent [LANG]: setting current_lang = '" +
          _config.current_lang +
          "'"
      );
      return _config.current_lang; // otherwise return default
    };

    /**
     * Get current client's browser language
     * @returns {string}
     */
    var _getBrowserLang = function () {
      var browser_lang = navigator.language || navigator.browserLanguage;
      browser_lang.length > 2 &&
        (browser_lang = browser_lang[0] + browser_lang[1]);
      _log(
        "CookieConsent [LANG]: detected_browser_lang = '" + browser_lang + "'"
      );
      return browser_lang.toLowerCase();
    };

    /**
     * Trap focus inside modal and focus the first
     * focusable element of current active modal
     */
    var _handleFocusTrap = function () {
      var tabbedOutsideDiv = false;
      var tabbedInsideModal = false;

      _addEvent(document, 'keydown', function (e) {
        e = e || window.event;

        // If is tab key => ok
        if (e.key !== 'Tab') return;

        // If there is any modal to focus
        if (current_modal_focusable) {
          // If reached natural end of the tab sequence => restart
          if (e.shiftKey) {
            if (document.activeElement === current_modal_focusable[0]) {
              current_modal_focusable[1].focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === current_modal_focusable[1]) {
              current_modal_focusable[0].focus();
              e.preventDefault();
            }
          }

          // If have not yet used tab (or shift+tab) and modal is open ...
          // Focus the first focusable element
          if (!tabbedInsideModal && !clicked_inside_modal) {
            tabbedInsideModal = true;
            !tabbedOutsideDiv && e.preventDefault();

            if (e.shiftKey) {
              if (current_modal_focusable[3]) {
                if (!current_modal_focusable[2]) {
                  current_modal_focusable[0].focus();
                } else {
                  current_modal_focusable[2].focus();
                }
              } else {
                current_modal_focusable[1].focus();
              }
            } else {
              if (current_modal_focusable[3]) {
                current_modal_focusable[3].focus();
              } else {
                current_modal_focusable[0].focus();
              }
            }
          }
        }

        !tabbedInsideModal && (tabbedOutsideDiv = true);
      });

      if (document.contains) {
        _addEvent(
          main_container,
          'click',
          function (e) {
            e = e || window.event;
            /**
             * If click is on the foreground overlay (and not inside settings_modal),
             * hide settings modal
             *
             * Notice: click on div is not supported in IE
             */
            if (settings_modal_visible) {
              if (!settings_inner.contains(e.target)) {
                _cookieconsent.hideSettings(0);
                clicked_inside_modal = false;
              } else {
                clicked_inside_modal = true;
              }
            } else if (consent_modal_visible) {
              if (consent_modal.contains(e.target)) {
                clicked_inside_modal = true;
              }
            }
          },
          true
        );
      }
    };

    /**
     * Manage each modal's layout
     * @param {Object} gui_options
     */
    var _guiManager = function (gui_options, only_consent_modal) {
      // If gui_options is not object => exit
      if (typeof gui_options !== 'object') return;

      var consent_modal_options = gui_options['consent_modal'];
      var settings_modal_options = gui_options['settings_modal'];

      /**
       * Helper function which adds layout and
       * position classes to given modal
       *
       * @param {HTMLElement} modal
       * @param {string[]} allowed_layouts
       * @param {string[]} allowed_positions
       * @param {string} layout
       * @param {string[]} position
       */
      function _setLayout(
        modal,
        allowed_layouts,
        allowed_positions,
        allowed_transitions,
        layout,
        position,
        transition
      ) {
        position = (position && position.split(' ')) || [];

        // Check if specified layout is valid
        if (_inArray(allowed_layouts, layout) > -1) {
          // Add layout classes
          _addClass(modal, layout);

          // Add position class (if specified)
          if (
            !(layout === 'bar' && position[0] === 'middle') &&
            _inArray(allowed_positions, position[0]) > -1
          ) {
            for (var i = 0; i < position.length; i++) {
              _addClass(modal, position[i]);
            }
          }
        }

        // Add transition class
        _inArray(allowed_transitions, transition) > -1 &&
          _addClass(modal, transition);
      }

      if (consent_modal_exists && consent_modal_options) {
        _setLayout(
          consent_modal,
          ['box', 'bar', 'cloud'],
          ['top', 'middle', 'bottom'],
          ['zoom', 'slide'],
          consent_modal_options['layout'],
          consent_modal_options['position'],
          consent_modal_options['transition']
        );
      }

      if (!only_consent_modal && settings_modal_options) {
        _setLayout(
          settings_container,
          ['bar'],
          ['left', 'right'],
          ['zoom', 'slide'],
          settings_modal_options['layout'],
          settings_modal_options['position'],
          settings_modal_options['transition']
        );
      }
    };

    /**
     * Returns true if cookie category is accepted by the user
     * @param {string} cookie_category
     * @returns {boolean}
     */
    _cookieconsent.allowedCategory = function (cookie_category) {
      return (
        _inArray(
          JSON.parse(_getCookie(_config.cookie_name, 'one', true) || '{}')[
            'level'
          ] || [],
          cookie_category
        ) > -1
      );
    };

    /**
     * Check if cookieconsent is already attached to dom
     * If not, create one, configure it and attach it to the body
     */
    _cookieconsent.run = function (conf_params) {
      if (!document.getElementById('cc_div')) {
        // configure all parameters
        _setConfig(conf_params);

        // if is bot, don't run plugin
        if (is_bot) return;

        // Retrieve cookie value (if set)
        saved_cookie_content = JSON.parse(
          _getCookie(_config.cookie_name, 'one', true) || '{}'
        );
        cookie_consent_accepted = saved_cookie_content['level'] !== undefined;
        data =
          saved_cookie_content['data'] !== undefined
            ? saved_cookie_content['data']
            : null;

        // Compare current revision with the one retrieved from cookie
        valid_revision =
          typeof conf_params['revision'] === 'number'
            ? cookie_consent_accepted
              ? conf_params['revision'] > -1
                ? saved_cookie_content['revision'] === _config.revision
                : true
              : true
            : true;

        // If invalid revision or cookie is empty => create consent modal
        consent_modal_exists = !cookie_consent_accepted || !valid_revision;

        // Generate cookie-settings dom (& consent modal)
        _createCookieConsentHTML(!consent_modal_exists, conf_params);

        _loadCSS(conf_params['theme_css'], function () {
          _getModalFocusableData();
          _guiManager(conf_params['gui_options']);
          _addCookieSettingsButtonListener();

          if (_config.autorun && consent_modal_exists) {
            _cookieconsent.show(conf_params['delay'] || 0);
          }

          // Add class to enable animations/transitions
          setTimeout(function () {
            _addClass(main_container, 'c--anim');
          }, 30);

          // Accessibility :=> if tab pressed => trap focus inside modal
          setTimeout(function () {
            _handleFocusTrap();
          }, 100);
        });

        if (cookie_consent_accepted && valid_revision) {
          var rfc_prop_exists =
            typeof saved_cookie_content['rfc_cookie'] === 'boolean';

          /*
           * Convert cookie to rfc format (if `use_rfc_cookie` is enabled)
           */
          if (
            !rfc_prop_exists ||
            (rfc_prop_exists &&
              saved_cookie_content['rfc_cookie'] !== _config.use_rfc_cookie)
          ) {
            saved_cookie_content['rfc_cookie'] = _config.use_rfc_cookie;
            _setCookie(
              _config.cookie_name,
              JSON.stringify(saved_cookie_content)
            );
          }

          _manageExistingScripts();
          if (typeof conf_params['onAccept'] === 'function') {
            conf_params['onAccept'](saved_cookie_content);
          }
        }
      } else {
        _log(
          'CookieConsent [NOTICE]: cookie consent already attached to body!'
        );
      }
    };

    /**
     * Show settings modal (with optional delay)
     * @param {number} delay
     */
    _cookieconsent.showSettings = function (delay) {
      setTimeout(
        function () {
          _addClass(html_dom, 'show--settings');
          settings_container.setAttribute('aria-hidden', 'false');
          settings_modal_visible = true;

          /**
           * Set focus to the first focusable element inside settings modal
           */
          setTimeout(function () {
            // If there is no consent-modal, keep track of the last focused elem.
            if (!consent_modal_visible) {
              last_elem_before_modal = document.activeElement;
            } else {
              last_consent_modal_btn_focus = document.activeElement;
            }

            if (settings_modal_focusable.length === 0) return;

            if (settings_modal_focusable[3]) {
              settings_modal_focusable[3].focus();
            } else {
              settings_modal_focusable[0].focus();
            }
            current_modal_focusable = settings_modal_focusable;
          }, 200);

          _log('CookieConsent [SETTINGS]: show settings_modal');
        },
        delay > 0 ? delay : 0
      );
    };

    /**
     * This function handles the loading/activation logic of the already
     * existing scripts based on the current accepted cookie categories
     */
    var _manageExistingScripts = function () {
      if (!_config.page_scripts) return;

      // get all the scripts with "cookie-category" attribute
      var scripts = document.querySelectorAll(
        'script[' + _config.script_selector + ']'
      );
      var sequential_enabled = _config.page_scripts_order;
      var accepted_categories = saved_cookie_content['level'] || [];
      _log(
        'CookieConsent [SCRIPT_MANAGER]: sequential loading:',
        sequential_enabled
      );

      /**
       * Load scripts (sequentially), using a recursive function
       * which loops through the scripts array
       * @param {Element[]} scripts scripts to load
       * @param {number} index current script to load
       */
      var _loadScripts = function (scripts, index) {
        if (index < scripts.length) {
          var curr_script = scripts[index];
          var curr_script_category = curr_script.getAttribute(
            _config.script_selector
          );

          /**
           * If current script's category is on the array of categories
           * accepted by the user => load script
           */
          if (_inArray(accepted_categories, curr_script_category) > -1) {
            curr_script.type = 'text/javascript';
            curr_script.removeAttribute(_config.script_selector);

            // get current script data-src
            var src = curr_script.getAttribute('data-src');

            // create fresh script (with the same code)
            var fresh_script = _createNode('script');
            fresh_script.textContent = curr_script.innerHTML;

            // Copy attributes over to the new "revived" script
            (function (destination, source) {
              var attr,
                attributes = source.attributes;
              var len = attributes.length;
              for (var i = 0; i < len; i++) {
                attr = attributes[i];
                destination.setAttribute(attr.nodeName, attr.nodeValue);
              }
            })(fresh_script, curr_script);

            // set src (if data-src found)
            src ? (fresh_script.src = src) : (src = curr_script.src);

            // if script has "src" attribute
            // try loading it sequentially
            if (src) {
              if (sequential_enabled) {
                // load script sequentially => the next script will not be loaded
                // until the current's script onload event triggers
                if (fresh_script.readyState) {
                  // only required for IE <9
                  fresh_script.onreadystatechange = function () {
                    if (
                      fresh_script.readyState === 'loaded' ||
                      fresh_script.readyState === 'complete'
                    ) {
                      fresh_script.onreadystatechange = null;
                      _loadScripts(scripts, ++index);
                    }
                  };
                } else {
                  // others
                  fresh_script.onload = function () {
                    fresh_script.onload = null;
                    _loadScripts(scripts, ++index);
                  };
                }
              } else {
                // if sequential option is disabled
                // treat current script as inline (without onload event)
                src = false;
              }
            }

            // Replace current "sleeping" script with the new "revived" one
            curr_script.parentNode.replaceChild(fresh_script, curr_script);

            /**
             * If we managed to get here and scr is still set, it means that
             * the script is loading/loaded sequentially so don't go any further
             */
            if (src) return;
          }

          // Go to next script right away
          _loadScripts(scripts, ++index);
        }
      };

      _loadScripts(scripts, 0);
    };

    /**
     * Save custom data inside cookie
     * @param {object|string} new_data
     * @param {string} [mode]
     * @returns {boolean}
     */
    var _setCookieData = function (new_data, mode) {
      var set = false;
      /**
       * If mode is 'update':
       * add/update only the specified props.
       */
      if (mode === 'update') {
        data = _cookieconsent.get('data');
        var same_type = typeof data === typeof new_data;

        if (same_type && typeof data === 'object') {
          !data && (data = {});

          for (var prop in new_data) {
            if (data[prop] !== new_data[prop]) {
              data[prop] = new_data[prop];
              set = true;
            }
          }
        } else if ((same_type || !data) && data !== new_data) {
          data = new_data;
          set = true;
        }
      } else {
        data = new_data;
        set = true;
      }

      if (set) {
        saved_cookie_content['data'] = data;
        _setCookie(_config.cookie_name, JSON.stringify(saved_cookie_content));
      }

      return set;
    };

    /**
     * Forcefully set a specific revision and show consent modal
     * @param {number} new_revision
     * @param {boolean} [prompt_consent]
     * @returns {boolean}
     */
    var _setRevision = function (new_revision, prompt_consent, message) {
      // If plugin has been initialized and new revision is valid
      if (
        main_container &&
        typeof new_revision === 'number' &&
        saved_cookie_content['revision'] !== new_revision
      ) {
        revision_enabled = true;
        revision_message = message;
        valid_revision = false;
        _config.revision = new_revision;

        // Show consent modal ?
        if (prompt_consent === true) {
          _createConsentModal(_conf_params);
          _guiManager(_conf_params['gui_options'], true);
          _getModalFocusableData();
          _cookieconsent.show();
        } else {
          // If revision was modified, save cookie with the new revision
          _cookieconsent.accept();
        }

        return true;
      }

      return false;
    };

    /**
     * Helper method to set a variety of fields
     * @param {string} field
     * @param {object} data
     * @returns {boolean}
     */
    _cookieconsent.set = function (field, data) {
      switch (field) {
        case 'data':
          return _setCookieData(data['value'], data['mode']);
        case 'revision':
          return _setRevision(
            data['value'],
            data['prompt_consent'],
            data['message']
          );
        default:
          return false;
      }
    };

    /**
     * Retrieve data from existing cookie
     * @param {string} field
     * @param {string} [cookie_name]
     * @returns {any}
     */
    _cookieconsent.get = function (field, cookie_name) {
      var cookie = JSON.parse(
        _getCookie(cookie_name || _config.cookie_name, 'one', true) || '{}'
      );

      return cookie[field];
    };

    /**
     * Read current configuration value
     * @returns {any}
     */
    _cookieconsent.getConfig = function (field) {
      return _config[field];
    };

    /**
     * @typedef {object} userPreferences
     * @property {string} accept_type
     * @property {string[]} accepted_categories
     * @property {string[]} rejected_categories
     */

    /**
     * Retrieve current user preferences (summary)
     * @returns {userPreferences}
     */
    _cookieconsent.getUserPreferences = function () {
      // get accepted categories
      accepted_categories = saved_cookie_content['level'] || [];

      // number of categories marked as necessary/readonly
      var necessary_categories_count = toggle_readonly.filter(function (
        readonly
      ) {
        return readonly === true;
      }).length;

      // calculate rejected categories (all_categories - accepted_categories)
      rejected_categories = toggle_categories.filter(function (category) {
        return _inArray(accepted_categories, category) === -1;
      });

      // set accept type based on accepted/rejected categories
      if (accepted_categories.length === toggle_categories.length)
        accept_type = 'all';
      else if (
        rejected_categories.length >= 0 &&
        accepted_categories.length === necessary_categories_count
      )
        accept_type = 'necessary';
      else accept_type = 'custom';

      return {
        accept_type: accept_type,
        accepted_categories: accepted_categories,
        rejected_categories: rejected_categories,
      };
    };

    /**
     * Function which will run after script load
     * @callback scriptLoaded
     */

    /**
     * Dynamically load script (append to head)
     * @param {string} src
     * @param {scriptLoaded} callback
     * @param {string[]} attrs
     */
    _cookieconsent.loadScript = function (src, callback, attrs) {
      var function_defined = typeof callback === 'function';

      // Load script only if not already loaded
      if (!document.querySelector('script[src="' + src + '"]')) {
        var script = _createNode('script');

        // if an array is provided => add custom attributes
        if (attrs && attrs.length > 0) {
          for (var i = 0; i < attrs.length; ++i) {
            attrs[i] &&
              script.setAttribute(attrs[i]['name'], attrs[i]['value']);
          }
        }

        // if callback function defined => run callback onload
        if (function_defined) {
          if (script.readyState) {
            // only required for IE <9
            script.onreadystatechange = function () {
              if (
                script.readyState === 'loaded' ||
                script.readyState === 'complete'
              ) {
                script.onreadystatechange = null;
                callback();
              }
            };
          } else {
            //Others
            script.onload = callback;
          }
        }

        script.src = src;

        /**
         * Append script to head
         */
        (document.head
          ? document.head
          : document.getElementsByTagName('head')[0]
        ).appendChild(script);
      } else {
        function_defined && callback();
      }
    };

    /**
     * Manage dynamically loaded scripts: https://github.com/orestbida/cookieconsent/issues/101
     * If plugin has already run, call this method to enable
     * the newly added scripts based on currently selected preferences
     */
    _cookieconsent.updateScripts = function () {
      _manageExistingScripts();
    };

    /**
     * Show cookie consent modal (with delay parameter)
     * @param {number} delay
     */
    _cookieconsent.show = function (delay) {
      if (consent_modal_exists) {
        setTimeout(
          function () {
            _addClass(html_dom, 'show--consent');

            /**
             * Update attributes/internal statuses
             */
            consent_modal.setAttribute('aria-hidden', 'false');
            consent_modal_visible = true;

            setTimeout(function () {
              last_elem_before_modal = document.activeElement;
              current_modal_focusable = consent_modal_focusable;
            }, 200);

            _log('CookieConsent [MODAL]: show consent_modal');
          },
          delay > 0 ? delay : 0
        );
      }
    };

    /**
     * Hide consent modal
     */
    _cookieconsent.hide = function () {
      if (consent_modal_exists) {
        _removeClass(html_dom, 'show--consent');
        consent_modal.setAttribute('aria-hidden', 'true');
        consent_modal_visible = false;

        setTimeout(function () {
          //restore focus to the last page element which had focus before modal opening
          last_elem_before_modal.focus();
          current_modal_focusable = null;
        }, 200);

        _log('CookieConsent [MODAL]: hide');
      }
    };

    /**
     * Hide settings modal
     */
    _cookieconsent.hideSettings = function () {
      _removeClass(html_dom, 'show--settings');
      settings_modal_visible = false;
      settings_container.setAttribute('aria-hidden', 'true');

      setTimeout(function () {
        /**
         * If consent modal is visible, focus him (instead of page document)
         */
        if (consent_modal_visible) {
          last_consent_modal_btn_focus && last_consent_modal_btn_focus.focus();
          current_modal_focusable = consent_modal_focusable;
        } else {
          /**
           * Restore focus to last page element which had focus before modal opening
           */
          last_elem_before_modal.focus();
          current_modal_focusable = null;
        }

        clicked_inside_modal = false;
      }, 200);

      _log('CookieConsent [SETTINGS]: hide settings_modal');
    };

    /**
     * Accept cookieconsent function API
     * @param {string[]|string} _categories - Categories to accept
     * @param {string[]} [_exclusions] - Excluded categories [optional]
     */
    _cookieconsent.accept = function (_categories, _exclusions) {
      var categories = _categories || undefined;
      var exclusions = _exclusions || [];
      var to_accept = [];

      /**
       * Get all accepted categories
       * @returns {string[]}
       */
      var _getCurrentPreferences = function () {
        var toggles = document.querySelectorAll('.c-tgl') || [];
        var states = [];

        for (var i = 0; i < toggles.length; i++) {
          if (toggles[i].checked) {
            states.push(toggles[i].value);
          }
        }
        return states;
      };

      if (!categories) {
        to_accept = _getCurrentPreferences();
      } else {
        if (
          typeof categories === 'object' &&
          typeof categories.length === 'number'
        ) {
          for (var i = 0; i < categories.length; i++) {
            if (_inArray(toggle_categories, categories[i]) !== -1)
              to_accept.push(categories[i]);
          }
        } else if (typeof categories === 'string') {
          if (categories === 'all') to_accept = toggle_categories.slice();
          else {
            if (_inArray(toggle_categories, categories) !== -1)
              to_accept.push(categories);
          }
        }
      }

      // Remove excluded categories
      if (exclusions.length >= 1) {
        for (i = 0; i < exclusions.length; i++) {
          to_accept = to_accept.filter(function (item) {
            return item !== exclusions[i];
          });
        }
      }

      // Add back all the categories set as "readonly/required"
      for (i = 0; i < toggle_categories.length; i++) {
        if (
          toggle_readonly[i] === true &&
          _inArray(to_accept, toggle_categories[i]) === -1
        ) {
          to_accept.push(toggle_categories[i]);
        }
      }

      _saveCookiePreferences(to_accept);
    };

    /**
     * API function to easily erase cookies
     * @param {(string|string[])} _cookies
     * @param {string} [_path] - optional
     * @param {string} [_domain] - optional
     */
    _cookieconsent.eraseCookies = function (_cookies, _path, _domain) {
      var cookies = [];
      var domains = _domain
        ? [_domain, '.' + _domain]
        : [_config.cookie_domain, '.' + _config.cookie_domain];

      if (typeof _cookies === 'object' && _cookies.length > 0) {
        for (var i = 0; i < _cookies.length; i++) {
          this.validCookie(_cookies[i]) && cookies.push(_cookies[i]);
        }
      } else {
        this.validCookie(_cookies) && cookies.push(_cookies);
      }

      _eraseCookies(cookies, _path, domains);
    };

    /**
     * Set cookie, by specifying name and value
     * @param {string} name
     * @param {string} value
     */
    var _setCookie = function (name, value) {
      var cookie_expiration = _config.cookie_expiration;

      if (
        typeof _config.cookie_necessary_only_expiration === 'number' &&
        accept_type === 'necessary'
      )
        cookie_expiration = _config.cookie_necessary_only_expiration;

      value = _config.use_rfc_cookie ? encodeURIComponent(value) : value;

      var date = new Date();
      date.setTime(date.getTime() + 1000 * (cookie_expiration * 24 * 60 * 60));
      var expires = '; expires=' + date.toUTCString();

      var cookieStr =
        name +
        '=' +
        (value || '') +
        expires +
        '; Path=' +
        _config.cookie_path +
        ';';
      cookieStr += ' SameSite=' + _config.cookie_same_site + ';';

      // assures cookie works with localhost (=> don't specify domain if on localhost)
      if (window.location.hostname.indexOf('.') > -1) {
        cookieStr += ' Domain=' + _config.cookie_domain + ';';
      }

      if (window.location.protocol === 'https:') {
        cookieStr += ' Secure;';
      }

      document.cookie = cookieStr;

      _log(
        'CookieConsent [SET_COOKIE]: cookie ' +
          name +
          "='" +
          value +
          "' was set! Expires after " +
          cookie_expiration +
          ' days'
      );
    };

    /**
     * Get cookie value by name,
     * returns the cookie value if found (or an array
     * of cookies if filter provided), otherwise empty string: ""
     * @param {string} name
     * @param {string} filter - 'one' or 'all'
     * @param {boolean} get_value - set to true to obtain its value
     * @returns {string|string[]}
     */
    var _getCookie = function (name, filter, get_value) {
      var found;

      if (filter === 'one') {
        found = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        found = found ? (get_value ? found.pop() : name) : '';

        if (found && name === _config.cookie_name) {
          try {
            found = JSON.parse(found);
          } catch (e) {
            try {
              found = JSON.parse(decodeURIComponent(found));
            } catch (e) {
              // if I got here => cookie value is not a valid json string
              found = {};
            }
          }
          found = JSON.stringify(found);
        }
      } else if (filter === 'all') {
        // array of names of all existing cookies
        var cookies = document.cookie.split(/;\s*/);
        found = [];
        for (var i = 0; i < cookies.length; i++) {
          found.push(cookies[i].split('=')[0]);
        }
      }

      return found;
    };

    /**
     * Delete cookie by name & path
     * @param {string[]} cookies
     * @param {string} [custom_path] - optional
     * @param {string[]} domains - example: ['domain.com', '.domain.com']
     */
    var _eraseCookies = function (cookies, custom_path, domains) {
      var path = custom_path ? custom_path : '/';
      var expires = 'Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

      for (var i = 0; i < cookies.length; i++) {
        for (var j = 0; j < domains.length; j++) {
          document.cookie =
            cookies[i] +
            '=; path=' +
            path +
            (domains[j].indexOf('.') > -1 ? '; domain=' + domains[j] : '') +
            '; ' +
            expires;
        }
        _log(
          "CookieConsent [AUTOCLEAR]: deleting cookie: '" +
            cookies[i] +
            "' path: '" +
            path +
            "' domain:",
          domains
        );
      }
    };

    /**
     * Returns true if cookie was found and has valid value (not empty string)
     * @param {string} cookie_name
     * @returns {boolean}
     */
    _cookieconsent.validCookie = function (cookie_name) {
      return _getCookie(cookie_name, 'one', true) !== '';
    };

    /**
     * Function to run when event is fired
     * @callback eventFired
     */

    /**
     * Add event listener to dom object (cross browser function)
     * @param {Element} elem
     * @param {string} event
     * @param {eventFired} fn
     * @param {boolean} passive
     */
    var _addEvent = function (elem, event, fn, _passive) {
      var passive = _passive === true;

      if (elem.addEventListener) {
        passive
          ? elem.addEventListener(event, fn, { passive: true })
          : elem.addEventListener(event, fn, false);
      } else {
        /**
         * For old browser, add 'on' before event:
         * 'click':=> 'onclick'
         */
        elem.attachEvent('on' + event, fn);
      }
    };

    /**
     * Get all prop. keys defined inside object
     * @param {Object} obj
     */
    var _getKeys = function (obj) {
      if (typeof obj === 'object') {
        var keys = [],
          i = 0;
        for (keys[i++] in obj);
        return keys;
      }
    };

    /**
     * Append class to the specified dom element
     * @param {HTMLElement} elem
     * @param {string} classname
     */
    var _addClass = function (elem, classname) {
      if (elem.classList) elem.classList.add(classname);
      else {
        if (!_hasClass(elem, classname)) elem.className += ' ' + classname;
      }
    };

    /**
     * Remove specified class from dom element
     * @param {HTMLElement} elem
     * @param {string} classname
     */
    var _removeClass = function (el, className) {
      el.classList
        ? el.classList.remove(className)
        : (el.className = el.className.replace(
            new RegExp('(\\s|^)' + className + '(\\s|$)'),
            ' '
          ));
    };

    /**
     * Check if html element has class
     * @param {HTMLElement} el
     * @param {string} className
     */
    var _hasClass = function (el, className) {
      if (el.classList) {
        return el.classList.contains(className);
      }
      return !!el.className.match(
        new RegExp('(\\s|^)' + className + '(\\s|$)')
      );
    };

    return _cookieconsent;
  };

  var init = 'initCookieConsent';
  /**
   * Make CookieConsent object accessible globally
   */
  if (typeof window[init] !== 'function') {
    window[init] = CookieConsent;
  }
})();

jQuery(document).ready(function ($) {
  var bodyWidth = window.innerWidth;

  // Create a new instance of Slidebars
  var controller = new slidebars();

  // Initialize Slidebars
  controller.init();

  $('.close-popup').on('click', function (event) {
    $.magnificPopup.close();
  });

  if (window.location.href.indexOf('#form-2') > -1) {
    $.magnificPopup.open({
      items: {
        src: '#lightbox-form',
      },
      type: 'inline',
    });
  }

  $('.js-hamburger').on('click', function (event) {
    event.stopPropagation();
    controller.toggle('slidebar');
  });

  if ($('.js-masonry').length) {
    if (bodyWidth > 1200) {
      $('.js-masonry').masonry({
        itemSelector: '.js-masonry-item',
        columnWidth: 460,
        gutter: 30,
      });
    }
  }

  $('.js-gallery').each(function () {
    // the containers for all your galleries
    $(this)
      .find('.js-gallery-item')
      .magnificPopup({
        type: 'image',
        gallery: {
          enabled: true,
          tCounter: '<div class="mfp-counter">%curr% z %total%</div>',
        },
      });
  });

  $('.js-lightbox-close').click(function () {
    $.magnificPopup.close();
    return false;
  });

  $('.js-lightbox').magnificPopup({
    type: 'inline',

    callbacks: {
      open: function () {
        // When you open the
        $('body').css('overflow', 'hidden'); // window, the element
      }, // "body" is used "overflow: hidden".

      close: function () {
        // When the window
        $('body').css('overflow', ''); // is closed, the
      }, // "overflow" gets the initial value.
    },
  });

  $("a[href^='#']").click(function () {
    var thisHref = $(this).attr('href');

    $.scrollTo(thisHref, 400, {
      offset: -150,
      axis: 'y',
    });

    return false;
  });

  if ($('.js-slider--big').length) {
    new Glide('.js-slider--big', {
      type: 'carousel',
      perView: 3,
      gap: 30,

      breakpoints: {
        1024: {
          perView: 2,
        },
        600: {
          perView: 1,
        },
      },
    }).mount();
  }

  if ($('.js-slider--small').length) {
    new Glide('.js-slider--small', {
      type: 'carousel',
      perView: 2,
      gap: 30,

      breakpoints: {
        600: {
          perView: 1,
        },
      },
    }).mount();
  }

  if ($('.js-slider--one').length) {
    new Glide('.js-slider--one', {
      perView: 1,
      gap: 0,
    }).mount();
  }
});

//Headroom.js
var myElement = document.querySelector('.header-wrapper');
var headroom = new Headroom(myElement, {
  offset: 70,
  tolerance: 1,
});
headroom.init();
// end Headroom.js

// Dropzone
window.Dropzone = Dropzone;
window.Dropzone.autoDiscover = false;

// Dropzone
if ($('#file').length) {
  var fileList = new Array();

  $('#file').dropzone({
    addRemoveLinks: true,
    maxFilesize: 10, //max velikost souboru 10 MB
    createImageThumbnails: false,
    acceptedFiles:
      'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/rtf,application/x-rtf,text/richtext,text/plain,application/vnd.oasis.opendocument.text',
    dictRemoveFile: 'x',
    dictCancelUpload: 'x',
    dictFallbackMessage:
      'Ve vašem prohlížeči nelze nahrávat soubory přetažením.',
    dictFileTooBig:
      'Soubor je příliš velký ({{filesize}}MB). Maximální povolená velikost je {{maxFilesize}}MB',
    dictInvalidFileType: 'Není dovoleno nahrávat soubory tohoto typu.',
    dictResponseError: 'Server vrátil odpověď {{statusCode}}.',
    dictCancelUploadConfirmation:
      'Opravdu chcete přerušit nahrávání tohoto souboru?',
    dictMaxFilesExceeded: 'Máte nahraný maximální počet souborů.',
    url: home_url + '/ajax/upload/', // eslint-disable-line

    init: function () {
      this.on('success', function (file, response) {
        fileList[file.upload.uuid] = { fid: response.file_id };
      });
    },

    processing: function () {
      $('.btn').attr('disabled', 'disabled'); //disabluje tlačítko, dokud nejsou nahrané přílohy
    },
    queuecomplete: function () {
      $('.btn').removeAttr('disabled'); // aktivuje tlačítko na odeslání formuláře
    },
    removedfile: function (file) {
      if (fileList[file.upload.uuid] && fileList[file.upload.uuid].fid > 0) {
        $.get(
          $('.dropzone').data('remove-upload-url') +
            fileList[file.upload.uuid].fid
        ).done(function () {
          file.previewElement.remove();
        });
      } else {
        file.previewElement.remove();
      }

      if ($('.dz-preview.dz-file-preview').children().length == 0) {
        $('.dz-preview.dz-file-preview').remove();
      }
    },
  });
}

//# sourceMappingURL=scripts.min.js.map
